module.exports = [
	{
		"fund_family_label": "Vanguard",
		"as_of": "202506",
		"fund_id": 188,
		"net_asset_sum": 9345792243237,
		"long_asset_sum": 9457430565407,
		"num_equity_funds": 103,
		"equity_fund_net_assets": 6727430814523,
		"equity_fund_long_assets": 6729924611947,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 37361141172,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 36532193544,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 22,
		"num_five_badgers": 10,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 8,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 6234,
		"ff_all_asset_sum": 573337925949,
		"ff_all_weight_total": 0.08519232517570959,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1460,
		"c2_asset_sum": 171218303997,
		"c2_weight_total": 0.025441340560197704,
		"mc50_count_sum": 356,
		"mc50_asset_sum": 108071824355,
		"mc50_weight_total": 0.016058400440793985,
		"co_count_sum": 1464,
		"co_asset_sum": 66582944834,
		"co_weight_total": 0.009893564738571005,
		"og_count_sum": 4304,
		"og_asset_sum": 399441226159,
		"og_weight_total": 0.05935300158487804,
		"ut_count_sum": 2438,
		"ut_asset_sum": 265272930775,
		"ut_weight_total": 0.03941692456763721,
		"cl_count_sum": 2250,
		"cl_asset_sum": 1283411075140,
		"cl_weight_total": 0.19070214737051905,
		"fossil_bank_count_sum": 637,
		"fossil_bank_asset_sum": 192955996022,
		"fossil_bank_weight_total": 0.028671345839366973,
		"fossil_insure_count_sum": 334,
		"fossil_insure_asset_sum": 134320713788,
		"fossil_insure_weight_total": 0.019958724879258396,
		"name": "Vanguard",
		"fund_family_name": "Vanguard",
		"label": "Vanguard"
	},
	{
		"fund_family_label": "BlackRock/iShares",
		"as_of": "202506",
		"fund_id": 600,
		"net_asset_sum": 3799009142213,
		"long_asset_sum": 4008575207308,
		"num_equity_funds": 314,
		"equity_fund_net_assets": 2581055799778,
		"equity_fund_long_assets": 2604506694385,
		"num_e_sri": 36,
		"num_e_usf": 0,
		"sri_long_assets": 60060870914,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 51894734670,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 119,
		"num_five_badgers": 54,
		"num_sri_badgers": 3,
		"num_fossil_A_grade": 50,
		"num_sri_fossil_A_grade": 2,
		"ff_all_count_sum": 9531,
		"ff_all_asset_sum": 222064228899,
		"ff_all_weight_total": 0.08526153124418666,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2504,
		"c2_asset_sum": 68845095699,
		"c2_weight_total": 0.02643306536605249,
		"mc50_count_sum": 531,
		"mc50_asset_sum": 32786850452,
		"mc50_weight_total": 0.012588506884119156,
		"co_count_sum": 2100,
		"co_asset_sum": 33728816881,
		"co_weight_total": 0.012950174769646487,
		"og_count_sum": 6791,
		"og_asset_sum": 156610201353,
		"og_weight_total": 0.06013046604588599,
		"ut_count_sum": 3892,
		"ut_asset_sum": 100792677542,
		"ut_weight_total": 0.0386993351790175,
		"cl_count_sum": 4742,
		"cl_asset_sum": 444143378198,
		"cl_weight_total": 0.17052879117397515,
		"fossil_bank_count_sum": 1581,
		"fossil_bank_asset_sum": 87584086926,
		"fossil_bank_weight_total": 0.033627898563217615,
		"fossil_insure_count_sum": 715,
		"fossil_insure_asset_sum": 49587387163,
		"fossil_insure_weight_total": 0.019039070726869077,
		"name": "BlackRock/iShares",
		"fund_family_name": "BlackRock/iShares",
		"label": "BlackRock/iShares"
	},
	{
		"fund_family_label": "Fidelity Investments",
		"as_of": "202506",
		"fund_id": 546,
		"net_asset_sum": 3795129055133,
		"long_asset_sum": 3883386689301,
		"num_equity_funds": 302,
		"equity_fund_net_assets": 2527294129881,
		"equity_fund_long_assets": 2541218482176,
		"num_e_sri": 21,
		"num_e_usf": 0,
		"sri_long_assets": 7549710873,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 6457252087,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 97,
		"num_five_badgers": 48,
		"num_sri_badgers": 2,
		"num_fossil_A_grade": 43,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 7604,
		"ff_all_asset_sum": 200805345554,
		"ff_all_weight_total": 0.07901931571899082,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1986,
		"c2_asset_sum": 57001940887,
		"c2_weight_total": 0.02243094849451522,
		"mc50_count_sum": 409,
		"mc50_asset_sum": 47816495580,
		"mc50_weight_total": 0.01881636542287997,
		"co_count_sum": 1516,
		"co_asset_sum": 20850279626,
		"co_weight_total": 0.008204835504008407,
		"og_count_sum": 5659,
		"og_asset_sum": 132029368609,
		"og_weight_total": 0.051955142595982384,
		"ut_count_sum": 2874,
		"ut_asset_sum": 93820609846,
		"ut_weight_total": 0.036919537026845126,
		"cl_count_sum": 3855,
		"cl_asset_sum": 464936651864,
		"cl_weight_total": 0.18295815772041885,
		"fossil_bank_count_sum": 1320,
		"fossil_bank_asset_sum": 72872844323,
		"fossil_bank_weight_total": 0.028676339651284247,
		"fossil_insure_count_sum": 629,
		"fossil_insure_asset_sum": 63607856808,
		"fossil_insure_weight_total": 0.02503045576527278,
		"name": "Fidelity Investments",
		"fund_family_name": "Fidelity Investments",
		"label": "Fidelity Investments"
	},
	{
		"fund_family_label": "American Funds/Capital Group",
		"as_of": "202506",
		"fund_id": 95,
		"net_asset_sum": 2784856377690,
		"long_asset_sum": 2803149165401,
		"num_equity_funds": 35,
		"equity_fund_net_assets": 2053952794144,
		"equity_fund_long_assets": 2058856685318,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 655,
		"ff_all_asset_sum": 146212361980,
		"ff_all_weight_total": 0.07101628929427733,
		"grade_fossil_fam": 4,
		"c2_count_sum": 190,
		"c2_asset_sum": 57505096965,
		"c2_weight_total": 0.027930597294642714,
		"mc50_count_sum": 11,
		"mc50_asset_sum": 1261272674,
		"mc50_weight_total": 0.0006126082903168126,
		"co_count_sum": 101,
		"co_asset_sum": 18610704522,
		"co_weight_total": 0.009039339481332325,
		"og_count_sum": 532,
		"og_asset_sum": 119321800251,
		"og_weight_total": 0.05795536964855336,
		"ut_count_sum": 212,
		"ut_asset_sum": 42888909839,
		"ut_weight_total": 0.020831420732121336,
		"cl_count_sum": 551,
		"cl_asset_sum": 348826122862,
		"cl_weight_total": 0.16942710259996663,
		"fossil_bank_count_sum": 238,
		"fossil_bank_asset_sum": 59979684398,
		"fossil_bank_weight_total": 0.029132520405972726,
		"fossil_insure_count_sum": 69,
		"fossil_insure_asset_sum": 18952163064,
		"fossil_insure_weight_total": 0.009205188102285395,
		"name": "American Funds/Capital Group",
		"fund_family_name": "American Funds/Capital Group",
		"label": "American Funds/Capital Group"
	},
	{
		"fund_family_label": "State Street",
		"as_of": "202506",
		"fund_id": 192,
		"net_asset_sum": 1603954014770,
		"long_asset_sum": 1604393175247,
		"num_equity_funds": 107,
		"equity_fund_net_assets": 1290555815131,
		"equity_fund_long_assets": 1290573185821,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 1637881412,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 1625087480,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 36,
		"num_five_badgers": 24,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 21,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4466,
		"ff_all_asset_sum": 135325410349,
		"ff_all_weight_total": 0.10485682783104822,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1093,
		"c2_asset_sum": 41629237677,
		"c2_weight_total": 0.03225639439464838,
		"mc50_count_sum": 276,
		"mc50_asset_sum": 27844626138,
		"mc50_weight_total": 0.021575394905083665,
		"co_count_sum": 1111,
		"co_asset_sum": 12555203387,
		"co_weight_total": 0.009728393186019117,
		"og_count_sum": 3086,
		"og_asset_sum": 93251524932,
		"og_weight_total": 0.07225589835316307,
		"ut_count_sum": 1922,
		"ut_asset_sum": 65301615453,
		"ut_weight_total": 0.05059892470294761,
		"cl_count_sum": 2018,
		"cl_asset_sum": 263841975000,
		"cl_weight_total": 0.20443782491277823,
		"fossil_bank_count_sum": 628,
		"fossil_bank_asset_sum": 35694137057,
		"fossil_bank_weight_total": 0.02765758459044159,
		"fossil_insure_count_sum": 287,
		"fossil_insure_asset_sum": 30102609340,
		"fossil_insure_weight_total": 0.023324992081599914,
		"name": "State Street",
		"fund_family_name": "State Street",
		"label": "State Street"
	},
	{
		"fund_family_label": "Invesco",
		"as_of": "202506",
		"fund_id": 330,
		"net_asset_sum": 1045138181023,
		"long_asset_sum": 1067901592301,
		"num_equity_funds": 200,
		"equity_fund_net_assets": 773860514349,
		"equity_fund_long_assets": 777145058356,
		"num_e_sri": 14,
		"num_e_usf": 0,
		"sri_long_assets": 9865258363,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 7336311052,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 94,
		"num_five_badgers": 52,
		"num_sri_badgers": 5,
		"num_fossil_A_grade": 49,
		"num_sri_fossil_A_grade": 5,
		"ff_all_count_sum": 2735,
		"ff_all_asset_sum": 50264730990,
		"ff_all_weight_total": 0.06467869858985115,
		"grade_fossil_fam": 4,
		"c2_count_sum": 691,
		"c2_asset_sum": 10538634304,
		"c2_weight_total": 0.013560704260661192,
		"mc50_count_sum": 161,
		"mc50_asset_sum": 5668184185,
		"mc50_weight_total": 0.007293598696993166,
		"co_count_sum": 459,
		"co_asset_sum": 7158962659,
		"co_weight_total": 0.009211874388218232,
		"og_count_sum": 2015,
		"og_asset_sum": 37020159567,
		"og_weight_total": 0.04763609981039286,
		"ut_count_sum": 1043,
		"ut_asset_sum": 19850185502,
		"ut_weight_total": 0.02554244576165971,
		"cl_count_sum": 1494,
		"cl_asset_sum": 183733396715,
		"cl_weight_total": 0.23642098053570088,
		"fossil_bank_count_sum": 409,
		"fossil_bank_asset_sum": 10288066081,
		"fossil_bank_weight_total": 0.013238282828129586,
		"fossil_insure_count_sum": 231,
		"fossil_insure_asset_sum": 4484081698,
		"fossil_insure_weight_total": 0.0057699417242461585,
		"name": "Invesco",
		"fund_family_name": "Invesco",
		"label": "Invesco"
	},
	{
		"fund_family_label": "T. Rowe Price",
		"as_of": "202506",
		"fund_id": 176,
		"net_asset_sum": 892953123756,
		"long_asset_sum": 897866033837,
		"num_equity_funds": 77,
		"equity_fund_net_assets": 590662111324,
		"equity_fund_long_assets": 591337854802,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 23319764,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 23319764,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 22,
		"num_five_badgers": 10,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 10,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1467,
		"ff_all_asset_sum": 42383252721,
		"ff_all_weight_total": 0.07167349828329754,
		"grade_fossil_fam": 4,
		"c2_count_sum": 438,
		"c2_asset_sum": 15110510549,
		"c2_weight_total": 0.025553091902191027,
		"mc50_count_sum": 47,
		"mc50_asset_sum": 2893000035,
		"mc50_weight_total": 0.00489229636071358,
		"co_count_sum": 220,
		"co_asset_sum": 6734216308,
		"co_weight_total": 0.011388102847322102,
		"og_count_sum": 1147,
		"og_asset_sum": 34124330727,
		"og_weight_total": 0.05770699516340956,
		"ut_count_sum": 456,
		"ut_asset_sum": 15696126070,
		"ut_weight_total": 0.026543414974263057,
		"cl_count_sum": 830,
		"cl_asset_sum": 97551204892,
		"cl_weight_total": 0.16496695433892603,
		"fossil_bank_count_sum": 236,
		"fossil_bank_asset_sum": 10161936239,
		"fossil_bank_weight_total": 0.017184653673833483,
		"fossil_insure_count_sum": 147,
		"fossil_insure_asset_sum": 8368067102,
		"fossil_insure_weight_total": 0.014151076299354982,
		"name": "T. Rowe Price",
		"fund_family_name": "T. Rowe Price",
		"label": "T. Rowe Price"
	},
	{
		"fund_family_label": "Schwab Funds",
		"as_of": "202506",
		"fund_id": 94,
		"net_asset_sum": 645418856631,
		"long_asset_sum": 645543864801,
		"num_equity_funds": 43,
		"equity_fund_net_assets": 557235607842,
		"equity_fund_long_assets": 557239003100,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 23616043,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 23616043,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 5,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2840,
		"ff_all_asset_sum": 56141155252,
		"ff_all_weight_total": 0.10074878990824179,
		"grade_fossil_fam": 5,
		"c2_count_sum": 743,
		"c2_asset_sum": 22832368149,
		"c2_weight_total": 0.04097410271352199,
		"mc50_count_sum": 149,
		"mc50_asset_sum": 7509825282,
		"mc50_weight_total": 0.013476847887929185,
		"co_count_sum": 566,
		"co_asset_sum": 6239918512,
		"co_weight_total": 0.011197921317937983,
		"og_count_sum": 2067,
		"og_asset_sum": 43372012442,
		"og_weight_total": 0.07783377007121776,
		"ut_count_sum": 1099,
		"ut_asset_sum": 18771903231,
		"ut_weight_total": 0.0336873462312746,
		"cl_count_sum": 1127,
		"cl_asset_sum": 104728151401,
		"cl_weight_total": 0.18794117213328995,
		"fossil_bank_count_sum": 311,
		"fossil_bank_asset_sum": 17265803875,
		"fossil_bank_weight_total": 0.03098455739628395,
		"fossil_insure_count_sum": 162,
		"fossil_insure_asset_sum": 10210514411,
		"fossil_insure_weight_total": 0.018323402264014996,
		"name": "Schwab Funds",
		"fund_family_name": "Schwab Funds",
		"label": "Schwab Funds"
	},
	{
		"fund_family_label": "Thrift Savings Plan",
		"as_of": "202506",
		"fund_id": 14,
		"net_asset_sum": 755499999968,
		"long_asset_sum": 757858755551,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 517100000020,
		"equity_fund_long_assets": 518833024684,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 273,
		"ff_all_asset_sum": 41372775280,
		"ff_all_weight_total": 0.07974198501569646,
		"grade_fossil_fam": 4,
		"c2_count_sum": 65,
		"c2_asset_sum": 12673183130,
		"c2_weight_total": 0.02442632316575977,
		"mc50_count_sum": 8,
		"mc50_asset_sum": 7799348894,
		"mc50_weight_total": 0.015032483521553518,
		"co_count_sum": 43,
		"co_asset_sum": 4797564139,
		"co_weight_total": 0.009246836478695628,
		"og_count_sum": 211,
		"og_asset_sum": 28664273661,
		"og_weight_total": 0.05524758891062927,
		"ut_count_sum": 88,
		"ut_asset_sum": 18609871654,
		"ut_weight_total": 0.035868710680733,
		"cl_count_sum": 110,
		"cl_asset_sum": 97570482920,
		"cl_weight_total": 0.18805757975685183,
		"fossil_bank_count_sum": 34,
		"fossil_bank_asset_sum": 16891854856,
		"fossil_bank_weight_total": 0.032557401037237636,
		"fossil_insure_count_sum": 19,
		"fossil_insure_asset_sum": 11190728944,
		"fossil_insure_weight_total": 0.021569037458276322,
		"name": "Thrift Savings Plan",
		"fund_family_name": "Thrift Savings Plan",
		"label": "Thrift Savings Plan"
	},
	{
		"fund_family_label": "Dimensional Fund Advisors",
		"as_of": "202506",
		"fund_id": 144,
		"net_asset_sum": 629307452418,
		"long_asset_sum": 635916719029,
		"num_equity_funds": 78,
		"equity_fund_net_assets": 507695328960,
		"equity_fund_long_assets": 507793032273,
		"num_e_sri": 7,
		"num_e_usf": 0,
		"sri_long_assets": 16538466879,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 14729526085,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 12,
		"num_five_badgers": 5,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 5,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 10849,
		"ff_all_asset_sum": 47508829781,
		"ff_all_weight_total": 0.09355943615125911,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2120,
		"c2_asset_sum": 20437847185,
		"c2_weight_total": 0.04024838051344547,
		"mc50_count_sum": 388,
		"mc50_asset_sum": 4283505708,
		"mc50_weight_total": 0.008435534628795574,
		"co_count_sum": 2640,
		"co_asset_sum": 7455347430,
		"co_weight_total": 0.014681862404901712,
		"og_count_sum": 7384,
		"og_asset_sum": 35858114182,
		"og_weight_total": 0.07061560892533464,
		"ut_count_sum": 3771,
		"ut_asset_sum": 13883304211,
		"ut_weight_total": 0.02734047796767729,
		"cl_count_sum": 3041,
		"cl_asset_sum": 51432647368,
		"cl_weight_total": 0.10128663470976645,
		"fossil_bank_count_sum": 908,
		"fossil_bank_asset_sum": 18221500571,
		"fossil_bank_weight_total": 0.03588371524011725,
		"fossil_insure_count_sum": 351,
		"fossil_insure_asset_sum": 8662592155,
		"fossil_insure_weight_total": 0.017059297005758856,
		"name": "Dimensional Fund Advisors",
		"fund_family_name": "Dimensional Fund Advisors",
		"label": "Dimensional Fund Advisors"
	},
	{
		"fund_family_label": "TIAA Investments/Nuveen",
		"as_of": "202506",
		"fund_id": 165,
		"net_asset_sum": 670047193680,
		"long_asset_sum": 671208023178,
		"num_equity_funds": 62,
		"equity_fund_net_assets": 437807095512,
		"equity_fund_long_assets": 437819319412,
		"num_e_sri": 15,
		"num_e_usf": 1,
		"sri_long_assets": 44475862860,
		"usf_long_assets": 13111848642,
		"equity_fund_sri_long_assets": 36971705592,
		"equity_fund_usf_long_assets": 6387650840,
		"sustainable_manager": 0,
		"num_c2_free": 20,
		"num_five_badgers": 7,
		"num_sri_badgers": 3,
		"num_fossil_A_grade": 7,
		"num_sri_fossil_A_grade": 3,
		"ff_all_count_sum": 2109,
		"ff_all_asset_sum": 32888496647,
		"ff_all_weight_total": 0.07511887938423983,
		"grade_fossil_fam": 4,
		"c2_count_sum": 467,
		"c2_asset_sum": 12892290313,
		"c2_weight_total": 0.0294465998675312,
		"mc50_count_sum": 128,
		"mc50_asset_sum": 4344956206,
		"mc50_weight_total": 0.009924085149635156,
		"co_count_sum": 511,
		"co_asset_sum": 5261152269,
		"co_weight_total": 0.012016720221633507,
		"og_count_sum": 1468,
		"og_asset_sum": 24835474250,
		"og_weight_total": 0.05672539595409936,
		"ut_count_sum": 898,
		"ut_asset_sum": 12595509853,
		"ut_weight_total": 0.02876873928248762,
		"cl_count_sum": 960,
		"cl_asset_sum": 84165795227,
		"cl_weight_total": 0.19223865072933813,
		"fossil_bank_count_sum": 306,
		"fossil_bank_asset_sum": 14636279445,
		"fossil_bank_weight_total": 0.033429953398714365,
		"fossil_insure_count_sum": 145,
		"fossil_insure_asset_sum": 7431064571,
		"fossil_insure_weight_total": 0.016972902385806243,
		"name": "TIAA Investments/Nuveen",
		"fund_family_name": "TIAA Investments/Nuveen",
		"label": "TIAA Investments/Nuveen"
	},
	{
		"fund_family_label": "JPMorgan",
		"as_of": "202506",
		"fund_id": 150,
		"net_asset_sum": 762571371376,
		"long_asset_sum": 766165742239,
		"num_equity_funds": 70,
		"equity_fund_net_assets": 383839415787,
		"equity_fund_long_assets": 384482689280,
		"num_e_sri": 3,
		"num_e_usf": 0,
		"sri_long_assets": 524591786,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 253096803,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 7,
		"num_five_badgers": 4,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 4,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1676,
		"ff_all_asset_sum": 31577851269,
		"ff_all_weight_total": 0.08213074905435701,
		"grade_fossil_fam": 4,
		"c2_count_sum": 480,
		"c2_asset_sum": 10351892493,
		"c2_weight_total": 0.026924209546040762,
		"mc50_count_sum": 95,
		"mc50_asset_sum": 3111631322,
		"mc50_weight_total": 0.008093033597499497,
		"co_count_sum": 366,
		"co_asset_sum": 3144086844,
		"co_weight_total": 0.008177447078014778,
		"og_count_sum": 1169,
		"og_asset_sum": 23644293105,
		"og_weight_total": 0.06149637880778818,
		"ut_count_sum": 723,
		"ut_asset_sum": 13104074100,
		"ut_weight_total": 0.0340823513395084,
		"cl_count_sum": 835,
		"cl_asset_sum": 58001626082,
		"cl_weight_total": 0.1508562744154139,
		"fossil_bank_count_sum": 324,
		"fossil_bank_asset_sum": 17542475703,
		"fossil_bank_weight_total": 0.04562617821845464,
		"fossil_insure_count_sum": 153,
		"fossil_insure_asset_sum": 6397202929,
		"fossil_insure_weight_total": 0.016638468017844178,
		"name": "JPMorgan",
		"fund_family_name": "JPMorgan",
		"label": "JPMorgan"
	},
	{
		"fund_family_label": "MFS",
		"as_of": "202506",
		"fund_id": 91,
		"net_asset_sum": 409957065586,
		"long_asset_sum": 418127043775,
		"num_equity_funds": 39,
		"equity_fund_net_assets": 289098825629,
		"equity_fund_long_assets": 289813409865,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 9,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 374,
		"ff_all_asset_sum": 25804057678,
		"ff_all_weight_total": 0.08903679677907232,
		"grade_fossil_fam": 4,
		"c2_count_sum": 112,
		"c2_asset_sum": 8454511309,
		"c2_weight_total": 0.02917225711860005,
		"mc50_count_sum": 32,
		"mc50_asset_sum": 2047999704,
		"mc50_weight_total": 0.007066614705489277,
		"co_count_sum": 58,
		"co_asset_sum": 2736539177,
		"co_weight_total": 0.0094424173756305,
		"og_count_sum": 274,
		"og_asset_sum": 20525679540,
		"og_weight_total": 0.07082377433660234,
		"ut_count_sum": 168,
		"ut_asset_sum": 11998143958,
		"ut_weight_total": 0.04139954725900689,
		"cl_count_sum": 234,
		"cl_asset_sum": 34850763990,
		"cl_weight_total": 0.12025242036327469,
		"fossil_bank_count_sum": 94,
		"fossil_bank_asset_sum": 11160789529,
		"fossil_bank_weight_total": 0.03851025918434514,
		"fossil_insure_count_sum": 53,
		"fossil_insure_asset_sum": 4279004783,
		"fossil_insure_weight_total": 0.0147646887181419,
		"name": "MFS",
		"fund_family_name": "MFS",
		"label": "MFS"
	},
	{
		"fund_family_label": "Franklin Templeton Investments",
		"as_of": "202506",
		"fund_id": 298,
		"net_asset_sum": 498232024906,
		"long_asset_sum": 530133926194,
		"num_equity_funds": 129,
		"equity_fund_net_assets": 287307397610,
		"equity_fund_long_assets": 293846826044,
		"num_e_sri": 10,
		"num_e_usf": 1,
		"sri_long_assets": 11452672051,
		"usf_long_assets": 95252393,
		"equity_fund_sri_long_assets": 8018459376,
		"equity_fund_usf_long_assets": 95252393,
		"sustainable_manager": 0,
		"num_c2_free": 42,
		"num_five_badgers": 15,
		"num_sri_badgers": 2,
		"num_fossil_A_grade": 14,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 1900,
		"ff_all_asset_sum": 25047826463,
		"ff_all_weight_total": 0.08524109924961173,
		"grade_fossil_fam": 4,
		"c2_count_sum": 548,
		"c2_asset_sum": 7396941823,
		"c2_weight_total": 0.02517278107980107,
		"mc50_count_sum": 172,
		"mc50_asset_sum": 3603991693,
		"mc50_weight_total": 0.012264865139160449,
		"co_count_sum": 483,
		"co_asset_sum": 2487203555,
		"co_weight_total": 0.008464285929117273,
		"og_count_sum": 1324,
		"og_asset_sum": 20057845897,
		"og_weight_total": 0.06825952884036454,
		"ut_count_sum": 858,
		"ut_asset_sum": 12874492753,
		"ut_weight_total": 0.04381361856558628,
		"cl_count_sum": 1222,
		"cl_asset_sum": 47800908222,
		"cl_weight_total": 0.16267287574800074,
		"fossil_bank_count_sum": 427,
		"fossil_bank_asset_sum": 9889752600,
		"fossil_bank_weight_total": 0.03365614913437632,
		"fossil_insure_count_sum": 184,
		"fossil_insure_asset_sum": 3296790809,
		"fossil_insure_weight_total": 0.011219419496150506,
		"name": "Franklin Templeton Investments",
		"fund_family_name": "Franklin Templeton Investments",
		"label": "Franklin Templeton Investments"
	},
	{
		"fund_family_label": "Dodge & Cox",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 288063699128,
		"long_asset_sum": 288099458604,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 190860370347,
		"equity_fund_long_assets": 190887155412,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 55,
		"ff_all_asset_sum": 12819528407,
		"ff_all_weight_total": 0.06715762712965709,
		"grade_fossil_fam": 4,
		"c2_count_sum": 27,
		"c2_asset_sum": 7543771599,
		"c2_weight_total": 0.03951953489336646,
		"mc50_count_sum": 5,
		"mc50_asset_sum": 917951797,
		"mc50_weight_total": 0.004808871477071074,
		"co_count_sum": 18,
		"co_asset_sum": 4698749897,
		"co_weight_total": 0.024615327767122334,
		"og_count_sum": 43,
		"og_asset_sum": 12151954828,
		"og_weight_total": 0.06366041131354234,
		"ut_count_sum": 16,
		"ut_asset_sum": 2013717277,
		"ut_weight_total": 0.010549254991273283,
		"cl_count_sum": 52,
		"cl_asset_sum": 31975902684,
		"cl_weight_total": 0.1675120707571184,
		"fossil_bank_count_sum": 19,
		"fossil_bank_asset_sum": 12848926260,
		"fossil_bank_weight_total": 0.06731163357884194,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 777718494,
		"fossil_insure_weight_total": 0.004074231670126869,
		"name": "Dodge & Cox",
		"fund_family_name": "Dodge & Cox",
		"label": "Dodge & Cox"
	},
	{
		"fund_family_label": "Janus Henderson",
		"as_of": "202506",
		"fund_id": 57,
		"net_asset_sum": 201605866479,
		"long_asset_sum": 204712166101,
		"num_equity_funds": 39,
		"equity_fund_net_assets": 155421980745,
		"equity_fund_long_assets": 155421980745,
		"num_e_sri": 4,
		"num_e_usf": 0,
		"sri_long_assets": 255944447,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 255944447,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 23,
		"num_five_badgers": 6,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 5,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 141,
		"ff_all_asset_sum": 5344320762,
		"ff_all_weight_total": 0.03438587474167118,
		"grade_fossil_fam": 3,
		"c2_count_sum": 43,
		"c2_asset_sum": 1615082948,
		"c2_weight_total": 0.010391599310845599,
		"mc50_count_sum": 7,
		"mc50_asset_sum": 87425383,
		"mc50_weight_total": 0.0005625033382082445,
		"co_count_sum": 27,
		"co_asset_sum": 1349167787,
		"co_weight_total": 0.008680675542371142,
		"og_count_sum": 116,
		"og_asset_sum": 4045959224,
		"og_weight_total": 0.0260320915008681,
		"ut_count_sum": 47,
		"ut_asset_sum": 2055449820,
		"ut_weight_total": 0.013224962197415084,
		"cl_count_sum": 225,
		"cl_asset_sum": 27064205530,
		"cl_weight_total": 0.1741337061866693,
		"fossil_bank_count_sum": 51,
		"fossil_bank_asset_sum": 2212841564,
		"fossil_bank_weight_total": 0.014237635843996848,
		"fossil_insure_count_sum": 19,
		"fossil_insure_asset_sum": 539674762,
		"fossil_insure_weight_total": 0.0034723194197701125,
		"name": "Janus Henderson",
		"fund_family_name": "Janus Henderson",
		"label": "Janus Henderson"
	},
	{
		"fund_family_label": "Columbia Threadneedle",
		"as_of": "202506",
		"fund_id": 105,
		"net_asset_sum": 210355283653,
		"long_asset_sum": 222507069680,
		"num_equity_funds": 56,
		"equity_fund_net_assets": 148291220899,
		"equity_fund_long_assets": 150929930810,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 17,
		"num_five_badgers": 9,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 7,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 641,
		"ff_all_asset_sum": 11807010931,
		"ff_all_weight_total": 0.07822842604932617,
		"grade_fossil_fam": 4,
		"c2_count_sum": 189,
		"c2_asset_sum": 4696400014,
		"c2_weight_total": 0.03111642593881608,
		"mc50_count_sum": 36,
		"mc50_asset_sum": 696286972,
		"mc50_weight_total": 0.0046133127356728825,
		"co_count_sum": 119,
		"co_asset_sum": 1535232271,
		"co_weight_total": 0.01017182120710468,
		"og_count_sum": 475,
		"og_asset_sum": 9308071981,
		"og_weight_total": 0.0616714784870443,
		"ut_count_sum": 255,
		"ut_asset_sum": 5095620487,
		"ut_weight_total": 0.03376149753500308,
		"cl_count_sum": 461,
		"cl_asset_sum": 24305665315,
		"cl_weight_total": 0.16103939877635992,
		"fossil_bank_count_sum": 140,
		"fossil_bank_asset_sum": 5157735405,
		"fossil_bank_weight_total": 0.03417304558028903,
		"fossil_insure_count_sum": 62,
		"fossil_insure_asset_sum": 1764645567,
		"fossil_insure_weight_total": 0.011691819889730459,
		"name": "Columbia Threadneedle",
		"fund_family_name": "Columbia Threadneedle",
		"label": "Columbia Threadneedle"
	},
	{
		"fund_family_label": "Jackson National",
		"as_of": "202506",
		"fund_id": 130,
		"net_asset_sum": 245228322524,
		"long_asset_sum": 249104104269,
		"num_equity_funds": 69,
		"equity_fund_net_assets": 146464315975,
		"equity_fund_long_assets": 146995860825,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 450619686,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 450619686,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 21,
		"num_five_badgers": 14,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 11,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1964,
		"ff_all_asset_sum": 12493739108,
		"ff_all_weight_total": 0.08499381572977703,
		"grade_fossil_fam": 4,
		"c2_count_sum": 537,
		"c2_asset_sum": 4443924642,
		"c2_weight_total": 0.030231631129331835,
		"mc50_count_sum": 112,
		"mc50_asset_sum": 1558406648,
		"mc50_weight_total": 0.010601704287818677,
		"co_count_sum": 415,
		"co_asset_sum": 1737957715,
		"co_weight_total": 0.011823174511485433,
		"og_count_sum": 1413,
		"og_asset_sum": 9608094554,
		"og_weight_total": 0.06536302791163984,
		"ut_count_sum": 785,
		"ut_asset_sum": 4870733505,
		"ut_weight_total": 0.033135174539361045,
		"cl_count_sum": 910,
		"cl_asset_sum": 24142560104,
		"cl_weight_total": 0.16423972735356102,
		"fossil_bank_count_sum": 264,
		"fossil_bank_asset_sum": 2632032705,
		"fossil_bank_weight_total": 0.017905488564289987,
		"fossil_insure_count_sum": 136,
		"fossil_insure_asset_sum": 1865027361,
		"fossil_insure_weight_total": 0.012687618212735481,
		"name": "Jackson National",
		"fund_family_name": "Jackson National",
		"label": "Jackson National"
	},
	{
		"fund_family_label": "First Trust",
		"as_of": "202506",
		"fund_id": 293,
		"net_asset_sum": 202217996469,
		"long_asset_sum": 206340399002,
		"num_equity_funds": 128,
		"equity_fund_net_assets": 112598866810,
		"equity_fund_long_assets": 112611117820,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 4709562080,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 4709562080,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 55,
		"num_five_badgers": 31,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 29,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1616,
		"ff_all_asset_sum": 12249443630,
		"ff_all_weight_total": 0.1087765033074245,
		"grade_fossil_fam": 5,
		"c2_count_sum": 446,
		"c2_asset_sum": 2933938860,
		"c2_weight_total": 0.026053722907623297,
		"mc50_count_sum": 101,
		"mc50_asset_sum": 1066468269,
		"mc50_weight_total": 0.009470363936042846,
		"co_count_sum": 331,
		"co_asset_sum": 2094112649,
		"co_weight_total": 0.018595967161495315,
		"og_count_sum": 1171,
		"og_asset_sum": 8913533463,
		"og_weight_total": 0.07915322781226256,
		"ut_count_sum": 694,
		"ut_asset_sum": 6025580332,
		"ut_weight_total": 0.05350786359861391,
		"cl_count_sum": 694,
		"cl_asset_sum": 11530935904,
		"cl_weight_total": 0.1023960700082144,
		"fossil_bank_count_sum": 193,
		"fossil_bank_asset_sum": 1402049001,
		"fossil_bank_weight_total": 0.012450360391955836,
		"fossil_insure_count_sum": 115,
		"fossil_insure_asset_sum": 1653505929,
		"fossil_insure_weight_total": 0.01468332755246244,
		"name": "First Trust",
		"fund_family_name": "First Trust",
		"label": "First Trust"
	},
	{
		"fund_family_label": "Principal Funds",
		"as_of": "202506",
		"fund_id": 85,
		"net_asset_sum": 193936820111,
		"long_asset_sum": 199376403565,
		"num_equity_funds": 35,
		"equity_fund_net_assets": 111510420692,
		"equity_fund_long_assets": 112124189481,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 22969209,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 22969209,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 7,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 838,
		"ff_all_asset_sum": 10051771726,
		"ff_all_weight_total": 0.08964855641345192,
		"grade_fossil_fam": 4,
		"c2_count_sum": 237,
		"c2_asset_sum": 1428302358,
		"c2_weight_total": 0.01273857465201149,
		"mc50_count_sum": 32,
		"mc50_asset_sum": 532971013,
		"mc50_weight_total": 0.004753399025375471,
		"co_count_sum": 122,
		"co_asset_sum": 413154804,
		"co_weight_total": 0.0036847963486952217,
		"og_count_sum": 657,
		"og_asset_sum": 8166799688,
		"og_weight_total": 0.07283709006774051,
		"ut_count_sum": 278,
		"ut_asset_sum": 2898429864,
		"ut_weight_total": 0.02585017450218584,
		"cl_count_sum": 354,
		"cl_asset_sum": 12711023062,
		"cl_weight_total": 0.11336557366288874,
		"fossil_bank_count_sum": 91,
		"fossil_bank_asset_sum": 1915583922,
		"fossil_bank_weight_total": 0.01708448400712502,
		"fossil_insure_count_sum": 63,
		"fossil_insure_asset_sum": 1373510643,
		"fossil_insure_weight_total": 0.012249904765044015,
		"name": "Principal Funds",
		"fund_family_name": "Principal Funds",
		"label": "Principal Funds"
	},
	{
		"fund_family_label": "Goldman Sachs",
		"as_of": "202506",
		"fund_id": 119,
		"net_asset_sum": 191770699579,
		"long_asset_sum": 215737067814,
		"num_equity_funds": 62,
		"equity_fund_net_assets": 108838033717,
		"equity_fund_long_assets": 108941029259,
		"num_e_sri": 4,
		"num_e_usf": 0,
		"sri_long_assets": 2023000445,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 2013329933,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 12,
		"num_five_badgers": 4,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 4,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1923,
		"ff_all_asset_sum": 17590858272,
		"ff_all_weight_total": 0.1614713794394113,
		"grade_fossil_fam": 5,
		"c2_count_sum": 486,
		"c2_asset_sum": 6841857097,
		"c2_weight_total": 0.06280330875830026,
		"mc50_count_sum": 148,
		"mc50_asset_sum": 1430438868,
		"mc50_weight_total": 0.013130396120998889,
		"co_count_sum": 497,
		"co_asset_sum": 4292398628,
		"co_weight_total": 0.039401120562163126,
		"og_count_sum": 1357,
		"og_asset_sum": 12471757654,
		"og_weight_total": 0.11448173143608945,
		"ut_count_sum": 852,
		"ut_asset_sum": 5635371173,
		"ut_weight_total": 0.05172863898322718,
		"cl_count_sum": 983,
		"cl_asset_sum": 19164195036,
		"cl_weight_total": 0.17591347508236232,
		"fossil_bank_count_sum": 344,
		"fossil_bank_asset_sum": 6157212968,
		"fossil_bank_weight_total": 0.05651876992424625,
		"fossil_insure_count_sum": 170,
		"fossil_insure_asset_sum": 2241614810,
		"fossil_insure_weight_total": 0.02057640565035154,
		"name": "Goldman Sachs",
		"fund_family_name": "Goldman Sachs",
		"label": "Goldman Sachs"
	},
	{
		"fund_family_label": "John Hancock",
		"as_of": "202506",
		"fund_id": 110,
		"net_asset_sum": 186974949822,
		"long_asset_sum": 188744725757,
		"num_equity_funds": 46,
		"equity_fund_net_assets": 99778268122,
		"equity_fund_long_assets": 99934079252,
		"num_e_sri": 3,
		"num_e_usf": 0,
		"sri_long_assets": 180047186,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 180047186,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 14,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1107,
		"ff_all_asset_sum": 9994458678,
		"ff_all_weight_total": 0.10001051445921016,
		"grade_fossil_fam": 5,
		"c2_count_sum": 301,
		"c2_asset_sum": 3426190914,
		"c2_weight_total": 0.03428450974527222,
		"mc50_count_sum": 71,
		"mc50_asset_sum": 861771039,
		"mc50_weight_total": 0.008623394996484677,
		"co_count_sum": 241,
		"co_asset_sum": 1321094063,
		"co_weight_total": 0.013219655125541777,
		"og_count_sum": 820,
		"og_asset_sum": 8282922731,
		"og_weight_total": 0.08288386497376202,
		"ut_count_sum": 459,
		"ut_asset_sum": 3628212935,
		"ut_weight_total": 0.03630606257802078,
		"cl_count_sum": 578,
		"cl_asset_sum": 10693148602,
		"cl_weight_total": 0.1070020225536425,
		"fossil_bank_count_sum": 199,
		"fossil_bank_asset_sum": 2885606845,
		"fossil_bank_weight_total": 0.028875103133971687,
		"fossil_insure_count_sum": 82,
		"fossil_insure_asset_sum": 1192491959,
		"fossil_insure_weight_total": 0.0119327857716379,
		"name": "John Hancock",
		"fund_family_name": "John Hancock",
		"label": "John Hancock"
	},
	{
		"fund_family_label": "American Century Investments",
		"as_of": "202506",
		"fund_id": 95,
		"net_asset_sum": 147175951989,
		"long_asset_sum": 149636714110,
		"num_equity_funds": 39,
		"equity_fund_net_assets": 99559209243,
		"equity_fund_long_assets": 99587141388,
		"num_e_sri": 5,
		"num_e_usf": 0,
		"sri_long_assets": 5100326141,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 5100326141,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 14,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 315,
		"ff_all_asset_sum": 6128340504,
		"ff_all_weight_total": 0.06153746777531712,
		"grade_fossil_fam": 4,
		"c2_count_sum": 82,
		"c2_asset_sum": 1714801113,
		"c2_weight_total": 0.01721910167417085,
		"mc50_count_sum": 21,
		"mc50_asset_sum": 720097121,
		"mc50_weight_total": 0.007230824290803169,
		"co_count_sum": 36,
		"co_asset_sum": 532498557,
		"co_weight_total": 0.0053470613733688785,
		"og_count_sum": 246,
		"og_asset_sum": 4513807209,
		"og_weight_total": 0.04532520108609024,
		"ut_count_sum": 118,
		"ut_asset_sum": 2423334475,
		"ut_weight_total": 0.024333808975984982,
		"cl_count_sum": 284,
		"cl_asset_sum": 19392946206,
		"cl_weight_total": 0.1947334358202273,
		"fossil_bank_count_sum": 89,
		"fossil_bank_asset_sum": 1650887432,
		"fossil_bank_weight_total": 0.016577315193414394,
		"fossil_insure_count_sum": 37,
		"fossil_insure_asset_sum": 617863474,
		"fossil_insure_weight_total": 0.006204249518446877,
		"name": "American Century Investments",
		"fund_family_name": "American Century Investments",
		"label": "American Century Investments"
	},
	{
		"fund_family_label": "Bridge Builder",
		"as_of": "202506",
		"fund_id": 12,
		"net_asset_sum": 201178879229,
		"long_asset_sum": 211350317026,
		"num_equity_funds": 8,
		"equity_fund_net_assets": 98166979950,
		"equity_fund_long_assets": 98166979950,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 594,
		"ff_all_asset_sum": 6889148157,
		"ff_all_weight_total": 0.07017785573630657,
		"grade_fossil_fam": 4,
		"c2_count_sum": 164,
		"c2_asset_sum": 2492098652,
		"c2_weight_total": 0.025386322908877466,
		"mc50_count_sum": 21,
		"mc50_asset_sum": 314501311,
		"mc50_weight_total": 0.003203738274928972,
		"co_count_sum": 88,
		"co_asset_sum": 863855276,
		"co_weight_total": 0.008799855882701014,
		"og_count_sum": 466,
		"og_asset_sum": 5650381653,
		"og_weight_total": 0.05755888238466686,
		"ut_count_sum": 195,
		"ut_asset_sum": 2566911495,
		"ut_weight_total": 0.026148420745014476,
		"cl_count_sum": 270,
		"cl_asset_sum": 13651600807,
		"cl_weight_total": 0.13906509922127844,
		"fossil_bank_count_sum": 73,
		"fossil_bank_asset_sum": 3341433053,
		"fossil_bank_weight_total": 0.03403825863545882,
		"fossil_insure_count_sum": 45,
		"fossil_insure_asset_sum": 1497822919,
		"fossil_insure_weight_total": 0.01525790973464698,
		"name": "Bridge Builder",
		"fund_family_name": "Bridge Builder",
		"label": "Bridge Builder"
	},
	{
		"fund_family_label": "Hartford Mutual Funds",
		"as_of": "202506",
		"fund_id": 81,
		"net_asset_sum": 139567054868,
		"long_asset_sum": 146061631266,
		"num_equity_funds": 49,
		"equity_fund_net_assets": 96172012082,
		"equity_fund_long_assets": 96172616460,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 453587878,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 377167845,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 11,
		"num_five_badgers": 4,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 640,
		"ff_all_asset_sum": 9109966213,
		"ff_all_weight_total": 0.09472515720510741,
		"grade_fossil_fam": 5,
		"c2_count_sum": 218,
		"c2_asset_sum": 3443544148,
		"c2_weight_total": 0.03580586943303383,
		"mc50_count_sum": 45,
		"mc50_asset_sum": 906031617,
		"mc50_weight_total": 0.009420889753756836,
		"co_count_sum": 117,
		"co_asset_sum": 867829905,
		"co_weight_total": 0.009023669490794677,
		"og_count_sum": 459,
		"og_asset_sum": 7242184748,
		"og_weight_total": 0.07530402119206314,
		"ut_count_sum": 280,
		"ut_asset_sum": 3540330786,
		"ut_weight_total": 0.03681225401070886,
		"cl_count_sum": 504,
		"cl_asset_sum": 15034273851,
		"cl_weight_total": 0.15632593148022583,
		"fossil_bank_count_sum": 173,
		"fossil_bank_asset_sum": 3968880681,
		"fossil_bank_weight_total": 0.04126830304810031,
		"fossil_insure_count_sum": 83,
		"fossil_insure_asset_sum": 1486466481,
		"fossil_insure_weight_total": 0.01545623417262698,
		"name": "Hartford Mutual Funds",
		"fund_family_name": "Hartford Mutual Funds",
		"label": "Hartford Mutual Funds"
	},
	{
		"fund_family_label": "Victory Capital",
		"as_of": "202506",
		"fund_id": 114,
		"net_asset_sum": 141627149948,
		"long_asset_sum": 146490416004,
		"num_equity_funds": 69,
		"equity_fund_net_assets": 89045396123,
		"equity_fund_long_assets": 89176997424,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 2532717605,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 2532717605,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 8,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1278,
		"ff_all_asset_sum": 8142189569,
		"ff_all_weight_total": 0.09130369718871821,
		"grade_fossil_fam": 5,
		"c2_count_sum": 419,
		"c2_asset_sum": 3309191569,
		"c2_weight_total": 0.03710812950189558,
		"mc50_count_sum": 81,
		"mc50_asset_sum": 736099631,
		"mc50_weight_total": 0.00825436662214751,
		"co_count_sum": 218,
		"co_asset_sum": 1226476623,
		"co_weight_total": 0.013753284573695696,
		"og_count_sum": 955,
		"og_asset_sum": 6281565289,
		"og_weight_total": 0.07043930016093429,
		"ut_count_sum": 481,
		"ut_asset_sum": 2944257004,
		"ut_weight_total": 0.03301587953226623,
		"cl_count_sum": 712,
		"cl_asset_sum": 11678870035,
		"cl_weight_total": 0.1309628084860468,
		"fossil_bank_count_sum": 289,
		"fossil_bank_asset_sum": 1637369491,
		"fossil_bank_weight_total": 0.01836089505475252,
		"fossil_insure_count_sum": 136,
		"fossil_insure_asset_sum": 1195302028,
		"fossil_insure_weight_total": 0.013403703449633202,
		"name": "Victory Capital",
		"fund_family_name": "Victory Capital",
		"label": "Victory Capital"
	},
	{
		"fund_family_label": "First Eagle",
		"as_of": "202506",
		"fund_id": 13,
		"net_asset_sum": 87430477989,
		"long_asset_sum": 92621067299,
		"num_equity_funds": 11,
		"equity_fund_net_assets": 80304343667,
		"equity_fund_long_assets": 85494932977,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 99,
		"ff_all_asset_sum": 5966620778,
		"ff_all_weight_total": 0.06978917428480996,
		"grade_fossil_fam": 4,
		"c2_count_sum": 28,
		"c2_asset_sum": 2518578823,
		"c2_weight_total": 0.029458808087229598,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 568839737,
		"mc50_weight_total": 0.006653490647837928,
		"co_count_sum": 12,
		"co_asset_sum": 88973508,
		"co_weight_total": 0.0010406874992689428,
		"og_count_sum": 78,
		"og_asset_sum": 4770381233,
		"og_weight_total": 0.05579723928531924,
		"ut_count_sum": 19,
		"ut_asset_sum": 1134776952,
		"ut_weight_total": 0.01327303165797299,
		"cl_count_sum": 54,
		"cl_asset_sum": 5673292611,
		"cl_weight_total": 0.06635823216010052,
		"fossil_bank_count_sum": 15,
		"fossil_bank_asset_sum": 910141968,
		"fossil_bank_weight_total": 0.010645566190979389,
		"fossil_insure_count_sum": 15,
		"fossil_insure_asset_sum": 1869447717,
		"fossil_insure_weight_total": 0.02186618144379296,
		"name": "First Eagle",
		"fund_family_name": "First Eagle",
		"label": "First Eagle"
	},
	{
		"fund_family_label": "Six Circles",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 102595619530,
		"long_asset_sum": 123361279384,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 67201968583,
		"equity_fund_long_assets": 67676867710,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 312,
		"ff_all_asset_sum": 4811295917,
		"ff_all_weight_total": 0.07109217787112625,
		"grade_fossil_fam": 4,
		"c2_count_sum": 91,
		"c2_asset_sum": 2310357990,
		"c2_weight_total": 0.03413807506428994,
		"mc50_count_sum": 15,
		"mc50_asset_sum": 471453554,
		"mc50_weight_total": 0.006966243710040049,
		"co_count_sum": 61,
		"co_asset_sum": 417587994,
		"co_weight_total": 0.006170320940227215,
		"og_count_sum": 234,
		"og_asset_sum": 3964747996,
		"og_weight_total": 0.05858350319919084,
		"ut_count_sum": 142,
		"ut_asset_sum": 1282957313,
		"ut_weight_total": 0.018957102425271214,
		"cl_count_sum": 227,
		"cl_asset_sum": 14494650979,
		"cl_weight_total": 0.21417437699851255,
		"fossil_bank_count_sum": 78,
		"fossil_bank_asset_sum": 4882576555,
		"fossil_bank_weight_total": 0.07214542753252373,
		"fossil_insure_count_sum": 35,
		"fossil_insure_asset_sum": 1712153494,
		"fossil_insure_weight_total": 0.025298947069132906,
		"name": "Six Circles",
		"fund_family_name": "Six Circles",
		"label": "Six Circles"
	},
	{
		"fund_family_label": "VanEck",
		"as_of": "202506",
		"fund_id": 77,
		"net_asset_sum": 86560721801,
		"long_asset_sum": 86865222498,
		"num_equity_funds": 47,
		"equity_fund_net_assets": 65903238455,
		"equity_fund_long_assets": 66207259754,
		"num_e_sri": 5,
		"num_e_usf": 0,
		"sri_long_assets": 378713969,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 239864101,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 33,
		"num_five_badgers": 20,
		"num_sri_badgers": 2,
		"num_fossil_A_grade": 15,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 270,
		"ff_all_asset_sum": 2903161670,
		"ff_all_weight_total": 0.04384959717086919,
		"grade_fossil_fam": 3,
		"c2_count_sum": 73,
		"c2_asset_sum": 231158682,
		"c2_weight_total": 0.003491440105796468,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 5055807,
		"mc50_weight_total": 0.00007636333264335935,
		"co_count_sum": 52,
		"co_asset_sum": 145631748,
		"co_weight_total": 0.0021996341268481732,
		"og_count_sum": 211,
		"og_asset_sum": 2500930274,
		"og_weight_total": 0.03777426045561269,
		"ut_count_sum": 64,
		"ut_asset_sum": 529130750,
		"ut_weight_total": 0.007992035193210543,
		"cl_count_sum": 147,
		"cl_asset_sum": 11022290834,
		"cl_weight_total": 0.16648160450915012,
		"fossil_bank_count_sum": 11,
		"fossil_bank_asset_sum": 320216751,
		"fossil_bank_weight_total": 0.004836580643720928,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "VanEck",
		"fund_family_name": "VanEck",
		"label": "VanEck"
	},
	{
		"fund_family_label": "Avantis Investors",
		"as_of": "202506",
		"fund_id": 38,
		"net_asset_sum": 68751293660,
		"long_asset_sum": 69078630442,
		"num_equity_funds": 28,
		"equity_fund_net_assets": 65769512892,
		"equity_fund_long_assets": 65769582231,
		"num_e_sri": 3,
		"num_e_usf": 0,
		"sri_long_assets": 667608581,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 667608581,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3002,
		"ff_all_asset_sum": 7793854458,
		"ff_all_weight_total": 0.11850241697789628,
		"grade_fossil_fam": 5,
		"c2_count_sum": 627,
		"c2_asset_sum": 3107228598,
		"c2_weight_total": 0.04724415896525843,
		"mc50_count_sum": 87,
		"mc50_asset_sum": 279609740,
		"mc50_weight_total": 0.0042513534450916435,
		"co_count_sum": 644,
		"co_asset_sum": 1400307290,
		"co_weight_total": 0.0212911081764478,
		"og_count_sum": 2174,
		"og_asset_sum": 6242638093,
		"og_weight_total": 0.09491679711563653,
		"ut_count_sum": 876,
		"ut_asset_sum": 1501124519,
		"ut_weight_total": 0.022823993525269134,
		"cl_count_sum": 799,
		"cl_asset_sum": 4687316937,
		"cl_weight_total": 0.07126876555999573,
		"fossil_bank_count_sum": 201,
		"fossil_bank_asset_sum": 1494400582,
		"fossil_bank_weight_total": 0.022721758772182462,
		"fossil_insure_count_sum": 115,
		"fossil_insure_asset_sum": 821128570,
		"fossil_insure_weight_total": 0.012484929083417032,
		"name": "Avantis Investors",
		"fund_family_name": "Avantis Investors",
		"label": "Avantis Investors"
	},
	{
		"fund_family_label": "Artisan Partners Funds",
		"as_of": "202506",
		"fund_id": 21,
		"net_asset_sum": 71830893226,
		"long_asset_sum": 71924277469,
		"num_equity_funds": 17,
		"equity_fund_net_assets": 61877488362,
		"equity_fund_long_assets": 61939634998,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 230414621,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 230414621,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 10,
		"num_five_badgers": 4,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 4,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 51,
		"ff_all_asset_sum": 1955054490,
		"ff_all_weight_total": 0.03156386843518093,
		"grade_fossil_fam": 3,
		"c2_count_sum": 11,
		"c2_asset_sum": 918684197,
		"c2_weight_total": 0.014831927844419229,
		"mc50_count_sum": 5,
		"mc50_asset_sum": 117409344,
		"mc50_weight_total": 0.0018955446541425549,
		"co_count_sum": 6,
		"co_asset_sum": 42248823,
		"co_weight_total": 0.0006820967382414215,
		"og_count_sum": 39,
		"og_asset_sum": 1745021978,
		"og_weight_total": 0.02817294577303121,
		"ut_count_sum": 20,
		"ut_asset_sum": 553750127,
		"ut_weight_total": 0.00894015805901795,
		"cl_count_sum": 32,
		"cl_asset_sum": 3179042802,
		"cl_weight_total": 0.05132485527405271,
		"fossil_bank_count_sum": 26,
		"fossil_bank_asset_sum": 2786191391,
		"fossil_bank_weight_total": 0.044982366962446015,
		"fossil_insure_count_sum": 10,
		"fossil_insure_asset_sum": 462516729,
		"fossil_insure_weight_total": 0.007467217541965406,
		"name": "Artisan Partners Funds",
		"fund_family_name": "Artisan Partners Funds",
		"label": "Artisan Partners Funds"
	},
	{
		"fund_family_label": "Transamerica",
		"as_of": "202506",
		"fund_id": 50,
		"net_asset_sum": 78898723461,
		"long_asset_sum": 79156219178,
		"num_equity_funds": 23,
		"equity_fund_net_assets": 61743009593,
		"equity_fund_long_assets": 61998802093,
		"num_e_sri": 4,
		"num_e_usf": 0,
		"sri_long_assets": 344530981,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 344530981,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 8,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 249,
		"ff_all_asset_sum": 5253716744,
		"ff_all_weight_total": 0.08473900408784145,
		"grade_fossil_fam": 4,
		"c2_count_sum": 61,
		"c2_asset_sum": 1501248025,
		"c2_weight_total": 0.02421414566604181,
		"mc50_count_sum": 19,
		"mc50_asset_sum": 1238808345,
		"mc50_weight_total": 0.019981165815780626,
		"co_count_sum": 35,
		"co_asset_sum": 431844250,
		"co_weight_total": 0.006965364417077302,
		"og_count_sum": 198,
		"og_asset_sum": 3611394515,
		"og_weight_total": 0.05824942407085226,
		"ut_count_sum": 86,
		"ut_asset_sum": 2330039264,
		"ut_weight_total": 0.03758200457655413,
		"cl_count_sum": 188,
		"cl_asset_sum": 13330703934,
		"cl_weight_total": 0.21501550810616563,
		"fossil_bank_count_sum": 58,
		"fossil_bank_asset_sum": 1647547973,
		"fossil_bank_weight_total": 0.026573867839069377,
		"fossil_insure_count_sum": 23,
		"fossil_insure_asset_sum": 1347166431,
		"fossil_insure_weight_total": 0.02172891064861562,
		"name": "Transamerica",
		"fund_family_name": "Transamerica",
		"label": "Transamerica"
	},
	{
		"fund_family_label": "WisdomTree",
		"as_of": "202506",
		"fund_id": 91,
		"net_asset_sum": 81276459535,
		"long_asset_sum": 81280414577,
		"num_equity_funds": 58,
		"equity_fund_net_assets": 59734390775,
		"equity_fund_long_assets": 59734390775,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 12,
		"num_five_badgers": 5,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 5,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1985,
		"ff_all_asset_sum": 7029518355,
		"ff_all_weight_total": 0.11767958564234642,
		"grade_fossil_fam": 5,
		"c2_count_sum": 462,
		"c2_asset_sum": 3267497150,
		"c2_weight_total": 0.05470043483506173,
		"mc50_count_sum": 98,
		"mc50_asset_sum": 479183241,
		"mc50_weight_total": 0.008021898855634558,
		"co_count_sum": 483,
		"co_asset_sum": 1689726367,
		"co_weight_total": 0.028287329042404552,
		"og_count_sum": 1349,
		"og_asset_sum": 5259336589,
		"og_weight_total": 0.08804537086199152,
		"ut_count_sum": 861,
		"ut_asset_sum": 2478573923,
		"ut_weight_total": 0.04149324854313792,
		"cl_count_sum": 820,
		"cl_asset_sum": 7811334064,
		"cl_weight_total": 0.13076778657411528,
		"fossil_bank_count_sum": 263,
		"fossil_bank_asset_sum": 2348488083,
		"fossil_bank_weight_total": 0.03931551075570503,
		"fossil_insure_count_sum": 131,
		"fossil_insure_asset_sum": 704521175,
		"fossil_insure_weight_total": 0.01179423052381503,
		"name": "WisdomTree",
		"fund_family_name": "WisdomTree",
		"label": "WisdomTree"
	},
	{
		"fund_family_label": "AllianceBernstein",
		"as_of": "202506",
		"fund_id": 72,
		"net_asset_sum": 116120996188,
		"long_asset_sum": 126766422994,
		"num_equity_funds": 35,
		"equity_fund_net_assets": 59348686513,
		"equity_fund_long_assets": 59350899131,
		"num_e_sri": 4,
		"num_e_usf": 0,
		"sri_long_assets": 3409949696,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 2515605813,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 11,
		"num_five_badgers": 4,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 240,
		"ff_all_asset_sum": 2012786078,
		"ff_all_weight_total": 0.03391332073263718,
		"grade_fossil_fam": 3,
		"c2_count_sum": 65,
		"c2_asset_sum": 625904901,
		"c2_weight_total": 0.010545836881400825,
		"mc50_count_sum": 19,
		"mc50_asset_sum": 205098358,
		"mc50_weight_total": 0.003455690832034482,
		"co_count_sum": 55,
		"co_asset_sum": 241290921,
		"co_weight_total": 0.004065497313990473,
		"og_count_sum": 178,
		"og_asset_sum": 1744246618,
		"og_weight_total": 0.029388714299847057,
		"ut_count_sum": 93,
		"ut_asset_sum": 807605146,
		"ut_weight_total": 0.013607294208255287,
		"cl_count_sum": 232,
		"cl_asset_sum": 8122312125,
		"cl_weight_total": 0.13685238545539702,
		"fossil_bank_count_sum": 75,
		"fossil_bank_asset_sum": 1672800878,
		"fossil_bank_weight_total": 0.028184928998426364,
		"fossil_insure_count_sum": 23,
		"fossil_insure_asset_sum": 244034324,
		"fossil_insure_weight_total": 0.004111720758625149,
		"name": "AllianceBernstein",
		"fund_family_name": "AllianceBernstein",
		"label": "AllianceBernstein"
	},
	{
		"fund_family_label": "Oakmark",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 53970181095,
		"long_asset_sum": 53970181095,
		"num_equity_funds": 8,
		"equity_fund_net_assets": 53775217371,
		"equity_fund_long_assets": 53775217371,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 20,
		"ff_all_asset_sum": 4314136384,
		"ff_all_weight_total": 0.08022536392993802,
		"grade_fossil_fam": 4,
		"c2_count_sum": 13,
		"c2_asset_sum": 2602300888,
		"c2_weight_total": 0.04839219654002503,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 3,
		"co_asset_sum": 420294966,
		"co_weight_total": 0.007815774376147059,
		"og_count_sum": 17,
		"og_asset_sum": 3893841418,
		"og_weight_total": 0.07240958955379097,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 26,
		"cl_asset_sum": 4632182372,
		"cl_weight_total": 0.08613972380701249,
		"fossil_bank_count_sum": 14,
		"fossil_bank_asset_sum": 2896976946,
		"fossil_bank_weight_total": 0.05387197091205599,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 1264646385,
		"fossil_insure_weight_total": 0.02351727146494067,
		"name": "Oakmark",
		"fund_family_name": "Oakmark",
		"label": "Oakmark"
	},
	{
		"fund_family_label": "Macquarie",
		"as_of": "202506",
		"fund_id": 53,
		"net_asset_sum": 68568424056,
		"long_asset_sum": 68910276454,
		"num_equity_funds": 28,
		"equity_fund_net_assets": 51382814814,
		"equity_fund_long_assets": 51395324463,
		"num_e_sri": 3,
		"num_e_usf": 0,
		"sri_long_assets": 106686296,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 106686296,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 7,
		"num_five_badgers": 5,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 5,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 220,
		"ff_all_asset_sum": 2780591867,
		"ff_all_weight_total": 0.0541020393596654,
		"grade_fossil_fam": 3,
		"c2_count_sum": 85,
		"c2_asset_sum": 966007922,
		"c2_weight_total": 0.01879563816540235,
		"mc50_count_sum": 14,
		"mc50_asset_sum": 141773573,
		"mc50_weight_total": 0.0027584916426019296,
		"co_count_sum": 38,
		"co_asset_sum": 448722396,
		"co_weight_total": 0.008730801890803115,
		"og_count_sum": 172,
		"og_asset_sum": 2117553310,
		"og_weight_total": 0.041201283037418074,
		"ut_count_sum": 77,
		"ut_asset_sum": 752901633,
		"ut_weight_total": 0.014649224241049811,
		"cl_count_sum": 136,
		"cl_asset_sum": 7346016840,
		"cl_weight_total": 0.14293161716078803,
		"fossil_bank_count_sum": 30,
		"fossil_bank_asset_sum": 607797844,
		"fossil_bank_weight_total": 0.01182593650979983,
		"fossil_insure_count_sum": 9,
		"fossil_insure_asset_sum": 208612465,
		"fossil_insure_weight_total": 0.004058977488315735,
		"name": "Macquarie",
		"fund_family_name": "Macquarie",
		"label": "Macquarie"
	},
	{
		"fund_family_label": "SEI",
		"as_of": "202506",
		"fund_id": 92,
		"net_asset_sum": 91844295099,
		"long_asset_sum": 93688228209,
		"num_equity_funds": 41,
		"equity_fund_net_assets": 46547284263,
		"equity_fund_long_assets": 46989798490,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1697,
		"ff_all_asset_sum": 2935555476,
		"ff_all_weight_total": 0.062472186949784896,
		"grade_fossil_fam": 4,
		"c2_count_sum": 440,
		"c2_asset_sum": 1019809805,
		"c2_weight_total": 0.02170279162225026,
		"mc50_count_sum": 112,
		"mc50_asset_sum": 495790928,
		"mc50_weight_total": 0.010551033286629444,
		"co_count_sum": 304,
		"co_asset_sum": 419393131,
		"co_weight_total": 0.00892519535041743,
		"og_count_sum": 1239,
		"og_asset_sum": 2117888546,
		"og_weight_total": 0.04507124129188833,
		"ut_count_sum": 687,
		"ut_asset_sum": 1234608926,
		"ut_weight_total": 0.026273977877618263,
		"cl_count_sum": 915,
		"cl_asset_sum": 7012140917,
		"cl_weight_total": 0.14922687779757704,
		"fossil_bank_count_sum": 256,
		"fossil_bank_asset_sum": 1560996351,
		"fossil_bank_weight_total": 0.03321989881127494,
		"fossil_insure_count_sum": 162,
		"fossil_insure_asset_sum": 630260808,
		"fossil_insure_weight_total": 0.013412715701135156,
		"name": "SEI",
		"fund_family_name": "SEI",
		"label": "SEI"
	},
	{
		"fund_family_label": "Eaton Vance",
		"as_of": "202506",
		"fund_id": 79,
		"net_asset_sum": 109459132046,
		"long_asset_sum": 113910948828,
		"num_equity_funds": 30,
		"equity_fund_net_assets": 45342583050,
		"equity_fund_long_assets": 45351219447,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 10,
		"num_five_badgers": 7,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 7,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 651,
		"ff_all_asset_sum": 2216272170,
		"ff_all_weight_total": 0.04886907556234648,
		"grade_fossil_fam": 3,
		"c2_count_sum": 157,
		"c2_asset_sum": 745722441,
		"c2_weight_total": 0.01644327209043394,
		"mc50_count_sum": 48,
		"mc50_asset_sum": 764883209,
		"mc50_weight_total": 0.016865769395548135,
		"co_count_sum": 164,
		"co_asset_sum": 134124473,
		"co_weight_total": 0.0029574612245376435,
		"og_count_sum": 455,
		"og_asset_sum": 1446336260,
		"og_weight_total": 0.031891893484590206,
		"ut_count_sum": 295,
		"ut_asset_sum": 1118176104,
		"ut_weight_total": 0.02465592144234983,
		"cl_count_sum": 305,
		"cl_asset_sum": 5558106626,
		"cl_weight_total": 0.12255693879401672,
		"fossil_bank_count_sum": 82,
		"fossil_bank_asset_sum": 650047307,
		"fossil_bank_weight_total": 0.014333623548087435,
		"fossil_insure_count_sum": 46,
		"fossil_insure_asset_sum": 747309681,
		"fossil_insure_weight_total": 0.0164782709288192,
		"name": "Eaton Vance",
		"fund_family_name": "Eaton Vance",
		"label": "Eaton Vance"
	},
	{
		"fund_family_label": "Voya",
		"as_of": "202506",
		"fund_id": 118,
		"net_asset_sum": 81886279771,
		"long_asset_sum": 86149446366,
		"num_equity_funds": 57,
		"equity_fund_net_assets": 44793501311,
		"equity_fund_long_assets": 45197713006,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 6,
		"num_five_badgers": 4,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 4,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1442,
		"ff_all_asset_sum": 3332351780,
		"ff_all_weight_total": 0.07372832735049294,
		"grade_fossil_fam": 4,
		"c2_count_sum": 400,
		"c2_asset_sum": 1101398462,
		"c2_weight_total": 0.02436845558654238,
		"mc50_count_sum": 81,
		"mc50_asset_sum": 544613023,
		"mc50_weight_total": 0.01204957036051144,
		"co_count_sum": 286,
		"co_asset_sum": 473974593,
		"co_weight_total": 0.01048669415943855,
		"og_count_sum": 1031,
		"og_asset_sum": 2467898621,
		"og_weight_total": 0.0546022897369251,
		"ut_count_sum": 583,
		"ut_asset_sum": 1521799743,
		"ut_weight_total": 0.033669839507100306,
		"cl_count_sum": 646,
		"cl_asset_sum": 6881171027,
		"cl_weight_total": 0.15224600028073376,
		"fossil_bank_count_sum": 220,
		"fossil_bank_asset_sum": 1113377970,
		"fossil_bank_weight_total": 0.02463350236000213,
		"fossil_insure_count_sum": 105,
		"fossil_insure_asset_sum": 721765517,
		"fossil_insure_weight_total": 0.015969071640951956,
		"name": "Voya",
		"fund_family_name": "Voya",
		"label": "Voya"
	},
	{
		"fund_family_label": "BNY Mellon",
		"as_of": "202506",
		"fund_id": 77,
		"net_asset_sum": 64164572122,
		"long_asset_sum": 67896455871,
		"num_equity_funds": 45,
		"equity_fund_net_assets": 40199766184,
		"equity_fund_long_assets": 40216108802,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 445148992,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 445148992,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 10,
		"num_five_badgers": 6,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 6,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 967,
		"ff_all_asset_sum": 3566748774,
		"ff_all_weight_total": 0.08868955451559304,
		"grade_fossil_fam": 4,
		"c2_count_sum": 280,
		"c2_asset_sum": 1370406419,
		"c2_weight_total": 0.03407605707819867,
		"mc50_count_sum": 58,
		"mc50_asset_sum": 595506285,
		"mc50_weight_total": 0.014807655507695083,
		"co_count_sum": 209,
		"co_asset_sum": 301416029,
		"co_weight_total": 0.007494907836160672,
		"og_count_sum": 679,
		"og_asset_sum": 2440532439,
		"og_weight_total": 0.06068544450721769,
		"ut_count_sum": 422,
		"ut_asset_sum": 1230216753,
		"ut_weight_total": 0.030590148814666516,
		"cl_count_sum": 538,
		"cl_asset_sum": 6769171662,
		"cl_weight_total": 0.16831990621786264,
		"fossil_bank_count_sum": 145,
		"fossil_bank_asset_sum": 876578908,
		"fossil_bank_weight_total": 0.02179671117152952,
		"fossil_insure_count_sum": 74,
		"fossil_insure_asset_sum": 830644685,
		"fossil_insure_weight_total": 0.02065452650055221,
		"name": "BNY Mellon",
		"fund_family_name": "BNY Mellon",
		"label": "BNY Mellon"
	},
	{
		"fund_family_label": "Allspring Global Investments",
		"as_of": "202506",
		"fund_id": 71,
		"net_asset_sum": 83859185089,
		"long_asset_sum": 85840232681,
		"num_equity_funds": 34,
		"equity_fund_net_assets": 40192575814,
		"equity_fund_long_assets": 40319359551,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 14,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 284,
		"ff_all_asset_sum": 3176806401,
		"ff_all_weight_total": 0.07879109282432065,
		"grade_fossil_fam": 4,
		"c2_count_sum": 76,
		"c2_asset_sum": 1091057265,
		"c2_weight_total": 0.0270603818401411,
		"mc50_count_sum": 24,
		"mc50_asset_sum": 578828907,
		"mc50_weight_total": 0.014356103704173145,
		"co_count_sum": 45,
		"co_asset_sum": 1034116593,
		"co_weight_total": 0.025648140360264027,
		"og_count_sum": 207,
		"og_asset_sum": 2314892409,
		"og_weight_total": 0.057413918146985696,
		"ut_count_sum": 127,
		"ut_asset_sum": 1429459524,
		"ut_weight_total": 0.035453428326208285,
		"cl_count_sum": 200,
		"cl_asset_sum": 3875545173,
		"cl_weight_total": 0.09612119875311557,
		"fossil_bank_count_sum": 40,
		"fossil_bank_asset_sum": 266062758,
		"fossil_bank_weight_total": 0.006598883537905827,
		"fossil_insure_count_sum": 29,
		"fossil_insure_asset_sum": 271085224,
		"fossil_insure_weight_total": 0.006723450645516926,
		"name": "Allspring Global Investments",
		"fund_family_name": "Allspring Global Investments",
		"label": "Allspring Global Investments"
	},
	{
		"fund_family_label": "PGIM Investments",
		"as_of": "202506",
		"fund_id": 131,
		"net_asset_sum": 162428001387,
		"long_asset_sum": 179428331551,
		"num_equity_funds": 42,
		"equity_fund_net_assets": 40040015496,
		"equity_fund_long_assets": 40155654075,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 15753833,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 15753833,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 21,
		"num_five_badgers": 10,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 10,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 599,
		"ff_all_asset_sum": 5087652819,
		"ff_all_weight_total": 0.12669829283561482,
		"grade_fossil_fam": 5,
		"c2_count_sum": 146,
		"c2_asset_sum": 469395294,
		"c2_weight_total": 0.011689394801621096,
		"mc50_count_sum": 36,
		"mc50_asset_sum": 577080892,
		"mc50_weight_total": 0.014371099295809441,
		"co_count_sum": 139,
		"co_asset_sum": 835342782,
		"co_weight_total": 0.02080261923862088,
		"og_count_sum": 416,
		"og_asset_sum": 3609600241,
		"og_weight_total": 0.08989021158161772,
		"ut_count_sum": 285,
		"ut_asset_sum": 3639101963,
		"ut_weight_total": 0.09062489571712946,
		"cl_count_sum": 375,
		"cl_asset_sum": 5279845135,
		"cl_weight_total": 0.13148447601273444,
		"fossil_bank_count_sum": 130,
		"fossil_bank_asset_sum": 278086435,
		"fossil_bank_weight_total": 0.006925212436600063,
		"fossil_insure_count_sum": 54,
		"fossil_insure_asset_sum": 235821897,
		"fossil_insure_weight_total": 0.0058726947034544105,
		"name": "PGIM Investments",
		"fund_family_name": "PGIM Investments",
		"label": "PGIM Investments"
	},
	{
		"fund_family_label": "Global X Funds",
		"as_of": "202506",
		"fund_id": 95,
		"net_asset_sum": 57091026080,
		"long_asset_sum": 57410346250,
		"num_equity_funds": 64,
		"equity_fund_net_assets": 39492667471,
		"equity_fund_long_assets": 39587768990,
		"num_e_sri": 8,
		"num_e_usf": 0,
		"sri_long_assets": 995979851,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 995979851,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 35,
		"num_five_badgers": 21,
		"num_sri_badgers": 2,
		"num_fossil_A_grade": 21,
		"num_sri_fossil_A_grade": 2,
		"ff_all_count_sum": 638,
		"ff_all_asset_sum": 6889958023,
		"ff_all_weight_total": 0.17404259443719666,
		"grade_fossil_fam": 5,
		"c2_count_sum": 149,
		"c2_asset_sum": 593904060,
		"c2_weight_total": 0.015002210913932081,
		"mc50_count_sum": 33,
		"mc50_asset_sum": 43269753,
		"mc50_weight_total": 0.0010930081210418824,
		"co_count_sum": 114,
		"co_asset_sum": 760289952,
		"co_weight_total": 0.019205172996539708,
		"og_count_sum": 466,
		"og_asset_sum": 5904051215,
		"og_weight_total": 0.14913826582375436,
		"ut_count_sum": 239,
		"ut_asset_sum": 935961144,
		"ut_weight_total": 0.023642684795812233,
		"cl_count_sum": 333,
		"cl_asset_sum": 2935040838,
		"cl_weight_total": 0.07414009207594904,
		"fossil_bank_count_sum": 63,
		"fossil_bank_asset_sum": 76630954,
		"fossil_bank_weight_total": 0.0019357229759362602,
		"fossil_insure_count_sum": 39,
		"fossil_insure_asset_sum": 63267033,
		"fossil_insure_weight_total": 0.0015981459580604671,
		"name": "Global X Funds",
		"fund_family_name": "Global X Funds",
		"label": "Global X Funds"
	},
	{
		"fund_family_label": "Harbor",
		"as_of": "202506",
		"fund_id": 41,
		"net_asset_sum": 44907134478,
		"long_asset_sum": 44933178964,
		"num_equity_funds": 32,
		"equity_fund_net_assets": 38874492017,
		"equity_fund_long_assets": 38882057640,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 13,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 292,
		"ff_all_asset_sum": 1238600864,
		"ff_all_weight_total": 0.031855332232360735,
		"grade_fossil_fam": 3,
		"c2_count_sum": 90,
		"c2_asset_sum": 382416813,
		"c2_weight_total": 0.00983530286747448,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 9684403,
		"mc50_weight_total": 0.0002490712577422124,
		"co_count_sum": 45,
		"co_asset_sum": 131392424,
		"co_weight_total": 0.0033792559338431142,
		"og_count_sum": 221,
		"og_asset_sum": 858638204,
		"og_weight_total": 0.022083147243644692,
		"ut_count_sum": 73,
		"ut_asset_sum": 360655650,
		"ut_weight_total": 0.009275631792412517,
		"cl_count_sum": 186,
		"cl_asset_sum": 7464541732,
		"cl_weight_total": 0.19197908200004407,
		"fossil_bank_count_sum": 54,
		"fossil_bank_asset_sum": 655126139,
		"fossil_bank_weight_total": 0.01684906043465245,
		"fossil_insure_count_sum": 27,
		"fossil_insure_asset_sum": 151269755,
		"fossil_insure_weight_total": 0.0038904771038758227,
		"name": "Harbor",
		"fund_family_name": "Harbor",
		"label": "Harbor"
	},
	{
		"fund_family_label": "Pacer",
		"as_of": "202506",
		"fund_id": 54,
		"net_asset_sum": 39879546746,
		"long_asset_sum": 40723059739,
		"num_equity_funds": 32,
		"equity_fund_net_assets": 37516109915,
		"equity_fund_long_assets": 37696799052,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 11,
		"num_five_badgers": 5,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 5,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 490,
		"ff_all_asset_sum": 5955642062,
		"ff_all_weight_total": 0.15798800459913384,
		"grade_fossil_fam": 5,
		"c2_count_sum": 141,
		"c2_asset_sum": 3236430327,
		"c2_weight_total": 0.08585424779795173,
		"mc50_count_sum": 34,
		"mc50_asset_sum": 359481604,
		"mc50_weight_total": 0.009536130733649856,
		"co_count_sum": 102,
		"co_asset_sum": 596728796,
		"co_weight_total": 0.015829694059085915,
		"og_count_sum": 366,
		"og_asset_sum": 5582512583,
		"og_weight_total": 0.14808983052644148,
		"ut_count_sum": 200,
		"ut_asset_sum": 748891925,
		"ut_weight_total": 0.019866194049180618,
		"cl_count_sum": 405,
		"cl_asset_sum": 5172310071,
		"cl_weight_total": 0.1372082033772993,
		"fossil_bank_count_sum": 69,
		"fossil_bank_asset_sum": 143930722,
		"fossil_bank_weight_total": 0.003818115214542699,
		"fossil_insure_count_sum": 40,
		"fossil_insure_asset_sum": 109922482,
		"fossil_insure_weight_total": 0.002915963285062212,
		"name": "Pacer",
		"fund_family_name": "Pacer",
		"label": "Pacer"
	},
	{
		"fund_family_label": "Parnassus",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 34091723281,
		"long_asset_sum": 34091723281,
		"num_equity_funds": 8,
		"equity_fund_net_assets": 34091723281,
		"equity_fund_long_assets": 34091723281,
		"num_e_sri": 5,
		"num_e_usf": 5,
		"sri_long_assets": 34037096691,
		"usf_long_assets": 34037096691,
		"equity_fund_sri_long_assets": 34037096691,
		"equity_fund_usf_long_assets": 34037096691,
		"sustainable_manager": 1,
		"num_c2_free": 8,
		"num_five_badgers": 4,
		"num_sri_badgers": 2,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 67552853,
		"ff_all_weight_total": 0.001981503030609443,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 7,
		"og_asset_sum": 67552853,
		"og_weight_total": 0.001981503030609443,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 41,
		"cl_asset_sum": 5868112062,
		"cl_weight_total": 0.17212717625425572,
		"fossil_bank_count_sum": 9,
		"fossil_bank_asset_sum": 779502954,
		"fossil_bank_weight_total": 0.022864873904289627,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 238738,
		"fossil_insure_weight_total": 0.000007002814085759445,
		"name": "Parnassus",
		"fund_family_name": "Parnassus",
		"label": "Parnassus"
	},
	{
		"fund_family_label": "Baron Capital Group, Inc.",
		"as_of": "202506",
		"fund_id": 19,
		"net_asset_sum": 34071584062,
		"long_asset_sum": 35070813892,
		"num_equity_funds": 18,
		"equity_fund_net_assets": 33559862784,
		"equity_fund_long_assets": 34558887147,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 17,
		"num_five_badgers": 9,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 9,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 18,
		"ff_all_asset_sum": 412455027,
		"ff_all_weight_total": 0.011934846896127688,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 3203476,
		"c2_weight_total": 0.00009269615616885073,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 34839797,
		"co_weight_total": 0.0010081284403576168,
		"og_count_sum": 17,
		"og_asset_sum": 377615230,
		"og_weight_total": 0.010926718455770071,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 45,
		"cl_asset_sum": 3696937389,
		"cl_weight_total": 0.10697501262915883,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 22818899,
		"fossil_bank_weight_total": 0.0006602903300368823,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Baron Capital Group, Inc.",
		"fund_family_name": "Baron Capital Group, Inc.",
		"label": "Baron Capital Group, Inc."
	},
	{
		"fund_family_label": "Federated",
		"as_of": "202506",
		"fund_id": 72,
		"net_asset_sum": 79943947664,
		"long_asset_sum": 83093062964,
		"num_equity_funds": 28,
		"equity_fund_net_assets": 32137822789,
		"equity_fund_long_assets": 32138196085,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 686902781,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 92060115,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 7,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 400,
		"ff_all_asset_sum": 4316018355,
		"ff_all_weight_total": 0.1342956008976009,
		"grade_fossil_fam": 5,
		"c2_count_sum": 117,
		"c2_asset_sum": 1163233878,
		"c2_weight_total": 0.03619474705187082,
		"mc50_count_sum": 39,
		"mc50_asset_sum": 1019684931,
		"mc50_weight_total": 0.031728132104960366,
		"co_count_sum": 74,
		"co_asset_sum": 470735210,
		"co_weight_total": 0.014647219425601436,
		"og_count_sum": 298,
		"og_asset_sum": 3787576069,
		"og_weight_total": 0.11785278983868643,
		"ut_count_sum": 169,
		"ut_asset_sum": 2118810689,
		"ut_weight_total": 0.06592811505026948,
		"cl_count_sum": 248,
		"cl_asset_sum": 3543012013,
		"cl_weight_total": 0.11024302682170906,
		"fossil_bank_count_sum": 88,
		"fossil_bank_asset_sum": 1425381298,
		"fossil_bank_weight_total": 0.04435162739782008,
		"fossil_insure_count_sum": 42,
		"fossil_insure_asset_sum": 388459844,
		"fossil_insure_weight_total": 0.012087170137757283,
		"name": "Federated",
		"fund_family_name": "Federated",
		"label": "Federated"
	},
	{
		"fund_family_label": "Northern Funds",
		"as_of": "202506",
		"fund_id": 35,
		"net_asset_sum": 44015573453,
		"long_asset_sum": 44015618085,
		"num_equity_funds": 18,
		"equity_fund_net_assets": 31226144350,
		"equity_fund_long_assets": 31226155758,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 2348307324,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 2348307324,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 804,
		"ff_all_asset_sum": 3021972027,
		"ff_all_weight_total": 0.09677694719836862,
		"grade_fossil_fam": 5,
		"c2_count_sum": 189,
		"c2_asset_sum": 915021793,
		"c2_weight_total": 0.02930305606912806,
		"mc50_count_sum": 47,
		"mc50_asset_sum": 447279366,
		"mc50_weight_total": 0.01432386904959984,
		"co_count_sum": 169,
		"co_asset_sum": 434540482,
		"co_weight_total": 0.013915913485081258,
		"og_count_sum": 572,
		"og_asset_sum": 2114016401,
		"og_weight_total": 0.06770018113607848,
		"ut_count_sum": 336,
		"ut_asset_sum": 1396414364,
		"ut_weight_total": 0.044719381239948015,
		"cl_count_sum": 364,
		"cl_asset_sum": 5350186808,
		"cl_weight_total": 0.1713367104636089,
		"fossil_bank_count_sum": 121,
		"fossil_bank_asset_sum": 1100943250,
		"fossil_bank_weight_total": 0.03525708571148542,
		"fossil_insure_count_sum": 50,
		"fossil_insure_asset_sum": 642353919,
		"fossil_insure_weight_total": 0.020571021421214548,
		"name": "Northern Funds",
		"fund_family_name": "Northern Funds",
		"label": "Northern Funds"
	},
	{
		"fund_family_label": "Neuberger Berman",
		"as_of": "202506",
		"fund_id": 43,
		"net_asset_sum": 46880114497,
		"long_asset_sum": 50842343813,
		"num_equity_funds": 28,
		"equity_fund_net_assets": 30538745079,
		"equity_fund_long_assets": 30545625908,
		"num_e_sri": 4,
		"num_e_usf": 1,
		"sri_long_assets": 2528097370,
		"usf_long_assets": 1609811458,
		"equity_fund_sri_long_assets": 2454273559,
		"equity_fund_usf_long_assets": 1609811458,
		"sustainable_manager": 0,
		"num_c2_free": 10,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 196,
		"ff_all_asset_sum": 3402324902,
		"ff_all_weight_total": 0.11138501179342081,
		"grade_fossil_fam": 5,
		"c2_count_sum": 52,
		"c2_asset_sum": 1255678969,
		"c2_weight_total": 0.04110830705456697,
		"mc50_count_sum": 10,
		"mc50_asset_sum": 550053583,
		"mc50_weight_total": 0.018007605562141687,
		"co_count_sum": 33,
		"co_asset_sum": 283466987,
		"co_weight_total": 0.009280117155031322,
		"og_count_sum": 149,
		"og_asset_sum": 2612593884,
		"og_weight_total": 0.08553086755756258,
		"ut_count_sum": 67,
		"ut_asset_sum": 1298383610,
		"ut_weight_total": 0.042506367815496264,
		"cl_count_sum": 124,
		"cl_asset_sum": 1925081399,
		"cl_weight_total": 0.06302314461645439,
		"fossil_bank_count_sum": 36,
		"fossil_bank_asset_sum": 874502964,
		"fossil_bank_weight_total": 0.028629400708104817,
		"fossil_insure_count_sum": 13,
		"fossil_insure_asset_sum": 515120185,
		"fossil_insure_weight_total": 0.01686395906737954,
		"name": "Neuberger Berman",
		"fund_family_name": "Neuberger Berman",
		"label": "Neuberger Berman"
	},
	{
		"fund_family_label": "GQG Partners Inc",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 30244356483,
		"long_asset_sum": 30522445238,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 30244356483,
		"equity_fund_long_assets": 30522445238,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 99,
		"ff_all_asset_sum": 8602516460,
		"ff_all_weight_total": 0.2818423095830472,
		"grade_fossil_fam": 5,
		"c2_count_sum": 47,
		"c2_asset_sum": 4513466160,
		"c2_weight_total": 0.14787367541512697,
		"mc50_count_sum": 14,
		"mc50_asset_sum": 1540399647,
		"mc50_weight_total": 0.05046776675291483,
		"co_count_sum": 25,
		"co_asset_sum": 3499751988,
		"co_weight_total": 0.11466158627562577,
		"og_count_sum": 76,
		"og_asset_sum": 5541369271,
		"og_weight_total": 0.18155063356788584,
		"ut_count_sum": 36,
		"ut_asset_sum": 3649694947,
		"ut_weight_total": 0.1195741336757706,
		"cl_count_sum": 31,
		"cl_asset_sum": 3939528598,
		"cl_weight_total": 0.12906988831600374,
		"fossil_bank_count_sum": 24,
		"fossil_bank_asset_sum": 1563443461,
		"fossil_bank_weight_total": 0.05122274604177308,
		"fossil_insure_count_sum": 14,
		"fossil_insure_asset_sum": 387214453,
		"fossil_insure_weight_total": 0.012686219927030081,
		"name": "GQG Partners Inc",
		"fund_family_name": "GQG Partners Inc",
		"label": "GQG Partners Inc"
	},
	{
		"fund_family_label": "Cohen & Steers",
		"as_of": "202506",
		"fund_id": 14,
		"net_asset_sum": 37471881089,
		"long_asset_sum": 37477378697,
		"num_equity_funds": 10,
		"equity_fund_net_assets": 27547459814,
		"equity_fund_long_assets": 27552957422,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 6,
		"num_five_badgers": 6,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 6,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 152,
		"ff_all_asset_sum": 953713659,
		"ff_all_weight_total": 0.03461383997343587,
		"grade_fossil_fam": 3,
		"c2_count_sum": 44,
		"c2_asset_sum": 160287390,
		"c2_weight_total": 0.00581742959730401,
		"mc50_count_sum": 11,
		"mc50_asset_sum": 60417280,
		"mc50_weight_total": 0.002192769330516915,
		"co_count_sum": 32,
		"co_asset_sum": 165307114,
		"co_weight_total": 0.0059996141781864945,
		"og_count_sum": 114,
		"og_asset_sum": 720388516,
		"og_weight_total": 0.026145596821660854,
		"ut_count_sum": 68,
		"ut_asset_sum": 517453280,
		"ut_weight_total": 0.018780317193349015,
		"cl_count_sum": 26,
		"cl_asset_sum": 1086796587,
		"cl_weight_total": 0.039443917774584655,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Cohen & Steers",
		"fund_family_name": "Cohen & Steers",
		"label": "Cohen & Steers"
	},
	{
		"fund_family_label": "VALIC",
		"as_of": "202506",
		"fund_id": 36,
		"net_asset_sum": 32158857696,
		"long_asset_sum": 32380777279,
		"num_equity_funds": 27,
		"equity_fund_net_assets": 26537836213,
		"equity_fund_long_assets": 26540288271,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 1142225408,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 1142225408,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 676,
		"ff_all_asset_sum": 1737083851,
		"ff_all_weight_total": 0.06545082831289643,
		"grade_fossil_fam": 4,
		"c2_count_sum": 184,
		"c2_asset_sum": 583379888,
		"c2_weight_total": 0.021980917541029373,
		"mc50_count_sum": 33,
		"mc50_asset_sum": 219777901,
		"mc50_weight_total": 0.008280916121025956,
		"co_count_sum": 124,
		"co_asset_sum": 227884952,
		"co_weight_total": 0.008586378176193548,
		"og_count_sum": 505,
		"og_asset_sum": 1231805333,
		"og_weight_total": 0.04641265838645645,
		"ut_count_sum": 262,
		"ut_asset_sum": 738093915,
		"ut_weight_total": 0.027810320199366457,
		"cl_count_sum": 407,
		"cl_asset_sum": 4570434458,
		"cl_weight_total": 0.17220741580994864,
		"fossil_bank_count_sum": 110,
		"fossil_bank_asset_sum": 507359897,
		"fossil_bank_weight_total": 0.019116593302205432,
		"fossil_insure_count_sum": 64,
		"fossil_insure_asset_sum": 365825624,
		"fossil_insure_weight_total": 0.013783784873193324,
		"name": "VALIC",
		"fund_family_name": "VALIC",
		"label": "VALIC"
	},
	{
		"fund_family_label": "New York Life Investment Management LLC",
		"as_of": "202506",
		"fund_id": 67,
		"net_asset_sum": 77031847866,
		"long_asset_sum": 77443581146,
		"num_equity_funds": 31,
		"equity_fund_net_assets": 26146076132,
		"equity_fund_long_assets": 26350707347,
		"num_e_sri": 4,
		"num_e_usf": 0,
		"sri_long_assets": 770221595,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 770221595,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 15,
		"num_five_badgers": 8,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 7,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 402,
		"ff_all_asset_sum": 2537414416,
		"ff_all_weight_total": 0.0962939773337387,
		"grade_fossil_fam": 5,
		"c2_count_sum": 80,
		"c2_asset_sum": 273677240,
		"c2_weight_total": 0.010385954213527322,
		"mc50_count_sum": 27,
		"mc50_asset_sum": 197691331,
		"mc50_weight_total": 0.007502315911170671,
		"co_count_sum": 61,
		"co_asset_sum": 156867744,
		"co_weight_total": 0.0059530752603443576,
		"og_count_sum": 314,
		"og_asset_sum": 2150346261,
		"og_weight_total": 0.08160487810376804,
		"ut_count_sum": 185,
		"ut_asset_sum": 851943244,
		"ut_weight_total": 0.03233094401532234,
		"cl_count_sum": 405,
		"cl_asset_sum": 5249021133,
		"cl_weight_total": 0.19919849072277734,
		"fossil_bank_count_sum": 89,
		"fossil_bank_asset_sum": 374863025,
		"fossil_bank_weight_total": 0.014225918874343909,
		"fossil_insure_count_sum": 48,
		"fossil_insure_asset_sum": 209036152,
		"fossil_insure_weight_total": 0.007932847845308356,
		"name": "New York Life Investment Management LLC",
		"fund_family_name": "New York Life Investment Management LLC",
		"label": "New York Life Investment Management LLC"
	},
	{
		"fund_family_label": "Russell",
		"as_of": "202506",
		"fund_id": 29,
		"net_asset_sum": 40455185832,
		"long_asset_sum": 42169965139,
		"num_equity_funds": 16,
		"equity_fund_net_assets": 25893464170,
		"equity_fund_long_assets": 26459842784,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 169866034,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 169866034,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 904,
		"ff_all_asset_sum": 2101260875,
		"ff_all_weight_total": 0.07941320332676395,
		"grade_fossil_fam": 4,
		"c2_count_sum": 275,
		"c2_asset_sum": 693975565,
		"c2_weight_total": 0.0262275014505997,
		"mc50_count_sum": 43,
		"mc50_asset_sum": 273998165,
		"mc50_weight_total": 0.010355245389654542,
		"co_count_sum": 148,
		"co_asset_sum": 262648538,
		"co_weight_total": 0.009926307580286188,
		"og_count_sum": 693,
		"og_asset_sum": 1622059191,
		"og_weight_total": 0.06130267682394707,
		"ut_count_sum": 343,
		"ut_asset_sum": 882512774,
		"ut_weight_total": 0.03335291071848872,
		"cl_count_sum": 504,
		"cl_asset_sum": 4222370497,
		"cl_weight_total": 0.15957655272060894,
		"fossil_bank_count_sum": 173,
		"fossil_bank_asset_sum": 713689084,
		"fossil_bank_weight_total": 0.026972536829718452,
		"fossil_insure_count_sum": 93,
		"fossil_insure_asset_sum": 359496635,
		"fossil_insure_weight_total": 0.01358649928250458,
		"name": "Russell",
		"fund_family_name": "Russell",
		"label": "Russell"
	},
	{
		"fund_family_label": "Virtus",
		"as_of": "202506",
		"fund_id": 97,
		"net_asset_sum": 47100728282,
		"long_asset_sum": 51286435258,
		"num_equity_funds": 51,
		"equity_fund_net_assets": 24934417728,
		"equity_fund_long_assets": 25024620179,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 701425468,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 565857811,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 37,
		"num_five_badgers": 22,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 22,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 325,
		"ff_all_asset_sum": 1810020079,
		"ff_all_weight_total": 0.0723295724791428,
		"grade_fossil_fam": 4,
		"c2_count_sum": 67,
		"c2_asset_sum": 161634186,
		"c2_weight_total": 0.006459006564089198,
		"mc50_count_sum": 16,
		"mc50_asset_sum": 102008594,
		"mc50_weight_total": 0.004076329361658121,
		"co_count_sum": 55,
		"co_asset_sum": 307720103,
		"co_weight_total": 0.01229669424746077,
		"og_count_sum": 264,
		"og_asset_sum": 1442883488,
		"og_weight_total": 0.05765855696027026,
		"ut_count_sum": 132,
		"ut_asset_sum": 851721377,
		"ut_weight_total": 0.03403533683659032,
		"cl_count_sum": 140,
		"cl_asset_sum": 1561378370,
		"cl_weight_total": 0.06239368904828643,
		"fossil_bank_count_sum": 52,
		"fossil_bank_asset_sum": 155321028,
		"fossil_bank_weight_total": 0.006206728689146751,
		"fossil_insure_count_sum": 18,
		"fossil_insure_asset_sum": 37356848,
		"fossil_insure_weight_total": 0.001492803796133093,
		"name": "Virtus",
		"fund_family_name": "Virtus",
		"label": "Virtus"
	},
	{
		"fund_family_label": "Lord Abbett",
		"as_of": "202506",
		"fund_id": 48,
		"net_asset_sum": 160348878885,
		"long_asset_sum": 160454910147,
		"num_equity_funds": 20,
		"equity_fund_net_assets": 23863699000,
		"equity_fund_long_assets": 23863699000,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 7,
		"num_five_badgers": 4,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 4,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 100,
		"ff_all_asset_sum": 1973677553,
		"ff_all_weight_total": 0.08270627085096909,
		"grade_fossil_fam": 4,
		"c2_count_sum": 36,
		"c2_asset_sum": 769171405,
		"c2_weight_total": 0.03223185998951797,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 11,
		"co_asset_sum": 96758952,
		"co_weight_total": 0.004054650203222895,
		"og_count_sum": 87,
		"og_asset_sum": 1778708892,
		"og_weight_total": 0.074536176977425,
		"ut_count_sum": 24,
		"ut_asset_sum": 648815316,
		"ut_weight_total": 0.02718837997411885,
		"cl_count_sum": 76,
		"cl_asset_sum": 2601633528,
		"cl_weight_total": 0.10902054740130605,
		"fossil_bank_count_sum": 27,
		"fossil_bank_asset_sum": 643957650,
		"fossil_bank_weight_total": 0.026984821171269383,
		"fossil_insure_count_sum": 13,
		"fossil_insure_asset_sum": 200978617,
		"fossil_insure_weight_total": 0.008421938987748715,
		"name": "Lord Abbett",
		"fund_family_name": "Lord Abbett",
		"label": "Lord Abbett"
	},
	{
		"fund_family_label": "Empower Funds",
		"as_of": "202506",
		"fund_id": 44,
		"net_asset_sum": 47793489479,
		"long_asset_sum": 47793489479,
		"num_equity_funds": 16,
		"equity_fund_net_assets": 23467474434,
		"equity_fund_long_assets": 23467474434,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 516,
		"ff_all_asset_sum": 1900154560,
		"ff_all_weight_total": 0.08096970832306649,
		"grade_fossil_fam": 4,
		"c2_count_sum": 156,
		"c2_asset_sum": 725989555,
		"c2_weight_total": 0.03093599002490768,
		"mc50_count_sum": 26,
		"mc50_asset_sum": 236528966,
		"mc50_weight_total": 0.010079012407799348,
		"co_count_sum": 94,
		"co_asset_sum": 231734822,
		"co_weight_total": 0.009874723530720435,
		"og_count_sum": 389,
		"og_asset_sum": 1474166424,
		"og_weight_total": 0.06281742963632284,
		"ut_count_sum": 209,
		"ut_asset_sum": 712472596,
		"ut_weight_total": 0.03036000307590662,
		"cl_count_sum": 288,
		"cl_asset_sum": 3114532189,
		"cl_weight_total": 0.13271697377403438,
		"fossil_bank_count_sum": 104,
		"fossil_bank_asset_sum": 851170590,
		"fossil_bank_weight_total": 0.0362702255154825,
		"fossil_insure_count_sum": 53,
		"fossil_insure_asset_sum": 454587454,
		"fossil_insure_weight_total": 0.019370957674993243,
		"name": "Empower Funds",
		"fund_family_name": "Empower Funds",
		"label": "Empower Funds"
	},
	{
		"fund_family_label": "Morgan Stanley",
		"as_of": "202506",
		"fund_id": 54,
		"net_asset_sum": 43588889491,
		"long_asset_sum": 45397301101,
		"num_equity_funds": 37,
		"equity_fund_net_assets": 22991086110,
		"equity_fund_long_assets": 23003861568,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 24,
		"num_five_badgers": 12,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 12,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 806,
		"ff_all_asset_sum": 660188906,
		"ff_all_weight_total": 0.028699047072964893,
		"grade_fossil_fam": 3,
		"c2_count_sum": 222,
		"c2_asset_sum": 163697923,
		"c2_weight_total": 0.007116106246601458,
		"mc50_count_sum": 42,
		"mc50_asset_sum": 62679029,
		"mc50_weight_total": 0.0027247177094471375,
		"co_count_sum": 179,
		"co_asset_sum": 78684115,
		"co_weight_total": 0.0034204742002731914,
		"og_count_sum": 592,
		"og_asset_sum": 496821167,
		"og_weight_total": 0.021597294242594184,
		"ut_count_sum": 315,
		"ut_asset_sum": 213133572,
		"ut_weight_total": 0.009265121482755047,
		"cl_count_sum": 379,
		"cl_asset_sum": 2559413851,
		"cl_weight_total": 0.11126018314074389,
		"fossil_bank_count_sum": 119,
		"fossil_bank_asset_sum": 266244043,
		"fossil_bank_weight_total": 0.011573884767693278,
		"fossil_insure_count_sum": 52,
		"fossil_insure_asset_sum": 111000413,
		"fossil_insure_weight_total": 0.004825294773743963,
		"name": "Morgan Stanley",
		"fund_family_name": "Morgan Stanley",
		"label": "Morgan Stanley"
	},
	{
		"fund_family_label": "Touchstone",
		"as_of": "202506",
		"fund_id": 37,
		"net_asset_sum": 27642297837,
		"long_asset_sum": 27674036443,
		"num_equity_funds": 26,
		"equity_fund_net_assets": 22661145601,
		"equity_fund_long_assets": 22663177642,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 1353729545,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 754388192,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 13,
		"num_five_badgers": 5,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 85,
		"ff_all_asset_sum": 989189487,
		"ff_all_weight_total": 0.043647431204298905,
		"grade_fossil_fam": 3,
		"c2_count_sum": 26,
		"c2_asset_sum": 322370431,
		"c2_weight_total": 0.01422441442644718,
		"mc50_count_sum": 8,
		"mc50_asset_sum": 184362793,
		"mc50_weight_total": 0.008134904818392899,
		"co_count_sum": 8,
		"co_asset_sum": 56684945,
		"co_weight_total": 0.002501191399345075,
		"og_count_sum": 70,
		"og_asset_sum": 773377814,
		"og_weight_total": 0.034124862197909785,
		"ut_count_sum": 33,
		"ut_asset_sum": 389686612,
		"ut_weight_total": 0.01719470315044535,
		"cl_count_sum": 111,
		"cl_asset_sum": 2460117294,
		"cl_weight_total": 0.10855129553592897,
		"fossil_bank_count_sum": 38,
		"fossil_bank_asset_sum": 515820803,
		"fossil_bank_weight_total": 0.022760303570319603,
		"fossil_insure_count_sum": 16,
		"fossil_insure_asset_sum": 189562928,
		"fossil_insure_weight_total": 0.008364357858127405,
		"name": "Touchstone",
		"fund_family_name": "Touchstone",
		"label": "Touchstone"
	},
	{
		"fund_family_label": "Calvert Research and Management",
		"as_of": "202506",
		"fund_id": 34,
		"net_asset_sum": 37244857359,
		"long_asset_sum": 37265659519,
		"num_equity_funds": 20,
		"equity_fund_net_assets": 22603714183,
		"equity_fund_long_assets": 22603716848,
		"num_e_sri": 20,
		"num_e_usf": 13,
		"sri_long_assets": 37265659519,
		"usf_long_assets": 35697643898,
		"equity_fund_sri_long_assets": 22603716848,
		"equity_fund_usf_long_assets": 21270278609,
		"sustainable_manager": 1,
		"num_c2_free": 15,
		"num_five_badgers": 3,
		"num_sri_badgers": 3,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 2,
		"ff_all_count_sum": 177,
		"ff_all_asset_sum": 576873105,
		"ff_all_weight_total": 0.02552116135940016,
		"grade_fossil_fam": 3,
		"c2_count_sum": 11,
		"c2_asset_sum": 31353671,
		"c2_weight_total": 0.0013871024491608867,
		"mc50_count_sum": 8,
		"mc50_asset_sum": 13123981,
		"mc50_weight_total": 0.0005806116351683649,
		"co_count_sum": 33,
		"co_asset_sum": 105691682,
		"co_weight_total": 0.0046758540956219645,
		"og_count_sum": 113,
		"og_asset_sum": 425611093,
		"og_weight_total": 0.01882925254559002,
		"ut_count_sum": 124,
		"ut_asset_sum": 354515493,
		"ut_weight_total": 0.01568394682095692,
		"cl_count_sum": 294,
		"cl_asset_sum": 3402713011,
		"cl_weight_total": 0.15053776482344652,
		"fossil_bank_count_sum": 53,
		"fossil_bank_asset_sum": 475599653,
		"fossil_bank_weight_total": 0.021040772019849538,
		"fossil_insure_count_sum": 29,
		"fossil_insure_asset_sum": 94440752,
		"fossil_insure_weight_total": 0.004178107195160526,
		"name": "Calvert Research and Management",
		"fund_family_name": "Calvert Research and Management",
		"label": "Calvert Research and Management"
	},
	{
		"fund_family_label": "Thornburg",
		"as_of": "202506",
		"fund_id": 30,
		"net_asset_sum": 44598829452,
		"long_asset_sum": 44599403134,
		"num_equity_funds": 12,
		"equity_fund_net_assets": 22179743592,
		"equity_fund_long_assets": 22179743592,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 484041941,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 484041941,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 5,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 60,
		"ff_all_asset_sum": 3262524410,
		"ff_all_weight_total": 0.14709477575641397,
		"grade_fossil_fam": 5,
		"c2_count_sum": 21,
		"c2_asset_sum": 1156483351,
		"c2_weight_total": 0.05214142112161889,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 9,
		"co_asset_sum": 253787660,
		"co_weight_total": 0.011442317128117682,
		"og_count_sum": 48,
		"og_asset_sum": 2772565919,
		"og_weight_total": 0.12500441709344357,
		"ut_count_sum": 20,
		"ut_asset_sum": 1601881095,
		"ut_weight_total": 0.07222270574749934,
		"cl_count_sum": 74,
		"cl_asset_sum": 5328355953,
		"cl_weight_total": 0.24023523675548178,
		"fossil_bank_count_sum": 17,
		"fossil_bank_asset_sum": 1467151585,
		"fossil_bank_weight_total": 0.06614826627342915,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 488735766,
		"fossil_insure_weight_total": 0.022035230658675506,
		"name": "Thornburg",
		"fund_family_name": "Thornburg",
		"label": "Thornburg"
	},
	{
		"fund_family_label": "DWS",
		"as_of": "202506",
		"fund_id": 43,
		"net_asset_sum": 30940845919,
		"long_asset_sum": 31184146329,
		"num_equity_funds": 24,
		"equity_fund_net_assets": 22111891314,
		"equity_fund_long_assets": 22131364106,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 218799148,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 218799148,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 10,
		"num_five_badgers": 7,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 7,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 303,
		"ff_all_asset_sum": 2462004234,
		"ff_all_weight_total": 0.11124502864839361,
		"grade_fossil_fam": 5,
		"c2_count_sum": 69,
		"c2_asset_sum": 449054979,
		"c2_weight_total": 0.020290433831787955,
		"mc50_count_sum": 19,
		"mc50_asset_sum": 124762873,
		"mc50_weight_total": 0.005637378356003629,
		"co_count_sum": 43,
		"co_asset_sum": 247358586,
		"co_weight_total": 0.011176834144305592,
		"og_count_sum": 228,
		"og_asset_sum": 1875748524,
		"og_weight_total": 0.08475521504304692,
		"ut_count_sum": 136,
		"ut_asset_sum": 1040316156,
		"ut_weight_total": 0.04700641817726733,
		"cl_count_sum": 231,
		"cl_asset_sum": 4190751206,
		"cl_weight_total": 0.1893580163395284,
		"fossil_bank_count_sum": 57,
		"fossil_bank_asset_sum": 329123471,
		"fossil_bank_weight_total": 0.014871359461786264,
		"fossil_insure_count_sum": 26,
		"fossil_insure_asset_sum": 116100442,
		"fossil_insure_weight_total": 0.00524596863726643,
		"name": "DWS",
		"fund_family_name": "DWS",
		"label": "DWS"
	},
	{
		"fund_family_label": "Loomis Sayles Funds",
		"as_of": "202506",
		"fund_id": 23,
		"net_asset_sum": 61921996796,
		"long_asset_sum": 67498084038,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 20200896977,
		"equity_fund_long_assets": 20245138602,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 26,
		"ff_all_asset_sum": 137362957,
		"ff_all_weight_total": 0.006784984765993651,
		"grade_fossil_fam": 3,
		"c2_count_sum": 5,
		"c2_asset_sum": 25400179,
		"c2_weight_total": 0.0012546310252225558,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 3373364,
		"co_weight_total": 0.00016662587825734857,
		"og_count_sum": 22,
		"og_asset_sum": 121653864,
		"og_weight_total": 0.006009040806862242,
		"ut_count_sum": 4,
		"ut_asset_sum": 15709093,
		"ut_weight_total": 0.000775943959131409,
		"cl_count_sum": 17,
		"cl_asset_sum": 3150780507,
		"cl_weight_total": 0.15563146140618356,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 41187259,
		"fossil_bank_weight_total": 0.002034427119008765,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Loomis Sayles Funds",
		"fund_family_name": "Loomis Sayles Funds",
		"label": "Loomis Sayles Funds"
	},
	{
		"fund_family_label": "WCM Investment Management",
		"as_of": "202506",
		"fund_id": 10,
		"net_asset_sum": 19288140857,
		"long_asset_sum": 19289133777,
		"num_equity_funds": 10,
		"equity_fund_net_assets": 19288140857,
		"equity_fund_long_assets": 19289133777,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 6,
		"num_five_badgers": 4,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 15,
		"ff_all_asset_sum": 1575166788,
		"ff_all_weight_total": 0.08166083589913194,
		"grade_fossil_fam": 4,
		"c2_count_sum": 5,
		"c2_asset_sum": 289960033,
		"c2_weight_total": 0.015032299342842595,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 443272,
		"co_weight_total": 0.000022980399489403157,
		"og_count_sum": 14,
		"og_asset_sum": 1574723516,
		"og_weight_total": 0.08163785549964253,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 20,
		"cl_asset_sum": 3041457241,
		"cl_weight_total": 0.15767723300392972,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 347654116,
		"fossil_bank_weight_total": 0.018023314059573595,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 2488878,
		"fossil_insure_weight_total": 0.00012903005540703394,
		"name": "WCM Investment Management",
		"fund_family_name": "WCM Investment Management",
		"label": "WCM Investment Management"
	},
	{
		"fund_family_label": "Old Westbury",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 28133137983,
		"long_asset_sum": 28373709595,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 19199382340,
		"equity_fund_long_assets": 19297430243,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 149,
		"ff_all_asset_sum": 715698717,
		"ff_all_weight_total": 0.03708777324170478,
		"grade_fossil_fam": 3,
		"c2_count_sum": 42,
		"c2_asset_sum": 257709500,
		"c2_weight_total": 0.013354601973155581,
		"mc50_count_sum": 5,
		"mc50_asset_sum": 41332101,
		"mc50_weight_total": 0.0021418448197263423,
		"co_count_sum": 21,
		"co_asset_sum": 118373105,
		"co_weight_total": 0.006134138251021219,
		"og_count_sum": 121,
		"og_asset_sum": 632528058,
		"og_weight_total": 0.032777838812473224,
		"ut_count_sum": 40,
		"ut_asset_sum": 233075013,
		"ut_weight_total": 0.012078033710449413,
		"cl_count_sum": 89,
		"cl_asset_sum": 1536865681,
		"cl_weight_total": 0.07964095020151643,
		"fossil_bank_count_sum": 45,
		"fossil_bank_asset_sum": 385924853,
		"fossil_bank_weight_total": 0.01999876916979614,
		"fossil_insure_count_sum": 22,
		"fossil_insure_asset_sum": 180642700,
		"fossil_insure_weight_total": 0.009360971783563089,
		"name": "Old Westbury",
		"fund_family_name": "Old Westbury",
		"label": "Old Westbury"
	},
	{
		"fund_family_label": "Brown Advisory Funds",
		"as_of": "202506",
		"fund_id": 21,
		"net_asset_sum": 21097801756,
		"long_asset_sum": 21258700204,
		"num_equity_funds": 15,
		"equity_fund_net_assets": 18606658922,
		"equity_fund_long_assets": 18626210016,
		"num_e_sri": 4,
		"num_e_usf": 0,
		"sri_long_assets": 9372009612,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 8406521964,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 11,
		"num_five_badgers": 3,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 40,
		"ff_all_asset_sum": 982248174,
		"ff_all_weight_total": 0.05273473096009571,
		"grade_fossil_fam": 3,
		"c2_count_sum": 6,
		"c2_asset_sum": 50422984,
		"c2_weight_total": 0.002707098435843171,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 88197503,
		"mc50_weight_total": 0.004735128774143421,
		"co_count_sum": 6,
		"co_asset_sum": 13684327,
		"co_weight_total": 0.0007346812361851982,
		"og_count_sum": 31,
		"og_asset_sum": 820019920,
		"og_weight_total": 0.044025054978742276,
		"ut_count_sum": 12,
		"ut_asset_sum": 168460653,
		"ut_weight_total": 0.009044279692717495,
		"cl_count_sum": 59,
		"cl_asset_sum": 2530195940,
		"cl_weight_total": 0.13584062124428695,
		"fossil_bank_count_sum": 9,
		"fossil_bank_asset_sum": 71828151,
		"fossil_bank_weight_total": 0.003856294487085633,
		"fossil_insure_count_sum": 10,
		"fossil_insure_asset_sum": 211665277,
		"fossil_insure_weight_total": 0.011363840352824249,
		"name": "Brown Advisory Funds",
		"fund_family_name": "Brown Advisory Funds",
		"label": "Brown Advisory Funds"
	},
	{
		"fund_family_label": "Thrivent Funds",
		"as_of": "202506",
		"fund_id": 30,
		"net_asset_sum": 40622098903,
		"long_asset_sum": 44122915727,
		"num_equity_funds": 15,
		"equity_fund_net_assets": 17541611613,
		"equity_fund_long_assets": 18134902727,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 309,
		"ff_all_asset_sum": 1523272807,
		"ff_all_weight_total": 0.08399674538822245,
		"grade_fossil_fam": 4,
		"c2_count_sum": 83,
		"c2_asset_sum": 586457454,
		"c2_weight_total": 0.03233860488961199,
		"mc50_count_sum": 15,
		"mc50_asset_sum": 71648898,
		"mc50_weight_total": 0.003950884053727299,
		"co_count_sum": 60,
		"co_asset_sum": 317356018,
		"co_weight_total": 0.017499736435172993,
		"og_count_sum": 217,
		"og_asset_sum": 1131838711,
		"og_weight_total": 0.062412174360046126,
		"ut_count_sum": 117,
		"ut_asset_sum": 692713957,
		"ut_weight_total": 0.03819783140985138,
		"cl_count_sum": 144,
		"cl_asset_sum": 1887195514,
		"cl_weight_total": 0.10406427552491167,
		"fossil_bank_count_sum": 62,
		"fossil_bank_asset_sum": 374144948,
		"fossil_bank_weight_total": 0.02063120787755632,
		"fossil_insure_count_sum": 31,
		"fossil_insure_asset_sum": 137246378,
		"fossil_insure_weight_total": 0.007568079082975276,
		"name": "Thrivent Funds",
		"fund_family_name": "Thrivent Funds",
		"label": "Thrivent Funds"
	},
	{
		"fund_family_label": "Lazard",
		"as_of": "202506",
		"fund_id": 24,
		"net_asset_sum": 17408460060,
		"long_asset_sum": 17412167766,
		"num_equity_funds": 19,
		"equity_fund_net_assets": 17166724004,
		"equity_fund_long_assets": 17166729759,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 9009374,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 9009374,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 8,
		"num_five_badgers": 2,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 151,
		"ff_all_asset_sum": 4748816859,
		"ff_all_weight_total": 0.27662909160146465,
		"grade_fossil_fam": 5,
		"c2_count_sum": 33,
		"c2_asset_sum": 163727428,
		"c2_weight_total": 0.009537485024727125,
		"mc50_count_sum": 9,
		"mc50_asset_sum": 441842442,
		"mc50_weight_total": 0.025738300084112136,
		"co_count_sum": 30,
		"co_asset_sum": 996558030,
		"co_weight_total": 0.05805171072128835,
		"og_count_sum": 116,
		"og_asset_sum": 2645417475,
		"og_weight_total": 0.1541014224688361,
		"ut_count_sum": 65,
		"ut_asset_sum": 3899830310,
		"ut_weight_total": 0.22717374623756958,
		"cl_count_sum": 110,
		"cl_asset_sum": 1836378568,
		"cl_weight_total": 0.10697311565921529,
		"fossil_bank_count_sum": 40,
		"fossil_bank_asset_sum": 447574351,
		"fossil_bank_weight_total": 0.026072196468599398,
		"fossil_insure_count_sum": 10,
		"fossil_insure_asset_sum": 64181358,
		"fossil_insure_weight_total": 0.003738706142697426,
		"name": "Lazard",
		"fund_family_name": "Lazard",
		"label": "Lazard"
	},
	{
		"fund_family_label": "GMO",
		"as_of": "202506",
		"fund_id": 30,
		"net_asset_sum": 26593440115,
		"long_asset_sum": 33943524615,
		"num_equity_funds": 17,
		"equity_fund_net_assets": 17110820809,
		"equity_fund_long_assets": 17241389411,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 418430120,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 418430120,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 7,
		"num_five_badgers": 4,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 221,
		"ff_all_asset_sum": 1108583754,
		"ff_all_weight_total": 0.06429782006389369,
		"grade_fossil_fam": 4,
		"c2_count_sum": 88,
		"c2_asset_sum": 797402448,
		"c2_weight_total": 0.046249314889393864,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 3516788,
		"mc50_weight_total": 0.0002039735845045232,
		"co_count_sum": 40,
		"co_asset_sum": 164882224,
		"co_weight_total": 0.009563163389535487,
		"og_count_sum": 184,
		"og_asset_sum": 981851146,
		"og_weight_total": 0.056947333106088266,
		"ut_count_sum": 43,
		"ut_asset_sum": 73100079,
		"ut_weight_total": 0.004239802098162818,
		"cl_count_sum": 151,
		"cl_asset_sum": 3645318757,
		"cl_weight_total": 0.21142836404323007,
		"fossil_bank_count_sum": 60,
		"fossil_bank_asset_sum": 747817740,
		"fossil_bank_weight_total": 0.04337340351021204,
		"fossil_insure_count_sum": 9,
		"fossil_insure_asset_sum": 46081706,
		"fossil_insure_weight_total": 0.0026727373822088775,
		"name": "GMO",
		"fund_family_name": "GMO",
		"label": "GMO"
	},
	{
		"fund_family_label": "Amundi US",
		"as_of": "202506",
		"fund_id": 13,
		"net_asset_sum": 29743228912,
		"long_asset_sum": 29961706212,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 16025110272,
		"equity_fund_long_assets": 16054241745,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 8055081633,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 8055081633,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 16,
		"ff_all_asset_sum": 929728620,
		"ff_all_weight_total": 0.05791171173123505,
		"grade_fossil_fam": 4,
		"c2_count_sum": 6,
		"c2_asset_sum": 66073090,
		"c2_weight_total": 0.004115615738786173,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 283324423,
		"mc50_weight_total": 0.01764794796915524,
		"co_count_sum": 2,
		"co_asset_sum": 40723052,
		"co_weight_total": 0.0025365914284106853,
		"og_count_sum": 14,
		"og_asset_sum": 919408692,
		"og_weight_total": 0.05726889544854054,
		"ut_count_sum": 5,
		"ut_asset_sum": 324445409,
		"ut_weight_total": 0.02020932624245842,
		"cl_count_sum": 21,
		"cl_asset_sum": 3222447500,
		"cl_weight_total": 0.20072249759186617,
		"fossil_bank_count_sum": 12,
		"fossil_bank_asset_sum": 890163208,
		"fossil_bank_weight_total": 0.05544722834868462,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Amundi US",
		"fund_family_name": "Amundi US",
		"label": "Amundi US"
	},
	{
		"fund_family_label": "Causeway",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 15863218729,
		"long_asset_sum": 15879123725,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 15863218729,
		"equity_fund_long_assets": 15879123725,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 74,
		"ff_all_asset_sum": 1039926554,
		"ff_all_weight_total": 0.06549017263230626,
		"grade_fossil_fam": 4,
		"c2_count_sum": 24,
		"c2_asset_sum": 564537798,
		"c2_weight_total": 0.03555220097637976,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 22698713,
		"mc50_weight_total": 0.0014294688669919033,
		"co_count_sum": 35,
		"co_asset_sum": 242593921,
		"co_weight_total": 0.015277538307612122,
		"og_count_sum": 41,
		"og_asset_sum": 700138141,
		"og_weight_total": 0.04409173661753807,
		"ut_count_sum": 50,
		"ut_asset_sum": 472217042,
		"ut_weight_total": 0.029738230533246885,
		"cl_count_sum": 43,
		"cl_asset_sum": 2683054677,
		"cl_weight_total": 0.16896742688488625,
		"fossil_bank_count_sum": 25,
		"fossil_bank_asset_sum": 1567019905,
		"fossil_bank_weight_total": 0.09868428082923071,
		"fossil_insure_count_sum": 14,
		"fossil_insure_asset_sum": 368791233,
		"fossil_insure_weight_total": 0.023224910856974885,
		"name": "Causeway",
		"fund_family_name": "Causeway",
		"label": "Causeway"
	},
	{
		"fund_family_label": "AMG Funds",
		"as_of": "202506",
		"fund_id": 33,
		"net_asset_sum": 17457796362,
		"long_asset_sum": 17481130258,
		"num_equity_funds": 25,
		"equity_fund_net_assets": 15535578370,
		"equity_fund_long_assets": 15538298544,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 962166315,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 490076478,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 10,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 122,
		"ff_all_asset_sum": 1938488066,
		"ff_all_weight_total": 0.12475549111833309,
		"grade_fossil_fam": 5,
		"c2_count_sum": 34,
		"c2_asset_sum": 1214932473,
		"c2_weight_total": 0.07818954369808638,
		"mc50_count_sum": 4,
		"mc50_asset_sum": 143704780,
		"mc50_weight_total": 0.009248424439334161,
		"co_count_sum": 19,
		"co_asset_sum": 98619437,
		"co_weight_total": 0.006346862027443872,
		"og_count_sum": 92,
		"og_asset_sum": 1578301179,
		"og_weight_total": 0.10157490374706755,
		"ut_count_sum": 35,
		"ut_asset_sum": 371899762,
		"ut_weight_total": 0.02393439416464336,
		"cl_count_sum": 59,
		"cl_asset_sum": 1116854555,
		"cl_weight_total": 0.07187753226888959,
		"fossil_bank_count_sum": 6,
		"fossil_bank_asset_sum": 18349602,
		"fossil_bank_weight_total": 0.0011809273678221072,
		"fossil_insure_count_sum": 10,
		"fossil_insure_asset_sum": 206904825,
		"fossil_insure_weight_total": 0.013315796733735353,
		"name": "AMG Funds",
		"fund_family_name": "AMG Funds",
		"label": "AMG Funds"
	},
	{
		"fund_family_label": "Edgewood",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 15449434870,
		"long_asset_sum": 15449434871,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 15449434870,
		"equity_fund_long_assets": 15449434871,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 695266419,
		"ff_all_weight_total": 0.0450027088243259,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 695266419,
		"og_weight_total": 0.0450027088243259,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Edgewood",
		"fund_family_name": "Edgewood",
		"label": "Edgewood"
	},
	{
		"fund_family_label": "ALPS",
		"as_of": "202506",
		"fund_id": 39,
		"net_asset_sum": 23632896567,
		"long_asset_sum": 24538710472,
		"num_equity_funds": 24,
		"equity_fund_net_assets": 15405888342,
		"equity_fund_long_assets": 15880627292,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 486649855,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 486649855,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 13,
		"num_five_badgers": 4,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 4,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 326,
		"ff_all_asset_sum": 11523366135,
		"ff_all_weight_total": 0.7256241156673322,
		"grade_fossil_fam": 5,
		"c2_count_sum": 89,
		"c2_asset_sum": 187846465,
		"c2_weight_total": 0.011828655225390828,
		"mc50_count_sum": 17,
		"mc50_asset_sum": 31207898,
		"mc50_weight_total": 0.0019651552439443774,
		"co_count_sum": 51,
		"co_asset_sum": 90507252,
		"co_weight_total": 0.005699223987555818,
		"og_count_sum": 258,
		"og_asset_sum": 11076919650,
		"og_weight_total": 0.6975114676723186,
		"ut_count_sum": 92,
		"ut_asset_sum": 505321599,
		"ut_weight_total": 0.031820002428654695,
		"cl_count_sum": 140,
		"cl_asset_sum": 584950254,
		"cl_weight_total": 0.036834203287087634,
		"fossil_bank_count_sum": 15,
		"fossil_bank_asset_sum": 81053780,
		"fossil_bank_weight_total": 0.005103940701437627,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 10367734,
		"fossil_insure_weight_total": 0.0006528541857551706,
		"name": "ALPS",
		"fund_family_name": "ALPS",
		"label": "ALPS"
	},
	{
		"fund_family_label": "ProShares",
		"as_of": "202506",
		"fund_id": 146,
		"net_asset_sum": 88160046428,
		"long_asset_sum": 123981992909,
		"num_equity_funds": 29,
		"equity_fund_net_assets": 15345982001,
		"equity_fund_long_assets": 15353776586,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 1439922,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 1439922,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 17,
		"num_five_badgers": 10,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 10,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 379,
		"ff_all_asset_sum": 1559664569,
		"ff_all_weight_total": 0.10158181996878511,
		"grade_fossil_fam": 5,
		"c2_count_sum": 69,
		"c2_asset_sum": 414486884,
		"c2_weight_total": 0.026995761054510892,
		"mc50_count_sum": 28,
		"mc50_asset_sum": 17085641,
		"mc50_weight_total": 0.0011127972915523053,
		"co_count_sum": 74,
		"co_asset_sum": 153260392,
		"co_weight_total": 0.009981934486382137,
		"og_count_sum": 240,
		"og_asset_sum": 690530737,
		"og_weight_total": 0.04497465057747715,
		"ut_count_sum": 217,
		"ut_asset_sum": 1084395844,
		"ut_weight_total": 0.07062730383798747,
		"cl_count_sum": 220,
		"cl_asset_sum": 926275394,
		"cl_weight_total": 0.060328831073691906,
		"fossil_bank_count_sum": 36,
		"fossil_bank_asset_sum": 18019279,
		"fossil_bank_weight_total": 0.0011736056532456306,
		"fossil_insure_count_sum": 24,
		"fossil_insure_asset_sum": 185128281,
		"fossil_insure_weight_total": 0.012057507803572256,
		"name": "ProShares",
		"fund_family_name": "ProShares",
		"label": "ProShares"
	},
	{
		"fund_family_label": "PRIMECAP Odyssey Funds",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 15038055763,
		"long_asset_sum": 15053557156,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 15038055763,
		"equity_fund_long_assets": 15053557156,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 23,
		"ff_all_asset_sum": 526445939,
		"ff_all_weight_total": 0.03497153088432463,
		"grade_fossil_fam": 3,
		"c2_count_sum": 13,
		"c2_asset_sum": 219158341,
		"c2_weight_total": 0.014558575008475558,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 16326748,
		"co_weight_total": 0.001084577407904718,
		"og_count_sum": 22,
		"og_asset_sum": 510119191,
		"og_weight_total": 0.03388695347641991,
		"ut_count_sum": 1,
		"ut_asset_sum": 25583997,
		"ut_weight_total": 0.0016995316611796841,
		"cl_count_sum": 46,
		"cl_asset_sum": 1922183939,
		"cl_weight_total": 0.12768968284907078,
		"fossil_bank_count_sum": 7,
		"fossil_bank_asset_sum": 179121930,
		"fossil_bank_weight_total": 0.011898976975591854,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "PRIMECAP Odyssey Funds",
		"fund_family_name": "PRIMECAP Odyssey Funds",
		"label": "PRIMECAP Odyssey Funds"
	},
	{
		"fund_family_label": "Harding Loevner",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 14101021717,
		"long_asset_sum": 14103717282,
		"num_equity_funds": 9,
		"equity_fund_net_assets": 14101021717,
		"equity_fund_long_assets": 14103717282,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 6,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 17,
		"ff_all_asset_sum": 560648294,
		"ff_all_weight_total": 0.03975181030575057,
		"grade_fossil_fam": 3,
		"c2_count_sum": 5,
		"c2_asset_sum": 521923853,
		"c2_weight_total": 0.0370061199160671,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 6,
		"co_asset_sum": 180227396,
		"co_weight_total": 0.012778715880104664,
		"og_count_sum": 11,
		"og_asset_sum": 380420898,
		"og_weight_total": 0.026973094425645903,
		"ut_count_sum": 4,
		"ut_asset_sum": 8954579,
		"ut_weight_total": 0.000634909139268437,
		"cl_count_sum": 34,
		"cl_asset_sum": 2035132043,
		"cl_weight_total": 0.14429756370665173,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 635674677,
		"fossil_bank_weight_total": 0.045071427928528154,
		"fossil_insure_count_sum": 6,
		"fossil_insure_asset_sum": 567200433,
		"fossil_insure_weight_total": 0.040216378537585605,
		"name": "Harding Loevner",
		"fund_family_name": "Harding Loevner",
		"label": "Harding Loevner"
	},
	{
		"fund_family_label": "Flexshares Trust",
		"as_of": "202506",
		"fund_id": 28,
		"net_asset_sum": 20774426645,
		"long_asset_sum": 20774444237,
		"num_equity_funds": 18,
		"equity_fund_net_assets": 14084404689,
		"equity_fund_long_assets": 14084422281,
		"num_e_sri": 4,
		"num_e_usf": 0,
		"sri_long_assets": 369630053,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 327509524,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1028,
		"ff_all_asset_sum": 3285995546,
		"ff_all_weight_total": 0.23330708781948656,
		"grade_fossil_fam": 5,
		"c2_count_sum": 273,
		"c2_asset_sum": 1839361163,
		"c2_weight_total": 0.1305954285026879,
		"mc50_count_sum": 76,
		"mc50_asset_sum": 147224110,
		"mc50_weight_total": 0.01045297471651404,
		"co_count_sum": 263,
		"co_asset_sum": 691554772,
		"co_weight_total": 0.04910068430232407,
		"og_count_sum": 706,
		"og_asset_sum": 2454178488,
		"og_weight_total": 0.1742477212793248,
		"ut_count_sum": 478,
		"ut_asset_sum": 835101871,
		"ut_weight_total": 0.05929258966670995,
		"cl_count_sum": 477,
		"cl_asset_sum": 2287160503,
		"cl_weight_total": 0.16238937298020367,
		"fossil_bank_count_sum": 157,
		"fossil_bank_asset_sum": 244269109,
		"fossil_bank_weight_total": 0.017343211111294284,
		"fossil_insure_count_sum": 67,
		"fossil_insure_asset_sum": 83692788,
		"fossil_insure_weight_total": 0.005942223708593447,
		"name": "Flexshares Trust",
		"fund_family_name": "Flexshares Trust",
		"label": "Flexshares Trust"
	},
	{
		"fund_family_label": "Nationwide",
		"as_of": "202506",
		"fund_id": 45,
		"net_asset_sum": 21346099680,
		"long_asset_sum": 24367576825,
		"num_equity_funds": 23,
		"equity_fund_net_assets": 13989537112,
		"equity_fund_long_assets": 15543293251,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 207090393,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 207090393,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 7,
		"num_five_badgers": 6,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 6,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 571,
		"ff_all_asset_sum": 937257193,
		"ff_all_weight_total": 0.060299781897230835,
		"grade_fossil_fam": 4,
		"c2_count_sum": 147,
		"c2_asset_sum": 302865067,
		"c2_weight_total": 0.019485257217321996,
		"mc50_count_sum": 26,
		"mc50_asset_sum": 206271751,
		"mc50_weight_total": 0.01327078809291134,
		"co_count_sum": 91,
		"co_asset_sum": 111413962,
		"co_weight_total": 0.007167976580048892,
		"og_count_sum": 429,
		"og_asset_sum": 639987396,
		"og_weight_total": 0.04117450437723843,
		"ut_count_sum": 201,
		"ut_asset_sum": 422389721,
		"ut_weight_total": 0.027175046766413222,
		"cl_count_sum": 289,
		"cl_asset_sum": 2223039253,
		"cl_weight_total": 0.1430224095435488,
		"fossil_bank_count_sum": 79,
		"fossil_bank_asset_sum": 352507351,
		"fossil_bank_weight_total": 0.022679064552637258,
		"fossil_insure_count_sum": 51,
		"fossil_insure_asset_sum": 313096675,
		"fossil_insure_weight_total": 0.020143522350378126,
		"name": "Nationwide",
		"fund_family_name": "Nationwide",
		"label": "Nationwide"
	},
	{
		"fund_family_label": "Alger",
		"as_of": "202506",
		"fund_id": 33,
		"net_asset_sum": 13506783298,
		"long_asset_sum": 13885706072,
		"num_equity_funds": 32,
		"equity_fund_net_assets": 13317122265,
		"equity_fund_long_assets": 13620571850,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 80714858,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 80714858,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 26,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 91,
		"ff_all_asset_sum": 496964282,
		"ff_all_weight_total": 0.036486300830313526,
		"grade_fossil_fam": 3,
		"c2_count_sum": 12,
		"c2_asset_sum": 35023433,
		"c2_weight_total": 0.002571362890318001,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 63329662,
		"mc50_weight_total": 0.004649559702590607,
		"co_count_sum": 8,
		"co_asset_sum": 73536431,
		"co_weight_total": 0.005398923907882766,
		"og_count_sum": 53,
		"og_asset_sum": 152913854,
		"og_weight_total": 0.011226683848813587,
		"ut_count_sum": 51,
		"ut_asset_sum": 415004900,
		"ut_weight_total": 0.03046897770301766,
		"cl_count_sum": 162,
		"cl_asset_sum": 3426250152,
		"cl_weight_total": 0.25154965516370736,
		"fossil_bank_count_sum": 13,
		"fossil_bank_asset_sum": 47741197,
		"fossil_bank_weight_total": 0.0035050802217235833,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 4402190,
		"fossil_insure_weight_total": 0.0003232015548598277,
		"name": "Alger",
		"fund_family_name": "Alger",
		"label": "Alger"
	},
	{
		"fund_family_label": "FullerThaler",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 12997664366,
		"long_asset_sum": 12997664366,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 12997664366,
		"equity_fund_long_assets": 12997664366,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 31,
		"ff_all_asset_sum": 385987029,
		"ff_all_weight_total": 0.029696645345735035,
		"grade_fossil_fam": 3,
		"c2_count_sum": 9,
		"c2_asset_sum": 127070571,
		"c2_weight_total": 0.009776415779160918,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 6,
		"co_asset_sum": 34636043,
		"co_weight_total": 0.0026647897671987016,
		"og_count_sum": 23,
		"og_asset_sum": 348352948,
		"og_weight_total": 0.026801195829555396,
		"ut_count_sum": 8,
		"ut_asset_sum": 24155683,
		"ut_weight_total": 0.0018584633607856313,
		"cl_count_sum": 12,
		"cl_asset_sum": 347307745,
		"cl_weight_total": 0.026720781151151014,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 4097987,
		"fossil_bank_weight_total": 0.000315286414897721,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 14117128,
		"fossil_insure_weight_total": 0.0010861280613560353,
		"name": "FullerThaler",
		"fund_family_name": "FullerThaler",
		"label": "FullerThaler"
	},
	{
		"fund_family_label": "Akre",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 12689364909,
		"long_asset_sum": 12689364909,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 12689364909,
		"equity_fund_long_assets": 12689364909,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 2486127465,
		"ff_all_weight_total": 0.195922135018491,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 2486127465,
		"og_weight_total": 0.195922135018491,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Akre",
		"fund_family_name": "Akre",
		"label": "Akre"
	},
	{
		"fund_family_label": "Baillie Gifford Funds",
		"as_of": "202506",
		"fund_id": 12,
		"net_asset_sum": 12457663992,
		"long_asset_sum": 12457663992,
		"num_equity_funds": 12,
		"equity_fund_net_assets": 12457663992,
		"equity_fund_long_assets": 12457663992,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 7,
		"num_five_badgers": 4,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 4,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 26,
		"ff_all_asset_sum": 600135142,
		"ff_all_weight_total": 0.04817397084922115,
		"grade_fossil_fam": 3,
		"c2_count_sum": 10,
		"c2_asset_sum": 220923449,
		"c2_weight_total": 0.017733938653496473,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 5,
		"co_asset_sum": 67446532,
		"co_weight_total": 0.005414059332737861,
		"og_count_sum": 20,
		"og_asset_sum": 532656429,
		"og_weight_total": 0.0427573282873947,
		"ut_count_sum": 3,
		"ut_asset_sum": 54604193,
		"ut_weight_total": 0.004383180750023877,
		"cl_count_sum": 38,
		"cl_asset_sum": 1204633607,
		"cl_weight_total": 0.0966981938005059,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 80048456,
		"fossil_bank_weight_total": 0.006425639353526079,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 85398783,
		"fossil_insure_weight_total": 0.006855120113597618,
		"name": "Baillie Gifford Funds",
		"fund_family_name": "Baillie Gifford Funds",
		"label": "Baillie Gifford Funds"
	},
	{
		"fund_family_label": "MassMutual",
		"as_of": "202506",
		"fund_id": 47,
		"net_asset_sum": 18191331935,
		"long_asset_sum": 18518837629,
		"num_equity_funds": 17,
		"equity_fund_net_assets": 12379416690,
		"equity_fund_long_assets": 12386030385,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 95275208,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 95275208,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 380,
		"ff_all_asset_sum": 734603231,
		"ff_all_weight_total": 0.059309012505704424,
		"grade_fossil_fam": 4,
		"c2_count_sum": 111,
		"c2_asset_sum": 256363185,
		"c2_weight_total": 0.020697768133240375,
		"mc50_count_sum": 23,
		"mc50_asset_sum": 74199230,
		"mc50_weight_total": 0.005990557724600641,
		"co_count_sum": 62,
		"co_asset_sum": 52218446,
		"co_weight_total": 0.004215914572859333,
		"og_count_sum": 293,
		"og_asset_sum": 599281310,
		"og_weight_total": 0.04838364604092645,
		"ut_count_sum": 137,
		"ut_asset_sum": 198976182,
		"ut_weight_total": 0.016064564337010544,
		"cl_count_sum": 235,
		"cl_asset_sum": 1664744901,
		"cl_weight_total": 0.13440503932689166,
		"fossil_bank_count_sum": 55,
		"fossil_bank_asset_sum": 166419974,
		"fossil_bank_weight_total": 0.013436102514453827,
		"fossil_insure_count_sum": 40,
		"fossil_insure_asset_sum": 156731920,
		"fossil_insure_weight_total": 0.012653926651900427,
		"name": "MassMutual",
		"fund_family_name": "MassMutual",
		"label": "MassMutual"
	},
	{
		"fund_family_label": "Xtrackers",
		"as_of": "202506",
		"fund_id": 40,
		"net_asset_sum": 26710741666,
		"long_asset_sum": 36926667981,
		"num_equity_funds": 25,
		"equity_fund_net_assets": 11960945468,
		"equity_fund_long_assets": 11961202063,
		"num_e_sri": 14,
		"num_e_usf": 0,
		"sri_long_assets": 5850419667,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 5850419667,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 8,
		"num_five_badgers": 3,
		"num_sri_badgers": 2,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 2,
		"ff_all_count_sum": 668,
		"ff_all_asset_sum": 819943989,
		"ff_all_weight_total": 0.06855029993485029,
		"grade_fossil_fam": 4,
		"c2_count_sum": 193,
		"c2_asset_sum": 377922907,
		"c2_weight_total": 0.03159572967745792,
		"mc50_count_sum": 40,
		"mc50_asset_sum": 72980251,
		"mc50_weight_total": 0.0061014144410913625,
		"co_count_sum": 144,
		"co_asset_sum": 119558582,
		"co_weight_total": 0.009995532336154966,
		"og_count_sum": 479,
		"og_asset_sum": 678782963,
		"og_weight_total": 0.05674872470382411,
		"ut_count_sum": 279,
		"ut_asset_sum": 291637299,
		"ut_weight_total": 0.02438193899442028,
		"cl_count_sum": 552,
		"cl_asset_sum": 2173712344,
		"cl_weight_total": 0.1817302585936592,
		"fossil_bank_count_sum": 163,
		"fossil_bank_asset_sum": 489134785,
		"fossil_bank_weight_total": 0.040893447199011675,
		"fossil_insure_count_sum": 82,
		"fossil_insure_asset_sum": 417473383,
		"fossil_insure_weight_total": 0.034902293331485874,
		"name": "Xtrackers",
		"fund_family_name": "Xtrackers",
		"label": "Xtrackers"
	},
	{
		"fund_family_label": "American Beacon",
		"as_of": "202506",
		"fund_id": 29,
		"net_asset_sum": 17910144796,
		"long_asset_sum": 18173114248,
		"num_equity_funds": 17,
		"equity_fund_net_assets": 11882091760,
		"equity_fund_long_assets": 11884897410,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 10827721,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 5,
		"num_five_badgers": 4,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 4,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 150,
		"ff_all_asset_sum": 1341687588,
		"ff_all_weight_total": 0.11289012784166726,
		"grade_fossil_fam": 5,
		"c2_count_sum": 59,
		"c2_asset_sum": 492614787,
		"c2_weight_total": 0.04144880431071386,
		"mc50_count_sum": 7,
		"mc50_asset_sum": 122726266,
		"mc50_weight_total": 0.010326236884193686,
		"co_count_sum": 20,
		"co_asset_sum": 164353299,
		"co_weight_total": 0.013828752014444187,
		"og_count_sum": 118,
		"og_asset_sum": 1054512542,
		"og_weight_total": 0.08872710513367402,
		"ut_count_sum": 44,
		"ut_asset_sum": 525555426,
		"ut_weight_total": 0.04422044279135263,
		"cl_count_sum": 85,
		"cl_asset_sum": 712137134,
		"cl_weight_total": 0.05991950198920564,
		"fossil_bank_count_sum": 28,
		"fossil_bank_asset_sum": 286148792,
		"fossil_bank_weight_total": 0.024076673287834464,
		"fossil_insure_count_sum": 19,
		"fossil_insure_asset_sum": 206154354,
		"fossil_insure_weight_total": 0.017345909425060826,
		"name": "American Beacon",
		"fund_family_name": "American Beacon",
		"label": "American Beacon"
	},
	{
		"fund_family_label": "GuideStone Funds",
		"as_of": "202506",
		"fund_id": 26,
		"net_asset_sum": 30005690874,
		"long_asset_sum": 38192773990,
		"num_equity_funds": 10,
		"equity_fund_net_assets": 11615663098,
		"equity_fund_long_assets": 12647379816,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 212407977,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 118136642,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 322,
		"ff_all_asset_sum": 882747059,
		"ff_all_weight_total": 0.06979683316565306,
		"grade_fossil_fam": 4,
		"c2_count_sum": 98,
		"c2_asset_sum": 286358272,
		"c2_weight_total": 0.022641707307448196,
		"mc50_count_sum": 19,
		"mc50_asset_sum": 160193883,
		"mc50_weight_total": 0.01266617159685054,
		"co_count_sum": 52,
		"co_asset_sum": 90054634,
		"co_weight_total": 0.007120418245530454,
		"og_count_sum": 253,
		"og_asset_sum": 643181091,
		"og_weight_total": 0.05085488855061677,
		"ut_count_sum": 125,
		"ut_asset_sum": 405607199,
		"ut_weight_total": 0.03207045292392285,
		"cl_count_sum": 229,
		"cl_asset_sum": 2034401593,
		"cl_weight_total": 0.16085557819860133,
		"fossil_bank_count_sum": 73,
		"fossil_bank_asset_sum": 378130927,
		"fossil_bank_weight_total": 0.029897965626179152,
		"fossil_insure_count_sum": 45,
		"fossil_insure_asset_sum": 280992020,
		"fossil_insure_weight_total": 0.022217409778784492,
		"name": "GuideStone Funds",
		"fund_family_name": "GuideStone Funds",
		"label": "GuideStone Funds"
	},
	{
		"fund_family_label": "FPA",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 21832799002,
		"long_asset_sum": 21883017577,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 11448479411,
		"equity_fund_long_assets": 11496271250,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 14,
		"ff_all_asset_sum": 317159204,
		"ff_all_weight_total": 0.02758800632857371,
		"grade_fossil_fam": 3,
		"c2_count_sum": 3,
		"c2_asset_sum": 142961463,
		"c2_weight_total": 0.012435463629131054,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 2395325,
		"mc50_weight_total": 0.0002083566878260636,
		"co_count_sum": 3,
		"co_asset_sum": 96065340,
		"co_weight_total": 0.008356217238698156,
		"og_count_sum": 5,
		"og_asset_sum": 137224179,
		"og_weight_total": 0.011936407554753895,
		"ut_count_sum": 6,
		"ut_asset_sum": 83869685,
		"ut_weight_total": 0.00729538153512166,
		"cl_count_sum": 15,
		"cl_asset_sum": 910309615,
		"cl_weight_total": 0.07918303206354843,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 400566171,
		"fossil_bank_weight_total": 0.03484313846543939,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 2395325,
		"fossil_insure_weight_total": 0.0002083566878260636,
		"name": "FPA",
		"fund_family_name": "FPA",
		"label": "FPA"
	},
	{
		"fund_family_label": "Davis",
		"as_of": "202506",
		"fund_id": 12,
		"net_asset_sum": 11216520952,
		"long_asset_sum": 11216520952,
		"num_equity_funds": 11,
		"equity_fund_net_assets": 11199939075,
		"equity_fund_long_assets": 11199939075,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 27,
		"ff_all_asset_sum": 1091794111,
		"ff_all_weight_total": 0.09748214733034162,
		"grade_fossil_fam": 5,
		"c2_count_sum": 12,
		"c2_asset_sum": 327006729,
		"c2_weight_total": 0.029197188199883133,
		"mc50_count_sum": 8,
		"mc50_asset_sum": 730280323,
		"mc50_weight_total": 0.06520395495990677,
		"co_count_sum": 4,
		"co_asset_sum": 16837468,
		"co_weight_total": 0.0015033535349834035,
		"og_count_sum": 19,
		"og_asset_sum": 361513788,
		"og_weight_total": 0.03227819237043484,
		"ut_count_sum": 11,
		"ut_asset_sum": 747949914,
		"ut_weight_total": 0.06678160559547508,
		"cl_count_sum": 15,
		"cl_asset_sum": 390846339,
		"cl_weight_total": 0.03489718438490702,
		"fossil_bank_count_sum": 30,
		"fossil_bank_asset_sum": 1196441874,
		"fossil_bank_weight_total": 0.10682574842488596,
		"fossil_insure_count_sum": 21,
		"fossil_insure_asset_sum": 1144588510,
		"fossil_insure_weight_total": 0.10219595859721228,
		"name": "Davis",
		"fund_family_name": "Davis",
		"label": "Davis"
	},
	{
		"fund_family_label": "William Blair",
		"as_of": "202506",
		"fund_id": 19,
		"net_asset_sum": 11115208661,
		"long_asset_sum": 11129847800,
		"num_equity_funds": 18,
		"equity_fund_net_assets": 11067490395,
		"equity_fund_long_assets": 11067635981,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 6,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 77,
		"ff_all_asset_sum": 354538803,
		"ff_all_weight_total": 0.032033833025285875,
		"grade_fossil_fam": 3,
		"c2_count_sum": 27,
		"c2_asset_sum": 101080340,
		"c2_weight_total": 0.009132965718562333,
		"mc50_count_sum": 4,
		"mc50_asset_sum": 5399015,
		"mc50_weight_total": 0.0004878200737057653,
		"co_count_sum": 7,
		"co_asset_sum": 31428983,
		"co_weight_total": 0.00283971961618133,
		"og_count_sum": 68,
		"og_asset_sum": 289339274,
		"og_weight_total": 0.026142825305847942,
		"ut_count_sum": 23,
		"ut_asset_sum": 103001517,
		"ut_weight_total": 0.00930655084580162,
		"cl_count_sum": 66,
		"cl_asset_sum": 1273142954,
		"cl_weight_total": 0.11503296243078705,
		"fossil_bank_count_sum": 23,
		"fossil_bank_asset_sum": 186335007,
		"fossil_bank_weight_total": 0.01683602598783376,
		"fossil_insure_count_sum": 16,
		"fossil_insure_asset_sum": 125973421,
		"fossil_insure_weight_total": 0.011382143505285205,
		"name": "William Blair",
		"fund_family_name": "William Blair",
		"label": "William Blair"
	},
	{
		"fund_family_label": "Wasatch",
		"as_of": "202506",
		"fund_id": 20,
		"net_asset_sum": 11269647293,
		"long_asset_sum": 11292490235,
		"num_equity_funds": 18,
		"equity_fund_net_assets": 11050345353,
		"equity_fund_long_assets": 11050345357,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 14,
		"num_five_badgers": 10,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 10,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 24,
		"ff_all_asset_sum": 155175609,
		"ff_all_weight_total": 0.01404260265057705,
		"grade_fossil_fam": 3,
		"c2_count_sum": 10,
		"c2_asset_sum": 50516383,
		"c2_weight_total": 0.004571475494021522,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 9641580,
		"mc50_weight_total": 0.0008725139068972539,
		"co_count_sum": 1,
		"co_asset_sum": 2620419,
		"co_weight_total": 0.00023713457953963927,
		"og_count_sum": 21,
		"og_asset_sum": 142981090,
		"og_weight_total": 0.012939060760614742,
		"ut_count_sum": 5,
		"ut_asset_sum": 15305892,
		"ut_weight_total": 0.001385105307166193,
		"cl_count_sum": 7,
		"cl_asset_sum": 7736962,
		"cl_weight_total": 0.0007001556738766458,
		"fossil_bank_count_sum": 6,
		"fossil_bank_asset_sum": 10359689,
		"fossil_bank_weight_total": 0.0009374991156667793,
		"fossil_insure_count_sum": 6,
		"fossil_insure_asset_sum": 10091195,
		"fossil_insure_weight_total": 0.0009132017755089969,
		"name": "Wasatch",
		"fund_family_name": "Wasatch",
		"label": "Wasatch"
	},
	{
		"fund_family_label": "ARK ETF Trust",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 10819122327,
		"long_asset_sum": 10819122327,
		"num_equity_funds": 8,
		"equity_fund_net_assets": 10819122327,
		"equity_fund_long_assets": 10819122327,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 8,
		"num_five_badgers": 7,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 7,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 3305790,
		"ff_all_weight_total": 0.0003055506629914085,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 3305790,
		"og_weight_total": 0.0003055506629914085,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 19,
		"cl_asset_sum": 1368067446,
		"cl_weight_total": 0.12644902281822587,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "ARK ETF Trust",
		"fund_family_name": "ARK ETF Trust",
		"label": "ARK ETF Trust"
	},
	{
		"fund_family_label": "Carillon Family of Funds",
		"as_of": "202506",
		"fund_id": 15,
		"net_asset_sum": 15970278590,
		"long_asset_sum": 17152876395,
		"num_equity_funds": 10,
		"equity_fund_net_assets": 10542249769,
		"equity_fund_long_assets": 10542818772,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 66,
		"ff_all_asset_sum": 1110672802,
		"ff_all_weight_total": 0.1053487521714558,
		"grade_fossil_fam": 5,
		"c2_count_sum": 24,
		"c2_asset_sum": 265043611,
		"c2_weight_total": 0.025139729396080716,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 92729255,
		"mc50_weight_total": 0.008795489802620312,
		"co_count_sum": 12,
		"co_asset_sum": 150716194,
		"co_weight_total": 0.014295625985744678,
		"og_count_sum": 53,
		"og_asset_sum": 951578060,
		"og_weight_total": 0.09025841006839988,
		"ut_count_sum": 24,
		"ut_asset_sum": 357883857,
		"ut_weight_total": 0.033945746838642515,
		"cl_count_sum": 42,
		"cl_asset_sum": 611972612,
		"cl_weight_total": 0.058046393970585836,
		"fossil_bank_count_sum": 27,
		"fossil_bank_asset_sum": 142098266,
		"fossil_bank_weight_total": 0.013478204365742274,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 77825843,
		"fossil_insure_weight_total": 0.007381881893549445,
		"name": "Carillon Family of Funds",
		"fund_family_name": "Carillon Family of Funds",
		"label": "Carillon Family of Funds"
	},
	{
		"fund_family_label": "Mutual of America",
		"as_of": "202506",
		"fund_id": 26,
		"net_asset_sum": 23154762907,
		"long_asset_sum": 23155295047,
		"num_equity_funds": 10,
		"equity_fund_net_assets": 10327715605,
		"equity_fund_long_assets": 10328247745,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 307,
		"ff_all_asset_sum": 910034988,
		"ff_all_weight_total": 0.0881112663511152,
		"grade_fossil_fam": 4,
		"c2_count_sum": 82,
		"c2_asset_sum": 341693659,
		"c2_weight_total": 0.03308341041348636,
		"mc50_count_sum": 20,
		"mc50_asset_sum": 148336011,
		"mc50_weight_total": 0.014362166232099809,
		"co_count_sum": 54,
		"co_asset_sum": 108814808,
		"co_weight_total": 0.010535650449775303,
		"og_count_sum": 221,
		"og_asset_sum": 655860913,
		"og_weight_total": 0.06350166351475335,
		"ut_count_sum": 136,
		"ut_asset_sum": 394967523,
		"ut_weight_total": 0.03824148420444382,
		"cl_count_sum": 148,
		"cl_asset_sum": 1682198835,
		"cl_weight_total": 0.1628735944888975,
		"fossil_bank_count_sum": 42,
		"fossil_bank_asset_sum": 378249152,
		"fossil_bank_weight_total": 0.0366227806825329,
		"fossil_insure_count_sum": 22,
		"fossil_insure_asset_sum": 225305717,
		"fossil_insure_weight_total": 0.021814515159076484,
		"name": "Mutual of America",
		"fund_family_name": "Mutual of America",
		"label": "Mutual of America"
	},
	{
		"fund_family_label": "State Farm",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 10789947247,
		"long_asset_sum": 10844470175,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 9977668529,
		"equity_fund_long_assets": 10029875298,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 55,
		"ff_all_asset_sum": 429160052,
		"ff_all_weight_total": 0.042788174254327606,
		"grade_fossil_fam": 3,
		"c2_count_sum": 18,
		"c2_asset_sum": 270988134,
		"c2_weight_total": 0.027018096032962263,
		"mc50_count_sum": 8,
		"mc50_asset_sum": 22949879,
		"mc50_weight_total": 0.002288151977779455,
		"co_count_sum": 8,
		"co_asset_sum": 15825021,
		"co_weight_total": 0.0015777884101067115,
		"og_count_sum": 39,
		"og_asset_sum": 343436744,
		"og_weight_total": 0.03424137726502769,
		"ut_count_sum": 24,
		"ut_asset_sum": 115793682,
		"ut_weight_total": 0.011544877534328842,
		"cl_count_sum": 36,
		"cl_asset_sum": 2246287128,
		"cl_weight_total": 0.22395962674111405,
		"fossil_bank_count_sum": 12,
		"fossil_bank_asset_sum": 133291397,
		"fossil_bank_weight_total": 0.013289437110606836,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 14685711,
		"fossil_insure_weight_total": 0.0014641967685209798,
		"name": "State Farm",
		"fund_family_name": "State Farm",
		"label": "State Farm"
	},
	{
		"fund_family_label": "Diamond Hill Funds",
		"as_of": "202506",
		"fund_id": 11,
		"net_asset_sum": 18024505146,
		"long_asset_sum": 18638242294,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 9859602817,
		"equity_fund_long_assets": 9859602817,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 23,
		"ff_all_asset_sum": 879338318,
		"ff_all_weight_total": 0.08918597780468787,
		"grade_fossil_fam": 4,
		"c2_count_sum": 15,
		"c2_asset_sum": 491543970,
		"c2_weight_total": 0.04985433785958155,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 362714517,
		"mc50_weight_total": 0.036787944071601436,
		"co_count_sum": 2,
		"co_asset_sum": 4050395,
		"co_weight_total": 0.0004108071161868994,
		"og_count_sum": 16,
		"og_asset_sum": 495202215,
		"og_weight_total": 0.05022537156833221,
		"ut_count_sum": 5,
		"ut_asset_sum": 380085708,
		"ut_weight_total": 0.03854979912016876,
		"cl_count_sum": 2,
		"cl_asset_sum": 6623893,
		"cl_weight_total": 0.0006718214843887052,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 201726480,
		"fossil_bank_weight_total": 0.020459899221516482,
		"fossil_insure_count_sum": 8,
		"fossil_insure_asset_sum": 880814747,
		"fossil_insure_weight_total": 0.08933572308625787,
		"name": "Diamond Hill Funds",
		"fund_family_name": "Diamond Hill Funds",
		"label": "Diamond Hill Funds"
	},
	{
		"fund_family_label": "FMI Funds",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 8036601774,
		"long_asset_sum": 11350440230,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 8036601774,
		"equity_fund_long_assets": 11350440230,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 5,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 403226489,
		"ff_all_weight_total": 0.03552518499980683,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 88269809,
		"mc50_weight_total": 0.007776774046763119,
		"co_count_sum": 1,
		"co_asset_sum": 46352250,
		"co_weight_total": 0.004083740283261242,
		"og_count_sum": 6,
		"og_asset_sum": 268604430,
		"og_weight_total": 0.02366467066978247,
		"ut_count_sum": 2,
		"ut_asset_sum": 88269809,
		"ut_weight_total": 0.007776774046763119,
		"cl_count_sum": 6,
		"cl_asset_sum": 210476948,
		"cl_weight_total": 0.018543505250456706,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 240847104,
		"fossil_bank_weight_total": 0.021219186139003175,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 88269809,
		"fossil_insure_weight_total": 0.007776774046763119,
		"name": "FMI Funds",
		"fund_family_name": "FMI Funds",
		"label": "FMI Funds"
	},
	{
		"fund_family_label": "American Growth",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 7597386641,
		"long_asset_sum": 7597386641,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 7597386641,
		"equity_fund_long_assets": 7597386641,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 4,
		"cl_asset_sum": 1342282960,
		"cl_weight_total": 0.17667693161175263,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "American Growth",
		"fund_family_name": "American Growth",
		"label": "American Growth"
	},
	{
		"fund_family_label": "Gabelli",
		"as_of": "202506",
		"fund_id": 27,
		"net_asset_sum": 7806503571,
		"long_asset_sum": 7891216423,
		"num_equity_funds": 24,
		"equity_fund_net_assets": 7398150134,
		"equity_fund_long_assets": 7398806625,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 32057920,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 32057920,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 16,
		"num_five_badgers": 6,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 6,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 234,
		"ff_all_asset_sum": 1592953717,
		"ff_all_weight_total": 0.21529873636885327,
		"grade_fossil_fam": 5,
		"c2_count_sum": 48,
		"c2_asset_sum": 253742094,
		"c2_weight_total": 0.03429500281067286,
		"mc50_count_sum": 13,
		"mc50_asset_sum": 219433449,
		"mc50_weight_total": 0.02965795162946295,
		"co_count_sum": 49,
		"co_asset_sum": 489031042,
		"co_weight_total": 0.06609593503195524,
		"og_count_sum": 166,
		"og_asset_sum": 1024455282,
		"og_weight_total": 0.13846223234682795,
		"ut_count_sum": 118,
		"ut_asset_sum": 1098304270,
		"ut_weight_total": 0.14844343495732326,
		"cl_count_sum": 165,
		"cl_asset_sum": 711496771,
		"cl_weight_total": 0.09616372032158632,
		"fossil_bank_count_sum": 53,
		"fossil_bank_asset_sum": 60480266,
		"fossil_bank_weight_total": 0.00817432716725449,
		"fossil_insure_count_sum": 13,
		"fossil_insure_asset_sum": 55587237,
		"fossil_insure_weight_total": 0.007513000382004172,
		"name": "Gabelli",
		"fund_family_name": "Gabelli",
		"label": "Gabelli"
	},
	{
		"fund_family_label": "Amana",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 7185985697,
		"long_asset_sum": 7185985697,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 6999784628,
		"equity_fund_long_assets": 6999784628,
		"num_e_sri": 3,
		"num_e_usf": 3,
		"sri_long_assets": 6999784628,
		"usf_long_assets": 6999784628,
		"equity_fund_sri_long_assets": 6999784628,
		"equity_fund_usf_long_assets": 6999784628,
		"sustainable_manager": 1,
		"num_c2_free": 3,
		"num_five_badgers": 2,
		"num_sri_badgers": 2,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 2,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 11505764,
		"ff_all_weight_total": 0.00164373114480916,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 8383204,
		"co_weight_total": 0.0011976374196523351,
		"og_count_sum": 2,
		"og_asset_sum": 7495709,
		"og_weight_total": 0.001070848518683881,
		"ut_count_sum": 2,
		"ut_asset_sum": 8383204,
		"ut_weight_total": 0.0011976374196523351,
		"cl_count_sum": 27,
		"cl_asset_sum": 2671526281,
		"cl_weight_total": 0.38165835421758065,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Amana",
		"fund_family_name": "Amana",
		"label": "Amana"
	},
	{
		"fund_family_label": "Catholic Responsible Investments Funds",
		"as_of": "202506",
		"fund_id": 13,
		"net_asset_sum": 13010897140,
		"long_asset_sum": 13011984354,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 6902827013,
		"equity_fund_long_assets": 6903914227,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 166,
		"ff_all_asset_sum": 534794886,
		"ff_all_weight_total": 0.07746256231117571,
		"grade_fossil_fam": 4,
		"c2_count_sum": 44,
		"c2_asset_sum": 173529722,
		"c2_weight_total": 0.025134976521196575,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 104229487,
		"mc50_weight_total": 0.015097158448518482,
		"co_count_sum": 24,
		"co_asset_sum": 44089052,
		"co_weight_total": 0.0063860949818257354,
		"og_count_sum": 123,
		"og_asset_sum": 356719074,
		"og_weight_total": 0.05166910570889397,
		"ut_count_sum": 61,
		"ut_asset_sum": 244601918,
		"ut_weight_total": 0.03542945493780973,
		"cl_count_sum": 89,
		"cl_asset_sum": 1342052324,
		"cl_weight_total": 0.19439006335731523,
		"fossil_bank_count_sum": 24,
		"fossil_bank_asset_sum": 203933065,
		"fossil_bank_weight_total": 0.02953875994033261,
		"fossil_insure_count_sum": 21,
		"fossil_insure_asset_sum": 170616060,
		"fossil_insure_weight_total": 0.024712946075249667,
		"name": "Catholic Responsible Investments Funds",
		"fund_family_name": "Catholic Responsible Investments Funds",
		"label": "Catholic Responsible Investments Funds"
	},
	{
		"fund_family_label": "KraneShares",
		"as_of": "202506",
		"fund_id": 28,
		"net_asset_sum": 7839175550,
		"long_asset_sum": 8063120392,
		"num_equity_funds": 14,
		"equity_fund_net_assets": 6794126538,
		"equity_fund_long_assets": 6794781291,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 546765277,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 110030259,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 9,
		"num_five_badgers": 7,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 7,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 123,
		"ff_all_asset_sum": 31182719,
		"ff_all_weight_total": 0.004589215997474848,
		"grade_fossil_fam": 3,
		"c2_count_sum": 23,
		"c2_asset_sum": 7274575,
		"c2_weight_total": 0.0010706120901397532,
		"mc50_count_sum": 11,
		"mc50_asset_sum": 2349315,
		"mc50_weight_total": 0.00034575285051658333,
		"co_count_sum": 41,
		"co_asset_sum": 6100139,
		"co_weight_total": 0.0008977682634288633,
		"og_count_sum": 86,
		"og_asset_sum": 21406104,
		"og_weight_total": 0.0031503742480060936,
		"ut_count_sum": 61,
		"ut_asset_sum": 13533542,
		"ut_weight_total": 0.0019917553517029016,
		"cl_count_sum": 83,
		"cl_asset_sum": 94355460,
		"cl_weight_total": 0.013886460205125092,
		"fossil_bank_count_sum": 12,
		"fossil_bank_asset_sum": 27784694,
		"fossil_bank_weight_total": 0.004089122638399282,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 4943216,
		"fossil_insure_weight_total": 0.0007275018559534089,
		"name": "KraneShares",
		"fund_family_name": "KraneShares",
		"label": "KraneShares"
	},
	{
		"fund_family_label": "Destinations Funds",
		"as_of": "202506",
		"fund_id": 11,
		"net_asset_sum": 10937827947,
		"long_asset_sum": 11399871479,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 6761377209,
		"equity_fund_long_assets": 6784564725,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 384,
		"ff_all_asset_sum": 649155383,
		"ff_all_weight_total": 0.09568121306411444,
		"grade_fossil_fam": 5,
		"c2_count_sum": 97,
		"c2_asset_sum": 202658972,
		"c2_weight_total": 0.029870593061517296,
		"mc50_count_sum": 18,
		"mc50_asset_sum": 102391198,
		"mc50_weight_total": 0.015091785862504245,
		"co_count_sum": 72,
		"co_asset_sum": 92436815,
		"co_weight_total": 0.013624575598694727,
		"og_count_sum": 290,
		"og_asset_sum": 439812910,
		"og_weight_total": 0.06482551612771296,
		"ut_count_sum": 140,
		"ut_asset_sum": 255211594,
		"ut_weight_total": 0.03761650221414904,
		"cl_count_sum": 167,
		"cl_asset_sum": 907532114,
		"cl_weight_total": 0.13376423555307743,
		"fossil_bank_count_sum": 50,
		"fossil_bank_asset_sum": 222833444,
		"fossil_bank_weight_total": 0.03284417689743538,
		"fossil_insure_count_sum": 25,
		"fossil_insure_asset_sum": 130129329,
		"fossil_insure_weight_total": 0.01918020304537665,
		"name": "Destinations Funds",
		"fund_family_name": "Destinations Funds",
		"label": "Destinations Funds"
	},
	{
		"fund_family_label": "Mercer Funds",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 10536662116,
		"long_asset_sum": 10879237609,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 6575293601,
		"equity_fund_long_assets": 6575324004,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 166,
		"ff_all_asset_sum": 454065579,
		"ff_all_weight_total": 0.06905600069650955,
		"grade_fossil_fam": 4,
		"c2_count_sum": 54,
		"c2_asset_sum": 202733525,
		"c2_weight_total": 0.030832476829532673,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 13441049,
		"mc50_weight_total": 0.002044165274870613,
		"co_count_sum": 47,
		"co_asset_sum": 80115163,
		"co_weight_total": 0.012184215249509094,
		"og_count_sum": 123,
		"og_asset_sum": 389719145,
		"og_weight_total": 0.05926995304914559,
		"ut_count_sum": 55,
		"ut_asset_sum": 116401292,
		"ut_weight_total": 0.01770274619610973,
		"cl_count_sum": 95,
		"cl_asset_sum": 547579721,
		"cl_weight_total": 0.08327798305709165,
		"fossil_bank_count_sum": 55,
		"fossil_bank_asset_sum": 419903558,
		"fossil_bank_weight_total": 0.06386051208192295,
		"fossil_insure_count_sum": 18,
		"fossil_insure_asset_sum": 123664869,
		"fossil_insure_weight_total": 0.018807418299808545,
		"name": "Mercer Funds",
		"fund_family_name": "Mercer Funds",
		"label": "Mercer Funds"
	},
	{
		"fund_family_label": "PIMCO",
		"as_of": "202506",
		"fund_id": 116,
		"net_asset_sum": 427354662788,
		"long_asset_sum": 1300745089518,
		"num_equity_funds": 8,
		"equity_fund_net_assets": 6448922800,
		"equity_fund_long_assets": 6460594275,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 5090745585,
		"usf_long_assets": 5005220488,
		"equity_fund_sri_long_assets": 85525097,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 426,
		"ff_all_asset_sum": 1157219084,
		"ff_all_weight_total": 0.17911960335877924,
		"grade_fossil_fam": 5,
		"c2_count_sum": 103,
		"c2_asset_sum": 494728115,
		"c2_weight_total": 0.07657625505356472,
		"mc50_count_sum": 35,
		"mc50_asset_sum": 76511663,
		"mc50_weight_total": 0.01184282122405837,
		"co_count_sum": 140,
		"co_asset_sum": 432584464,
		"co_weight_total": 0.06695737970637383,
		"og_count_sum": 272,
		"og_asset_sum": 796126149,
		"og_weight_total": 0.12322800583232725,
		"ut_count_sum": 207,
		"ut_asset_sum": 370316009,
		"ut_weight_total": 0.05731918663163537,
		"cl_count_sum": 196,
		"cl_asset_sum": 498529694,
		"cl_weight_total": 0.07716468064387157,
		"fossil_bank_count_sum": 54,
		"fossil_bank_asset_sum": 223491169,
		"fossil_bank_weight_total": 0.03459297387932629,
		"fossil_insure_count_sum": 28,
		"fossil_insure_asset_sum": 121253988,
		"fossil_insure_weight_total": 0.018768240635262612,
		"name": "PIMCO",
		"fund_family_name": "PIMCO",
		"label": "PIMCO"
	},
	{
		"fund_family_label": "Polen Capital",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 6688818683,
		"long_asset_sum": 6706933613,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 6384995054,
		"equity_fund_long_assets": 6403093172,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 7,
		"num_five_badgers": 6,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 6,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 232347,
		"ff_all_weight_total": 0.000036286681102194024,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 232347,
		"og_weight_total": 0.000036286681102194024,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 18,
		"cl_asset_sum": 853121003,
		"cl_weight_total": 0.13323576279205201,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Polen Capital",
		"fund_family_name": "Polen Capital",
		"label": "Polen Capital"
	},
	{
		"fund_family_label": "Impax Asset Management",
		"as_of": "202506",
		"fund_id": 12,
		"net_asset_sum": 9901734936,
		"long_asset_sum": 9904685541,
		"num_equity_funds": 9,
		"equity_fund_net_assets": 6362763090,
		"equity_fund_long_assets": 6363939583,
		"num_e_sri": 9,
		"num_e_usf": 7,
		"sri_long_assets": 9904685541,
		"usf_long_assets": 9780238217,
		"equity_fund_sri_long_assets": 6363939583,
		"equity_fund_usf_long_assets": 6239492259,
		"sustainable_manager": 1,
		"num_c2_free": 9,
		"num_five_badgers": 4,
		"num_sri_badgers": 4,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 3,
		"ff_all_count_sum": 12,
		"ff_all_asset_sum": 119973999,
		"ff_all_weight_total": 0.018852158703782592,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 10,
		"og_asset_sum": 110499839,
		"og_weight_total": 0.01736343306828028,
		"ut_count_sum": 8,
		"ut_asset_sum": 45985334,
		"ut_weight_total": 0.007225922465203894,
		"cl_count_sum": 81,
		"cl_asset_sum": 1214154983,
		"cl_weight_total": 0.19078669229408993,
		"fossil_bank_count_sum": 21,
		"fossil_bank_asset_sum": 180821432,
		"fossil_bank_weight_total": 0.028413442591917203,
		"fossil_insure_count_sum": 13,
		"fossil_insure_asset_sum": 128868319,
		"fossil_insure_weight_total": 0.020249770966438166,
		"name": "Impax Asset Management",
		"fund_family_name": "Impax Asset Management",
		"label": "Impax Asset Management"
	},
	{
		"fund_family_label": "Jensen",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 6266634009,
		"long_asset_sum": 6266891744,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 6266634009,
		"equity_fund_long_assets": 6266891744,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 4,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 4,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 15,
		"cl_asset_sum": 1175345383,
		"cl_weight_total": 0.18754837820922793,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Jensen",
		"fund_family_name": "Jensen",
		"label": "Jensen"
	},
	{
		"fund_family_label": "Mairs & Power",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 6129213757,
		"long_asset_sum": 6130322581,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 6103563187,
		"equity_fund_long_assets": 6104240739,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 278907856,
		"ff_all_weight_total": 0.04569083493350081,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 7478145,
		"c2_weight_total": 0.001225073734759857,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 3,
		"co_asset_sum": 139906553,
		"co_weight_total": 0.022919566737618472,
		"og_count_sum": 3,
		"og_asset_sum": 139001303,
		"og_weight_total": 0.02277126819588234,
		"ut_count_sum": 6,
		"ut_asset_sum": 278907856,
		"ut_weight_total": 0.04569083493350081,
		"cl_count_sum": 8,
		"cl_asset_sum": 1032062681,
		"cl_weight_total": 0.1690730633223802,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 114621601,
		"fossil_bank_weight_total": 0.018777372305728783,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Mairs & Power",
		"fund_family_name": "Mairs & Power",
		"label": "Mairs & Power"
	},
	{
		"fund_family_label": "Eventide Funds",
		"as_of": "202506",
		"fund_id": 10,
		"net_asset_sum": 6400963433,
		"long_asset_sum": 6405727966,
		"num_equity_funds": 8,
		"equity_fund_net_assets": 6094866035,
		"equity_fund_long_assets": 6099630568,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 6222859983,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 5916762585,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 6,
		"num_five_badgers": 2,
		"num_sri_badgers": 2,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 2,
		"ff_all_count_sum": 64,
		"ff_all_asset_sum": 581106320,
		"ff_all_weight_total": 0.0952691008941773,
		"grade_fossil_fam": 5,
		"c2_count_sum": 6,
		"c2_asset_sum": 9320358,
		"c2_weight_total": 0.0015280200818876871,
		"mc50_count_sum": 4,
		"mc50_asset_sum": 4612692,
		"mc50_weight_total": 0.0007562248153518008,
		"co_count_sum": 7,
		"co_asset_sum": 85276260,
		"co_weight_total": 0.013980561453570314,
		"og_count_sum": 52,
		"og_asset_sum": 460449404,
		"og_weight_total": 0.0754880806086222,
		"ut_count_sum": 31,
		"ut_asset_sum": 217144109,
		"ut_weight_total": 0.035599550920212386,
		"cl_count_sum": 26,
		"cl_asset_sum": 240550037,
		"cl_weight_total": 0.03943682069238394,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Eventide Funds",
		"fund_family_name": "Eventide Funds",
		"label": "Eventide Funds"
	},
	{
		"fund_family_label": "Nicholas",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 5928473291,
		"long_asset_sum": 5928473291,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 5928473291,
		"equity_fund_long_assets": 5928473291,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 51014270,
		"ff_all_weight_total": 0.008604959067192667,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 20788838,
		"c2_weight_total": 0.003506609033991851,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 6,
		"og_asset_sum": 38461887,
		"og_weight_total": 0.006487654597076264,
		"ut_count_sum": 3,
		"ut_asset_sum": 24218353,
		"ut_weight_total": 0.004085091019430891,
		"cl_count_sum": 20,
		"cl_asset_sum": 890677000,
		"cl_weight_total": 0.15023716162340386,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 17615095,
		"fossil_bank_weight_total": 0.0029712700277728216,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 9246934,
		"fossil_insure_weight_total": 0.0015597496262718677,
		"name": "Nicholas",
		"fund_family_name": "Nicholas",
		"label": "Nicholas"
	},
	{
		"fund_family_label": "Royce Investment Partners",
		"as_of": "202506",
		"fund_id": 10,
		"net_asset_sum": 5785715296,
		"long_asset_sum": 5796608527,
		"num_equity_funds": 10,
		"equity_fund_net_assets": 5785715296,
		"equity_fund_long_assets": 5796608527,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 7,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 55,
		"ff_all_asset_sum": 207393357,
		"ff_all_weight_total": 0.035778396287067395,
		"grade_fossil_fam": 3,
		"c2_count_sum": 16,
		"c2_asset_sum": 46883891,
		"c2_weight_total": 0.0080881589263135,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 55,
		"og_asset_sum": 207393357,
		"og_weight_total": 0.035778396287067395,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 4,
		"cl_asset_sum": 14192058,
		"cl_weight_total": 0.0024483381849740014,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 19367871,
		"fossil_insure_weight_total": 0.003341241850262351,
		"name": "Royce Investment Partners",
		"fund_family_name": "Royce Investment Partners",
		"label": "Royce Investment Partners"
	},
	{
		"fund_family_label": "Champlain Funds",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 5780892747,
		"long_asset_sum": 5780892747,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 5780892747,
		"equity_fund_long_assets": 5780892747,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 5,
		"cl_asset_sum": 169898145,
		"cl_weight_total": 0.02938960337712005,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 61766100,
		"fossil_insure_weight_total": 0.010684526197455156,
		"name": "Champlain Funds",
		"fund_family_name": "Champlain Funds",
		"label": "Champlain Funds"
	},
	{
		"fund_family_label": "Natixis Funds",
		"as_of": "202506",
		"fund_id": 26,
		"net_asset_sum": 12695302210,
		"long_asset_sum": 12896964758,
		"num_equity_funds": 17,
		"equity_fund_net_assets": 5761532165,
		"equity_fund_long_assets": 5761654745,
		"num_e_sri": 8,
		"num_e_usf": 1,
		"sri_long_assets": 1097106644,
		"usf_long_assets": 862352734,
		"equity_fund_sri_long_assets": 1004593415,
		"equity_fund_usf_long_assets": 862352734,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 270,
		"ff_all_asset_sum": 375151109,
		"ff_all_weight_total": 0.06511169544227871,
		"grade_fossil_fam": 4,
		"c2_count_sum": 94,
		"c2_asset_sum": 188568309,
		"c2_weight_total": 0.03272815143316957,
		"mc50_count_sum": 9,
		"mc50_asset_sum": 33881696,
		"mc50_weight_total": 0.005880549512169702,
		"co_count_sum": 33,
		"co_asset_sum": 19262311,
		"co_weight_total": 0.003343190776350484,
		"og_count_sum": 201,
		"og_asset_sum": 283470683,
		"og_weight_total": 0.04919952609899051,
		"ut_count_sum": 95,
		"ut_asset_sum": 108722776,
		"ut_weight_total": 0.018870060913377413,
		"cl_count_sum": 198,
		"cl_asset_sum": 725447282,
		"cl_weight_total": 0.12590953712204775,
		"fossil_bank_count_sum": 61,
		"fossil_bank_asset_sum": 150634081,
		"fossil_bank_weight_total": 0.026144239401141,
		"fossil_insure_count_sum": 29,
		"fossil_insure_asset_sum": 92574940,
		"fossil_insure_weight_total": 0.016067422311331153,
		"name": "Natixis Funds",
		"fund_family_name": "Natixis Funds",
		"label": "Natixis Funds"
	},
	{
		"fund_family_label": "Delaware Funds by Macquarie",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 8912532464,
		"long_asset_sum": 9525964441,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 5656637997,
		"equity_fund_long_assets": 5658293154,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 80,
		"ff_all_asset_sum": 394401781,
		"ff_all_weight_total": 0.06970331339605244,
		"grade_fossil_fam": 4,
		"c2_count_sum": 25,
		"c2_asset_sum": 149373024,
		"c2_weight_total": 0.02639895458481224,
		"mc50_count_sum": 4,
		"mc50_asset_sum": 62181273,
		"mc50_weight_total": 0.010989404632745545,
		"co_count_sum": 15,
		"co_asset_sum": 26826936,
		"co_weight_total": 0.004741171104051991,
		"og_count_sum": 58,
		"og_asset_sum": 317772917,
		"og_weight_total": 0.05616056085311836,
		"ut_count_sum": 28,
		"ut_asset_sum": 159057415,
		"ut_weight_total": 0.02811049386643356,
		"cl_count_sum": 56,
		"cl_asset_sum": 859331464,
		"cl_weight_total": 0.15187114569921414,
		"fossil_bank_count_sum": 23,
		"fossil_bank_asset_sum": 153147549,
		"fossil_bank_weight_total": 0.027066032959380315,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 95817537,
		"fossil_insure_weight_total": 0.016934000129043156,
		"name": "Delaware Funds by Macquarie",
		"fund_family_name": "Delaware Funds by Macquarie",
		"label": "Delaware Funds by Macquarie"
	},
	{
		"fund_family_label": "Calamos",
		"as_of": "202506",
		"fund_id": 46,
		"net_asset_sum": 24843168378,
		"long_asset_sum": 28678484827,
		"num_equity_funds": 14,
		"equity_fund_net_assets": 5647694098,
		"equity_fund_long_assets": 5647695580,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 17060927,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 17060927,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 5,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 77,
		"ff_all_asset_sum": 219906150,
		"ff_all_weight_total": 0.038937323530458416,
		"grade_fossil_fam": 3,
		"c2_count_sum": 21,
		"c2_asset_sum": 82564313,
		"c2_weight_total": 0.014619115324200955,
		"mc50_count_sum": 5,
		"mc50_asset_sum": 9131197,
		"mc50_weight_total": 0.001616800493343871,
		"co_count_sum": 6,
		"co_asset_sum": 32946134,
		"co_weight_total": 0.005833553443756967,
		"og_count_sum": 65,
		"og_asset_sum": 172564153,
		"og_weight_total": 0.030554790100779477,
		"ut_count_sum": 20,
		"ut_asset_sum": 34397708,
		"ut_weight_total": 0.006090574024883969,
		"cl_count_sum": 115,
		"cl_asset_sum": 1195832912,
		"cl_weight_total": 0.21173820278748098,
		"fossil_bank_count_sum": 34,
		"fossil_bank_asset_sum": 141388279,
		"fossil_bank_weight_total": 0.025034684854596926,
		"fossil_insure_count_sum": 13,
		"fossil_insure_asset_sum": 40048443,
		"fossil_insure_weight_total": 0.007091112194825487,
		"name": "Calamos",
		"fund_family_name": "Calamos",
		"label": "Calamos"
	},
	{
		"fund_family_label": "AQR Funds",
		"as_of": "202506",
		"fund_id": 22,
		"net_asset_sum": 23069906275,
		"long_asset_sum": 93073425432,
		"num_equity_funds": 9,
		"equity_fund_net_assets": 5614479039,
		"equity_fund_long_assets": 5645639795,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 192,
		"ff_all_asset_sum": 434865343,
		"ff_all_weight_total": 0.07702676025933036,
		"grade_fossil_fam": 4,
		"c2_count_sum": 64,
		"c2_asset_sum": 201883241,
		"c2_weight_total": 0.03575914304323767,
		"mc50_count_sum": 9,
		"mc50_asset_sum": 51626758,
		"mc50_weight_total": 0.009144536292542553,
		"co_count_sum": 40,
		"co_asset_sum": 65728643,
		"co_weight_total": 0.01164237276671669,
		"og_count_sum": 147,
		"og_asset_sum": 303971643,
		"og_weight_total": 0.053841841498497515,
		"ut_count_sum": 65,
		"ut_asset_sum": 149301707,
		"ut_weight_total": 0.02644548933713898,
		"cl_count_sum": 109,
		"cl_asset_sum": 689003183,
		"cl_weight_total": 0.1220416477172717,
		"fossil_bank_count_sum": 78,
		"fossil_bank_asset_sum": 181290995,
		"fossil_bank_weight_total": 0.032111682923972304,
		"fossil_insure_count_sum": 38,
		"fossil_insure_asset_sum": 148671650,
		"fossil_insure_weight_total": 0.026333888699677482,
		"name": "AQR Funds",
		"fund_family_name": "AQR Funds",
		"label": "AQR Funds"
	},
	{
		"fund_family_label": "Amplify ETFs",
		"as_of": "202506",
		"fund_id": 32,
		"net_asset_sum": 11214146270,
		"long_asset_sum": 11392889643,
		"num_equity_funds": 20,
		"equity_fund_net_assets": 5250260046,
		"equity_fund_long_assets": 5259576716,
		"num_e_sri": 2,
		"num_e_usf": 1,
		"sri_long_assets": 207069676,
		"usf_long_assets": 150215255,
		"equity_fund_sri_long_assets": 207069676,
		"equity_fund_usf_long_assets": 150215255,
		"sustainable_manager": 0,
		"num_c2_free": 12,
		"num_five_badgers": 12,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 12,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 125,
		"ff_all_asset_sum": 84848113,
		"ff_all_weight_total": 0.016132118149714617,
		"grade_fossil_fam": 3,
		"c2_count_sum": 41,
		"c2_asset_sum": 33664892,
		"c2_weight_total": 0.006400684659202526,
		"mc50_count_sum": 4,
		"mc50_asset_sum": 2904574,
		"mc50_weight_total": 0.0005522448206077274,
		"co_count_sum": 10,
		"co_asset_sum": 17671665,
		"co_weight_total": 0.0033599025081698227,
		"og_count_sum": 115,
		"og_asset_sum": 71795193,
		"og_weight_total": 0.013650374712017034,
		"ut_count_sum": 14,
		"ut_asset_sum": 19542545,
		"ut_weight_total": 0.0037156117412548073,
		"cl_count_sum": 68,
		"cl_asset_sum": 431723133,
		"cl_weight_total": 0.08208324667775413,
		"fossil_bank_count_sum": 9,
		"fossil_bank_asset_sum": 41436750,
		"fossil_bank_weight_total": 0.007878343113419471,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 1457452,
		"fossil_insure_weight_total": 0.00027710442849256844,
		"name": "Amplify ETFs",
		"fund_family_name": "Amplify ETFs",
		"label": "Amplify ETFs"
	},
	{
		"fund_family_label": "Tweedy, Browne",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 5241261855,
		"long_asset_sum": 8375479300,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 5241261855,
		"equity_fund_long_assets": 8375479300,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 39,
		"ff_all_asset_sum": 295595024,
		"ff_all_weight_total": 0.035292908430924065,
		"grade_fossil_fam": 3,
		"c2_count_sum": 15,
		"c2_asset_sum": 185019167,
		"c2_weight_total": 0.02209057659541944,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 21557923,
		"mc50_weight_total": 0.002573933052404535,
		"co_count_sum": 3,
		"co_asset_sum": 692413,
		"co_weight_total": 0.00008267144782985733,
		"og_count_sum": 33,
		"og_asset_sum": 272116651,
		"og_weight_total": 0.03248968103831383,
		"ut_count_sum": 5,
		"ut_asset_sum": 23306986,
		"ut_weight_total": 0.002782764444298728,
		"cl_count_sum": 20,
		"cl_asset_sum": 205748766,
		"cl_weight_total": 0.02456561094957276,
		"fossil_bank_count_sum": 15,
		"fossil_bank_asset_sum": 81943160,
		"fossil_bank_weight_total": 0.009783697990871996,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 151248461,
		"fossil_insure_weight_total": 0.018058484246985126,
		"name": "Tweedy, Browne",
		"fund_family_name": "Tweedy, Browne",
		"label": "Tweedy, Browne"
	},
	{
		"fund_family_label": "RBC Global Asset Management.",
		"as_of": "202506",
		"fund_id": 21,
		"net_asset_sum": 7248067413,
		"long_asset_sum": 7375983386,
		"num_equity_funds": 13,
		"equity_fund_net_assets": 4961535737,
		"equity_fund_long_assets": 4964835663,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 2107960027,
		"usf_long_assets": 761127303,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 7,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 71,
		"ff_all_asset_sum": 72946459,
		"ff_all_weight_total": 0.014692623069808142,
		"grade_fossil_fam": 3,
		"c2_count_sum": 10,
		"c2_asset_sum": 2600319,
		"c2_weight_total": 0.0005237472449246706,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 37235,
		"mc50_weight_total": 0.000007499744710079843,
		"co_count_sum": 7,
		"co_asset_sum": 2637241,
		"co_weight_total": 0.0005311839462590486,
		"og_count_sum": 52,
		"og_asset_sum": 65890801,
		"og_weight_total": 0.013271496877740664,
		"ut_count_sum": 16,
		"ut_asset_sum": 21634052,
		"ut_weight_total": 0.004357455808905391,
		"cl_count_sum": 29,
		"cl_asset_sum": 408724462,
		"cl_weight_total": 0.08232386522800403,
		"fossil_bank_count_sum": 13,
		"fossil_bank_asset_sum": 10354520,
		"fossil_bank_weight_total": 0.002085571548151361,
		"fossil_insure_count_sum": 9,
		"fossil_insure_asset_sum": 167799901,
		"fossil_insure_weight_total": 0.03379767476505093,
		"name": "RBC Global Asset Management.",
		"fund_family_name": "RBC Global Asset Management.",
		"label": "RBC Global Asset Management."
	},
	{
		"fund_family_label": "Driehaus",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 5104968838,
		"long_asset_sum": 5107578043,
		"num_equity_funds": 8,
		"equity_fund_net_assets": 4914344768,
		"equity_fund_long_assets": 4915752948,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 42,
		"ff_all_asset_sum": 206853510,
		"ff_all_weight_total": 0.04207972047988283,
		"grade_fossil_fam": 3,
		"c2_count_sum": 14,
		"c2_asset_sum": 49453021,
		"c2_weight_total": 0.010060111141289194,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 4,
		"co_asset_sum": 68688308,
		"co_weight_total": 0.013973100098113393,
		"og_count_sum": 38,
		"og_asset_sum": 153861465,
		"og_weight_total": 0.03129967405351389,
		"ut_count_sum": 5,
		"ut_asset_sum": 33450880,
		"ut_weight_total": 0.0068048334311856876,
		"cl_count_sum": 26,
		"cl_asset_sum": 437110967,
		"cl_weight_total": 0.08892045056451442,
		"fossil_bank_count_sum": 14,
		"fossil_bank_asset_sum": 137166916,
		"fossil_bank_weight_total": 0.0279035414210161,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 41700,
		"fossil_insure_weight_total": 0.000008482932409564208,
		"name": "Driehaus",
		"fund_family_name": "Driehaus",
		"label": "Driehaus"
	},
	{
		"fund_family_label": "Matthews Asia Funds",
		"as_of": "202506",
		"fund_id": 24,
		"net_asset_sum": 4872548605,
		"long_asset_sum": 4892556699,
		"num_equity_funds": 24,
		"equity_fund_net_assets": 4872548605,
		"equity_fund_long_assets": 4892556699,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 225987111,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 225987111,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 14,
		"num_five_badgers": 2,
		"num_sri_badgers": 2,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 2,
		"ff_all_count_sum": 54,
		"ff_all_asset_sum": 182776065,
		"ff_all_weight_total": 0.03735798606837975,
		"grade_fossil_fam": 3,
		"c2_count_sum": 14,
		"c2_asset_sum": 51667143,
		"c2_weight_total": 0.010560356512692097,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 778493,
		"mc50_weight_total": 0.00015911782895824546,
		"co_count_sum": 10,
		"co_asset_sum": 48442801,
		"co_weight_total": 0.009901326439385225,
		"og_count_sum": 47,
		"og_asset_sum": 152189744,
		"og_weight_total": 0.031106383300801885,
		"ut_count_sum": 15,
		"ut_asset_sum": 84211491,
		"ut_weight_total": 0.017212164555438298,
		"cl_count_sum": 65,
		"cl_asset_sum": 324904941,
		"cl_weight_total": 0.06640800730350412,
		"fossil_bank_count_sum": 48,
		"fossil_bank_asset_sum": 237928156,
		"fossil_bank_weight_total": 0.04863063846528966,
		"fossil_insure_count_sum": 19,
		"fossil_insure_asset_sum": 74064117,
		"fossil_insure_weight_total": 0.015138121345663325,
		"name": "Matthews Asia Funds",
		"fund_family_name": "Matthews Asia Funds",
		"label": "Matthews Asia Funds"
	},
	{
		"fund_family_label": "Tortoise Capital Advisors, LLC",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 4857779560,
		"long_asset_sum": 4858734666,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 4857779560,
		"equity_fund_long_assets": 4858734666,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 54268921,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 54268921,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 118,
		"ff_all_asset_sum": 4597150106,
		"ff_all_weight_total": 0.9461619993718752,
		"grade_fossil_fam": 5,
		"c2_count_sum": 8,
		"c2_asset_sum": 126272363,
		"c2_weight_total": 0.025988734038846977,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 2744194,
		"mc50_weight_total": 0.000564796019672172,
		"co_count_sum": 4,
		"co_asset_sum": 39452737,
		"co_weight_total": 0.008119961206377183,
		"og_count_sum": 104,
		"og_asset_sum": 4478964793,
		"og_weight_total": 0.9218377007377007,
		"ut_count_sum": 28,
		"ut_asset_sum": 229443557,
		"ut_weight_total": 0.047222903239721795,
		"cl_count_sum": 5,
		"cl_asset_sum": 11658374,
		"cl_weight_total": 0.00239946710438458,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Tortoise Capital Advisors, LLC",
		"fund_family_name": "Tortoise Capital Advisors, LLC",
		"label": "Tortoise Capital Advisors, LLC"
	},
	{
		"fund_family_label": "CIBC Private Wealth Management",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 4710984719,
		"long_asset_sum": 4711252176,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 4710984719,
		"equity_fund_long_assets": 4711252176,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 32,
		"ff_all_asset_sum": 394177951,
		"ff_all_weight_total": 0.08366734283679746,
		"grade_fossil_fam": 4,
		"c2_count_sum": 9,
		"c2_asset_sum": 113664264,
		"c2_weight_total": 0.024126126081517568,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 12591111,
		"co_weight_total": 0.0026725614612907954,
		"og_count_sum": 29,
		"og_asset_sum": 369623380,
		"og_weight_total": 0.07845544373169636,
		"ut_count_sum": 6,
		"ut_asset_sum": 55955496,
		"ut_weight_total": 0.011876990216114469,
		"cl_count_sum": 31,
		"cl_asset_sum": 724911331,
		"cl_weight_total": 0.15386808090911244,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 101922977,
		"fossil_bank_weight_total": 0.021633946388863394,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 22808911,
		"fossil_insure_weight_total": 0.004841369162150322,
		"name": "CIBC Private Wealth Management",
		"fund_family_name": "CIBC Private Wealth Management",
		"label": "CIBC Private Wealth Management"
	},
	{
		"fund_family_label": "JOHCM Funds",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 4688440654,
		"long_asset_sum": 4705465549,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 4679069423,
		"equity_fund_long_assets": 4696046802,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 37,
		"ff_all_asset_sum": 548122922,
		"ff_all_weight_total": 0.11672007224599207,
		"grade_fossil_fam": 5,
		"c2_count_sum": 4,
		"c2_asset_sum": 21491660,
		"c2_weight_total": 0.004576542974581709,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 2172100,
		"mc50_weight_total": 0.0004625379796204169,
		"co_count_sum": 3,
		"co_asset_sum": 13904336,
		"co_weight_total": 0.0029608597584841532,
		"og_count_sum": 27,
		"og_asset_sum": 347064172,
		"og_weight_total": 0.07390560329428335,
		"ut_count_sum": 13,
		"ut_asset_sum": 282723570,
		"ut_weight_total": 0.06020458950272617,
		"cl_count_sum": 17,
		"cl_asset_sum": 261965559,
		"cl_weight_total": 0.055784273463465366,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 85747950,
		"fossil_bank_weight_total": 0.01825960294166591,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 4442030,
		"fossil_insure_weight_total": 0.0009459083751269649,
		"name": "JOHCM Funds",
		"fund_family_name": "JOHCM Funds",
		"label": "JOHCM Funds"
	},
	{
		"fund_family_label": "Smead Funds",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 4670496775,
		"long_asset_sum": 4670496775,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 4670496775,
		"equity_fund_long_assets": 4670496775,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 17,
		"ff_all_asset_sum": 1083856655,
		"ff_all_weight_total": 0.2320645334349899,
		"grade_fossil_fam": 5,
		"c2_count_sum": 15,
		"c2_asset_sum": 994984454,
		"c2_weight_total": 0.21303610770612297,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 82898512,
		"mc50_weight_total": 0.017749399259568057,
		"co_count_sum": 5,
		"co_asset_sum": 157747530,
		"co_weight_total": 0.0337753214699522,
		"og_count_sum": 13,
		"og_asset_sum": 991894336,
		"og_weight_total": 0.21237448258381464,
		"ut_count_sum": 1,
		"ut_asset_sum": 82898512,
		"ut_weight_total": 0.017749399259568057,
		"cl_count_sum": 5,
		"cl_asset_sum": 497032631,
		"cl_weight_total": 0.10641964975984808,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 157647915,
		"fossil_bank_weight_total": 0.03375399290367779,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 89022095,
		"fossil_insure_weight_total": 0.019060519531137028,
		"name": "Smead Funds",
		"fund_family_name": "Smead Funds",
		"label": "Smead Funds"
	},
	{
		"fund_family_label": "Value Line",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 4645353232,
		"long_asset_sum": 4645353232,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 4609842370,
		"equity_fund_long_assets": 4609842370,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 4,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 4,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 14905360,
		"ff_all_weight_total": 0.003233377370341624,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 10711960,
		"c2_weight_total": 0.002323715029761419,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 14905360,
		"og_weight_total": 0.003233377370341624,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 21,
		"cl_asset_sum": 334468115,
		"cl_weight_total": 0.07255521732731178,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 9988705,
		"fossil_bank_weight_total": 0.0021668213787535647,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Value Line",
		"fund_family_name": "Value Line",
		"label": "Value Line"
	},
	{
		"fund_family_label": "Column Funds",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 4504254770,
		"long_asset_sum": 4517635161,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 4504254770,
		"equity_fund_long_assets": 4517635161,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 210,
		"ff_all_asset_sum": 341513199,
		"ff_all_weight_total": 0.0755955686612826,
		"grade_fossil_fam": 4,
		"c2_count_sum": 53,
		"c2_asset_sum": 107833034,
		"c2_weight_total": 0.02386935424332288,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 11027865,
		"mc50_weight_total": 0.0024410702960703293,
		"co_count_sum": 32,
		"co_asset_sum": 51254488,
		"co_weight_total": 0.01134542435884853,
		"og_count_sum": 161,
		"og_asset_sum": 244291914,
		"og_weight_total": 0.05407517546103144,
		"ut_count_sum": 61,
		"ut_asset_sum": 130990803,
		"ut_weight_total": 0.02899543640239522,
		"cl_count_sum": 28,
		"cl_asset_sum": 71263082,
		"cl_weight_total": 0.015774421674242853,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 6670034,
		"fossil_bank_weight_total": 0.0014764437061189236,
		"fossil_insure_count_sum": 6,
		"fossil_insure_asset_sum": 9257299,
		"fossil_insure_weight_total": 0.0020491471024302135,
		"name": "Column Funds",
		"fund_family_name": "Column Funds",
		"label": "Column Funds"
	},
	{
		"fund_family_label": "Conestoga Capital Advisors",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 4262305246,
		"long_asset_sum": 4262305246,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 4262305246,
		"equity_fund_long_assets": 4262305246,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 4,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 4,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 215066,
		"cl_weight_total": 0.000050457671984387014,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Conestoga Capital Advisors",
		"fund_family_name": "Conestoga Capital Advisors",
		"label": "Conestoga Capital Advisors"
	},
	{
		"fund_family_label": "Hennessy",
		"as_of": "202506",
		"fund_id": 17,
		"net_asset_sum": 4230282667,
		"long_asset_sum": 4254559350,
		"num_equity_funds": 15,
		"equity_fund_net_assets": 4166715131,
		"equity_fund_long_assets": 4170303314,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 91103276,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 91103276,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 8,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 115,
		"ff_all_asset_sum": 921332534,
		"ff_all_weight_total": 0.22092698411336706,
		"grade_fossil_fam": 5,
		"c2_count_sum": 32,
		"c2_asset_sum": 132806641,
		"c2_weight_total": 0.03184579897441964,
		"mc50_count_sum": 5,
		"mc50_asset_sum": 50179094,
		"mc50_weight_total": 0.012032480666704811,
		"co_count_sum": 11,
		"co_asset_sum": 53548224,
		"co_weight_total": 0.0128403667474821,
		"og_count_sum": 85,
		"og_asset_sum": 647926471,
		"og_weight_total": 0.1553667496617969,
		"ut_count_sum": 47,
		"ut_asset_sum": 445266521,
		"ut_weight_total": 0.10677077600212175,
		"cl_count_sum": 24,
		"cl_asset_sum": 79146753,
		"cl_weight_total": 0.0189786562368974,
		"fossil_bank_count_sum": 17,
		"fossil_bank_asset_sum": 78232776,
		"fossil_bank_weight_total": 0.01875949304151741,
		"fossil_insure_count_sum": 8,
		"fossil_insure_asset_sum": 89344373,
		"fossil_insure_weight_total": 0.02142395079515312,
		"name": "Hennessy",
		"fund_family_name": "Hennessy",
		"label": "Hennessy"
	},
	{
		"fund_family_label": "Boston Trust Walden Funds",
		"as_of": "202506",
		"fund_id": 10,
		"net_asset_sum": 4077872894,
		"long_asset_sum": 4077872894,
		"num_equity_funds": 10,
		"equity_fund_net_assets": 4077872894,
		"equity_fund_long_assets": 4077872894,
		"num_e_sri": 10,
		"num_e_usf": 4,
		"sri_long_assets": 4077872894,
		"usf_long_assets": 833987591,
		"equity_fund_sri_long_assets": 4077872894,
		"equity_fund_usf_long_assets": 833987591,
		"sustainable_manager": 1,
		"num_c2_free": 4,
		"num_five_badgers": 1,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 47,
		"ff_all_asset_sum": 255317507,
		"ff_all_weight_total": 0.06261046227695394,
		"grade_fossil_fam": 4,
		"c2_count_sum": 11,
		"c2_asset_sum": 47568976,
		"c2_weight_total": 0.011665144362393165,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 15330938,
		"mc50_weight_total": 0.003759542878974295,
		"co_count_sum": 2,
		"co_asset_sum": 23084115,
		"co_weight_total": 0.005660822590612114,
		"og_count_sum": 30,
		"og_asset_sum": 159048079,
		"og_weight_total": 0.03900270634575596,
		"ut_count_sum": 23,
		"ut_asset_sum": 134546845,
		"ut_weight_total": 0.03299436949051703,
		"cl_count_sum": 38,
		"cl_asset_sum": 288086626,
		"cl_weight_total": 0.07064629856999168,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 18237519,
		"fossil_bank_weight_total": 0.0044723117846154235,
		"fossil_insure_count_sum": 10,
		"fossil_insure_asset_sum": 43734436,
		"fossil_insure_weight_total": 0.010724815887309508,
		"name": "Boston Trust Walden Funds",
		"fund_family_name": "Boston Trust Walden Funds",
		"label": "Boston Trust Walden Funds"
	},
	{
		"fund_family_label": "Davenport",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 4045914754,
		"long_asset_sum": 4045914754,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 4045914754,
		"equity_fund_long_assets": 4045914754,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 26,
		"ff_all_asset_sum": 417000032,
		"ff_all_weight_total": 0.10306693476122607,
		"grade_fossil_fam": 5,
		"c2_count_sum": 6,
		"c2_asset_sum": 107347771,
		"c2_weight_total": 0.026532385758713885,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 51524985,
		"mc50_weight_total": 0.012735064412580552,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 22,
		"og_asset_sum": 363632029,
		"og_weight_total": 0.0898763446858327,
		"ut_count_sum": 7,
		"ut_asset_sum": 92282785,
		"ut_weight_total": 0.022808880218933056,
		"cl_count_sum": 20,
		"cl_asset_sum": 334882155,
		"cl_weight_total": 0.08277044262213341,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 39845816,
		"fossil_bank_weight_total": 0.00984840720151268,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 51524985,
		"fossil_insure_weight_total": 0.012735064412580552,
		"name": "Davenport",
		"fund_family_name": "Davenport",
		"label": "Davenport"
	},
	{
		"fund_family_label": "UBS",
		"as_of": "202506",
		"fund_id": 26,
		"net_asset_sum": 5850745832,
		"long_asset_sum": 6625781382,
		"num_equity_funds": 14,
		"equity_fund_net_assets": 3708968734,
		"equity_fund_long_assets": 3721139260,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 260698030,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 201362841,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 130,
		"ff_all_asset_sum": 273353667,
		"ff_all_weight_total": 0.0734596713265711,
		"grade_fossil_fam": 4,
		"c2_count_sum": 43,
		"c2_asset_sum": 103643912,
		"c2_weight_total": 0.027852736691182045,
		"mc50_count_sum": 11,
		"mc50_asset_sum": 29791417,
		"mc50_weight_total": 0.008005993573054291,
		"co_count_sum": 19,
		"co_asset_sum": 27836891,
		"co_weight_total": 0.007480744217027771,
		"og_count_sum": 103,
		"og_asset_sum": 237304466,
		"og_weight_total": 0.06377199277406242,
		"ut_count_sum": 50,
		"ut_asset_sum": 91766351,
		"ut_weight_total": 0.024660821481859833,
		"cl_count_sum": 102,
		"cl_asset_sum": 576716544,
		"cl_weight_total": 0.15498386480703763,
		"fossil_bank_count_sum": 25,
		"fossil_bank_asset_sum": 96445170,
		"fossil_bank_weight_total": 0.025918183454386495,
		"fossil_insure_count_sum": 16,
		"fossil_insure_asset_sum": 72632431,
		"fossil_insure_weight_total": 0.01951886933680628,
		"name": "UBS",
		"fund_family_name": "UBS",
		"label": "UBS"
	},
	{
		"fund_family_label": "Ariel Investments",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 3611448214,
		"long_asset_sum": 3616972630,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 3611448214,
		"equity_fund_long_assets": 3616972630,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 17,
		"ff_all_asset_sum": 266741556,
		"ff_all_weight_total": 0.07374718674606061,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 5427600,
		"c2_weight_total": 0.001500591946696594,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 1745779,
		"co_weight_total": 0.00048266303856438084,
		"og_count_sum": 14,
		"og_asset_sum": 260330746,
		"og_weight_total": 0.07197476249633661,
		"ut_count_sum": 4,
		"ut_asset_sum": 8156589,
		"ut_weight_total": 0.0022550872882883826,
		"cl_count_sum": 14,
		"cl_asset_sum": 51781509,
		"cl_weight_total": 0.014316256797331641,
		"fossil_bank_count_sum": 12,
		"fossil_bank_asset_sum": 35959620,
		"fossil_bank_weight_total": 0.009941911006387682,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 6049329,
		"fossil_insure_weight_total": 0.001672484040886978,
		"name": "Ariel Investments",
		"fund_family_name": "Ariel Investments",
		"label": "Ariel Investments"
	},
	{
		"fund_family_label": "Bahl & Gaynor Inc.",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 3601468531,
		"long_asset_sum": 3602852361,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 3601468531,
		"equity_fund_long_assets": 3602852361,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 27,
		"ff_all_asset_sum": 617609877,
		"ff_all_weight_total": 0.17142247728091126,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 82386392,
		"c2_weight_total": 0.022866990857525176,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 31156322,
		"mc50_weight_total": 0.008647682135759878,
		"co_count_sum": 1,
		"co_asset_sum": 21105323,
		"co_weight_total": 0.005857948337950227,
		"og_count_sum": 22,
		"og_asset_sum": 551203283,
		"og_weight_total": 0.15299080499846215,
		"ut_count_sum": 12,
		"ut_asset_sum": 265115818,
		"ut_weight_total": 0.07358497974266562,
		"cl_count_sum": 11,
		"cl_asset_sum": 393912979,
		"cl_weight_total": 0.10933364443794925,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 39730172,
		"fossil_bank_weight_total": 0.011027421614626633,
		"fossil_insure_count_sum": 5,
		"fossil_insure_asset_sum": 155982938,
		"fossil_insure_weight_total": 0.04329429084812837,
		"name": "Bahl & Gaynor Inc.",
		"fund_family_name": "Bahl & Gaynor Inc.",
		"label": "Bahl & Gaynor Inc."
	},
	{
		"fund_family_label": "Sprott",
		"as_of": "202506",
		"fund_id": 12,
		"net_asset_sum": 3565391379,
		"long_asset_sum": 3567926204,
		"num_equity_funds": 12,
		"equity_fund_net_assets": 3565391379,
		"equity_fund_long_assets": 3567926204,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 12,
		"num_five_badgers": 5,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 5,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 10,
		"ff_all_asset_sum": 22488107,
		"ff_all_weight_total": 0.006302850931947134,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 79757,
		"co_weight_total": 0.00002235388162193054,
		"og_count_sum": 8,
		"og_asset_sum": 22408350,
		"og_weight_total": 0.0062804970503252035,
		"ut_count_sum": 2,
		"ut_asset_sum": 79757,
		"ut_weight_total": 0.00002235388162193054,
		"cl_count_sum": 7,
		"cl_asset_sum": 69509585,
		"cl_weight_total": 0.019481788867178038,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Sprott",
		"fund_family_name": "Sprott",
		"label": "Sprott"
	},
	{
		"fund_family_label": "Hood River Capital Management",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 3495577387,
		"long_asset_sum": 3501660022,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 3495577387,
		"equity_fund_long_assets": 3501660022,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 17,
		"ff_all_asset_sum": 156729007,
		"ff_all_weight_total": 0.044758487693069365,
		"grade_fossil_fam": 3,
		"c2_count_sum": 4,
		"c2_asset_sum": 27442190,
		"c2_weight_total": 0.00783690873116979,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1353814,
		"mc50_weight_total": 0.00038662062892866415,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 15,
		"og_asset_sum": 143831184,
		"og_weight_total": 0.041075142388566244,
		"ut_count_sum": 5,
		"ut_asset_sum": 74332945,
		"ut_weight_total": 0.02122791605495275,
		"cl_count_sum": 6,
		"cl_asset_sum": 46472292,
		"cl_weight_total": 0.013271503146515347,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Hood River Capital Management",
		"fund_family_name": "Hood River Capital Management",
		"label": "Hood River Capital Management"
	},
	{
		"fund_family_label": "Pear Tree Funds",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 3494241171,
		"long_asset_sum": 3494431518,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 3494241171,
		"equity_fund_long_assets": 3494431518,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 35891519,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 35891519,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 15,
		"ff_all_asset_sum": 254212973,
		"ff_all_weight_total": 0.0727480197252502,
		"grade_fossil_fam": 4,
		"c2_count_sum": 4,
		"c2_asset_sum": 136106932,
		"c2_weight_total": 0.038949663571572674,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 43306454,
		"co_weight_total": 0.012392989754392434,
		"og_count_sum": 12,
		"og_asset_sum": 215048083,
		"og_weight_total": 0.0615402196014648,
		"ut_count_sum": 6,
		"ut_asset_sum": 128407564,
		"ut_weight_total": 0.036746338664405326,
		"cl_count_sum": 19,
		"cl_asset_sum": 320691610,
		"cl_weight_total": 0.09177218335746479,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 13780390,
		"fossil_bank_weight_total": 0.003943528419148147,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 99750758,
		"fossil_insure_weight_total": 0.028545632525971282,
		"name": "Pear Tree Funds",
		"fund_family_name": "Pear Tree Funds",
		"label": "Pear Tree Funds"
	},
	{
		"fund_family_label": "Brandes",
		"as_of": "202506",
		"fund_id": 10,
		"net_asset_sum": 3768553636,
		"long_asset_sum": 3770266581,
		"num_equity_funds": 8,
		"equity_fund_net_assets": 3459257464,
		"equity_fund_long_assets": 3459731550,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 38,
		"ff_all_asset_sum": 200375938,
		"ff_all_weight_total": 0.05791661436853388,
		"grade_fossil_fam": 4,
		"c2_count_sum": 14,
		"c2_asset_sum": 115887965,
		"c2_weight_total": 0.033496230365040895,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 2927312,
		"mc50_weight_total": 0.0008461095774901957,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 33,
		"og_asset_sum": 187864533,
		"og_weight_total": 0.05430032078644946,
		"ut_count_sum": 11,
		"ut_asset_sum": 57909758,
		"ut_weight_total": 0.016738222941025584,
		"cl_count_sum": 43,
		"cl_asset_sum": 464794091,
		"cl_weight_total": 0.13434397561857075,
		"fossil_bank_count_sum": 20,
		"fossil_bank_asset_sum": 129209108,
		"fossil_bank_weight_total": 0.03734657042972019,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 3962578,
		"fossil_insure_weight_total": 0.0011453426205856926,
		"name": "Brandes",
		"fund_family_name": "Brandes",
		"label": "Brandes"
	},
	{
		"fund_family_label": "BBH",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 15927197750,
		"long_asset_sum": 16675304478,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 3448306292,
		"equity_fund_long_assets": 3448306292,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 67713175,
		"ff_all_weight_total": 0.019636647462869868,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 34207605,
		"c2_weight_total": 0.009920117908133899,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 26509000,
		"mc50_weight_total": 0.007687542159900453,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 41204175,
		"og_weight_total": 0.011949105302969415,
		"ut_count_sum": 1,
		"ut_asset_sum": 26509000,
		"ut_weight_total": 0.007687542159900453,
		"cl_count_sum": 19,
		"cl_asset_sum": 552120818,
		"cl_weight_total": 0.1601136242685022,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 38889206,
		"fossil_bank_weight_total": 0.01127777021728672,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 26509000,
		"fossil_insure_weight_total": 0.007687542159900453,
		"name": "BBH",
		"fund_family_name": "BBH",
		"label": "BBH"
	},
	{
		"fund_family_label": "Bridgeway",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 3433822444,
		"long_asset_sum": 3436182633,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 3411343270,
		"equity_fund_long_assets": 3411351988,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 177,
		"ff_all_asset_sum": 398577503,
		"ff_all_weight_total": 0.11683857438401633,
		"grade_fossil_fam": 5,
		"c2_count_sum": 26,
		"c2_asset_sum": 84919943,
		"c2_weight_total": 0.02489333944392724,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 9118982,
		"mc50_weight_total": 0.002673128434731315,
		"co_count_sum": 20,
		"co_asset_sum": 56170058,
		"co_weight_total": 0.016465629520960475,
		"og_count_sum": 154,
		"og_asset_sum": 332955293,
		"og_weight_total": 0.0976021513380108,
		"ut_count_sum": 11,
		"ut_asset_sum": 29219740,
		"ut_weight_total": 0.008565442705058086,
		"cl_count_sum": 20,
		"cl_asset_sum": 91483701,
		"cl_weight_total": 0.026817432303030936,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 17834945,
		"fossil_bank_weight_total": 0.005228116319493678,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 7966682,
		"fossil_insure_weight_total": 0.0023353444698829477,
		"name": "Bridgeway",
		"fund_family_name": "Bridgeway",
		"label": "Bridgeway"
	},
	{
		"fund_family_label": "Grandeur Peak Funds",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 3395384544,
		"long_asset_sum": 3411998134,
		"num_equity_funds": 9,
		"equity_fund_net_assets": 3395384544,
		"equity_fund_long_assets": 3411998134,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 9,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 26,
		"ff_all_asset_sum": 44579844,
		"ff_all_weight_total": 0.013065612069294292,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 26,
		"og_asset_sum": 44579844,
		"og_weight_total": 0.013065612069294292,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 3,
		"cl_asset_sum": 10177749,
		"cl_weight_total": 0.0029829292397848656,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Grandeur Peak Funds",
		"fund_family_name": "Grandeur Peak Funds",
		"label": "Grandeur Peak Funds"
	},
	{
		"fund_family_label": "Sequoia",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 3365002048,
		"long_asset_sum": 3365002048,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 3365002048,
		"equity_fund_long_assets": 3365002048,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 35534432,
		"ff_all_weight_total": 0.010560003082648942,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 35534432,
		"mc50_weight_total": 0.010560003082648942,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 35534432,
		"ut_weight_total": 0.010560003082648942,
		"cl_count_sum": 4,
		"cl_asset_sum": 547396598,
		"cl_weight_total": 0.1626734813803002,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 35534432,
		"fossil_insure_weight_total": 0.010560003082648942,
		"name": "Sequoia",
		"fund_family_name": "Sequoia",
		"label": "Sequoia"
	},
	{
		"fund_family_label": "Baird",
		"as_of": "202506",
		"fund_id": 15,
		"net_asset_sum": 133203090212,
		"long_asset_sum": 133203597321,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 3152582414,
		"equity_fund_long_assets": 3153050644,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 32480966,
		"ff_all_weight_total": 0.010301441260326297,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 28023604,
		"c2_weight_total": 0.00888777478196446,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 32480966,
		"og_weight_total": 0.010301441260326297,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 7,
		"cl_asset_sum": 140802204,
		"cl_weight_total": 0.044655865032785055,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 56052191,
		"fossil_bank_weight_total": 0.0177771299381641,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Baird",
		"fund_family_name": "Baird",
		"label": "Baird"
	},
	{
		"fund_family_label": "Congress",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 3447376065,
		"long_asset_sum": 3470177414,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 3111222240,
		"equity_fund_long_assets": 3132929466,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 57135995,
		"ff_all_weight_total": 0.018237242689331582,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 21851517,
		"c2_weight_total": 0.006974787411316716,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 7,
		"og_asset_sum": 57135995,
		"og_weight_total": 0.018237242689331582,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 11,
		"cl_asset_sum": 158087570,
		"cl_weight_total": 0.05045998376779288,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 16082361,
		"fossil_bank_weight_total": 0.005133330058826163,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Congress",
		"fund_family_name": "Congress",
		"label": "Congress"
	},
	{
		"fund_family_label": "Glenmede",
		"as_of": "202506",
		"fund_id": 14,
		"net_asset_sum": 3726458152,
		"long_asset_sum": 3816620645,
		"num_equity_funds": 11,
		"equity_fund_net_assets": 3107166992,
		"equity_fund_long_assets": 3116150747,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 42570956,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 42570956,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 72,
		"ff_all_asset_sum": 176387676,
		"ff_all_weight_total": 0.05660434629801303,
		"grade_fossil_fam": 4,
		"c2_count_sum": 24,
		"c2_asset_sum": 64934962,
		"c2_weight_total": 0.020838196631698447,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 18961,
		"mc50_weight_total": 0.000006084750559084554,
		"co_count_sum": 9,
		"co_asset_sum": 16469838,
		"co_weight_total": 0.005285314908418967,
		"og_count_sum": 50,
		"og_asset_sum": 111433939,
		"og_weight_total": 0.035760124604780556,
		"ut_count_sum": 26,
		"ut_asset_sum": 62508478,
		"ut_weight_total": 0.020059516716313723,
		"cl_count_sum": 57,
		"cl_asset_sum": 203929515,
		"cl_weight_total": 0.06544276306155224,
		"fossil_bank_count_sum": 24,
		"fossil_bank_asset_sum": 17735074,
		"fossil_bank_weight_total": 0.0056913401949742065,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 4856176,
		"fossil_insure_weight_total": 0.0015583893059972044,
		"name": "Glenmede",
		"fund_family_name": "Glenmede",
		"label": "Glenmede"
	},
	{
		"fund_family_label": "Buffalo",
		"as_of": "202506",
		"fund_id": 10,
		"net_asset_sum": 3753319373,
		"long_asset_sum": 3753344204,
		"num_equity_funds": 9,
		"equity_fund_net_assets": 3081759695,
		"equity_fund_long_assets": 3081784526,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 42,
		"ff_all_asset_sum": 231034910,
		"ff_all_weight_total": 0.0749678986479537,
		"grade_fossil_fam": 4,
		"c2_count_sum": 14,
		"c2_asset_sum": 106339595,
		"c2_weight_total": 0.03450585013418294,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 3313279,
		"mc50_weight_total": 0.0010751170213384347,
		"co_count_sum": 5,
		"co_asset_sum": 17009163,
		"co_weight_total": 0.00551925770815555,
		"og_count_sum": 34,
		"og_asset_sum": 210253372,
		"og_weight_total": 0.06822455308804416,
		"ut_count_sum": 10,
		"ut_asset_sum": 23367669,
		"ut_weight_total": 0.007582512275876098,
		"cl_count_sum": 49,
		"cl_asset_sum": 394378074,
		"cl_weight_total": 0.1279706840866914,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 19102323,
		"fossil_bank_weight_total": 0.0061984615857598084,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 23399305,
		"fossil_insure_weight_total": 0.007592777756714584,
		"name": "Buffalo",
		"fund_family_name": "Buffalo",
		"label": "Buffalo"
	},
	{
		"fund_family_label": "Seafarer Funds",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 2945966201,
		"long_asset_sum": 2945966335,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 2945966201,
		"equity_fund_long_assets": 2945966335,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 10,
		"ff_all_asset_sum": 223934614,
		"ff_all_weight_total": 0.07601397590308852,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 8,
		"og_asset_sum": 149916170,
		"og_weight_total": 0.05088862293465414,
		"ut_count_sum": 3,
		"ut_asset_sum": 77102916,
		"ut_weight_total": 0.02617236832748803,
		"cl_count_sum": 3,
		"cl_asset_sum": 211508018,
		"cl_weight_total": 0.07179580278537026,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 78985056,
		"fossil_bank_weight_total": 0.026811255465348013,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Seafarer Funds",
		"fund_family_name": "Seafarer Funds",
		"label": "Seafarer Funds"
	},
	{
		"fund_family_label": "Hotchkis & Wiley",
		"as_of": "202506",
		"fund_id": 12,
		"net_asset_sum": 3684594435,
		"long_asset_sum": 3684594435,
		"num_equity_funds": 11,
		"equity_fund_net_assets": 2880596669,
		"equity_fund_long_assets": 2880596669,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 171,
		"ff_all_asset_sum": 445033015,
		"ff_all_weight_total": 0.15449334500358683,
		"grade_fossil_fam": 5,
		"c2_count_sum": 66,
		"c2_asset_sum": 155564395,
		"c2_weight_total": 0.05400422651117077,
		"mc50_count_sum": 5,
		"mc50_asset_sum": 14924856,
		"mc50_weight_total": 0.005181168249139567,
		"co_count_sum": 11,
		"co_asset_sum": 26822571,
		"co_weight_total": 0.009311463589698402,
		"og_count_sum": 148,
		"og_asset_sum": 388547738,
		"og_weight_total": 0.13488446410475247,
		"ut_count_sum": 35,
		"ut_asset_sum": 123932671,
		"ut_weight_total": 0.04302326401114088,
		"cl_count_sum": 36,
		"cl_asset_sum": 144693285,
		"cl_weight_total": 0.05023031740511952,
		"fossil_bank_count_sum": 30,
		"fossil_bank_asset_sum": 81360465,
		"fossil_bank_weight_total": 0.028244309894395702,
		"fossil_insure_count_sum": 14,
		"fossil_insure_asset_sum": 27845997,
		"fossil_insure_weight_total": 0.009666746233399883,
		"name": "Hotchkis & Wiley",
		"fund_family_name": "Hotchkis & Wiley",
		"label": "Hotchkis & Wiley"
	},
	{
		"fund_family_label": "FAM",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 2869918540,
		"long_asset_sum": 2869918540,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 2869918540,
		"equity_fund_long_assets": 2869918540,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 170723686,
		"ff_all_weight_total": 0.0594872933222697,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1,
		"c2_asset_sum": 29944040,
		"c2_weight_total": 0.010433759558903717,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 22356365,
		"mc50_weight_total": 0.007789895318770964,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 132648375,
		"og_weight_total": 0.046220257875333286,
		"ut_count_sum": 2,
		"ut_asset_sum": 38075311,
		"ut_weight_total": 0.013267035446936413,
		"cl_count_sum": 3,
		"cl_asset_sum": 148730049,
		"cl_weight_total": 0.05182378765356873,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 22356365,
		"fossil_insure_weight_total": 0.007789895318770964,
		"name": "FAM",
		"fund_family_name": "FAM",
		"label": "FAM"
	},
	{
		"fund_family_label": "Longleaf Partners",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 2849103910,
		"long_asset_sum": 2849268689,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 2849103910,
		"equity_fund_long_assets": 2849268689,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 200681123,
		"ff_all_weight_total": 0.0704325021275661,
		"grade_fossil_fam": 4,
		"c2_count_sum": 3,
		"c2_asset_sum": 130059579,
		"c2_weight_total": 0.04564665294716261,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 200681123,
		"og_weight_total": 0.0704325021275661,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Longleaf Partners",
		"fund_family_name": "Longleaf Partners",
		"label": "Longleaf Partners"
	},
	{
		"fund_family_label": "Brown Capital Management",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 2821833995,
		"long_asset_sum": 2821833995,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 2821833995,
		"equity_fund_long_assets": 2821833995,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 20851400,
		"ff_all_weight_total": 0.0073893078178753745,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 20851400,
		"og_weight_total": 0.0073893078178753745,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 2677234,
		"cl_weight_total": 0.0009487567322329321,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Brown Capital Management",
		"fund_family_name": "Brown Capital Management",
		"label": "Brown Capital Management"
	},
	{
		"fund_family_label": "Kopernik",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 2795823772,
		"long_asset_sum": 2797043729,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 2795823772,
		"equity_fund_long_assets": 2797043729,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 35,
		"ff_all_asset_sum": 436615363,
		"ff_all_weight_total": 0.15609886912854912,
		"grade_fossil_fam": 5,
		"c2_count_sum": 14,
		"c2_asset_sum": 194384114,
		"c2_weight_total": 0.06949627279137902,
		"mc50_count_sum": 4,
		"mc50_asset_sum": 56673859,
		"mc50_weight_total": 0.020262056832505104,
		"co_count_sum": 13,
		"co_asset_sum": 119187858,
		"co_weight_total": 0.04261208245128584,
		"og_count_sum": 27,
		"og_asset_sum": 396883472,
		"og_weight_total": 0.14189391030432474,
		"ut_count_sum": 13,
		"ut_asset_sum": 97009627,
		"ut_weight_total": 0.03468291396169302,
		"cl_count_sum": 6,
		"cl_asset_sum": 89637029,
		"cl_weight_total": 0.03204706028391163,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Kopernik",
		"fund_family_name": "Kopernik",
		"label": "Kopernik"
	},
	{
		"fund_family_label": "Ave Maria Mutual Funds",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 3523151448,
		"long_asset_sum": 3523151448,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 2794460979,
		"equity_fund_long_assets": 2794460979,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 24,
		"ff_all_asset_sum": 392971154,
		"ff_all_weight_total": 0.14062502820870487,
		"grade_fossil_fam": 5,
		"c2_count_sum": 9,
		"c2_asset_sum": 133588504,
		"c2_weight_total": 0.04780474839473506,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 13820800,
		"co_weight_total": 0.0049457838573740915,
		"og_count_sum": 24,
		"og_asset_sum": 392971154,
		"og_weight_total": 0.14062502820870487,
		"ut_count_sum": 1,
		"ut_asset_sum": 1379093,
		"ut_weight_total": 0.0004935094855013898,
		"cl_count_sum": 6,
		"cl_asset_sum": 68852216,
		"cl_weight_total": 0.024638818189774408,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 24690000,
		"fossil_bank_weight_total": 0.008835335395821249,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 55490662,
		"fossil_insure_weight_total": 0.019857375864971775,
		"name": "Ave Maria Mutual Funds",
		"fund_family_name": "Ave Maria Mutual Funds",
		"label": "Ave Maria Mutual Funds"
	},
	{
		"fund_family_label": "Madison Funds",
		"as_of": "202506",
		"fund_id": 12,
		"net_asset_sum": 3539570791,
		"long_asset_sum": 3543451011,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 2755802255,
		"equity_fund_long_assets": 2755802255,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 90367106,
		"ff_all_weight_total": 0.03279157850895945,
		"grade_fossil_fam": 3,
		"c2_count_sum": 5,
		"c2_asset_sum": 12295325,
		"c2_weight_total": 0.004461613665382533,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 9664623,
		"mc50_weight_total": 0.003507008887326714,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 8,
		"og_asset_sum": 80702483,
		"og_weight_total": 0.029284569621632738,
		"ut_count_sum": 2,
		"ut_asset_sum": 13931567,
		"ut_weight_total": 0.0050553580086246065,
		"cl_count_sum": 5,
		"cl_asset_sum": 52896217,
		"cl_weight_total": 0.01919448933755227,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 7347440,
		"fossil_bank_weight_total": 0.0026661709803993175,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 14864169,
		"fossil_insure_weight_total": 0.005393771985283465,
		"name": "Madison Funds",
		"fund_family_name": "Madison Funds",
		"label": "Madison Funds"
	},
	{
		"fund_family_label": "Eagle Capital Management, LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 2715799314,
		"long_asset_sum": 2715799314,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 2715799314,
		"equity_fund_long_assets": 2715799314,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 307261056,
		"ff_all_weight_total": 0.11313835098788894,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 240064787,
		"c2_weight_total": 0.08839562841129725,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 307261056,
		"og_weight_total": 0.11313835098788894,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 5,
		"cl_asset_sum": 497998949,
		"cl_weight_total": 0.18337104160561696,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 43149107,
		"fossil_bank_weight_total": 0.015888179504857183,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Eagle Capital Management, LLC",
		"fund_family_name": "Eagle Capital Management, LLC",
		"label": "Eagle Capital Management, LLC"
	},
	{
		"fund_family_label": "Active Passive Funds",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 3669661851,
		"long_asset_sum": 3672170914,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 2682801082,
		"equity_fund_long_assets": 2685310145,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 84,
		"ff_all_asset_sum": 186017770,
		"ff_all_weight_total": 0.06927235959926707,
		"grade_fossil_fam": 4,
		"c2_count_sum": 31,
		"c2_asset_sum": 76983552,
		"c2_weight_total": 0.028668402472370656,
		"mc50_count_sum": 7,
		"mc50_asset_sum": 45784444,
		"mc50_weight_total": 0.017049965005066482,
		"co_count_sum": 19,
		"co_asset_sum": 28318339,
		"co_weight_total": 0.01054564928104422,
		"og_count_sum": 67,
		"og_asset_sum": 135885580,
		"og_weight_total": 0.05060330936186889,
		"ut_count_sum": 34,
		"ut_asset_sum": 80302848,
		"ut_weight_total": 0.02990449656235146,
		"cl_count_sum": 78,
		"cl_asset_sum": 589331497,
		"cl_weight_total": 0.21946496500500132,
		"fossil_bank_count_sum": 36,
		"fossil_bank_asset_sum": 142810989,
		"fossil_bank_weight_total": 0.05318230717815279,
		"fossil_insure_count_sum": 14,
		"fossil_insure_asset_sum": 54408017,
		"fossil_insure_weight_total": 0.020261353088508887,
		"name": "Active Passive Funds",
		"fund_family_name": "Active Passive Funds",
		"label": "Active Passive Funds"
	},
	{
		"fund_family_label": "Pzena",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 2635524705,
		"long_asset_sum": 2636304018,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 2635524705,
		"equity_fund_long_assets": 2636304018,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 13,
		"ff_all_asset_sum": 150173058,
		"ff_all_weight_total": 0.056963482578131094,
		"grade_fossil_fam": 4,
		"c2_count_sum": 6,
		"c2_asset_sum": 77136963,
		"c2_weight_total": 0.029259509704999433,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 3,
		"co_asset_sum": 59169657,
		"co_weight_total": 0.022444170549377057,
		"og_count_sum": 12,
		"og_asset_sum": 147961429,
		"og_weight_total": 0.05612456984845365,
		"ut_count_sum": 2,
		"ut_asset_sum": 19413781,
		"ut_weight_total": 0.00736401449432529,
		"cl_count_sum": 18,
		"cl_asset_sum": 241913683,
		"cl_weight_total": 0.09176243762034884,
		"fossil_bank_count_sum": 13,
		"fossil_bank_asset_sum": 123546187,
		"fossil_bank_weight_total": 0.04686340655571538,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 29434887,
		"fossil_insure_weight_total": 0.011165209626441498,
		"name": "Pzena",
		"fund_family_name": "Pzena",
		"label": "Pzena"
	},
	{
		"fund_family_label": "Westwood",
		"as_of": "202506",
		"fund_id": 15,
		"net_asset_sum": 3852245368,
		"long_asset_sum": 3964006957,
		"num_equity_funds": 9,
		"equity_fund_net_assets": 2595037733,
		"equity_fund_long_assets": 2596009331,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 124,
		"ff_all_asset_sum": 1425468601,
		"ff_all_weight_total": 0.5490999527535981,
		"grade_fossil_fam": 5,
		"c2_count_sum": 35,
		"c2_asset_sum": 95554732,
		"c2_weight_total": 0.03680831607919979,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 5587558,
		"mc50_weight_total": 0.002152364374533136,
		"co_count_sum": 10,
		"co_asset_sum": 59948750,
		"co_weight_total": 0.023092655825280622,
		"og_count_sum": 109,
		"og_asset_sum": 1362298764,
		"og_weight_total": 0.5247665128673608,
		"ut_count_sum": 23,
		"ut_asset_sum": 77817529,
		"ut_weight_total": 0.029975827925866574,
		"cl_count_sum": 34,
		"cl_asset_sum": 24214966,
		"cl_weight_total": 0.009327765393921845,
		"fossil_bank_count_sum": 15,
		"fossil_bank_asset_sum": 11629585,
		"fossil_bank_weight_total": 0.004479793219972829,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 5667500,
		"fossil_insure_weight_total": 0.002183158562768664,
		"name": "Westwood",
		"fund_family_name": "Westwood",
		"label": "Westwood"
	},
	{
		"fund_family_label": "Kinetics",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 2887891160,
		"long_asset_sum": 2888379762,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 2564213448,
		"equity_fund_long_assets": 2564214692,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 42,
		"ff_all_asset_sum": 1766634188,
		"ff_all_weight_total": 0.6889572053040869,
		"grade_fossil_fam": 5,
		"c2_count_sum": 5,
		"c2_asset_sum": 147194,
		"c2_weight_total": 0.00005740314976714906,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 4,
		"co_asset_sum": 146553,
		"co_weight_total": 0.00005715317069870373,
		"og_count_sum": 32,
		"og_asset_sum": 1720926533,
		"og_weight_total": 0.6711319993482043,
		"ut_count_sum": 7,
		"ut_asset_sum": 45561256,
		"ut_weight_total": 0.017768112842557568,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Kinetics",
		"fund_family_name": "Kinetics",
		"label": "Kinetics"
	},
	{
		"fund_family_label": "Morningstar",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 4669454411,
		"long_asset_sum": 5350823950,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 2481031066,
		"equity_fund_long_assets": 2484554511,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 115,
		"ff_all_asset_sum": 179282335,
		"ff_all_weight_total": 0.07215874483987121,
		"grade_fossil_fam": 4,
		"c2_count_sum": 41,
		"c2_asset_sum": 93319247,
		"c2_weight_total": 0.037559750283941346,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 11015895,
		"mc50_weight_total": 0.00443375057831444,
		"co_count_sum": 27,
		"co_asset_sum": 26285302,
		"co_weight_total": 0.010579482914794458,
		"og_count_sum": 86,
		"og_asset_sum": 148566418,
		"og_weight_total": 0.059795998575295495,
		"ut_count_sum": 38,
		"ut_asset_sum": 52049305,
		"ut_weight_total": 0.02094914994602024,
		"cl_count_sum": 72,
		"cl_asset_sum": 381949622,
		"cl_weight_total": 0.15372962046474495,
		"fossil_bank_count_sum": 19,
		"fossil_bank_asset_sum": 67120976,
		"fossil_bank_weight_total": 0.02701529618401679,
		"fossil_insure_count_sum": 10,
		"fossil_insure_asset_sum": 42004515,
		"fossil_insure_weight_total": 0.016906256157404147,
		"name": "Morningstar",
		"fund_family_name": "Morningstar",
		"label": "Morningstar"
	},
	{
		"fund_family_label": "Oberweis",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 2415163228,
		"long_asset_sum": 2423450310,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 2415163228,
		"equity_fund_long_assets": 2423450310,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 22,
		"ff_all_asset_sum": 70945461,
		"ff_all_weight_total": 0.029274568043443812,
		"grade_fossil_fam": 3,
		"c2_count_sum": 6,
		"c2_asset_sum": 13137543,
		"c2_weight_total": 0.005421007786208746,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 310292,
		"mc50_weight_total": 0.00012803728581503286,
		"co_count_sum": 2,
		"co_asset_sum": 226698,
		"co_weight_total": 0.00009354349006644167,
		"og_count_sum": 17,
		"og_asset_sum": 67893604,
		"og_weight_total": 0.028015265557477017,
		"ut_count_sum": 3,
		"ut_asset_sum": 2825159,
		"ut_weight_total": 0.0011657589959003533,
		"cl_count_sum": 12,
		"cl_asset_sum": 22964942,
		"cl_weight_total": 0.009476134874826462,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 4185662,
		"fossil_bank_weight_total": 0.001727149916269585,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 734670,
		"fossil_insure_weight_total": 0.000303150428530965,
		"name": "Oberweis",
		"fund_family_name": "Oberweis",
		"label": "Oberweis"
	},
	{
		"fund_family_label": "Rydex Funds",
		"as_of": "202506",
		"fund_id": 56,
		"net_asset_sum": 4322800531,
		"long_asset_sum": 4426444340,
		"num_equity_funds": 27,
		"equity_fund_net_assets": 2401835019,
		"equity_fund_long_assets": 2419801433,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 15,
		"num_five_badgers": 11,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 10,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 300,
		"ff_all_asset_sum": 100257378,
		"ff_all_weight_total": 0.04143206819896118,
		"grade_fossil_fam": 3,
		"c2_count_sum": 80,
		"c2_asset_sum": 17530590,
		"c2_weight_total": 0.007244639895210773,
		"mc50_count_sum": 15,
		"mc50_asset_sum": 13875811,
		"mc50_weight_total": 0.005734276709968376,
		"co_count_sum": 46,
		"co_asset_sum": 20040302,
		"co_weight_total": 0.00828179607082661,
		"og_count_sum": 227,
		"og_asset_sum": 64987085,
		"og_weight_total": 0.026856370987197443,
		"ut_count_sum": 101,
		"ut_asset_sum": 51313333,
		"ut_weight_total": 0.02120559658334577,
		"cl_count_sum": 141,
		"cl_asset_sum": 687875645,
		"cl_weight_total": 0.2842694593114575,
		"fossil_bank_count_sum": 37,
		"fossil_bank_asset_sum": 15572363,
		"fossil_bank_weight_total": 0.0064353887834068405,
		"fossil_insure_count_sum": 17,
		"fossil_insure_asset_sum": 6785924,
		"fossil_insure_weight_total": 0.0028043309287518717,
		"name": "Rydex Funds",
		"fund_family_name": "Rydex Funds",
		"label": "Rydex Funds"
	},
	{
		"fund_family_label": "Boston Partners",
		"as_of": "202506",
		"fund_id": 10,
		"net_asset_sum": 3071243163,
		"long_asset_sum": 3459143015,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 2292290012,
		"equity_fund_long_assets": 2293021929,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 10471914,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 10471914,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 53,
		"ff_all_asset_sum": 117196536,
		"ff_all_weight_total": 0.0511100807706231,
		"grade_fossil_fam": 3,
		"c2_count_sum": 19,
		"c2_asset_sum": 48395511,
		"c2_weight_total": 0.021105559605836634,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 5,
		"co_asset_sum": 2744829,
		"co_weight_total": 0.0011970356520737836,
		"og_count_sum": 42,
		"og_asset_sum": 105124909,
		"og_weight_total": 0.04584557507735897,
		"ut_count_sum": 13,
		"ut_asset_sum": 17507255,
		"ut_weight_total": 0.007635014204872875,
		"cl_count_sum": 23,
		"cl_asset_sum": 158773901,
		"cl_weight_total": 0.06924220784458097,
		"fossil_bank_count_sum": 22,
		"fossil_bank_asset_sum": 104119400,
		"fossil_bank_weight_total": 0.045407066841880166,
		"fossil_insure_count_sum": 11,
		"fossil_insure_asset_sum": 76151016,
		"fossil_insure_weight_total": 0.033209894348114624,
		"name": "Boston Partners",
		"fund_family_name": "Boston Partners",
		"label": "Boston Partners"
	},
	{
		"fund_family_label": "SA Funds",
		"as_of": "202506",
		"fund_id": 10,
		"net_asset_sum": 3572622309,
		"long_asset_sum": 3583419122,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 2267267895,
		"equity_fund_long_assets": 2275192455,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 436,
		"ff_all_asset_sum": 267555556,
		"ff_all_weight_total": 0.11759688962224517,
		"grade_fossil_fam": 5,
		"c2_count_sum": 127,
		"c2_asset_sum": 144769688,
		"c2_weight_total": 0.06362964490403955,
		"mc50_count_sum": 20,
		"mc50_asset_sum": 26848953,
		"mc50_weight_total": 0.011800739291744883,
		"co_count_sum": 133,
		"co_asset_sum": 36848973,
		"co_weight_total": 0.016195980660458017,
		"og_count_sum": 288,
		"og_asset_sum": 210036439,
		"og_weight_total": 0.09231589993119944,
		"ut_count_sum": 160,
		"ut_asset_sum": 72670152,
		"ut_weight_total": 0.03194022195366326,
		"cl_count_sum": 134,
		"cl_asset_sum": 245748211,
		"cl_weight_total": 0.10801205430333585,
		"fossil_bank_count_sum": 62,
		"fossil_bank_asset_sum": 168769312,
		"fossil_bank_weight_total": 0.07417803783108977,
		"fossil_insure_count_sum": 22,
		"fossil_insure_asset_sum": 61230485,
		"fossil_insure_weight_total": 0.026912222245392425,
		"name": "SA Funds",
		"fund_family_name": "SA Funds",
		"label": "SA Funds"
	},
	{
		"fund_family_label": "Shelton Capital Management",
		"as_of": "202506",
		"fund_id": 11,
		"net_asset_sum": 3168927019,
		"long_asset_sum": 3197032781,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 2234988494,
		"equity_fund_long_assets": 2238573118,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 109496312,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 75137132,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 142,
		"ff_all_asset_sum": 81636148,
		"ff_all_weight_total": 0.036467939038299486,
		"grade_fossil_fam": 3,
		"c2_count_sum": 37,
		"c2_asset_sum": 16756407,
		"c2_weight_total": 0.007485306986519437,
		"mc50_count_sum": 7,
		"mc50_asset_sum": 13437760,
		"mc50_weight_total": 0.006002823804122891,
		"co_count_sum": 27,
		"co_asset_sum": 17217202,
		"co_weight_total": 0.0076911501623776754,
		"og_count_sum": 100,
		"og_asset_sum": 51282910,
		"og_weight_total": 0.02290874914365875,
		"ut_count_sum": 58,
		"ut_asset_sum": 40130228,
		"ut_weight_total": 0.017926699680845537,
		"cl_count_sum": 72,
		"cl_asset_sum": 705367194,
		"cl_weight_total": 0.315096785683817,
		"fossil_bank_count_sum": 15,
		"fossil_bank_asset_sum": 10935710,
		"fossil_bank_weight_total": 0.004885125221985267,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 7147906,
		"fossil_insure_weight_total": 0.0031930634485533922,
		"name": "Shelton Capital Management",
		"fund_family_name": "Shelton Capital Management",
		"label": "Shelton Capital Management"
	},
	{
		"fund_family_label": "Motley Fool",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 2158240221,
		"long_asset_sum": 2160015461,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 2158240221,
		"equity_fund_long_assets": 2160015461,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 77503980,
		"ff_all_weight_total": 0.03588121538913373,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 3182264,
		"c2_weight_total": 0.0014732598249675214,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 55049567,
		"mc50_weight_total": 0.025485728224609223,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 7,
		"og_asset_sum": 17648776,
		"og_weight_total": 0.008170671145024734,
		"ut_count_sum": 3,
		"ut_asset_sum": 59865837,
		"ut_weight_total": 0.027715466894058495,
		"cl_count_sum": 28,
		"cl_asset_sum": 565187757,
		"cl_weight_total": 0.26165912568900823,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 2583260,
		"fossil_bank_weight_total": 0.001195945143283398,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 55049567,
		"fossil_insure_weight_total": 0.025485728224609223,
		"name": "Motley Fool",
		"fund_family_name": "Motley Fool",
		"label": "Motley Fool"
	},
	{
		"fund_family_label": "Marsico Investment Fund",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 2135112822,
		"long_asset_sum": 2135112822,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 2135112822,
		"equity_fund_long_assets": 2135112822,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 5,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 12,
		"ff_all_asset_sum": 140865607,
		"ff_all_weight_total": 0.06597572060292746,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 34130134,
		"mc50_weight_total": 0.01598516652062895,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 10,
		"og_asset_sum": 106735473,
		"og_weight_total": 0.049990554082298515,
		"ut_count_sum": 2,
		"ut_asset_sum": 34130134,
		"ut_weight_total": 0.01598516652062895,
		"cl_count_sum": 18,
		"cl_asset_sum": 337015859,
		"cl_weight_total": 0.1578445202180515,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 34130134,
		"fossil_insure_weight_total": 0.01598516652062895,
		"name": "Marsico Investment Fund",
		"fund_family_name": "Marsico Investment Fund",
		"label": "Marsico Investment Fund"
	},
	{
		"fund_family_label": "CAMBRIA ETF TRUST",
		"as_of": "202506",
		"fund_id": 16,
		"net_asset_sum": 2608596969,
		"long_asset_sum": 2804317584,
		"num_equity_funds": 8,
		"equity_fund_net_assets": 2111573345,
		"equity_fund_long_assets": 2111780087,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 113,
		"ff_all_asset_sum": 338401104,
		"ff_all_weight_total": 0.16024448098700156,
		"grade_fossil_fam": 5,
		"c2_count_sum": 48,
		"c2_asset_sum": 150269156,
		"c2_weight_total": 0.07115757787709455,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 16955387,
		"mc50_weight_total": 0.008028954863423712,
		"co_count_sum": 26,
		"co_asset_sum": 75071046,
		"co_weight_total": 0.035548704366583035,
		"og_count_sum": 91,
		"og_asset_sum": 276016473,
		"og_weight_total": 0.13070322743316976,
		"ut_count_sum": 25,
		"ut_asset_sum": 77910565,
		"ut_weight_total": 0.03689331359814077,
		"cl_count_sum": 30,
		"cl_asset_sum": 91254092,
		"cl_weight_total": 0.04321192938685002,
		"fossil_bank_count_sum": 7,
		"fossil_bank_asset_sum": 25545404,
		"fossil_bank_weight_total": 0.012096621308845593,
		"fossil_insure_count_sum": 8,
		"fossil_insure_asset_sum": 25482907,
		"fossil_insure_weight_total": 0.012067026844732247,
		"name": "CAMBRIA ETF TRUST",
		"fund_family_name": "CAMBRIA ETF TRUST",
		"label": "CAMBRIA ETF TRUST"
	},
	{
		"fund_family_label": "Manning & Napier",
		"as_of": "202506",
		"fund_id": 14,
		"net_asset_sum": 5978431412,
		"long_asset_sum": 5999176842,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 2082058157,
		"equity_fund_long_assets": 2092379358,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 6,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 28,
		"ff_all_asset_sum": 78781894,
		"ff_all_weight_total": 0.037651821453306464,
		"grade_fossil_fam": 3,
		"c2_count_sum": 8,
		"c2_asset_sum": 15410224,
		"c2_weight_total": 0.0073649283248186205,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 5,
		"co_asset_sum": 11252439,
		"co_weight_total": 0.0053778197328211265,
		"og_count_sum": 22,
		"og_asset_sum": 58310041,
		"og_weight_total": 0.02786781506759636,
		"ut_count_sum": 2,
		"ut_asset_sum": 10401320,
		"ut_weight_total": 0.004971048849354974,
		"cl_count_sum": 32,
		"cl_asset_sum": 213861155,
		"cl_weight_total": 0.10220955114201619,
		"fossil_bank_count_sum": 7,
		"fossil_bank_asset_sum": 16346870,
		"fossil_bank_weight_total": 0.007812574683218606,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 5427745,
		"fossil_insure_weight_total": 0.0025940539793835988,
		"name": "Manning & Napier",
		"fund_family_name": "Manning & Napier",
		"label": "Manning & Napier"
	},
	{
		"fund_family_label": "LSV Fund",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 2080229806,
		"long_asset_sum": 2080449646,
		"num_equity_funds": 8,
		"equity_fund_net_assets": 2080229806,
		"equity_fund_long_assets": 2080449646,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 153,
		"ff_all_asset_sum": 195997577,
		"ff_all_weight_total": 0.09420923855419282,
		"grade_fossil_fam": 5,
		"c2_count_sum": 63,
		"c2_asset_sum": 77755801,
		"c2_weight_total": 0.03737451716243076,
		"mc50_count_sum": 19,
		"mc50_asset_sum": 25100131,
		"mc50_weight_total": 0.012064762561429472,
		"co_count_sum": 36,
		"co_asset_sum": 19805283,
		"co_weight_total": 0.00951971274002178,
		"og_count_sum": 107,
		"og_asset_sum": 158605899,
		"og_weight_total": 0.07623635559021841,
		"ut_count_sum": 53,
		"ut_asset_sum": 51441672,
		"ut_weight_total": 0.02472622786084004,
		"cl_count_sum": 86,
		"cl_asset_sum": 129559887,
		"cl_weight_total": 0.06227494486545242,
		"fossil_bank_count_sum": 40,
		"fossil_bank_asset_sum": 83826339,
		"fossil_bank_weight_total": 0.04029241426783371,
		"fossil_insure_count_sum": 30,
		"fossil_insure_asset_sum": 56044459,
		"fossil_insure_weight_total": 0.026938627958506236,
		"name": "LSV Fund",
		"fund_family_name": "LSV Fund",
		"label": "LSV Fund"
	},
	{
		"fund_family_label": "Timothy Plan",
		"as_of": "202506",
		"fund_id": 19,
		"net_asset_sum": 2562655702,
		"long_asset_sum": 2624248915,
		"num_equity_funds": 11,
		"equity_fund_net_assets": 2063949273,
		"equity_fund_long_assets": 2071058573,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 243,
		"ff_all_asset_sum": 288274666,
		"ff_all_weight_total": 0.13919194259311757,
		"grade_fossil_fam": 5,
		"c2_count_sum": 73,
		"c2_asset_sum": 81618530,
		"c2_weight_total": 0.03940908821413618,
		"mc50_count_sum": 10,
		"mc50_asset_sum": 16042370,
		"mc50_weight_total": 0.007745975999491927,
		"co_count_sum": 46,
		"co_asset_sum": 51890496,
		"co_weight_total": 0.02505505960888147,
		"og_count_sum": 182,
		"og_asset_sum": 206395115,
		"og_weight_total": 0.09965682172910713,
		"ut_count_sum": 104,
		"ut_asset_sum": 149695559,
		"ut_weight_total": 0.07227973218698533,
		"cl_count_sum": 82,
		"cl_asset_sum": 117501443,
		"cl_weight_total": 0.05673496854789341,
		"fossil_bank_count_sum": 18,
		"fossil_bank_asset_sum": 19775400,
		"fossil_bank_weight_total": 0.009548450371132985,
		"fossil_insure_count_sum": 13,
		"fossil_insure_asset_sum": 14859221,
		"fossil_insure_weight_total": 0.00717469857864807,
		"name": "Timothy Plan",
		"fund_family_name": "Timothy Plan",
		"label": "Timothy Plan"
	},
	{
		"fund_family_label": "Sterling Capital Funds",
		"as_of": "202506",
		"fund_id": 19,
		"net_asset_sum": 4447297610,
		"long_asset_sum": 4447297610,
		"num_equity_funds": 8,
		"equity_fund_net_assets": 2056061286,
		"equity_fund_long_assets": 2056061286,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 58,
		"ff_all_asset_sum": 112273682,
		"ff_all_weight_total": 0.05460619426302451,
		"grade_fossil_fam": 3,
		"c2_count_sum": 20,
		"c2_asset_sum": 69955682,
		"c2_weight_total": 0.03402412295603138,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 1298268,
		"mc50_weight_total": 0.0006314344853629037,
		"co_count_sum": 10,
		"co_asset_sum": 4174523,
		"co_weight_total": 0.002030349498054797,
		"og_count_sum": 41,
		"og_asset_sum": 98654616,
		"og_weight_total": 0.04798233237100112,
		"ut_count_sum": 20,
		"ut_asset_sum": 16166982,
		"ut_weight_total": 0.007863083707710062,
		"cl_count_sum": 18,
		"cl_asset_sum": 205256993,
		"cl_weight_total": 0.09983019202667873,
		"fossil_bank_count_sum": 7,
		"fossil_bank_asset_sum": 25650356,
		"fossil_bank_weight_total": 0.012475482211866324,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 50775728,
		"fossil_insure_weight_total": 0.024695629622394438,
		"name": "Sterling Capital Funds",
		"fund_family_name": "Sterling Capital Funds",
		"label": "Sterling Capital Funds"
	},
	{
		"fund_family_label": "Aberdeen",
		"as_of": "202506",
		"fund_id": 22,
		"net_asset_sum": 15748317589,
		"long_asset_sum": 15773312614,
		"num_equity_funds": 10,
		"equity_fund_net_assets": 2053135735,
		"equity_fund_long_assets": 2061781776,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 313262835,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 313262835,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 48,
		"ff_all_asset_sum": 95334870,
		"ff_all_weight_total": 0.04623906909535124,
		"grade_fossil_fam": 3,
		"c2_count_sum": 11,
		"c2_asset_sum": 20664043,
		"c2_weight_total": 0.010022420044903918,
		"mc50_count_sum": 4,
		"mc50_asset_sum": 2749272,
		"mc50_weight_total": 0.0013334447088448802,
		"co_count_sum": 17,
		"co_asset_sum": 31987676,
		"co_weight_total": 0.015514578881407282,
		"og_count_sum": 35,
		"og_asset_sum": 54505750,
		"og_weight_total": 0.026436236188751724,
		"ut_count_sum": 24,
		"ut_asset_sum": 41113422,
		"ut_weight_total": 0.019940724318440187,
		"cl_count_sum": 37,
		"cl_asset_sum": 250116421,
		"cl_weight_total": 0.1213108117995122,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 18346492,
		"fossil_bank_weight_total": 0.008898367525390331,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 1423844,
		"fossil_insure_weight_total": 0.0006905890897737763,
		"name": "Aberdeen",
		"fund_family_name": "Aberdeen",
		"label": "Aberdeen"
	},
	{
		"fund_family_label": "Aristotle Funds",
		"as_of": "202506",
		"fund_id": 19,
		"net_asset_sum": 15694082238,
		"long_asset_sum": 15697071465,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 2010659335,
		"equity_fund_long_assets": 2012578132,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 28,
		"ff_all_asset_sum": 122973192,
		"ff_all_weight_total": 0.061102319480036964,
		"grade_fossil_fam": 4,
		"c2_count_sum": 12,
		"c2_asset_sum": 43027985,
		"c2_weight_total": 0.02137953519212739,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 3,
		"co_asset_sum": 1212935,
		"co_weight_total": 0.0006026772231668072,
		"og_count_sum": 24,
		"og_asset_sum": 104405500,
		"og_weight_total": 0.05187649529722705,
		"ut_count_sum": 8,
		"ut_asset_sum": 37903246,
		"ut_weight_total": 0.018833179888690155,
		"cl_count_sum": 25,
		"cl_asset_sum": 283577333,
		"cl_weight_total": 0.14090252124432803,
		"fossil_bank_count_sum": 7,
		"fossil_bank_asset_sum": 58748292,
		"fossil_bank_weight_total": 0.029190564612574257,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 47712828,
		"fossil_insure_weight_total": 0.023707317117962205,
		"name": "Aristotle Funds",
		"fund_family_name": "Aristotle Funds",
		"label": "Aristotle Funds"
	},
	{
		"fund_family_label": "Clarkston Funds",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 2007559815,
		"long_asset_sum": 2008078550,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 2007559815,
		"equity_fund_long_assets": 2008078550,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 92755200,
		"cl_weight_total": 0.046191021760578044,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Clarkston Funds",
		"fund_family_name": "Clarkston Funds",
		"label": "Clarkston Funds"
	},
	{
		"fund_family_label": "Cullen Funds Trust",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 2157596319,
		"long_asset_sum": 2158105526,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 1995282828,
		"equity_fund_long_assets": 1995282828,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 35,
		"ff_all_asset_sum": 276365996,
		"ff_all_weight_total": 0.13850968500391464,
		"grade_fossil_fam": 5,
		"c2_count_sum": 16,
		"c2_asset_sum": 135177293,
		"c2_weight_total": 0.06774843701506561,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 20058088,
		"mc50_weight_total": 0.010052754285519265,
		"co_count_sum": 3,
		"co_asset_sum": 23274187,
		"co_weight_total": 0.011664605475169258,
		"og_count_sum": 31,
		"og_asset_sum": 266903576,
		"og_weight_total": 0.1337672896566421,
		"ut_count_sum": 7,
		"ut_asset_sum": 61780534,
		"ut_weight_total": 0.03096329659786958,
		"cl_count_sum": 21,
		"cl_asset_sum": 188016510,
		"cl_weight_total": 0.09423050575163873,
		"fossil_bank_count_sum": 13,
		"fossil_bank_asset_sum": 142866639,
		"fossil_bank_weight_total": 0.0716021994451806,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 76250766,
		"fossil_insure_weight_total": 0.03821551758475816,
		"name": "Cullen Funds Trust",
		"fund_family_name": "Cullen Funds Trust",
		"label": "Cullen Funds Trust"
	},
	{
		"fund_family_label": "Gotham",
		"as_of": "202506",
		"fund_id": 10,
		"net_asset_sum": 2465902016,
		"long_asset_sum": 4050922861,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 1982239122,
		"equity_fund_long_assets": 3023310577,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 267,
		"ff_all_asset_sum": 286916656,
		"ff_all_weight_total": 0.094901482561115,
		"grade_fossil_fam": 5,
		"c2_count_sum": 62,
		"c2_asset_sum": 88013851,
		"c2_weight_total": 0.02911174646414767,
		"mc50_count_sum": 21,
		"mc50_asset_sum": 50517384,
		"mc50_weight_total": 0.016709293575166824,
		"co_count_sum": 33,
		"co_asset_sum": 21344132,
		"co_weight_total": 0.007059854241365954,
		"og_count_sum": 202,
		"og_asset_sum": 205323258,
		"og_weight_total": 0.06791338592932128,
		"ut_count_sum": 102,
		"ut_asset_sum": 122074219,
		"ut_weight_total": 0.040377664117172175,
		"cl_count_sum": 167,
		"cl_asset_sum": 524810428,
		"cl_weight_total": 0.17358799720826698,
		"fossil_bank_count_sum": 35,
		"fossil_bank_asset_sum": 37075179,
		"fossil_bank_weight_total": 0.012263106305402907,
		"fossil_insure_count_sum": 30,
		"fossil_insure_asset_sum": 48149993,
		"fossil_insure_weight_total": 0.015926247659206333,
		"name": "Gotham",
		"fund_family_name": "Gotham",
		"label": "Gotham"
	},
	{
		"fund_family_label": "Distillate Capital Partners",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 1963373050,
		"long_asset_sum": 1963373050,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 1963373050,
		"equity_fund_long_assets": 1963373050,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 40,
		"ff_all_asset_sum": 164440355,
		"ff_all_weight_total": 0.08375400436508997,
		"grade_fossil_fam": 4,
		"c2_count_sum": 24,
		"c2_asset_sum": 54868893,
		"c2_weight_total": 0.027946239253920695,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 597022,
		"mc50_weight_total": 0.00030407975702834465,
		"co_count_sum": 7,
		"co_asset_sum": 26007335,
		"co_weight_total": 0.013246252412398143,
		"og_count_sum": 33,
		"og_asset_sum": 138433020,
		"og_weight_total": 0.07050775195269182,
		"ut_count_sum": 4,
		"ut_asset_sum": 24857159,
		"ut_weight_total": 0.012660436079633465,
		"cl_count_sum": 16,
		"cl_asset_sum": 180078575,
		"cl_weight_total": 0.09171898076119564,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Distillate Capital Partners",
		"fund_family_name": "Distillate Capital Partners",
		"label": "Distillate Capital Partners"
	},
	{
		"fund_family_label": "Domini",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 2137068209,
		"long_asset_sum": 2281694926,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 1875260680,
		"equity_fund_long_assets": 1875266364,
		"num_e_sri": 3,
		"num_e_usf": 2,
		"sri_long_assets": 2281694926,
		"usf_long_assets": 2247143231,
		"equity_fund_sri_long_assets": 1875266364,
		"equity_fund_usf_long_assets": 1840714669,
		"sustainable_manager": 1,
		"num_c2_free": 3,
		"num_five_badgers": 1,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 12,
		"ff_all_asset_sum": 44340759,
		"ff_all_weight_total": 0.02364504576588246,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 1321835,
		"co_weight_total": 0.0007048785310586417,
		"og_count_sum": 8,
		"og_asset_sum": 38098283,
		"og_weight_total": 0.020316198131307174,
		"ut_count_sum": 8,
		"ut_asset_sum": 13228942,
		"ut_weight_total": 0.007054433574856142,
		"cl_count_sum": 75,
		"cl_asset_sum": 431456150,
		"cl_weight_total": 0.23007726170680678,
		"fossil_bank_count_sum": 15,
		"fossil_bank_asset_sum": 126517251,
		"fossil_bank_weight_total": 0.0674662828858802,
		"fossil_insure_count_sum": 8,
		"fossil_insure_asset_sum": 27252573,
		"fossil_insure_weight_total": 0.014532641081381865,
		"name": "Domini",
		"fund_family_name": "Domini",
		"label": "Domini"
	},
	{
		"fund_family_label": "Defiance ETFs",
		"as_of": "202506",
		"fund_id": 27,
		"net_asset_sum": 4344016962,
		"long_asset_sum": 7640827424,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 1871595334,
		"equity_fund_long_assets": 1871595334,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 57,
		"ff_all_asset_sum": 3824582,
		"ff_all_weight_total": 0.0020434876762735078,
		"grade_fossil_fam": 3,
		"c2_count_sum": 12,
		"c2_asset_sum": 1073840,
		"c2_weight_total": 0.0005737565062769065,
		"mc50_count_sum": 5,
		"mc50_asset_sum": 867491,
		"mc50_weight_total": 0.0004635035064689897,
		"co_count_sum": 8,
		"co_asset_sum": 292715,
		"co_weight_total": 0.0001563986587711807,
		"og_count_sum": 41,
		"og_asset_sum": 2619734,
		"og_weight_total": 0.0013997331326965148,
		"ut_count_sum": 28,
		"ut_asset_sum": 1823744,
		"ut_weight_total": 0.0009744328631672043,
		"cl_count_sum": 47,
		"cl_asset_sum": 328628011,
		"cl_weight_total": 0.17558710744253223,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 1272137,
		"fossil_bank_weight_total": 0.0006797072940341066,
		"fossil_insure_count_sum": 5,
		"fossil_insure_asset_sum": 952741,
		"fossil_insure_weight_total": 0.0005090528826890097,
		"name": "Defiance ETFs",
		"fund_family_name": "Defiance ETFs",
		"label": "Defiance ETFs"
	},
	{
		"fund_family_label": "Praxis Investment Management, Inc.",
		"as_of": "202506",
		"fund_id": 10,
		"net_asset_sum": 3041901372,
		"long_asset_sum": 3041901372,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 1810036520,
		"equity_fund_long_assets": 1810036520,
		"num_e_sri": 6,
		"num_e_usf": 4,
		"sri_long_assets": 3041901372,
		"usf_long_assets": 2970715425,
		"equity_fund_sri_long_assets": 1810036520,
		"equity_fund_usf_long_assets": 1738850573,
		"sustainable_manager": 1,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 144,
		"ff_all_asset_sum": 99513832,
		"ff_all_weight_total": 0.054978908381362386,
		"grade_fossil_fam": 3,
		"c2_count_sum": 33,
		"c2_asset_sum": 27199082,
		"c2_weight_total": 0.015026813934118853,
		"mc50_count_sum": 10,
		"mc50_asset_sum": 7170322,
		"mc50_weight_total": 0.0039614239385623,
		"co_count_sum": 20,
		"co_asset_sum": 11004418,
		"co_weight_total": 0.0060796662820924744,
		"og_count_sum": 114,
		"og_asset_sum": 86676032,
		"og_weight_total": 0.047886344304257464,
		"ut_count_sum": 64,
		"ut_asset_sum": 37768913,
		"ut_weight_total": 0.02086638174571196,
		"cl_count_sum": 154,
		"cl_asset_sum": 365000266,
		"cl_weight_total": 0.2016535368026718,
		"fossil_bank_count_sum": 50,
		"fossil_bank_asset_sum": 70536161,
		"fossil_bank_weight_total": 0.03896946841713448,
		"fossil_insure_count_sum": 25,
		"fossil_insure_asset_sum": 32857233,
		"fossil_insure_weight_total": 0.01815280113795715,
		"name": "Praxis Investment Management, Inc.",
		"fund_family_name": "Praxis Investment Management, Inc.",
		"label": "Praxis Investment Management, Inc."
	},
	{
		"fund_family_label": "Horizon Investments",
		"as_of": "202506",
		"fund_id": 13,
		"net_asset_sum": 5129122257,
		"long_asset_sum": 5214577025,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 1766963007,
		"equity_fund_long_assets": 1768195032,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 447531863,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 447531863,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 90,
		"ff_all_asset_sum": 131872831,
		"ff_all_weight_total": 0.07458047817883474,
		"grade_fossil_fam": 4,
		"c2_count_sum": 12,
		"c2_asset_sum": 30717790,
		"c2_weight_total": 0.01737239922298345,
		"mc50_count_sum": 9,
		"mc50_asset_sum": 45363335,
		"mc50_weight_total": 0.02565516483138722,
		"co_count_sum": 10,
		"co_asset_sum": 9791956,
		"co_weight_total": 0.005537825761745495,
		"og_count_sum": 58,
		"og_asset_sum": 71964126,
		"og_weight_total": 0.04069920155730875,
		"ut_count_sum": 48,
		"ut_asset_sum": 71436391,
		"ut_weight_total": 0.04040074183400375,
		"cl_count_sum": 59,
		"cl_asset_sum": 305079233,
		"cl_weight_total": 0.17253709431302147,
		"fossil_bank_count_sum": 6,
		"fossil_bank_asset_sum": 12425737,
		"fossil_bank_weight_total": 0.0070273565840445135,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 46743398,
		"fossil_insure_weight_total": 0.02643565735343611,
		"name": "Horizon Investments",
		"fund_family_name": "Horizon Investments",
		"label": "Horizon Investments"
	},
	{
		"fund_family_label": "Selected Funds",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 1740198584,
		"long_asset_sum": 1740198584,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 1740198584,
		"equity_fund_long_assets": 1740198584,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 221663802,
		"ff_all_weight_total": 0.12737845211348592,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 60830190,
		"c2_weight_total": 0.034955889838834624,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 158091437,
		"mc50_weight_total": 0.0908467794730719,
		"co_count_sum": 1,
		"co_asset_sum": 853689,
		"co_weight_total": 0.0004905698739495124,
		"og_count_sum": 5,
		"og_asset_sum": 63572365,
		"og_weight_total": 0.03653167264041401,
		"ut_count_sum": 2,
		"ut_asset_sum": 159979923,
		"ut_weight_total": 0.09193199240070178,
		"cl_count_sum": 3,
		"cl_asset_sum": 90344884,
		"cl_weight_total": 0.051916421970838705,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 159272981,
		"fossil_bank_weight_total": 0.09152575025885666,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 210146930,
		"fossil_insure_weight_total": 0.12076031547902925,
		"name": "Selected Funds",
		"fund_family_name": "Selected Funds",
		"label": "Selected Funds"
	},
	{
		"fund_family_label": "Meridian",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 1715241882,
		"long_asset_sum": 1730519199,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 1673125421,
		"equity_fund_long_assets": 1676336611,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 10,
		"ff_all_asset_sum": 60429044,
		"ff_all_weight_total": 0.03604827550950625,
		"grade_fossil_fam": 3,
		"c2_count_sum": 4,
		"c2_asset_sum": 16756727,
		"c2_weight_total": 0.009996039512615525,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 13652100,
		"mc50_weight_total": 0.008144008733339059,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 9,
		"og_asset_sum": 46776944,
		"og_weight_total": 0.027904266776167187,
		"ut_count_sum": 1,
		"ut_asset_sum": 13652100,
		"ut_weight_total": 0.008144008733339059,
		"cl_count_sum": 3,
		"cl_asset_sum": 23985045,
		"cl_weight_total": 0.014308012390000829,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 19346320,
		"fossil_insure_weight_total": 0.011540832475441295,
		"name": "Meridian",
		"fund_family_name": "Meridian",
		"label": "Meridian"
	},
	{
		"fund_family_label": "Homestead",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 2537229736,
		"long_asset_sum": 2537362434,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 1656505231,
		"equity_fund_long_assets": 1656505231,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 11,
		"ff_all_asset_sum": 102339301,
		"ff_all_weight_total": 0.061780246198329086,
		"grade_fossil_fam": 4,
		"c2_count_sum": 9,
		"c2_asset_sum": 83853542,
		"c2_weight_total": 0.05062075291448325,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 17479037,
		"co_weight_total": 0.010551754786459833,
		"og_count_sum": 9,
		"og_asset_sum": 84860264,
		"og_weight_total": 0.051228491411869255,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 17,
		"cl_asset_sum": 202915759,
		"cl_weight_total": 0.12249629835307173,
		"fossil_bank_count_sum": 6,
		"fossil_bank_asset_sum": 90821903,
		"fossil_bank_weight_total": 0.054827416962138165,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 27895209,
		"fossil_insure_weight_total": 0.016839795297935885,
		"name": "Homestead",
		"fund_family_name": "Homestead",
		"label": "Homestead"
	},
	{
		"fund_family_label": "Strive AM",
		"as_of": "202506",
		"fund_id": 13,
		"net_asset_sum": 2083198417,
		"long_asset_sum": 2120690166,
		"num_equity_funds": 11,
		"equity_fund_net_assets": 1650976921,
		"equity_fund_long_assets": 1658176528,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 373,
		"ff_all_asset_sum": 365398660,
		"ff_all_weight_total": 0.22036173702248907,
		"grade_fossil_fam": 5,
		"c2_count_sum": 117,
		"c2_asset_sum": 240826517,
		"c2_weight_total": 0.1452357532104688,
		"mc50_count_sum": 16,
		"mc50_asset_sum": 18080030,
		"mc50_weight_total": 0.010903561650222562,
		"co_count_sum": 66,
		"co_asset_sum": 20617733,
		"co_weight_total": 0.01243397952621363,
		"og_count_sum": 283,
		"og_asset_sum": 330084161,
		"og_weight_total": 0.19906454796952716,
		"ut_count_sum": 137,
		"ut_asset_sum": 49704781,
		"ut_weight_total": 0.02997556663038231,
		"cl_count_sum": 164,
		"cl_asset_sum": 311768859,
		"cl_weight_total": 0.18801910034032276,
		"fossil_bank_count_sum": 56,
		"fossil_bank_asset_sum": 31688176,
		"fossil_bank_weight_total": 0.019110254828067375,
		"fossil_insure_count_sum": 25,
		"fossil_insure_asset_sum": 20181610,
		"fossil_insure_weight_total": 0.01217096591298511,
		"name": "Strive AM",
		"fund_family_name": "Strive AM",
		"label": "Strive AM"
	},
	{
		"fund_family_label": "Brookfield Investment Funds",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 1610334746,
		"long_asset_sum": 1610415237,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 1610334746,
		"equity_fund_long_assets": 1610415237,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 57748396,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 57748396,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 50,
		"ff_all_asset_sum": 1346377362,
		"ff_all_weight_total": 0.8360436060628257,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 3103216,
		"c2_weight_total": 0.0019269663678672707,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 22209260,
		"mc50_weight_total": 0.013791014571728124,
		"co_count_sum": 6,
		"co_asset_sum": 21753887,
		"co_weight_total": 0.013508247127942444,
		"og_count_sum": 38,
		"og_asset_sum": 1302631010,
		"og_weight_total": 0.8088789649225109,
		"ut_count_sum": 26,
		"ut_asset_sum": 111686935,
		"ut_weight_total": 0.06935288019756858,
		"cl_count_sum": 12,
		"cl_asset_sum": 36741281,
		"cl_weight_total": 0.02281478723987011,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Brookfield Investment Funds",
		"fund_family_name": "Brookfield Investment Funds",
		"label": "Brookfield Investment Funds"
	},
	{
		"fund_family_label": "Direxion Funds",
		"as_of": "202506",
		"fund_id": 112,
		"net_asset_sum": 49699221522,
		"long_asset_sum": 59144235443,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 1605198688,
		"equity_fund_long_assets": 1626209293,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 4547644,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 66,
		"ff_all_asset_sum": 105650516,
		"ff_all_weight_total": 0.06496735472781485,
		"grade_fossil_fam": 4,
		"c2_count_sum": 14,
		"c2_asset_sum": 16809209,
		"c2_weight_total": 0.010336436442932072,
		"mc50_count_sum": 7,
		"mc50_asset_sum": 18542304,
		"mc50_weight_total": 0.011402163349954489,
		"co_count_sum": 12,
		"co_asset_sum": 24346433,
		"co_weight_total": 0.014971278976696882,
		"og_count_sum": 46,
		"og_asset_sum": 58064898,
		"og_weight_total": 0.035705673464012114,
		"ut_count_sum": 35,
		"ut_asset_sum": 62155510,
		"ut_weight_total": 0.03822110122451502,
		"cl_count_sum": 54,
		"cl_asset_sum": 251995584,
		"cl_weight_total": 0.1549588881853721,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 8397588,
		"fossil_bank_weight_total": 0.005163903586178805,
		"fossil_insure_count_sum": 6,
		"fossil_insure_asset_sum": 8275178,
		"fossil_insure_weight_total": 0.005088630372253075,
		"name": "Direxion Funds",
		"fund_family_name": "Direxion Funds",
		"label": "Direxion Funds"
	},
	{
		"fund_family_label": "Applied Finance",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 1558227263,
		"long_asset_sum": 1558227263,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 1558227263,
		"equity_fund_long_assets": 1558227263,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 46,
		"ff_all_asset_sum": 117617042,
		"ff_all_weight_total": 0.07548131443519737,
		"grade_fossil_fam": 4,
		"c2_count_sum": 18,
		"c2_asset_sum": 50339494,
		"c2_weight_total": 0.03230561754071941,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 469571,
		"mc50_weight_total": 0.0003013494957699248,
		"co_count_sum": 6,
		"co_asset_sum": 20131208,
		"co_weight_total": 0.012919301617943775,
		"og_count_sum": 32,
		"og_asset_sum": 64142921,
		"og_weight_total": 0.04116403462002577,
		"ut_count_sum": 13,
		"ut_asset_sum": 41902831,
		"ut_weight_total": 0.02689134761981122,
		"cl_count_sum": 36,
		"cl_asset_sum": 167772046,
		"cl_weight_total": 0.10766853461220695,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 14570488,
		"fossil_bank_weight_total": 0.009350682243839037,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 14310319,
		"fossil_insure_weight_total": 0.009183717510146015,
		"name": "Applied Finance",
		"fund_family_name": "Applied Finance",
		"label": "Applied Finance"
	},
	{
		"fund_family_label": "Nuance Investments",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 1557192091,
		"long_asset_sum": 1557412943,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 1557192091,
		"equity_fund_long_assets": 1557412943,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 34979115,
		"ff_all_weight_total": 0.022459756198391887,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 21349886,
		"co_weight_total": 0.013708558218910346,
		"og_count_sum": 1,
		"og_asset_sum": 7178312,
		"og_weight_total": 0.004609125686455786,
		"ut_count_sum": 3,
		"ut_asset_sum": 34979115,
		"ut_weight_total": 0.022459756198391887,
		"cl_count_sum": 6,
		"cl_asset_sum": 118289192,
		"cl_weight_total": 0.07595236223743133,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 3536262,
		"fossil_insure_weight_total": 0.002270600110198262,
		"name": "Nuance Investments",
		"fund_family_name": "Nuance Investments",
		"label": "Nuance Investments"
	},
	{
		"fund_family_label": "Patient Capital Management",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 1546723371,
		"long_asset_sum": 1557571455,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 1546723371,
		"equity_fund_long_assets": 1557571455,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 155020000,
		"ff_all_weight_total": 0.09952673407204936,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 31920000,
		"c2_weight_total": 0.020493441824150534,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 155020000,
		"og_weight_total": 0.09952673407204936,
		"ut_count_sum": 1,
		"ut_asset_sum": 14958000,
		"ut_weight_total": 0.009603411742031444,
		"cl_count_sum": 1,
		"cl_asset_sum": 73454000,
		"cl_weight_total": 0.04715931315009879,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 125322250,
		"fossil_bank_weight_total": 0.08046003257038374,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Patient Capital Management",
		"fund_family_name": "Patient Capital Management",
		"label": "Patient Capital Management"
	},
	{
		"fund_family_label": "Inspire",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 1890432297,
		"long_asset_sum": 1890603109,
		"num_equity_funds": 8,
		"equity_fund_net_assets": 1512501262,
		"equity_fund_long_assets": 1512672074,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 202,
		"ff_all_asset_sum": 197804178,
		"ff_all_weight_total": 0.13076474498332016,
		"grade_fossil_fam": 5,
		"c2_count_sum": 62,
		"c2_asset_sum": 58296124,
		"c2_weight_total": 0.038538507454458366,
		"mc50_count_sum": 8,
		"mc50_asset_sum": 9274851,
		"mc50_weight_total": 0.006131435331832536,
		"co_count_sum": 28,
		"co_asset_sum": 21666873,
		"co_weight_total": 0.014323575725640057,
		"og_count_sum": 154,
		"og_asset_sum": 163809943,
		"og_weight_total": 0.1082917744140228,
		"ut_count_sum": 82,
		"ut_asset_sum": 77636282,
		"ut_weight_total": 0.05132393420518716,
		"cl_count_sum": 61,
		"cl_asset_sum": 98019642,
		"cl_weight_total": 0.06479900282736363,
		"fossil_bank_count_sum": 11,
		"fossil_bank_asset_sum": 12718138,
		"fossil_bank_weight_total": 0.008407729750949312,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Inspire",
		"fund_family_name": "Inspire",
		"label": "Inspire"
	},
	{
		"fund_family_label": "SP Funds",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 1808667464,
		"long_asset_sum": 1809381736,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 1490322133,
		"equity_fund_long_assets": 1490831914,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 44,
		"ff_all_asset_sum": 46555878,
		"ff_all_weight_total": 0.03122812006022028,
		"grade_fossil_fam": 3,
		"c2_count_sum": 19,
		"c2_asset_sum": 29128154,
		"c2_weight_total": 0.01953818785770909,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 176145,
		"mc50_weight_total": 0.000118152152731552,
		"co_count_sum": 5,
		"co_asset_sum": 3200406,
		"co_weight_total": 0.0021467249057025486,
		"og_count_sum": 39,
		"og_asset_sum": 39684077,
		"og_weight_total": 0.026618746638931958,
		"ut_count_sum": 10,
		"ut_asset_sum": 4370329,
		"ut_weight_total": 0.0029314699792507928,
		"cl_count_sum": 88,
		"cl_asset_sum": 544313280,
		"cl_weight_total": 0.365107075377513,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "SP Funds",
		"fund_family_name": "SP Funds",
		"label": "SP Funds"
	},
	{
		"fund_family_label": "Heartland",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 1490072584,
		"long_asset_sum": 1490134278,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 1490072584,
		"equity_fund_long_assets": 1490134278,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 20,
		"ff_all_asset_sum": 116003679,
		"ff_all_weight_total": 0.07784780251863986,
		"grade_fossil_fam": 4,
		"c2_count_sum": 6,
		"c2_asset_sum": 40931548,
		"c2_weight_total": 0.027468362149843786,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 3,
		"co_asset_sum": 18479385,
		"co_weight_total": 0.012401154226719963,
		"og_count_sum": 13,
		"og_asset_sum": 78677260,
		"og_weight_total": 0.052798772004357584,
		"ut_count_sum": 8,
		"ut_asset_sum": 42676690,
		"ut_weight_total": 0.02863949284978464,
		"cl_count_sum": 2,
		"cl_asset_sum": 23672117,
		"cl_weight_total": 0.01588589521728994,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 6007235,
		"fossil_bank_weight_total": 0.0040313380402621675,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Heartland",
		"fund_family_name": "Heartland",
		"label": "Heartland"
	},
	{
		"fund_family_label": "Hamlin Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 1487062988,
		"long_asset_sum": 1487062988,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 1487062988,
		"equity_fund_long_assets": 1487062988,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 261260615,
		"ff_all_weight_total": 0.17568900383391156,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 61684967,
		"c2_weight_total": 0.04148107208489006,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 190553887,
		"og_weight_total": 0.12814109996529616,
		"ut_count_sum": 1,
		"ut_asset_sum": 70706728,
		"ut_weight_total": 0.04754790386861542,
		"cl_count_sum": 2,
		"cl_asset_sum": 137707305,
		"cl_weight_total": 0.09260354545250776,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 61257700,
		"fossil_bank_weight_total": 0.04119374935313769,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Hamlin Funds",
		"fund_family_name": "Hamlin Funds",
		"label": "Hamlin Funds"
	},
	{
		"fund_family_label": "Crossmark Steward Funds",
		"as_of": "202506",
		"fund_id": 10,
		"net_asset_sum": 1827031221,
		"long_asset_sum": 1961743176,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 1432895491,
		"equity_fund_long_assets": 1434346690,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 143,
		"ff_all_asset_sum": 100581259,
		"ff_all_weight_total": 0.07012339464456811,
		"grade_fossil_fam": 4,
		"c2_count_sum": 47,
		"c2_asset_sum": 54019868,
		"c2_weight_total": 0.03766165347374978,
		"mc50_count_sum": 8,
		"mc50_asset_sum": 11010270,
		"mc50_weight_total": 0.00767615673167552,
		"co_count_sum": 26,
		"co_asset_sum": 16881854,
		"co_weight_total": 0.011769716566920094,
		"og_count_sum": 101,
		"og_asset_sum": 71911666,
		"og_weight_total": 0.05013548432980314,
		"ut_count_sum": 56,
		"ut_asset_sum": 38885733,
		"ut_weight_total": 0.027110414289030778,
		"cl_count_sum": 91,
		"cl_asset_sum": 249968286,
		"cl_weight_total": 0.17427326861959713,
		"fossil_bank_count_sum": 37,
		"fossil_bank_asset_sum": 107722581,
		"fossil_bank_weight_total": 0.0751021923437492,
		"fossil_insure_count_sum": 9,
		"fossil_insure_asset_sum": 14095621,
		"fossil_insure_weight_total": 0.00982720641966971,
		"name": "Crossmark Steward Funds",
		"fund_family_name": "Crossmark Steward Funds",
		"label": "Crossmark Steward Funds"
	},
	{
		"fund_family_label": "TCW ETF",
		"as_of": "202506",
		"fund_id": 11,
		"net_asset_sum": 3910950250,
		"long_asset_sum": 4064795462,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 1432711728,
		"equity_fund_long_assets": 1432711728,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 1222620644,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 1222620644,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 67,
		"ff_all_asset_sum": 179471270,
		"ff_all_weight_total": 0.1252668394433636,
		"grade_fossil_fam": 5,
		"c2_count_sum": 15,
		"c2_asset_sum": 34051601,
		"c2_weight_total": 0.023767238261903863,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 17077106,
		"mc50_weight_total": 0.011919429195877986,
		"co_count_sum": 8,
		"co_asset_sum": 43388553,
		"co_weight_total": 0.030284217091297517,
		"og_count_sum": 49,
		"og_asset_sum": 95867261,
		"og_weight_total": 0.06691315435368586,
		"ut_count_sum": 31,
		"ut_asset_sum": 93616268,
		"ut_weight_total": 0.06534201275136069,
		"cl_count_sum": 55,
		"cl_asset_sum": 368192447,
		"cl_weight_total": 0.2569899022980567,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 18591273,
		"fossil_bank_weight_total": 0.012976283111713314,
		"fossil_insure_count_sum": 6,
		"fossil_insure_asset_sum": 17991178,
		"fossil_insure_weight_total": 0.012557430534274234,
		"name": "TCW ETF",
		"fund_family_name": "TCW ETF",
		"label": "TCW ETF"
	},
	{
		"fund_family_label": "Independent Franchise Partners",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 1425492553,
		"long_asset_sum": 1426548600,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 1425492553,
		"equity_fund_long_assets": 1426548600,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Independent Franchise Partners",
		"fund_family_name": "Independent Franchise Partners",
		"label": "Independent Franchise Partners"
	},
	{
		"fund_family_label": "Weitz",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 6700700850,
		"long_asset_sum": 6702285230,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 1423845548,
		"equity_fund_long_assets": 1425138062,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 86544250,
		"ff_all_weight_total": 0.060726923452276725,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 86544250,
		"mc50_weight_total": 0.060726923452276725,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 2,
		"ut_asset_sum": 86544250,
		"ut_weight_total": 0.060726923452276725,
		"cl_count_sum": 6,
		"cl_asset_sum": 146320040,
		"cl_weight_total": 0.10267078250275516,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 86544250,
		"fossil_insure_weight_total": 0.060726923452276725,
		"name": "Weitz",
		"fund_family_name": "Weitz",
		"label": "Weitz"
	},
	{
		"fund_family_label": "Rockefeller Asset Management",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 1607837078,
		"long_asset_sum": 1610400673,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 1413946731,
		"equity_fund_long_assets": 1414500754,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 56602887,
		"ff_all_weight_total": 0.04001615894508035,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 24369794,
		"c2_weight_total": 0.017228547903623104,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 48179895,
		"og_weight_total": 0.03406141344481744,
		"ut_count_sum": 1,
		"ut_asset_sum": 8422992,
		"ut_weight_total": 0.005954745500262914,
		"cl_count_sum": 11,
		"cl_asset_sum": 141788437,
		"cl_weight_total": 0.1002392092044088,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 17610709,
		"fossil_bank_weight_total": 0.01245012344475569,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Rockefeller Asset Management",
		"fund_family_name": "Rockefeller Asset Management",
		"label": "Rockefeller Asset Management"
	},
	{
		"fund_family_label": "Sands Capital",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 1336374166,
		"long_asset_sum": 1343472638,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 1336374166,
		"equity_fund_long_assets": 1343472638,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 5,
		"cl_asset_sum": 130174326,
		"cl_weight_total": 0.09689391679296709,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Sands Capital",
		"fund_family_name": "Sands Capital",
		"label": "Sands Capital"
	},
	{
		"fund_family_label": "Fairholme",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 1312526361,
		"long_asset_sum": 1312526361,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 1312526361,
		"equity_fund_long_assets": 1312526361,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 173162125,
		"ff_all_weight_total": 0.13193039785354832,
		"grade_fossil_fam": 5,
		"c2_count_sum": 6,
		"c2_asset_sum": 1652560,
		"c2_weight_total": 0.0012590680454912402,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 810810,
		"co_weight_total": 0.0006177475928043475,
		"og_count_sum": 8,
		"og_asset_sum": 172790875,
		"og_weight_total": 0.13164754639164158,
		"ut_count_sum": 1,
		"ut_asset_sum": 371250,
		"ut_weight_total": 0.0002828514619067525,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Fairholme",
		"fund_family_name": "Fairholme",
		"label": "Fairholme"
	},
	{
		"fund_family_label": "Horizon Kinetics",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 1301534778,
		"long_asset_sum": 1301546239,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 1285775611,
		"equity_fund_long_assets": 1285787072,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 38,
		"ff_all_asset_sum": 442328311,
		"ff_all_weight_total": 0.34401365562960023,
		"grade_fossil_fam": 5,
		"c2_count_sum": 9,
		"c2_asset_sum": 19475393,
		"c2_weight_total": 0.01514667041231536,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 18417962,
		"co_weight_total": 0.014324270636312635,
		"og_count_sum": 36,
		"og_asset_sum": 391840231,
		"og_weight_total": 0.30474737188833706,
		"ut_count_sum": 1,
		"ut_asset_sum": 32147804,
		"ut_weight_total": 0.02500243212898006,
		"cl_count_sum": 8,
		"cl_asset_sum": 4501952,
		"cl_weight_total": 0.0035013200070501253,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Horizon Kinetics",
		"fund_family_name": "Horizon Kinetics",
		"label": "Horizon Kinetics"
	},
	{
		"fund_family_label": "Oak Associates",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 1249912219,
		"long_asset_sum": 1249912219,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 1249912219,
		"equity_fund_long_assets": 1249912219,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 6,
		"num_five_badgers": 6,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 4,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 1878500,
		"ff_all_weight_total": 0.0015029055412410525,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 1878500,
		"c2_weight_total": 0.0015029055412410525,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 1878500,
		"og_weight_total": 0.0015029055412410525,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 21,
		"cl_asset_sum": 307432375,
		"cl_weight_total": 0.24596317271461124,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 18568604,
		"fossil_insure_weight_total": 0.01485592645446408,
		"name": "Oak Associates",
		"fund_family_name": "Oak Associates",
		"label": "Oak Associates"
	},
	{
		"fund_family_label": "U.S. Global Investors",
		"as_of": "202506",
		"fund_id": 10,
		"net_asset_sum": 1295264057,
		"long_asset_sum": 1394868811,
		"num_equity_funds": 8,
		"equity_fund_net_assets": 1241313031,
		"equity_fund_long_assets": 1340917785,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 7,
		"num_five_badgers": 5,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 5,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 31,
		"ff_all_asset_sum": 10532408,
		"ff_all_weight_total": 0.007854626225275996,
		"grade_fossil_fam": 3,
		"c2_count_sum": 14,
		"c2_asset_sum": 4965792,
		"c2_weight_total": 0.003703278497421078,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 4,
		"co_asset_sum": 1280849,
		"co_weight_total": 0.0009552032304501055,
		"og_count_sum": 27,
		"og_asset_sum": 9251559,
		"og_weight_total": 0.006899422994825891,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 14,
		"cl_asset_sum": 11619147,
		"cl_weight_total": 0.0086650703943046,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 1543269,
		"fossil_bank_weight_total": 0.0011509050124202805,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "U.S. Global Investors",
		"fund_family_name": "U.S. Global Investors",
		"label": "U.S. Global Investors"
	},
	{
		"fund_family_label": "Segall Bryant & Hamill",
		"as_of": "202506",
		"fund_id": 16,
		"net_asset_sum": 2522761425,
		"long_asset_sum": 2523176922,
		"num_equity_funds": 11,
		"equity_fund_net_assets": 1241048096,
		"equity_fund_long_assets": 1241463593,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 138,
		"ff_all_asset_sum": 64767260,
		"ff_all_weight_total": 0.05217008405658498,
		"grade_fossil_fam": 3,
		"c2_count_sum": 42,
		"c2_asset_sum": 27257127,
		"c2_weight_total": 0.02195563941922218,
		"mc50_count_sum": 9,
		"mc50_asset_sum": 2857662,
		"mc50_weight_total": 0.0023018492174180093,
		"co_count_sum": 33,
		"co_asset_sum": 8967181,
		"co_weight_total": 0.007223072066359017,
		"og_count_sum": 84,
		"og_asset_sum": 43573870,
		"og_weight_total": 0.03509879004562964,
		"ut_count_sum": 60,
		"ut_asset_sum": 21899742,
		"ut_weight_total": 0.017640261159072104,
		"cl_count_sum": 67,
		"cl_asset_sum": 123237843,
		"cl_weight_total": 0.09926818933303991,
		"fossil_bank_count_sum": 25,
		"fossil_bank_asset_sum": 3967531,
		"fossil_bank_weight_total": 0.0031958496587181032,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 2122086,
		"fossil_insure_weight_total": 0.0017093421119760538,
		"name": "Segall Bryant & Hamill",
		"fund_family_name": "Segall Bryant & Hamill",
		"label": "Segall Bryant & Hamill"
	},
	{
		"fund_family_label": "Exchange Traded Concepts",
		"as_of": "202506",
		"fund_id": 15,
		"net_asset_sum": 1995024922,
		"long_asset_sum": 2009118965,
		"num_equity_funds": 13,
		"equity_fund_net_assets": 1234854368,
		"equity_fund_long_assets": 1237065328,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 7,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 162,
		"ff_all_asset_sum": 205747407,
		"ff_all_weight_total": 0.1663189504572389,
		"grade_fossil_fam": 5,
		"c2_count_sum": 38,
		"c2_asset_sum": 40965569,
		"c2_weight_total": 0.03311512179088411,
		"mc50_count_sum": 14,
		"mc50_asset_sum": 35592444,
		"mc50_weight_total": 0.028771676963530578,
		"co_count_sum": 48,
		"co_asset_sum": 45521385,
		"co_weight_total": 0.03679788283582062,
		"og_count_sum": 93,
		"og_asset_sum": 116019401,
		"og_weight_total": 0.09378599365287522,
		"ut_count_sum": 72,
		"ut_asset_sum": 130022086,
		"ut_weight_total": 0.10510527056013326,
		"cl_count_sum": 49,
		"cl_asset_sum": 69365686,
		"cl_weight_total": 0.05607277516389983,
		"fossil_bank_count_sum": 11,
		"fossil_bank_asset_sum": 19273815,
		"fossil_bank_weight_total": 0.01558027257231479,
		"fossil_insure_count_sum": 9,
		"fossil_insure_asset_sum": 17912326,
		"fossil_insure_weight_total": 0.014479692862267335,
		"name": "Exchange Traded Concepts",
		"fund_family_name": "Exchange Traded Concepts",
		"label": "Exchange Traded Concepts"
	},
	{
		"fund_family_label": "Third Avenue",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 1211017920,
		"long_asset_sum": 1213514820,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 1211017920,
		"equity_fund_long_assets": 1213514820,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 13,
		"ff_all_asset_sum": 195247697,
		"ff_all_weight_total": 0.1608943655092733,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 46170530,
		"c2_weight_total": 0.03804694367061788,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 44986272,
		"co_weight_total": 0.03707105282818054,
		"og_count_sum": 11,
		"og_asset_sum": 150261425,
		"og_weight_total": 0.12382331268109276,
		"ut_count_sum": 1,
		"ut_asset_sum": 19297594,
		"ut_weight_total": 0.015902231832652856,
		"cl_count_sum": 2,
		"cl_asset_sum": 52582891,
		"cl_weight_total": 0.0433310661999167,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 29997598,
		"fossil_bank_weight_total": 0.024719597573600295,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Third Avenue",
		"fund_family_name": "Third Avenue",
		"label": "Third Avenue"
	},
	{
		"fund_family_label": "Altair",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 1206453234,
		"long_asset_sum": 1206617840,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 1206453234,
		"equity_fund_long_assets": 1206617840,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 114,
		"ff_all_asset_sum": 67505378,
		"ff_all_weight_total": 0.05594594722716846,
		"grade_fossil_fam": 4,
		"c2_count_sum": 37,
		"c2_asset_sum": 26522204,
		"c2_weight_total": 0.021980616497432194,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 307139,
		"mc50_weight_total": 0.00025454538281979985,
		"co_count_sum": 26,
		"co_asset_sum": 8998542,
		"co_weight_total": 0.007457657015911516,
		"og_count_sum": 88,
		"og_asset_sum": 55851134,
		"og_weight_total": 0.046287343140890405,
		"ut_count_sum": 42,
		"ut_asset_sum": 16026636,
		"ut_weight_total": 0.013282279996788379,
		"cl_count_sum": 84,
		"cl_asset_sum": 59690537,
		"cl_weight_total": 0.0494692975863841,
		"fossil_bank_count_sum": 39,
		"fossil_bank_asset_sum": 36261303,
		"fossil_bank_weight_total": 0.030052019618738605,
		"fossil_insure_count_sum": 17,
		"fossil_insure_asset_sum": 9883056,
		"fossil_insure_weight_total": 0.008190709330138862,
		"name": "Altair",
		"fund_family_name": "Altair",
		"label": "Altair"
	},
	{
		"fund_family_label": "Mondrian",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 1203285342,
		"long_asset_sum": 1205407923,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 1203285342,
		"equity_fund_long_assets": 1205407923,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 32,
		"ff_all_asset_sum": 175299618,
		"ff_all_weight_total": 0.14542763047692361,
		"grade_fossil_fam": 5,
		"c2_count_sum": 7,
		"c2_asset_sum": 47489056,
		"c2_weight_total": 0.039396668209886986,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 5,
		"co_asset_sum": 15569647,
		"co_weight_total": 0.012916496318732094,
		"og_count_sum": 22,
		"og_asset_sum": 145797646,
		"og_weight_total": 0.12095295145990176,
		"ut_count_sum": 14,
		"ut_asset_sum": 111225570,
		"ut_weight_total": 0.09227214113806684,
		"cl_count_sum": 21,
		"cl_asset_sum": 183059865,
		"cl_weight_total": 0.15186549010263972,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 79624246,
		"fossil_bank_weight_total": 0.06605585087065999,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 40753011,
		"fossil_insure_weight_total": 0.03380848111448825,
		"name": "Mondrian",
		"fund_family_name": "Mondrian",
		"label": "Mondrian"
	},
	{
		"fund_family_label": "Robo Global",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 1200989058,
		"long_asset_sum": 1201003171,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 1200989058,
		"equity_fund_long_assets": 1201003171,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 10954998,
		"ff_all_weight_total": 0.009121539613320472,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 10954998,
		"og_weight_total": 0.009121539613320472,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 11,
		"cl_asset_sum": 70402329,
		"cl_weight_total": 0.0586196029285921,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Robo Global",
		"fund_family_name": "Robo Global",
		"label": "Robo Global"
	},
	{
		"fund_family_label": "TCW",
		"as_of": "202506",
		"fund_id": 20,
		"net_asset_sum": 46481743333,
		"long_asset_sum": 51703893138,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 1198786342,
		"equity_fund_long_assets": 1198786342,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 19579745,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 18,
		"ff_all_asset_sum": 51241602,
		"ff_all_weight_total": 0.0427445660704733,
		"grade_fossil_fam": 3,
		"c2_count_sum": 5,
		"c2_asset_sum": 13408403,
		"c2_weight_total": 0.011184981451849074,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 110121,
		"co_weight_total": 0.00009186040593045062,
		"og_count_sum": 16,
		"og_asset_sum": 51131481,
		"og_weight_total": 0.04265270566454285,
		"ut_count_sum": 3,
		"ut_asset_sum": 16143600,
		"ut_weight_total": 0.013466619892471214,
		"cl_count_sum": 15,
		"cl_asset_sum": 182816230,
		"cl_weight_total": 0.15250109514510968,
		"fossil_bank_count_sum": 6,
		"fossil_bank_asset_sum": 18181763,
		"fossil_bank_weight_total": 0.015166808598825361,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 26383,
		"fossil_insure_weight_total": 0.000022008091914013483,
		"name": "TCW",
		"fund_family_name": "TCW",
		"label": "TCW"
	},
	{
		"fund_family_label": "kovitzetf",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 1185619848,
		"long_asset_sum": 1185619848,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 1185619848,
		"equity_fund_long_assets": 1185619848,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 32450488,
		"ff_all_weight_total": 0.02737006136894564,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 32450488,
		"mc50_weight_total": 0.02737006136894564,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 32450488,
		"ut_weight_total": 0.02737006136894564,
		"cl_count_sum": 6,
		"cl_asset_sum": 143737505,
		"cl_weight_total": 0.1212340576471186,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 32450488,
		"fossil_insure_weight_total": 0.02737006136894564,
		"name": "kovitzetf",
		"fund_family_name": "kovitzetf",
		"label": "kovitzetf"
	},
	{
		"fund_family_label": "Knights of Columbus Asset Advisors",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 1812756694,
		"long_asset_sum": 1887318233,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 1182005980,
		"equity_fund_long_assets": 1187135595,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 218,
		"ff_all_asset_sum": 113022402,
		"ff_all_weight_total": 0.09520597518601066,
		"grade_fossil_fam": 5,
		"c2_count_sum": 50,
		"c2_asset_sum": 44935777,
		"c2_weight_total": 0.037852269942255413,
		"mc50_count_sum": 9,
		"mc50_asset_sum": 20086046,
		"mc50_weight_total": 0.016919757173989886,
		"co_count_sum": 36,
		"co_asset_sum": 24351107,
		"co_weight_total": 0.020512489982241665,
		"og_count_sum": 163,
		"og_asset_sum": 79272829,
		"og_weight_total": 0.06677655807296386,
		"ut_count_sum": 69,
		"ut_asset_sum": 48282685,
		"ut_weight_total": 0.040671583939827866,
		"cl_count_sum": 71,
		"cl_asset_sum": 187488366,
		"cl_weight_total": 0.15793340439766698,
		"fossil_bank_count_sum": 22,
		"fossil_bank_asset_sum": 51364646,
		"fossil_bank_weight_total": 0.043267716187046015,
		"fossil_insure_count_sum": 16,
		"fossil_insure_asset_sum": 40685611,
		"fossil_insure_weight_total": 0.034272084142165746,
		"name": "Knights of Columbus Asset Advisors",
		"fund_family_name": "Knights of Columbus Asset Advisors",
		"label": "Knights of Columbus Asset Advisors"
	},
	{
		"fund_family_label": "Green Century",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 1153496464,
		"long_asset_sum": 1153783806,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 1153496464,
		"equity_fund_long_assets": 1153783806,
		"num_e_sri": 3,
		"num_e_usf": 3,
		"sri_long_assets": 1153783806,
		"usf_long_assets": 1153783806,
		"equity_fund_sri_long_assets": 1153783806,
		"equity_fund_usf_long_assets": 1153783806,
		"sustainable_manager": 1,
		"num_c2_free": 3,
		"num_five_badgers": 2,
		"num_sri_badgers": 2,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 1513085,
		"ff_all_weight_total": 0.0013114111951749825,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 1513085,
		"co_weight_total": 0.0013114111951749825,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 56,
		"cl_asset_sum": 255532222,
		"cl_weight_total": 0.22147322632815666,
		"fossil_bank_count_sum": 7,
		"fossil_bank_asset_sum": 20369099,
		"fossil_bank_weight_total": 0.0176541730730445,
		"fossil_insure_count_sum": 11,
		"fossil_insure_asset_sum": 22923594,
		"fossil_insure_weight_total": 0.01986818837358513,
		"name": "Green Century",
		"fund_family_name": "Green Century",
		"label": "Green Century"
	},
	{
		"fund_family_label": "Clipper Fund",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 1129415864,
		"long_asset_sum": 1129415864,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 1129415864,
		"equity_fund_long_assets": 1129415864,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 152592374,
		"ff_all_weight_total": 0.1351073407624811,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 37616784,
		"c2_weight_total": 0.03330640661162167,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 114975590,
		"mc50_weight_total": 0.10180093415085942,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 37616784,
		"og_weight_total": 0.03330640661162167,
		"ut_count_sum": 1,
		"ut_asset_sum": 114975590,
		"ut_weight_total": 0.10180093415085942,
		"cl_count_sum": 1,
		"cl_asset_sum": 58268971,
		"cl_weight_total": 0.05159213081497853,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 100851987,
		"fossil_bank_weight_total": 0.08929570605004358,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 134831306,
		"fossil_insure_weight_total": 0.11938145221590406,
		"name": "Clipper Fund",
		"fund_family_name": "Clipper Fund",
		"label": "Clipper Fund"
	},
	{
		"fund_family_label": "New Age Alpha Advisors LLC",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 1165776469,
		"long_asset_sum": 1276109250,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 1128093636,
		"equity_fund_long_assets": 1207559111,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 73,
		"ff_all_asset_sum": 80056761,
		"ff_all_weight_total": 0.06629634961199013,
		"grade_fossil_fam": 4,
		"c2_count_sum": 20,
		"c2_asset_sum": 21423619,
		"c2_weight_total": 0.017741259044668,
		"mc50_count_sum": 15,
		"mc50_asset_sum": 19234601,
		"mc50_weight_total": 0.015928496439459185,
		"co_count_sum": 13,
		"co_asset_sum": 11932478,
		"co_weight_total": 0.009881485627745804,
		"og_count_sum": 48,
		"og_asset_sum": 44200219,
		"og_weight_total": 0.0366029444002928,
		"ut_count_sum": 33,
		"ut_asset_sum": 39198968,
		"ut_weight_total": 0.03246132437155699,
		"cl_count_sum": 68,
		"cl_asset_sum": 128593511,
		"cl_weight_total": 0.10649044823446328,
		"fossil_bank_count_sum": 30,
		"fossil_bank_asset_sum": 16793506,
		"fossil_bank_weight_total": 0.013906984632903822,
		"fossil_insure_count_sum": 24,
		"fossil_insure_asset_sum": 22790687,
		"fossil_insure_weight_total": 0.018873351037140242,
		"name": "New Age Alpha Advisors LLC",
		"fund_family_name": "New Age Alpha Advisors LLC",
		"label": "New Age Alpha Advisors LLC"
	},
	{
		"fund_family_label": "Wilmington Funds",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 2791989922,
		"long_asset_sum": 2849118470,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 1125631970,
		"equity_fund_long_assets": 1126153395,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 122,
		"ff_all_asset_sum": 99883132,
		"ff_all_weight_total": 0.08869407351029653,
		"grade_fossil_fam": 4,
		"c2_count_sum": 37,
		"c2_asset_sum": 33611053,
		"c2_weight_total": 0.02984589235287969,
		"mc50_count_sum": 9,
		"mc50_asset_sum": 15512281,
		"mc50_weight_total": 0.0137745719800454,
		"co_count_sum": 19,
		"co_asset_sum": 12501480,
		"co_weight_total": 0.011101045430849143,
		"og_count_sum": 99,
		"og_asset_sum": 75711237,
		"og_weight_total": 0.06722995049888386,
		"ut_count_sum": 49,
		"ut_asset_sum": 41418407,
		"ut_weight_total": 0.03677865482970018,
		"cl_count_sum": 66,
		"cl_asset_sum": 188932285,
		"cl_weight_total": 0.1677678066228269,
		"fossil_bank_count_sum": 28,
		"fossil_bank_asset_sum": 50086719,
		"fossil_bank_weight_total": 0.044475929498041425,
		"fossil_insure_count_sum": 12,
		"fossil_insure_asset_sum": 20552701,
		"fossil_insure_weight_total": 0.018250356559995986,
		"name": "Wilmington Funds",
		"fund_family_name": "Wilmington Funds",
		"label": "Wilmington Funds"
	},
	{
		"fund_family_label": "Fundstrat",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 1123652545,
		"long_asset_sum": 1134844844,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 1123652545,
		"equity_fund_long_assets": 1134844844,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 31779053,
		"ff_all_weight_total": 0.028002993685011624,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 31779053,
		"og_weight_total": 0.028002993685011624,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 6,
		"cl_asset_sum": 179225839,
		"cl_weight_total": 0.15792981740859016,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 29247920,
		"fossil_bank_weight_total": 0.025772615661634888,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Fundstrat",
		"fund_family_name": "Fundstrat",
		"label": "Fundstrat"
	},
	{
		"fund_family_label": "ARGA",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 1114564640,
		"long_asset_sum": 1115685471,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 1114564640,
		"equity_fund_long_assets": 1115685471,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 21,
		"ff_all_asset_sum": 67567299,
		"ff_all_weight_total": 0.06056124307098734,
		"grade_fossil_fam": 4,
		"c2_count_sum": 10,
		"c2_asset_sum": 26118768,
		"c2_weight_total": 0.02341051190403106,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 5,
		"co_asset_sum": 27797861,
		"co_weight_total": 0.02491549968387103,
		"og_count_sum": 16,
		"og_asset_sum": 53958709,
		"og_weight_total": 0.048363728311023244,
		"ut_count_sum": 5,
		"ut_asset_sum": 13340145,
		"ut_weight_total": 0.011956904832724132,
		"cl_count_sum": 9,
		"cl_asset_sum": 60279669,
		"cl_weight_total": 0.05402926771643869,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 43159533,
		"fossil_bank_weight_total": 0.03868431930131319,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 33714821,
		"fossil_insure_weight_total": 0.03021892986540469,
		"name": "ARGA",
		"fund_family_name": "ARGA",
		"label": "ARGA"
	},
	{
		"fund_family_label": "Marshfield",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 1106790902,
		"long_asset_sum": 1106790902,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 1106790902,
		"equity_fund_long_assets": 1106790902,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Marshfield",
		"fund_family_name": "Marshfield",
		"label": "Marshfield"
	},
	{
		"fund_family_label": "Rrecurrent Advisors",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 1105619217,
		"long_asset_sum": 1105732963,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 1105619217,
		"equity_fund_long_assets": 1105732963,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 25,
		"ff_all_asset_sum": 1082348445,
		"ff_all_weight_total": 0.978851568342003,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 151562933,
		"c2_weight_total": 0.13707010469217604,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 36744036,
		"co_weight_total": 0.03323047899404985,
		"og_count_sum": 24,
		"og_asset_sum": 1045604409,
		"og_weight_total": 0.9456210893479532,
		"ut_count_sum": 1,
		"ut_asset_sum": 23617104,
		"ut_weight_total": 0.02135877720053101,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Rrecurrent Advisors",
		"fund_family_name": "Rrecurrent Advisors",
		"label": "Rrecurrent Advisors"
	},
	{
		"fund_family_label": "Life + Liberty Investments, LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 1090792603,
		"long_asset_sum": 1096670334,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 1090792603,
		"equity_fund_long_assets": 1096670334,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 17,
		"ff_all_asset_sum": 100025349,
		"ff_all_weight_total": 0.09120821991707127,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 17262559,
		"c2_weight_total": 0.01574088261969891,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 8,
		"co_asset_sum": 69806124,
		"co_weight_total": 0.06365278774833714,
		"og_count_sum": 9,
		"og_asset_sum": 57746273,
		"og_weight_total": 0.0526559999023371,
		"ut_count_sum": 10,
		"ut_asset_sum": 31355493,
		"ut_weight_total": 0.02859153934221403,
		"cl_count_sum": 3,
		"cl_asset_sum": 81779105,
		"cl_weight_total": 0.07457036309327211,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Life + Liberty Investments, LLC",
		"fund_family_name": "Life + Liberty Investments, LLC",
		"label": "Life + Liberty Investments, LLC"
	},
	{
		"fund_family_label": "Lyrical",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 1077641575,
		"long_asset_sum": 1077641575,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 1077641575,
		"equity_fund_long_assets": 1077641575,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 99625052,
		"ff_all_weight_total": 0.09244729816590457,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 47441409,
		"c2_weight_total": 0.04402336556104009,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 52137293,
		"mc50_weight_total": 0.048380922014817404,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 99625052,
		"og_weight_total": 0.09244729816590457,
		"ut_count_sum": 1,
		"ut_asset_sum": 52137293,
		"ut_weight_total": 0.048380922014817404,
		"cl_count_sum": 2,
		"cl_asset_sum": 51229544,
		"cl_weight_total": 0.04753857422399465,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Lyrical",
		"fund_family_name": "Lyrical",
		"label": "Lyrical"
	},
	{
		"fund_family_label": "Select Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 1062668861,
		"long_asset_sum": 1062668861,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 1062668861,
		"equity_fund_long_assets": 1062668861,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Select Funds",
		"fund_family_name": "Select Funds",
		"label": "Select Funds"
	},
	{
		"fund_family_label": "LKCM",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 1287813680,
		"long_asset_sum": 1287813680,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 1011299241,
		"equity_fund_long_assets": 1011299241,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 27,
		"ff_all_asset_sum": 63852894,
		"ff_all_weight_total": 0.06313946595753452,
		"grade_fossil_fam": 4,
		"c2_count_sum": 19,
		"c2_asset_sum": 47596338,
		"c2_weight_total": 0.04706454437060138,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 26,
		"og_asset_sum": 63348819,
		"og_weight_total": 0.06264102298480811,
		"ut_count_sum": 1,
		"ut_asset_sum": 504075,
		"ut_weight_total": 0.0004984429727264079,
		"cl_count_sum": 27,
		"cl_asset_sum": 159350636,
		"cl_weight_total": 0.15757021219795417,
		"fossil_bank_count_sum": 6,
		"fossil_bank_asset_sum": 14727153,
		"fossil_bank_weight_total": 0.014562606598455857,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 2769041,
		"fossil_insure_weight_total": 0.002738102519746675,
		"name": "LKCM",
		"fund_family_name": "LKCM",
		"label": "LKCM"
	},
	{
		"fund_family_label": "Vident Financial",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 1448153041,
		"long_asset_sum": 1482281351,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 999965701,
		"equity_fund_long_assets": 1001468784,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 38,
		"ff_all_asset_sum": 60176750,
		"ff_all_weight_total": 0.06008849298292257,
		"grade_fossil_fam": 4,
		"c2_count_sum": 20,
		"c2_asset_sum": 28989459,
		"c2_weight_total": 0.028946942194455857,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 1969343,
		"mc50_weight_total": 0.001966454702795809,
		"co_count_sum": 12,
		"co_asset_sum": 15651023,
		"co_weight_total": 0.01562806874267985,
		"og_count_sum": 22,
		"og_asset_sum": 34765909,
		"og_weight_total": 0.03471492028053068,
		"ut_count_sum": 16,
		"ut_asset_sum": 28572385,
		"ut_weight_total": 0.02853047988762873,
		"cl_count_sum": 31,
		"cl_asset_sum": 113495882,
		"cl_weight_total": 0.11332942555301853,
		"fossil_bank_count_sum": 9,
		"fossil_bank_asset_sum": 17754219,
		"fossil_bank_weight_total": 0.017728180132672012,
		"fossil_insure_count_sum": 8,
		"fossil_insure_asset_sum": 12442722,
		"fossil_insure_weight_total": 0.012424473132654327,
		"name": "Vident Financial",
		"fund_family_name": "Vident Financial",
		"label": "Vident Financial"
	},
	{
		"fund_family_label": "Acadian Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 987575349,
		"long_asset_sum": 992459510,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 987575349,
		"equity_fund_long_assets": 992459510,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 37,
		"ff_all_asset_sum": 61448924,
		"ff_all_weight_total": 0.061915799466720815,
		"grade_fossil_fam": 4,
		"c2_count_sum": 9,
		"c2_asset_sum": 22683659,
		"c2_weight_total": 0.02285600447316989,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 51778,
		"mc50_weight_total": 0.00005217139790418251,
		"co_count_sum": 19,
		"co_asset_sum": 21988962,
		"co_weight_total": 0.022156029317508378,
		"og_count_sum": 18,
		"og_asset_sum": 34625440,
		"og_weight_total": 0.034888516509857415,
		"ut_count_sum": 16,
		"ut_asset_sum": 30377654,
		"ut_weight_total": 0.030608456762130275,
		"cl_count_sum": 7,
		"cl_asset_sum": 116314900,
		"cl_weight_total": 0.11719863513625861,
		"fossil_bank_count_sum": 7,
		"fossil_bank_asset_sum": 71083750,
		"fossil_bank_weight_total": 0.07162382876456089,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Acadian Funds",
		"fund_family_name": "Acadian Funds",
		"label": "Acadian Funds"
	},
	{
		"fund_family_label": "Howard Capital Management",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 4873443882,
		"long_asset_sum": 4873443882,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 984583994,
		"equity_fund_long_assets": 984583994,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 60,
		"ff_all_asset_sum": 33846558,
		"ff_all_weight_total": 0.03437650642937427,
		"grade_fossil_fam": 3,
		"c2_count_sum": 12,
		"c2_asset_sum": 8032123,
		"c2_weight_total": 0.00815788500417162,
		"mc50_count_sum": 5,
		"mc50_asset_sum": 8164458,
		"mc50_weight_total": 0.008292292023589406,
		"co_count_sum": 9,
		"co_asset_sum": 4054545,
		"co_weight_total": 0.00411802855287936,
		"og_count_sum": 43,
		"og_asset_sum": 21154950,
		"og_weight_total": 0.021486181096703874,
		"ut_count_sum": 29,
		"ut_asset_sum": 17706802,
		"ut_weight_total": 0.017984044132246985,
		"cl_count_sum": 47,
		"cl_asset_sum": 283467989,
		"cl_weight_total": 0.2879063550976231,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 8307472,
		"fossil_bank_weight_total": 0.008437545248171077,
		"fossil_insure_count_sum": 5,
		"fossil_insure_asset_sum": 7625049,
		"fossil_insure_weight_total": 0.007744437291756339,
		"name": "Howard Capital Management",
		"fund_family_name": "Howard Capital Management",
		"label": "Howard Capital Management"
	},
	{
		"fund_family_label": "Alpha Architect",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 7892047148,
		"long_asset_sum": 14889471873,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 980220912,
		"equity_fund_long_assets": 981564547,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 25,
		"ff_all_asset_sum": 125689838,
		"ff_all_weight_total": 0.12805050710536717,
		"grade_fossil_fam": 5,
		"c2_count_sum": 8,
		"c2_asset_sum": 33354045,
		"c2_weight_total": 0.033980490739953344,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 5615655,
		"co_weight_total": 0.0057211265598002495,
		"og_count_sum": 22,
		"og_asset_sum": 117055397,
		"og_weight_total": 0.11925389660594578,
		"ut_count_sum": 6,
		"ut_asset_sum": 24316304,
		"ut_weight_total": 0.024773005580039555,
		"cl_count_sum": 15,
		"cl_asset_sum": 67167061,
		"cl_weight_total": 0.0684285727365416,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 1950760,
		"fossil_bank_weight_total": 0.0019873985933601575,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 3530233,
		"fossil_insure_weight_total": 0.003596536784860059,
		"name": "Alpha Architect",
		"fund_family_name": "Alpha Architect",
		"label": "Alpha Architect"
	},
	{
		"fund_family_label": "Paydenfunds",
		"as_of": "202506",
		"fund_id": 19,
		"net_asset_sum": 8654352133,
		"long_asset_sum": 10840270080,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 976438620,
		"equity_fund_long_assets": 996909001,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 181676157,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 143250296,
		"ff_all_weight_total": 0.1436944554180026,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 16629888,
		"c2_weight_total": 0.016681450346339083,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 27821886,
		"mc50_weight_total": 0.027908150063939485,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 8,
		"og_asset_sum": 143250296,
		"og_weight_total": 0.1436944554180026,
		"ut_count_sum": 3,
		"ut_asset_sum": 53626430,
		"ut_weight_total": 0.05379270319177307,
		"cl_count_sum": 8,
		"cl_asset_sum": 91666043,
		"cl_weight_total": 0.09195026116531171,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 52283049,
		"fossil_bank_weight_total": 0.052445156927618114,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 10398300,
		"fossil_insure_weight_total": 0.01043054079115492,
		"name": "Paydenfunds",
		"fund_family_name": "Paydenfunds",
		"label": "Paydenfunds"
	},
	{
		"fund_family_label": "MainGate Trust",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 970416152,
		"long_asset_sum": 970416152,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 970416152,
		"equity_fund_long_assets": 970416152,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 16,
		"ff_all_asset_sum": 956417260,
		"ff_all_weight_total": 0.9855743415119909,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 16,
		"og_asset_sum": 956417260,
		"og_weight_total": 0.9855743415119909,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "MainGate Trust",
		"fund_family_name": "MainGate Trust",
		"label": "MainGate Trust"
	},
	{
		"fund_family_label": "1919 Funds",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 968588322,
		"long_asset_sum": 968807326,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 968588322,
		"equity_fund_long_assets": 968807326,
		"num_e_sri": 1,
		"num_e_usf": 1,
		"sri_long_assets": 852234059,
		"usf_long_assets": 852234059,
		"equity_fund_sri_long_assets": 852234059,
		"equity_fund_usf_long_assets": 852234059,
		"sustainable_manager": 1,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 5599125,
		"ff_all_weight_total": 0.005779399938187503,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 5599125,
		"mc50_weight_total": 0.005779399938187503,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 5599125,
		"ut_weight_total": 0.005779399938187503,
		"cl_count_sum": 9,
		"cl_asset_sum": 143966450,
		"cl_weight_total": 0.14860173549100517,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 23455189,
		"fossil_bank_weight_total": 0.024210375345572067,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 20857202,
		"fossil_insure_weight_total": 0.021528740999631955,
		"name": "1919 Funds",
		"fund_family_name": "1919 Funds",
		"label": "1919 Funds"
	},
	{
		"fund_family_label": "GuideMark",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 1148268316,
		"long_asset_sum": 1157733679,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 966830061,
		"equity_fund_long_assets": 969337487,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 230,
		"ff_all_asset_sum": 64092397,
		"ff_all_weight_total": 0.06611979610771,
		"grade_fossil_fam": 4,
		"c2_count_sum": 66,
		"c2_asset_sum": 17287306,
		"c2_weight_total": 0.01783414572514103,
		"mc50_count_sum": 13,
		"mc50_asset_sum": 16053865,
		"mc50_weight_total": 0.01656168797276691,
		"co_count_sum": 52,
		"co_asset_sum": 7566192,
		"co_weight_total": 0.007805529138686864,
		"og_count_sum": 167,
		"og_asset_sum": 40957049,
		"og_weight_total": 0.042252620526167683,
		"ut_count_sum": 89,
		"ut_asset_sum": 30728031,
		"ut_weight_total": 0.03170003369528202,
		"cl_count_sum": 106,
		"cl_asset_sum": 162113704,
		"cl_weight_total": 0.1672417565338624,
		"fossil_bank_count_sum": 58,
		"fossil_bank_asset_sum": 22661552,
		"fossil_bank_weight_total": 0.023378392256483527,
		"fossil_insure_count_sum": 25,
		"fossil_insure_asset_sum": 20938861,
		"fossil_insure_weight_total": 0.021601208331273377,
		"name": "GuideMark",
		"fund_family_name": "GuideMark",
		"label": "GuideMark"
	},
	{
		"fund_family_label": "Sound Shore",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 932622574,
		"long_asset_sum": 932622574,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 932622574,
		"equity_fund_long_assets": 932622574,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 207541427,
		"ff_all_weight_total": 0.2225352814588852,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 64246473,
		"c2_weight_total": 0.06888796689152411,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 23681170,
		"mc50_weight_total": 0.025392018872577707,
		"co_count_sum": 2,
		"co_asset_sum": 51371271,
		"co_weight_total": 0.05508259443010222,
		"og_count_sum": 5,
		"og_asset_sum": 136282237,
		"og_weight_total": 0.14612796301454312,
		"ut_count_sum": 3,
		"ut_asset_sum": 67003935,
		"ut_weight_total": 0.07184464205345302,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 57483113,
		"fossil_bank_weight_total": 0.061635987164085096,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 23681170,
		"fossil_insure_weight_total": 0.025392018872577707,
		"name": "Sound Shore",
		"fund_family_name": "Sound Shore",
		"label": "Sound Shore"
	},
	{
		"fund_family_label": "Sit",
		"as_of": "202506",
		"fund_id": 14,
		"net_asset_sum": 1823435351,
		"long_asset_sum": 1828303248,
		"num_equity_funds": 10,
		"equity_fund_net_assets": 932287880,
		"equity_fund_long_assets": 933262063,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 11356997,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 11356997,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 60,
		"ff_all_asset_sum": 75727500,
		"ff_all_weight_total": 0.08114280329425541,
		"grade_fossil_fam": 4,
		"c2_count_sum": 15,
		"c2_asset_sum": 22540058,
		"c2_weight_total": 0.024151906408307524,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 3538780,
		"mc50_weight_total": 0.0037918395489306414,
		"co_count_sum": 4,
		"co_asset_sum": 2574350,
		"co_weight_total": 0.0027584427805033367,
		"og_count_sum": 51,
		"og_asset_sum": 66989103,
		"og_weight_total": 0.0717795200896321,
		"ut_count_sum": 15,
		"ut_asset_sum": 18003864,
		"ut_weight_total": 0.019291327392143228,
		"cl_count_sum": 62,
		"cl_asset_sum": 179776665,
		"cl_weight_total": 0.19263256498619724,
		"fossil_bank_count_sum": 11,
		"fossil_bank_asset_sum": 16047390,
		"fossil_bank_weight_total": 0.017194945167293273,
		"fossil_insure_count_sum": 19,
		"fossil_insure_asset_sum": 17514865,
		"fossil_insure_weight_total": 0.018767359881422717,
		"name": "Sit",
		"fund_family_name": "Sit",
		"label": "Sit"
	},
	{
		"fund_family_label": "Needham",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 932266087,
		"long_asset_sum": 932266087,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 932266087,
		"equity_fund_long_assets": 932266087,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 9945208,
		"ff_all_weight_total": 0.010667778372163397,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 1930628,
		"c2_weight_total": 0.0020708980267776277,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 2183518,
		"og_weight_total": 0.00234216178240108,
		"ut_count_sum": 3,
		"ut_asset_sum": 7761690,
		"ut_weight_total": 0.008325616589762318,
		"cl_count_sum": 9,
		"cl_asset_sum": 23566882,
		"cl_weight_total": 0.025279136856557135,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Needham",
		"fund_family_name": "Needham",
		"label": "Needham"
	},
	{
		"fund_family_label": "Meeder Funds",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 2405907447,
		"long_asset_sum": 2857800035,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 908984731,
		"equity_fund_long_assets": 1034156936,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 18,
		"ff_all_asset_sum": 85730496,
		"ff_all_weight_total": 0.08289892279946957,
		"grade_fossil_fam": 4,
		"c2_count_sum": 8,
		"c2_asset_sum": 18049631,
		"c2_weight_total": 0.017453473812024986,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 59324062,
		"mc50_weight_total": 0.05736466094735935,
		"co_count_sum": 3,
		"co_asset_sum": 7283576,
		"co_weight_total": 0.007043008412409855,
		"og_count_sum": 14,
		"og_asset_sum": 23611753,
		"og_weight_total": 0.022831885740018862,
		"ut_count_sum": 4,
		"ut_asset_sum": 62118743,
		"ut_weight_total": 0.06006703705945071,
		"cl_count_sum": 14,
		"cl_asset_sum": 151623349,
		"cl_weight_total": 0.14661541563165612,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 60612718,
		"fossil_insure_weight_total": 0.058610754219222294,
		"name": "Meeder Funds",
		"fund_family_name": "Meeder Funds",
		"label": "Meeder Funds"
	},
	{
		"fund_family_label": "Wilshire Mutual Funds",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 1072102187,
		"long_asset_sum": 1301385037,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 893404950,
		"equity_fund_long_assets": 995910693,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 335,
		"ff_all_asset_sum": 53399654,
		"ff_all_weight_total": 0.053618918217599655,
		"grade_fossil_fam": 3,
		"c2_count_sum": 80,
		"c2_asset_sum": 15901806,
		"c2_weight_total": 0.015967100375334557,
		"mc50_count_sum": 18,
		"mc50_asset_sum": 8942543,
		"mc50_weight_total": 0.008979261958782885,
		"co_count_sum": 53,
		"co_asset_sum": 5330654,
		"co_weight_total": 0.005352542188238158,
		"og_count_sum": 252,
		"og_asset_sum": 39298753,
		"og_weight_total": 0.03946011753485611,
		"ut_count_sum": 118,
		"ut_asset_sum": 22495175,
		"ut_weight_total": 0.022587542395229608,
		"cl_count_sum": 121,
		"cl_asset_sum": 144127242,
		"cl_weight_total": 0.14471904259391258,
		"fossil_bank_count_sum": 38,
		"fossil_bank_asset_sum": 24042886,
		"fossil_bank_weight_total": 0.02414160844841938,
		"fossil_insure_count_sum": 22,
		"fossil_insure_asset_sum": 9234640,
		"fossil_insure_weight_total": 0.00927255833771834,
		"name": "Wilshire Mutual Funds",
		"fund_family_name": "Wilshire Mutual Funds",
		"label": "Wilshire Mutual Funds"
	},
	{
		"fund_family_label": "First American",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 3508886910,
		"long_asset_sum": 3508886910,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 891793418,
		"equity_fund_long_assets": 891793418,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 28,
		"ff_all_asset_sum": 36751311,
		"ff_all_weight_total": 0.041210565427160395,
		"grade_fossil_fam": 3,
		"c2_count_sum": 7,
		"c2_asset_sum": 6688566,
		"c2_weight_total": 0.007500129362919339,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 2090542,
		"co_weight_total": 0.002344199853693022,
		"og_count_sum": 23,
		"og_asset_sum": 30820139,
		"og_weight_total": 0.03455972916812894,
		"ut_count_sum": 6,
		"ut_asset_sum": 7204725,
		"ut_weight_total": 0.008078916994204592,
		"cl_count_sum": 26,
		"cl_asset_sum": 65771625,
		"cl_weight_total": 0.0737520861585906,
		"fossil_bank_count_sum": 16,
		"fossil_bank_asset_sum": 25826393,
		"fossil_bank_weight_total": 0.028960062362783666,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 7226261,
		"fossil_insure_weight_total": 0.008103066084751032,
		"name": "First American",
		"fund_family_name": "First American",
		"label": "First American"
	},
	{
		"fund_family_label": "Emerald",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 878561770,
		"long_asset_sum": 878862844,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 878561770,
		"equity_fund_long_assets": 878862844,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 11,
		"ff_all_asset_sum": 15212062,
		"ff_all_weight_total": 0.017308800916835666,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 51806,
		"c2_weight_total": 0.00005894662671619327,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 11,
		"og_asset_sum": 15212062,
		"og_weight_total": 0.017308800916835666,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 5,
		"cl_asset_sum": 4827931,
		"cl_weight_total": 0.005493383902801562,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Emerald",
		"fund_family_name": "Emerald",
		"label": "Emerald"
	},
	{
		"fund_family_label": "Johnson Mutual Funds",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 3922264138,
		"long_asset_sum": 3922264138,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 853779192,
		"equity_fund_long_assets": 853779192,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 21,
		"ff_all_asset_sum": 104265620,
		"ff_all_weight_total": 0.12212246559412518,
		"grade_fossil_fam": 5,
		"c2_count_sum": 5,
		"c2_asset_sum": 23250458,
		"c2_weight_total": 0.027232401794116342,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 22793722,
		"mc50_weight_total": 0.026697443804650604,
		"co_count_sum": 5,
		"co_asset_sum": 46398628,
		"co_weight_total": 0.05434499743582413,
		"og_count_sum": 16,
		"og_asset_sum": 74542925,
		"og_weight_total": 0.08730937190607943,
		"ut_count_sum": 10,
		"ut_asset_sum": 53167958,
		"ut_weight_total": 0.06227366337595166,
		"cl_count_sum": 22,
		"cl_asset_sum": 76570668,
		"cl_weight_total": 0.08968439230831009,
		"fossil_bank_count_sum": 12,
		"fossil_bank_asset_sum": 3047011,
		"fossil_bank_weight_total": 0.003568851324266052,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 36871532,
		"fossil_insure_weight_total": 0.04318626214540024,
		"name": "Johnson Mutual Funds",
		"fund_family_name": "Johnson Mutual Funds",
		"label": "Johnson Mutual Funds"
	},
	{
		"fund_family_label": "Dunham Funds",
		"as_of": "202506",
		"fund_id": 15,
		"net_asset_sum": 2149617010,
		"long_asset_sum": 2324644215,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 848736633,
		"equity_fund_long_assets": 849664928,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 79,
		"ff_all_asset_sum": 59198181,
		"ff_all_weight_total": 0.06967238384117462,
		"grade_fossil_fam": 4,
		"c2_count_sum": 26,
		"c2_asset_sum": 19741300,
		"c2_weight_total": 0.023234217806857624,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 6724022,
		"mc50_weight_total": 0.007913733730104016,
		"co_count_sum": 11,
		"co_asset_sum": 5578535,
		"co_weight_total": 0.006565570516287098,
		"og_count_sum": 66,
		"og_asset_sum": 47822210,
		"og_weight_total": 0.056283610661166425,
		"ut_count_sum": 18,
		"ut_asset_sum": 15538033,
		"ut_weight_total": 0.01828724769960141,
		"cl_count_sum": 55,
		"cl_asset_sum": 83150561,
		"cl_weight_total": 0.09786276714483853,
		"fossil_bank_count_sum": 31,
		"fossil_bank_asset_sum": 35491761,
		"fossil_bank_weight_total": 0.04177147935662469,
		"fossil_insure_count_sum": 14,
		"fossil_insure_asset_sum": 19094873,
		"fossil_insure_weight_total": 0.022473415543874255,
		"name": "Dunham Funds",
		"fund_family_name": "Dunham Funds",
		"label": "Dunham Funds"
	},
	{
		"fund_family_label": "North Square",
		"as_of": "202506",
		"fund_id": 14,
		"net_asset_sum": 2301541790,
		"long_asset_sum": 2303957223,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 808447315,
		"equity_fund_long_assets": 808466492,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 34,
		"ff_all_asset_sum": 63553976,
		"ff_all_weight_total": 0.07861052576561206,
		"grade_fossil_fam": 4,
		"c2_count_sum": 6,
		"c2_asset_sum": 13267847,
		"c2_weight_total": 0.016411127896194862,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 3450356,
		"co_weight_total": 0.0042677786081949335,
		"og_count_sum": 26,
		"og_asset_sum": 40424828,
		"og_weight_total": 0.05000185956995729,
		"ut_count_sum": 7,
		"ut_asset_sum": 22789208,
		"ut_weight_total": 0.028188191131612167,
		"cl_count_sum": 6,
		"cl_asset_sum": 9788750,
		"cl_weight_total": 0.012107799267950366,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 1963480,
		"fossil_bank_weight_total": 0.002428647345844483,
		"fossil_insure_count_sum": 6,
		"fossil_insure_asset_sum": 14242771,
		"fossil_insure_weight_total": 0.017617020792990393,
		"name": "North Square",
		"fund_family_name": "North Square",
		"label": "North Square"
	},
	{
		"fund_family_label": "Trillium Mutual Funds",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 804768020,
		"long_asset_sum": 804856716,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 804768020,
		"equity_fund_long_assets": 804856716,
		"num_e_sri": 2,
		"num_e_usf": 2,
		"sri_long_assets": 804856716,
		"usf_long_assets": 804856716,
		"equity_fund_sri_long_assets": 804856716,
		"equity_fund_usf_long_assets": 804856716,
		"sustainable_manager": 1,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 9951895,
		"ff_all_weight_total": 0.012364803327304285,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 9951895,
		"og_weight_total": 0.012364803327304285,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 20,
		"cl_asset_sum": 216983468,
		"cl_weight_total": 0.26959266623054434,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 8638855,
		"fossil_bank_weight_total": 0.01073340736091963,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 24003067,
		"fossil_insure_weight_total": 0.029822782767212445,
		"name": "Trillium Mutual Funds",
		"fund_family_name": "Trillium Mutual Funds",
		"label": "Trillium Mutual Funds"
	},
	{
		"fund_family_label": "FCF Funds",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 798737341,
		"long_asset_sum": 798738691,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 796303018,
		"equity_fund_long_assets": 796303944,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 15,
		"ff_all_asset_sum": 18789907,
		"ff_all_weight_total": 0.023596400773320796,
		"grade_fossil_fam": 3,
		"c2_count_sum": 6,
		"c2_asset_sum": 5972649,
		"c2_weight_total": 0.007500463918335183,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 9217,
		"co_weight_total": 0.000011574726044556675,
		"og_count_sum": 14,
		"og_asset_sum": 18780690,
		"og_weight_total": 0.023584826047276238,
		"ut_count_sum": 1,
		"ut_asset_sum": 9217,
		"ut_weight_total": 0.000011574726044556675,
		"cl_count_sum": 17,
		"cl_asset_sum": 94719209,
		"cl_weight_total": 0.11894856193252762,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "FCF Funds",
		"fund_family_name": "FCF Funds",
		"label": "FCF Funds"
	},
	{
		"fund_family_label": "APTUS ETFs",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 4722554300,
		"long_asset_sum": 4871572743,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 777461089,
		"equity_fund_long_assets": 783102721,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 49,
		"ff_all_asset_sum": 72634008,
		"ff_all_weight_total": 0.0927515714761512,
		"grade_fossil_fam": 5,
		"c2_count_sum": 12,
		"c2_asset_sum": 33482367,
		"c2_weight_total": 0.042756034556033676,
		"mc50_count_sum": 4,
		"mc50_asset_sum": 4367710,
		"mc50_weight_total": 0.005577441991802248,
		"co_count_sum": 6,
		"co_asset_sum": 9879797,
		"co_weight_total": 0.01261622100786954,
		"og_count_sum": 37,
		"og_asset_sum": 59728994,
		"og_weight_total": 0.07627223402279559,
		"ut_count_sum": 22,
		"ut_asset_sum": 15406300,
		"ut_weight_total": 0.019673408847726375,
		"cl_count_sum": 30,
		"cl_asset_sum": 51583307,
		"cl_weight_total": 0.06587042238102503,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 5047289,
		"fossil_bank_weight_total": 0.006445245131513213,
		"fossil_insure_count_sum": 5,
		"fossil_insure_asset_sum": 4831354,
		"fossil_insure_weight_total": 0.006169502251033553,
		"name": "APTUS ETFs",
		"fund_family_name": "APTUS ETFs",
		"label": "APTUS ETFs"
	},
	{
		"fund_family_label": "Symmetry Partners",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 1595870901,
		"long_asset_sum": 1597686983,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 764630796,
		"equity_fund_long_assets": 764630884,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 145,
		"ff_all_asset_sum": 38165281,
		"ff_all_weight_total": 0.04991333962388053,
		"grade_fossil_fam": 3,
		"c2_count_sum": 37,
		"c2_asset_sum": 14710974,
		"c2_weight_total": 0.0192393144297844,
		"mc50_count_sum": 15,
		"mc50_asset_sum": 6504994,
		"mc50_weight_total": 0.008507364973241128,
		"co_count_sum": 27,
		"co_asset_sum": 4323273,
		"co_weight_total": 0.005654065367309961,
		"og_count_sum": 106,
		"og_asset_sum": 29117036,
		"og_weight_total": 0.03807985867335173,
		"ut_count_sum": 69,
		"ut_asset_sum": 13706574,
		"ut_weight_total": 0.017925739447374977,
		"cl_count_sum": 92,
		"cl_asset_sum": 73346302,
		"cl_weight_total": 0.09592380262788339,
		"fossil_bank_count_sum": 45,
		"fossil_bank_asset_sum": 14615149,
		"fossil_bank_weight_total": 0.019113992523482743,
		"fossil_insure_count_sum": 20,
		"fossil_insure_asset_sum": 9238631,
		"fossil_insure_weight_total": 0.012082471677929243,
		"name": "Symmetry Partners",
		"fund_family_name": "Symmetry Partners",
		"label": "Symmetry Partners"
	},
	{
		"fund_family_label": "DF Dent Funds",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 760636386,
		"long_asset_sum": 760636386,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 760636386,
		"equity_fund_long_assets": 760636386,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 8,
		"cl_asset_sum": 79762018,
		"cl_weight_total": 0.10486221730654889,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "DF Dent Funds",
		"fund_family_name": "DF Dent Funds",
		"label": "DF Dent Funds"
	},
	{
		"fund_family_label": "Spyglass Capital Management",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 759141248,
		"long_asset_sum": 759191856,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 759141248,
		"equity_fund_long_assets": 759191856,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Spyglass Capital Management",
		"fund_family_name": "Spyglass Capital Management",
		"label": "Spyglass Capital Management"
	},
	{
		"fund_family_label": "Calvert ETFs",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 914251931,
		"long_asset_sum": 914260144,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 739847954,
		"equity_fund_long_assets": 739852042,
		"num_e_sri": 5,
		"num_e_usf": 0,
		"sri_long_assets": 914260144,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 739852042,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 3,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 113,
		"ff_all_asset_sum": 30046119,
		"ff_all_weight_total": 0.04061098340524685,
		"grade_fossil_fam": 3,
		"c2_count_sum": 6,
		"c2_asset_sum": 2464295,
		"c2_weight_total": 0.003330794348202934,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 1004174,
		"mc50_weight_total": 0.0013572632675115332,
		"co_count_sum": 19,
		"co_asset_sum": 3383419,
		"co_weight_total": 0.004573102198723133,
		"og_count_sum": 70,
		"og_asset_sum": 22737501,
		"og_weight_total": 0.030732497457917403,
		"ut_count_sum": 83,
		"ut_asset_sum": 16968033,
		"ut_weight_total": 0.022934359894623363,
		"cl_count_sum": 174,
		"cl_asset_sum": 160125116,
		"cl_weight_total": 0.2164285653211727,
		"fossil_bank_count_sum": 44,
		"fossil_bank_asset_sum": 33158202,
		"fossil_bank_weight_total": 0.04481734200579526,
		"fossil_insure_count_sum": 27,
		"fossil_insure_asset_sum": 9175176,
		"fossil_insure_weight_total": 0.012401366055836338,
		"name": "Calvert ETFs",
		"fund_family_name": "Calvert ETFs",
		"label": "Calvert ETFs"
	},
	{
		"fund_family_label": "Wahed Invest",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 728270018,
		"long_asset_sum": 728270115,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 728270018,
		"equity_fund_long_assets": 728270115,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 24,
		"ff_all_asset_sum": 42301322,
		"ff_all_weight_total": 0.05808465997537191,
		"grade_fossil_fam": 4,
		"c2_count_sum": 13,
		"c2_asset_sum": 29949232,
		"c2_weight_total": 0.0411237964913609,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 2768244,
		"co_weight_total": 0.0038011226095691158,
		"og_count_sum": 22,
		"og_asset_sum": 39634844,
		"og_weight_total": 0.0544232739798749,
		"ut_count_sum": 1,
		"ut_asset_sum": 637127,
		"ut_weight_total": 0.0008748498488091881,
		"cl_count_sum": 40,
		"cl_asset_sum": 326187859,
		"cl_weight_total": 0.4478940605711934,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Wahed Invest",
		"fund_family_name": "Wahed Invest",
		"label": "Wahed Invest"
	},
	{
		"fund_family_label": "RMB Funds",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 725417286,
		"long_asset_sum": 726648000,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 725417286,
		"equity_fund_long_assets": 726648000,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 12,
		"ff_all_asset_sum": 37417692,
		"ff_all_weight_total": 0.051493559467582654,
		"grade_fossil_fam": 3,
		"c2_count_sum": 8,
		"c2_asset_sum": 21437871,
		"c2_weight_total": 0.029502415199656504,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 4662053,
		"co_weight_total": 0.006415834076471689,
		"og_count_sum": 10,
		"og_asset_sum": 33899222,
		"og_weight_total": 0.046651503891843096,
		"ut_count_sum": 4,
		"ut_asset_sum": 15979821,
		"ut_weight_total": 0.021991144267926147,
		"cl_count_sum": 13,
		"cl_asset_sum": 60168267,
		"cl_weight_total": 0.08280249446774779,
		"fossil_bank_count_sum": 7,
		"fossil_bank_asset_sum": 33159491,
		"fossil_bank_weight_total": 0.04563349930089947,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 9821367,
		"fossil_insure_weight_total": 0.01351598986028999,
		"name": "RMB Funds",
		"fund_family_name": "RMB Funds",
		"label": "RMB Funds"
	},
	{
		"fund_family_label": "Tributary Funds",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 1166085633,
		"long_asset_sum": 1166085633,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 718238472,
		"equity_fund_long_assets": 718238472,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 17,
		"ff_all_asset_sum": 47827126,
		"ff_all_weight_total": 0.06658947948975921,
		"grade_fossil_fam": 4,
		"c2_count_sum": 9,
		"c2_asset_sum": 22234398,
		"c2_weight_total": 0.030956846321649002,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 3,
		"co_asset_sum": 14037239,
		"co_weight_total": 0.01954398093005522,
		"og_count_sum": 14,
		"og_asset_sum": 37166578,
		"og_weight_total": 0.05174684933891985,
		"ut_count_sum": 6,
		"ut_asset_sum": 25189827,
		"ut_weight_total": 0.035071676026844745,
		"cl_count_sum": 6,
		"cl_asset_sum": 9373357,
		"cl_weight_total": 0.013050480258874241,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 1084048,
		"fossil_bank_weight_total": 0.0015093148616522453,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 534970,
		"fossil_insure_weight_total": 0.0007448361802596395,
		"name": "Tributary Funds",
		"fund_family_name": "Tributary Funds",
		"label": "Tributary Funds"
	},
	{
		"fund_family_label": "Roundhill Investments",
		"as_of": "202506",
		"fund_id": 23,
		"net_asset_sum": 4863849149,
		"long_asset_sum": 7531943161,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 715060464,
		"equity_fund_long_assets": 715095377,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 5,
		"num_five_badgers": 5,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 5,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 18,
		"cl_asset_sum": 135595917,
		"cl_weight_total": 0.18961934500102354,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Roundhill Investments",
		"fund_family_name": "Roundhill Investments",
		"label": "Roundhill Investments"
	},
	{
		"fund_family_label": "Commerce",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 2650168180,
		"long_asset_sum": 2650168180,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 700440893,
		"equity_fund_long_assets": 700440893,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 25,
		"ff_all_asset_sum": 53542829,
		"ff_all_weight_total": 0.07644160918514505,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 10031403,
		"c2_weight_total": 0.014321555323583885,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 11602908,
		"mc50_weight_total": 0.016565149345156807,
		"co_count_sum": 3,
		"co_asset_sum": 4074780,
		"co_weight_total": 0.0058174501813388554,
		"og_count_sum": 21,
		"og_asset_sum": 51737392,
		"og_weight_total": 0.0738640369473688,
		"ut_count_sum": 10,
		"ut_asset_sum": 17460078,
		"ut_weight_total": 0.024927268202771823,
		"cl_count_sum": 16,
		"cl_asset_sum": 99723815,
		"cl_weight_total": 0.1423729196804619,
		"fossil_bank_count_sum": 7,
		"fossil_bank_asset_sum": 21713295,
		"fossil_bank_weight_total": 0.03099946793083653,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 5058332,
		"fossil_insure_weight_total": 0.007221640042081324,
		"name": "Commerce",
		"fund_family_name": "Commerce",
		"label": "Commerce"
	},
	{
		"fund_family_label": "Cambiar Funds",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 695505028,
		"long_asset_sum": 695505028,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 695505028,
		"equity_fund_long_assets": 695505028,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 18,
		"ff_all_asset_sum": 59283287,
		"ff_all_weight_total": 0.08523775474416843,
		"grade_fossil_fam": 4,
		"c2_count_sum": 5,
		"c2_asset_sum": 18057867,
		"c2_weight_total": 0.025963675707603943,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 8017160,
		"mc50_weight_total": 0.011527105739341974,
		"co_count_sum": 4,
		"co_asset_sum": 13054673,
		"co_weight_total": 0.018770062723399896,
		"og_count_sum": 14,
		"og_asset_sum": 49890038,
		"og_weight_total": 0.07173210256073087,
		"ut_count_sum": 8,
		"ut_asset_sum": 31637237,
		"ut_weight_total": 0.04548814994332435,
		"cl_count_sum": 8,
		"cl_asset_sum": 24376486,
		"cl_weight_total": 0.035048612186309024,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 26633084,
		"fossil_bank_weight_total": 0.03829315810496197,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 16780431,
		"fossil_insure_weight_total": 0.02412697295410494,
		"name": "Cambiar Funds",
		"fund_family_name": "Cambiar Funds",
		"label": "Cambiar Funds"
	},
	{
		"fund_family_label": "IntegrityVikingFunds",
		"as_of": "202506",
		"fund_id": 11,
		"net_asset_sum": 936359356,
		"long_asset_sum": 936359356,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 693649179,
		"equity_fund_long_assets": 693649179,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 97602790,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 97602790,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 62,
		"ff_all_asset_sum": 242212710,
		"ff_all_weight_total": 0.34918618421661823,
		"grade_fossil_fam": 5,
		"c2_count_sum": 14,
		"c2_asset_sum": 66398160,
		"c2_weight_total": 0.09572297064594378,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 20590420,
		"mc50_weight_total": 0.029684198617064894,
		"co_count_sum": 5,
		"co_asset_sum": 23395680,
		"co_weight_total": 0.03372840436966768,
		"og_count_sum": 55,
		"og_asset_sum": 229861530,
		"og_weight_total": 0.3313800937981071,
		"ut_count_sum": 19,
		"ut_asset_sum": 93873855,
		"ut_weight_total": 0.1353333325288921,
		"cl_count_sum": 19,
		"cl_asset_sum": 89644100,
		"cl_weight_total": 0.12923550220189908,
		"fossil_bank_count_sum": 7,
		"fossil_bank_asset_sum": 30285305,
		"fossil_bank_weight_total": 0.043660838817196956,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "IntegrityVikingFunds",
		"fund_family_name": "IntegrityVikingFunds",
		"label": "IntegrityVikingFunds"
	},
	{
		"fund_family_label": "Osterweis",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 6635580797,
		"long_asset_sum": 6635580797,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 673623371,
		"equity_fund_long_assets": 673623371,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 13982168,
		"ff_all_weight_total": 0.020756655130957445,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 13982168,
		"og_weight_total": 0.020756655130957445,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 10,
		"cl_asset_sum": 49996039,
		"cl_weight_total": 0.07421957306169533,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Osterweis",
		"fund_family_name": "Osterweis",
		"label": "Osterweis"
	},
	{
		"fund_family_label": "Reinhartfunds",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 635764550,
		"long_asset_sum": 635837078,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 635764550,
		"equity_fund_long_assets": 635837078,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 6000663,
		"ff_all_weight_total": 0.00943742226998596,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 6000663,
		"og_weight_total": 0.00943742226998596,
		"ut_count_sum": 1,
		"ut_asset_sum": 2878675,
		"ut_weight_total": 0.004527378316871292,
		"cl_count_sum": 1,
		"cl_asset_sum": 33200,
		"cl_weight_total": 0.000052214633510252766,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Reinhartfunds",
		"fund_family_name": "Reinhartfunds",
		"label": "Reinhartfunds"
	},
	{
		"fund_family_label": "CRM",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 983908469,
		"long_asset_sum": 1111888837,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 635593775,
		"equity_fund_long_assets": 635593775,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 22,
		"ff_all_asset_sum": 64183426,
		"ff_all_weight_total": 0.10098183544985159,
		"grade_fossil_fam": 5,
		"c2_count_sum": 10,
		"c2_asset_sum": 26586067,
		"c2_weight_total": 0.041828708910813354,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 19,
		"og_asset_sum": 50708959,
		"og_weight_total": 0.07978202587021875,
		"ut_count_sum": 6,
		"ut_asset_sum": 30765306,
		"ut_weight_total": 0.04840403919940846,
		"cl_count_sum": 7,
		"cl_asset_sum": 24170614,
		"cl_weight_total": 0.0380283995072167,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 12798219,
		"fossil_bank_weight_total": 0.020135846988117528,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "CRM",
		"fund_family_name": "CRM",
		"label": "CRM"
	},
	{
		"fund_family_label": "Dearborn Partners",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 615462474,
		"long_asset_sum": 615626661,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 615462474,
		"equity_fund_long_assets": 615626661,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 53515642,
		"ff_all_weight_total": 0.08692872708448213,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 24574704,
		"c2_weight_total": 0.03991819321158347,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 37702108,
		"og_weight_total": 0.06124183760780952,
		"ut_count_sum": 2,
		"ut_asset_sum": 28940938,
		"ut_weight_total": 0.047010533872898656,
		"cl_count_sum": 7,
		"cl_asset_sum": 109604593,
		"cl_weight_total": 0.1780374372057938,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Dearborn Partners",
		"fund_family_name": "Dearborn Partners",
		"label": "Dearborn Partners"
	},
	{
		"fund_family_label": "Catalyst Mutual Funds",
		"as_of": "202506",
		"fund_id": 17,
		"net_asset_sum": 10047833324,
		"long_asset_sum": 28303836168,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 603969813,
		"equity_fund_long_assets": 604337244,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 28,
		"ff_all_asset_sum": 348350634,
		"ff_all_weight_total": 0.5764176169158954,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 3573287,
		"c2_weight_total": 0.0059127366970618146,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 2612221,
		"co_weight_total": 0.0043224557578317975,
		"og_count_sum": 26,
		"og_asset_sum": 345976017,
		"og_weight_total": 0.5724883257401888,
		"ut_count_sum": 2,
		"ut_asset_sum": 9793820,
		"ut_weight_total": 0.01620588520273293,
		"cl_count_sum": 18,
		"cl_asset_sum": 38159318,
		"cl_weight_total": 0.06314242317324398,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 3205255,
		"fossil_bank_weight_total": 0.005303752220837807,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Catalyst Mutual Funds",
		"fund_family_name": "Catalyst Mutual Funds",
		"label": "Catalyst Mutual Funds"
	},
	{
		"fund_family_label": "1290 Funds",
		"as_of": "202506",
		"fund_id": 16,
		"net_asset_sum": 1647703329,
		"long_asset_sum": 1769569024,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 592836392,
		"equity_fund_long_assets": 592836392,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 45,
		"ff_all_asset_sum": 30481580,
		"ff_all_weight_total": 0.05141651290530086,
		"grade_fossil_fam": 3,
		"c2_count_sum": 9,
		"c2_asset_sum": 6696977,
		"c2_weight_total": 0.011296501177006016,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 3189302,
		"mc50_weight_total": 0.005379733840631025,
		"co_count_sum": 5,
		"co_asset_sum": 5334875,
		"co_weight_total": 0.008998899311835768,
		"og_count_sum": 33,
		"og_asset_sum": 19731704,
		"og_weight_total": 0.033283557261781595,
		"ut_count_sum": 22,
		"ut_asset_sum": 15837034,
		"ut_weight_total": 0.02671400442636794,
		"cl_count_sum": 52,
		"cl_asset_sum": 96763533,
		"cl_weight_total": 0.1632213108131864,
		"fossil_bank_count_sum": 11,
		"fossil_bank_asset_sum": 7342762,
		"fossil_bank_weight_total": 0.012385815208186476,
		"fossil_insure_count_sum": 13,
		"fossil_insure_asset_sum": 9380786,
		"fossil_insure_weight_total": 0.01582356637782115,
		"name": "1290 Funds",
		"fund_family_name": "1290 Funds",
		"label": "1290 Funds"
	},
	{
		"fund_family_label": "Summit Global Investments",
		"as_of": "202506",
		"fund_id": 11,
		"net_asset_sum": 1419716472,
		"long_asset_sum": 1451929759,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 589520458,
		"equity_fund_long_assets": 589992152,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 80,
		"ff_all_asset_sum": 74358794,
		"ff_all_weight_total": 0.12603353069686254,
		"grade_fossil_fam": 5,
		"c2_count_sum": 22,
		"c2_asset_sum": 18588421,
		"c2_weight_total": 0.031506217391176414,
		"mc50_count_sum": 9,
		"mc50_asset_sum": 20257974,
		"mc50_weight_total": 0.034336005879617194,
		"co_count_sum": 7,
		"co_asset_sum": 6911638,
		"co_weight_total": 0.0117147965046152,
		"og_count_sum": 60,
		"og_asset_sum": 37366305,
		"og_weight_total": 0.06333356278271308,
		"ut_count_sum": 37,
		"ut_asset_sum": 48245373,
		"ut_weight_total": 0.08177290636232057,
		"cl_count_sum": 53,
		"cl_asset_sum": 56421680,
		"cl_weight_total": 0.09563123815924927,
		"fossil_bank_count_sum": 29,
		"fossil_bank_asset_sum": 22711484,
		"fossil_bank_weight_total": 0.03849455272076229,
		"fossil_insure_count_sum": 11,
		"fossil_insure_asset_sum": 14825870,
		"fossil_insure_weight_total": 0.02512892747766584,
		"name": "Summit Global Investments",
		"fund_family_name": "Summit Global Investments",
		"label": "Summit Global Investments"
	},
	{
		"fund_family_label": "Zacks Funds",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 572300648,
		"long_asset_sum": 572332769,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 572300648,
		"equity_fund_long_assets": 572332769,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 38,
		"ff_all_asset_sum": 36897767,
		"ff_all_weight_total": 0.06446907987545267,
		"grade_fossil_fam": 4,
		"c2_count_sum": 11,
		"c2_asset_sum": 9927262,
		"c2_weight_total": 0.01734526229792025,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 5750732,
		"mc50_weight_total": 0.010047881776973704,
		"co_count_sum": 7,
		"co_asset_sum": 9411623,
		"co_weight_total": 0.016444319650689092,
		"og_count_sum": 31,
		"og_asset_sum": 30702185,
		"og_weight_total": 0.053643940488754364,
		"ut_count_sum": 17,
		"ut_asset_sum": 19036141,
		"ut_weight_total": 0.03326061695412027,
		"cl_count_sum": 33,
		"cl_asset_sum": 81355566,
		"cl_weight_total": 0.14214731430134137,
		"fossil_bank_count_sum": 12,
		"fossil_bank_asset_sum": 14334380,
		"fossil_bank_weight_total": 0.02504553430523563,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 6169730,
		"fossil_insure_weight_total": 0.0107799698605061,
		"name": "Zacks Funds",
		"fund_family_name": "Zacks Funds",
		"label": "Zacks Funds"
	},
	{
		"fund_family_label": "YCG FUNDS",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 565517206,
		"long_asset_sum": 571002880,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 565517206,
		"equity_fund_long_assets": 571002880,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 6,
		"cl_asset_sum": 114412991,
		"cl_weight_total": 0.2003720033776362,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "YCG FUNDS",
		"fund_family_name": "YCG FUNDS",
		"label": "YCG FUNDS"
	},
	{
		"fund_family_label": "Euro Pacific Asset Management",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 616651639,
		"long_asset_sum": 616807183,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 565277293,
		"equity_fund_long_assets": 565277293,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 30,
		"ff_all_asset_sum": 62237630,
		"ff_all_weight_total": 0.11010106149797176,
		"grade_fossil_fam": 5,
		"c2_count_sum": 10,
		"c2_asset_sum": 19885779,
		"c2_weight_total": 0.03517880382999924,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 4,
		"co_asset_sum": 3424572,
		"co_weight_total": 0.006058216104569409,
		"og_count_sum": 21,
		"og_asset_sum": 50814552,
		"og_weight_total": 0.08989314205479682,
		"ut_count_sum": 13,
		"ut_asset_sum": 19332888,
		"ut_weight_total": 0.03420071571847129,
		"cl_count_sum": 14,
		"cl_asset_sum": 25167022,
		"cl_weight_total": 0.04452155130172547,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 7270032,
		"fossil_bank_weight_total": 0.012861001299763867,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Euro Pacific Asset Management",
		"fund_family_name": "Euro Pacific Asset Management",
		"label": "Euro Pacific Asset Management"
	},
	{
		"fund_family_label": "Olstein",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 559778205,
		"long_asset_sum": 559778205,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 559778205,
		"equity_fund_long_assets": 559778205,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 15193675,
		"ff_all_weight_total": 0.02714231255216519,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 4660075,
		"mc50_weight_total": 0.008324859664730962,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 10533600,
		"og_weight_total": 0.01881745288743423,
		"ut_count_sum": 1,
		"ut_asset_sum": 4660075,
		"ut_weight_total": 0.008324859664730962,
		"cl_count_sum": 6,
		"cl_asset_sum": 32488590,
		"cl_weight_total": 0.0580383260902414,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 17616832,
		"fossil_bank_weight_total": 0.03147109309123602,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 15840705,
		"fossil_insure_weight_total": 0.02829818106262283,
		"name": "Olstein",
		"fund_family_name": "Olstein",
		"label": "Olstein"
	},
	{
		"fund_family_label": "DGI",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 556879512,
		"long_asset_sum": 556879512,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 556879512,
		"equity_fund_long_assets": 556879512,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 33576770,
		"ff_all_weight_total": 0.06029449688211909,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 27205928,
		"c2_weight_total": 0.048854244793979776,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 33576770,
		"og_weight_total": 0.06029449688211909,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 11197078,
		"cl_weight_total": 0.020106823394860324,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "DGI",
		"fund_family_name": "DGI",
		"label": "DGI"
	},
	{
		"fund_family_label": "SSGA",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 548436015,
		"long_asset_sum": 548436015,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 548436015,
		"equity_fund_long_assets": 548436015,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 173,
		"ff_all_asset_sum": 27798292,
		"ff_all_weight_total": 0.05068648163086081,
		"grade_fossil_fam": 3,
		"c2_count_sum": 38,
		"c2_asset_sum": 8032647,
		"c2_weight_total": 0.014646461538453124,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 7099709,
		"mc50_weight_total": 0.012945373399666322,
		"co_count_sum": 25,
		"co_asset_sum": 2051024,
		"co_weight_total": 0.0037397689865425778,
		"og_count_sum": 130,
		"og_asset_sum": 18395799,
		"og_weight_total": 0.03354228842903397,
		"ut_count_sum": 57,
		"ut_asset_sum": 13461387,
		"ut_weight_total": 0.024545045605730325,
		"cl_count_sum": 45,
		"cl_asset_sum": 70737332,
		"cl_weight_total": 0.128980099893695,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 6852693,
		"fossil_bank_weight_total": 0.012494972635960095,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 7511805,
		"fossil_insure_weight_total": 0.013696775548192253,
		"name": "SSGA",
		"fund_family_name": "SSGA",
		"label": "SSGA"
	},
	{
		"fund_family_label": "Cantor",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 667525707,
		"long_asset_sum": 668167944,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 547688743,
		"equity_fund_long_assets": 547810886,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 19,
		"ff_all_asset_sum": 24743046,
		"ff_all_weight_total": 0.045167130906558876,
		"grade_fossil_fam": 3,
		"c2_count_sum": 6,
		"c2_asset_sum": 8973638,
		"c2_weight_total": 0.016380904851167926,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 323360,
		"co_weight_total": 0.0005902766963269146,
		"og_count_sum": 14,
		"og_asset_sum": 22569496,
		"og_weight_total": 0.04119942954182185,
		"ut_count_sum": 8,
		"ut_asset_sum": 6074350,
		"ut_weight_total": 0.01108840688499936,
		"cl_count_sum": 8,
		"cl_asset_sum": 69575952,
		"cl_weight_total": 0.12700724607360211,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 2642118,
		"fossil_bank_weight_total": 0.004823047638377891,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 770329,
		"fossil_insure_weight_total": 0.0014061951299010878,
		"name": "Cantor",
		"fund_family_name": "Cantor",
		"label": "Cantor"
	},
	{
		"fund_family_label": "WesMark",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 837848588,
		"long_asset_sum": 840036084,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 533099110,
		"equity_fund_long_assets": 533099110,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 20,
		"ff_all_asset_sum": 39739050,
		"ff_all_weight_total": 0.07454345590635107,
		"grade_fossil_fam": 4,
		"c2_count_sum": 9,
		"c2_asset_sum": 23213027,
		"c2_weight_total": 0.04354354859080519,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 3035345,
		"mc50_weight_total": 0.0056937724019085305,
		"co_count_sum": 1,
		"co_asset_sum": 1691548,
		"co_weight_total": 0.0031730460026466747,
		"og_count_sum": 19,
		"og_asset_sum": 38047502,
		"og_weight_total": 0.0713704099037044,
		"ut_count_sum": 5,
		"ut_asset_sum": 10364102,
		"ut_weight_total": 0.01944122923033955,
		"cl_count_sum": 18,
		"cl_asset_sum": 111490832,
		"cl_weight_total": 0.20913715650360024,
		"fossil_bank_count_sum": 6,
		"fossil_bank_asset_sum": 12514813,
		"fossil_bank_weight_total": 0.02347558411793259,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "WesMark",
		"fund_family_name": "WesMark",
		"label": "WesMark"
	},
	{
		"fund_family_label": "Vulcan Value Partners",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 530696686,
		"long_asset_sum": 531308753,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 530696686,
		"equity_fund_long_assets": 531308753,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 22055439,
		"ff_all_weight_total": 0.04151152954937296,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 22055439,
		"og_weight_total": 0.04151152954937296,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 4,
		"cl_asset_sum": 44872028,
		"cl_weight_total": 0.08445565360373425,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 21150893,
		"fossil_insure_weight_total": 0.03980904301043954,
		"name": "Vulcan Value Partners",
		"fund_family_name": "Vulcan Value Partners",
		"label": "Vulcan Value Partners"
	},
	{
		"fund_family_label": "SoFi",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 562892011,
		"long_asset_sum": 567629311,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 527350381,
		"equity_fund_long_assets": 527350381,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 95,
		"ff_all_asset_sum": 31145200,
		"ff_all_weight_total": 0.05905978476954964,
		"grade_fossil_fam": 4,
		"c2_count_sum": 23,
		"c2_asset_sum": 7552565,
		"c2_weight_total": 0.014321720950837807,
		"mc50_count_sum": 7,
		"mc50_asset_sum": 6818523,
		"mc50_weight_total": 0.01292977732768529,
		"co_count_sum": 14,
		"co_asset_sum": 2270626,
		"co_weight_total": 0.0043057255324140935,
		"og_count_sum": 66,
		"og_asset_sum": 21752952,
		"og_weight_total": 0.04124952362554565,
		"ut_count_sum": 44,
		"ut_asset_sum": 13880020,
		"ut_weight_total": 0.026320299558103475,
		"cl_count_sum": 54,
		"cl_asset_sum": 122629925,
		"cl_weight_total": 0.23253974855855844,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 9657235,
		"fossil_bank_weight_total": 0.018312748692221006,
		"fossil_insure_count_sum": 8,
		"fossil_insure_asset_sum": 7279291,
		"fossil_insure_weight_total": 0.013803518992811726,
		"name": "SoFi",
		"fund_family_name": "SoFi",
		"label": "SoFi"
	},
	{
		"fund_family_label": "3fourteensmi",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 972985975,
		"long_asset_sum": 973588931,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 507422084,
		"equity_fund_long_assets": 507422084,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 23044324,
		"cl_weight_total": 0.0454145074221878,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "3fourteensmi",
		"fund_family_name": "3fourteensmi",
		"label": "3fourteensmi"
	},
	{
		"fund_family_label": "Scharf Investments",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 496308221,
		"long_asset_sum": 496308221,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 496308221,
		"equity_fund_long_assets": 496308221,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 13,
		"ff_all_asset_sum": 85093986,
		"ff_all_weight_total": 0.17145391190286166,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 20582281,
		"c2_weight_total": 0.04147076378974589,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 30438544,
		"mc50_weight_total": 0.061329921029053436,
		"co_count_sum": 3,
		"co_asset_sum": 20582281,
		"co_weight_total": 0.04147076378974589,
		"og_count_sum": 9,
		"og_asset_sum": 54300025,
		"og_weight_total": 0.10940786934899473,
		"ut_count_sum": 4,
		"ut_asset_sum": 30793961,
		"ut_weight_total": 0.06204604255386695,
		"cl_count_sum": 3,
		"cl_asset_sum": 20455377,
		"cl_weight_total": 0.04121506784389937,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 30438544,
		"fossil_insure_weight_total": 0.061329921029053436,
		"name": "Scharf Investments",
		"fund_family_name": "Scharf Investments",
		"label": "Scharf Investments"
	},
	{
		"fund_family_label": "Crawford",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 494544861,
		"long_asset_sum": 494544861,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 494544861,
		"equity_fund_long_assets": 494544861,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 17,
		"ff_all_asset_sum": 51140255,
		"ff_all_weight_total": 0.10340872796977664,
		"grade_fossil_fam": 5,
		"c2_count_sum": 4,
		"c2_asset_sum": 10156979,
		"c2_weight_total": 0.020538033656768703,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 9070085,
		"mc50_weight_total": 0.018340267416104037,
		"co_count_sum": 4,
		"co_asset_sum": 9743985,
		"co_weight_total": 0.01970293449273149,
		"og_count_sum": 14,
		"og_asset_sum": 41052632,
		"og_weight_total": 0.08301093639308892,
		"ut_count_sum": 7,
		"ut_asset_sum": 22630586,
		"ut_weight_total": 0.04576043102387025,
		"cl_count_sum": 7,
		"cl_asset_sum": 15346048,
		"cl_weight_total": 0.031030649007188854,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 5841322,
		"fossil_bank_weight_total": 0.011811510867160745,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Crawford",
		"fund_family_name": "Crawford",
		"label": "Crawford"
	},
	{
		"fund_family_label": "New Covenant",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 1321611776,
		"long_asset_sum": 1339022239,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 486245393,
		"equity_fund_long_assets": 486245393,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 122,
		"ff_all_asset_sum": 38267150,
		"ff_all_weight_total": 0.07869925463746244,
		"grade_fossil_fam": 4,
		"c2_count_sum": 25,
		"c2_asset_sum": 6942322,
		"c2_weight_total": 0.014277404166583024,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 10389330,
		"mc50_weight_total": 0.02136643379981597,
		"co_count_sum": 17,
		"co_asset_sum": 2554041,
		"co_weight_total": 0.0052525762439460276,
		"og_count_sum": 93,
		"og_asset_sum": 24960222,
		"og_weight_total": 0.0513325624454811,
		"ut_count_sum": 45,
		"ut_asset_sum": 17983862,
		"ut_weight_total": 0.03698515658738591,
		"cl_count_sum": 42,
		"cl_asset_sum": 107742029,
		"cl_weight_total": 0.22157953689856347,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 8155835,
		"fossil_bank_weight_total": 0.016773084367300115,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 10275043,
		"fossil_insure_weight_total": 0.021131394040786317,
		"name": "New Covenant",
		"fund_family_name": "New Covenant",
		"label": "New Covenant"
	},
	{
		"fund_family_label": "Longview Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 484375558,
		"long_asset_sum": 484375558,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 484375558,
		"equity_fund_long_assets": 484375558,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 153,
		"ff_all_asset_sum": 51169033,
		"ff_all_weight_total": 0.10563917223915745,
		"grade_fossil_fam": 5,
		"c2_count_sum": 34,
		"c2_asset_sum": 20693703,
		"c2_weight_total": 0.0427224343966588,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 7691363,
		"mc50_weight_total": 0.01587892467522071,
		"co_count_sum": 21,
		"co_asset_sum": 4214364,
		"co_weight_total": 0.008700612428507386,
		"og_count_sum": 117,
		"og_asset_sum": 39894908,
		"og_weight_total": 0.08236358614940682,
		"ut_count_sum": 52,
		"ut_asset_sum": 15004900,
		"ut_weight_total": 0.030977822378064748,
		"cl_count_sum": 45,
		"cl_asset_sum": 78754994,
		"cl_weight_total": 0.16259076805027392,
		"fossil_bank_count_sum": 9,
		"fossil_bank_asset_sum": 8771190,
		"fossil_bank_weight_total": 0.018108242365111247,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 14646995,
		"fossil_insure_weight_total": 0.03023892258411602,
		"name": "Longview Funds",
		"fund_family_name": "Longview Funds",
		"label": "Longview Funds"
	},
	{
		"fund_family_label": "Hodges",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 471015291,
		"long_asset_sum": 471360334,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 471015291,
		"equity_fund_long_assets": 471360334,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 18,
		"ff_all_asset_sum": 68016754,
		"ff_all_weight_total": 0.14429884972035004,
		"grade_fossil_fam": 5,
		"c2_count_sum": 8,
		"c2_asset_sum": 38524294,
		"c2_weight_total": 0.08173002949374183,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1133200,
		"mc50_weight_total": 0.002404105560566749,
		"co_count_sum": 1,
		"co_asset_sum": 1378700,
		"co_weight_total": 0.0029249385248441375,
		"og_count_sum": 16,
		"og_asset_sum": 65504854,
		"og_weight_total": 0.13896980563493916,
		"ut_count_sum": 3,
		"ut_asset_sum": 3862300,
		"ut_weight_total": 0.008193943616816938,
		"cl_count_sum": 9,
		"cl_asset_sum": 23575810,
		"cl_weight_total": 0.050016533635602864,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 5508630,
		"fossil_bank_weight_total": 0.011686664325895525,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 1133200,
		"fossil_insure_weight_total": 0.002404105560566749,
		"name": "Hodges",
		"fund_family_name": "Hodges",
		"label": "Hodges"
	},
	{
		"fund_family_label": "Huber Funds",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 465478808,
		"long_asset_sum": 466463889,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 465478808,
		"equity_fund_long_assets": 466463889,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 32,
		"ff_all_asset_sum": 74764341,
		"ff_all_weight_total": 0.160278947123386,
		"grade_fossil_fam": 5,
		"c2_count_sum": 10,
		"c2_asset_sum": 30972084,
		"c2_weight_total": 0.06639760275205354,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 32781,
		"mc50_weight_total": 0.00007027553637705062,
		"co_count_sum": 4,
		"co_asset_sum": 4039795,
		"co_weight_total": 0.008660466748370312,
		"og_count_sum": 30,
		"og_asset_sum": 73250099,
		"og_weight_total": 0.1570327322808047,
		"ut_count_sum": 10,
		"ut_asset_sum": 9592610,
		"ut_weight_total": 0.020564528629567723,
		"cl_count_sum": 8,
		"cl_asset_sum": 35666916,
		"cl_weight_total": 0.07646233039917051,
		"fossil_bank_count_sum": 9,
		"fossil_bank_asset_sum": 39764521,
		"fossil_bank_weight_total": 0.08524672957052845,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Huber Funds",
		"fund_family_name": "Huber Funds",
		"label": "Huber Funds"
	},
	{
		"fund_family_label": "Bright Rock",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 461926706,
		"long_asset_sum": 461966426,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 461926706,
		"equity_fund_long_assets": 461966426,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 31743916,
		"ff_all_weight_total": 0.06871476846241635,
		"grade_fossil_fam": 4,
		"c2_count_sum": 3,
		"c2_asset_sum": 9314750,
		"c2_weight_total": 0.02016326182110905,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 8,
		"og_asset_sum": 31743916,
		"og_weight_total": 0.06871476846241635,
		"ut_count_sum": 2,
		"ut_asset_sum": 11956640,
		"ut_weight_total": 0.02588205403480988,
		"cl_count_sum": 6,
		"cl_asset_sum": 92962600,
		"cl_weight_total": 0.20123237267463243,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 12873600,
		"fossil_insure_weight_total": 0.02786696018467801,
		"name": "Bright Rock",
		"fund_family_name": "Bright Rock",
		"label": "Bright Rock"
	},
	{
		"fund_family_label": "iM Global Partner Fund Management",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 2251145962,
		"long_asset_sum": 3446426881,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 459999138,
		"equity_fund_long_assets": 460000528,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 10,
		"ff_all_asset_sum": 12432023,
		"ff_all_weight_total": 0.027026105935252318,
		"grade_fossil_fam": 3,
		"c2_count_sum": 5,
		"c2_asset_sum": 6772704,
		"c2_weight_total": 0.014723252665483896,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 3126341,
		"mc50_weight_total": 0.006796385677192093,
		"co_count_sum": 2,
		"co_asset_sum": 5837603,
		"co_weight_total": 0.012690426737944962,
		"og_count_sum": 7,
		"og_asset_sum": 5924452,
		"og_weight_total": 0.012879228695146194,
		"ut_count_sum": 3,
		"ut_asset_sum": 3126341,
		"ut_weight_total": 0.006796385677192093,
		"cl_count_sum": 20,
		"cl_asset_sum": 56546165,
		"cl_weight_total": 0.12292630455415478,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 5032814,
		"fossil_bank_weight_total": 0.01094088744176398,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 4440039,
		"fossil_insure_weight_total": 0.009652247616550562,
		"name": "iM Global Partner Fund Management",
		"fund_family_name": "iM Global Partner Fund Management",
		"label": "iM Global Partner Fund Management"
	},
	{
		"fund_family_label": "Spirit of America",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 542505765,
		"long_asset_sum": 542505765,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 455437889,
		"equity_fund_long_assets": 455437889,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 155,
		"ff_all_asset_sum": 225457684,
		"ff_all_weight_total": 0.49503497501061006,
		"grade_fossil_fam": 5,
		"c2_count_sum": 32,
		"c2_asset_sum": 38733868,
		"c2_weight_total": 0.08504753103666349,
		"mc50_count_sum": 11,
		"mc50_asset_sum": 8489457,
		"mc50_weight_total": 0.018640208039432574,
		"co_count_sum": 19,
		"co_asset_sum": 11208740,
		"co_weight_total": 0.02461090803097412,
		"og_count_sum": 123,
		"og_asset_sum": 203727900,
		"og_weight_total": 0.4473231255469832,
		"ut_count_sum": 61,
		"ut_asset_sum": 40508593,
		"ut_weight_total": 0.0889442753411322,
		"cl_count_sum": 19,
		"cl_asset_sum": 42963693,
		"cl_weight_total": 0.09433491160415948,
		"fossil_bank_count_sum": 10,
		"fossil_bank_asset_sum": 4621069,
		"fossil_bank_weight_total": 0.010146430746344866,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 2143665,
		"fossil_insure_weight_total": 0.004706821834052547,
		"name": "Spirit of America",
		"fund_family_name": "Spirit of America",
		"label": "Spirit of America"
	},
	{
		"fund_family_label": "Tocqueville",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 455027955,
		"long_asset_sum": 455027955,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 455027955,
		"equity_fund_long_assets": 455027955,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 48164947,
		"ff_all_weight_total": 0.10585052296402317,
		"grade_fossil_fam": 5,
		"c2_count_sum": 5,
		"c2_asset_sum": 25821772,
		"c2_weight_total": 0.05674766070141778,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 4936000,
		"co_weight_total": 0.010847685171342934,
		"og_count_sum": 7,
		"og_asset_sum": 48164947,
		"og_weight_total": 0.10585052296402317,
		"ut_count_sum": 1,
		"ut_asset_sum": 12405750,
		"ut_weight_total": 0.027263709545054214,
		"cl_count_sum": 8,
		"cl_asset_sum": 76464200,
		"cl_weight_total": 0.16804286233359003,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Tocqueville",
		"fund_family_name": "Tocqueville",
		"label": "Tocqueville"
	},
	{
		"fund_family_label": "BMO Capital Markets",
		"as_of": "202506",
		"fund_id": 18,
		"net_asset_sum": 2894636107,
		"long_asset_sum": 2894643122,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 454943929,
		"equity_fund_long_assets": 454943929,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 4,
		"cl_asset_sum": 174666006,
		"cl_weight_total": 0.38392864453412673,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "BMO Capital Markets",
		"fund_family_name": "BMO Capital Markets",
		"label": "BMO Capital Markets"
	},
	{
		"fund_family_label": "Leuthold",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 557037060,
		"long_asset_sum": 688915171,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 444692169,
		"equity_fund_long_assets": 534549574,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 11,
		"ff_all_asset_sum": 10715173,
		"ff_all_weight_total": 0.020045237188796264,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 92962,
		"og_weight_total": 0.00017390716319231413,
		"ut_count_sum": 10,
		"ut_asset_sum": 10622211,
		"ut_weight_total": 0.01987133002560395,
		"cl_count_sum": 19,
		"cl_asset_sum": 43360825,
		"cl_weight_total": 0.08111656450408096,
		"fossil_bank_count_sum": 29,
		"fossil_bank_asset_sum": 30597420,
		"fossil_bank_weight_total": 0.057239630313502037,
		"fossil_insure_count_sum": 12,
		"fossil_insure_asset_sum": 6944001,
		"fossil_insure_weight_total": 0.012990377951362842,
		"name": "Leuthold",
		"fund_family_name": "Leuthold",
		"label": "Leuthold"
	},
	{
		"fund_family_label": "Wall Street",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 440653337,
		"long_asset_sum": 440803250,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 440653337,
		"equity_fund_long_assets": 440803250,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 37553303,
		"ff_all_weight_total": 0.08519289047891548,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1,
		"c2_asset_sum": 9160700,
		"c2_weight_total": 0.020781834072230637,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 37553303,
		"og_weight_total": 0.08519289047891548,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 4,
		"cl_asset_sum": 69091006,
		"cl_weight_total": 0.1567388761312445,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 15835047,
		"fossil_bank_weight_total": 0.03592316299845793,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 13148237,
		"fossil_insure_weight_total": 0.02982790394580802,
		"name": "Wall Street",
		"fund_family_name": "Wall Street",
		"label": "Wall Street"
	},
	{
		"fund_family_label": "TrueShares",
		"as_of": "202506",
		"fund_id": 22,
		"net_asset_sum": 1063633742,
		"long_asset_sum": 1088044115,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 439630484,
		"equity_fund_long_assets": 441207517,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 2356546,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 2356546,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 102,
		"ff_all_asset_sum": 71927369,
		"ff_all_weight_total": 0.1630238974373594,
		"grade_fossil_fam": 5,
		"c2_count_sum": 23,
		"c2_asset_sum": 14785491,
		"c2_weight_total": 0.03351142133872574,
		"mc50_count_sum": 10,
		"mc50_asset_sum": 14697897,
		"mc50_weight_total": 0.033312888909823354,
		"co_count_sum": 18,
		"co_asset_sum": 7119222,
		"co_weight_total": 0.01613576769590714,
		"og_count_sum": 76,
		"og_asset_sum": 71175693,
		"og_weight_total": 0.16132021839510047,
		"ut_count_sum": 54,
		"ut_asset_sum": 31673165,
		"ut_weight_total": 0.07178745551608541,
		"cl_count_sum": 23,
		"cl_asset_sum": 32414876,
		"cl_weight_total": 0.07346854881441198,
		"fossil_bank_count_sum": 15,
		"fossil_bank_asset_sum": 25925305,
		"fossil_bank_weight_total": 0.05875988962354873,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 4028282,
		"fossil_insure_weight_total": 0.00913013002904028,
		"name": "TrueShares",
		"fund_family_name": "TrueShares",
		"label": "TrueShares"
	},
	{
		"fund_family_label": "Adaptive ETF",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 481976000,
		"long_asset_sum": 504731286,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 437015040,
		"equity_fund_long_assets": 459749480,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 12,
		"ff_all_asset_sum": 50287598,
		"ff_all_weight_total": 0.10938043475329216,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 7826267,
		"mc50_weight_total": 0.017022894729538357,
		"co_count_sum": 2,
		"co_asset_sum": 7114663,
		"co_weight_total": 0.015475086562360005,
		"og_count_sum": 8,
		"og_asset_sum": 28767225,
		"og_weight_total": 0.06257152264750794,
		"ut_count_sum": 8,
		"ut_asset_sum": 38978494,
		"ut_weight_total": 0.08478202955226834,
		"cl_count_sum": 8,
		"cl_asset_sum": 39434800,
		"cl_weight_total": 0.0857745396471139,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Adaptive ETF",
		"fund_family_name": "Adaptive ETF",
		"label": "Adaptive ETF"
	},
	{
		"fund_family_label": "Goehring & Rozencwajg",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 433640322,
		"long_asset_sum": 433640322,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 433640322,
		"equity_fund_long_assets": 433640322,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 22,
		"ff_all_asset_sum": 177552788,
		"ff_all_weight_total": 0.409447136237483,
		"grade_fossil_fam": 5,
		"c2_count_sum": 12,
		"c2_asset_sum": 139210525,
		"c2_weight_total": 0.32102763035952175,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 19453711,
		"co_weight_total": 0.04486139782914376,
		"og_count_sum": 20,
		"og_asset_sum": 158099077,
		"og_weight_total": 0.36458573840833924,
		"ut_count_sum": 1,
		"ut_asset_sum": 13667286,
		"ut_weight_total": 0.03151756261263915,
		"cl_count_sum": 1,
		"cl_asset_sum": 8236727,
		"cl_weight_total": 0.018994375250925122,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Goehring & Rozencwajg",
		"fund_family_name": "Goehring & Rozencwajg",
		"label": "Goehring & Rozencwajg"
	},
	{
		"fund_family_label": "Boston Common",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 428183855,
		"long_asset_sum": 475666210,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 428183855,
		"equity_fund_long_assets": 475666210,
		"num_e_sri": 3,
		"num_e_usf": 0,
		"sri_long_assets": 475666210,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 475666210,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 3,
		"num_five_badgers": 1,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 25825210,
		"ff_all_weight_total": 0.054292715053272336,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 25825210,
		"og_weight_total": 0.054292715053272336,
		"ut_count_sum": 1,
		"ut_asset_sum": 7543984,
		"ut_weight_total": 0.015859827419736204,
		"cl_count_sum": 30,
		"cl_asset_sum": 98426843,
		"cl_weight_total": 0.20692418534417234,
		"fossil_bank_count_sum": 6,
		"fossil_bank_asset_sum": 28663488,
		"fossil_bank_weight_total": 0.0602596682240683,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 16995691,
		"fossil_insure_weight_total": 0.035730288682898036,
		"name": "Boston Common",
		"fund_family_name": "Boston Common",
		"label": "Boston Common"
	},
	{
		"fund_family_label": "Dean Fund",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 424519048,
		"long_asset_sum": 424519049,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 424519048,
		"equity_fund_long_assets": 424519049,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 26,
		"ff_all_asset_sum": 59672213,
		"ff_all_weight_total": 0.14056427653968478,
		"grade_fossil_fam": 5,
		"c2_count_sum": 4,
		"c2_asset_sum": 9929007,
		"c2_weight_total": 0.023388837375822917,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 3695823,
		"mc50_weight_total": 0.008705906151221968,
		"co_count_sum": 6,
		"co_asset_sum": 13207476,
		"co_weight_total": 0.031111621565891145,
		"og_count_sum": 19,
		"og_asset_sum": 48760072,
		"og_weight_total": 0.11485956193216668,
		"ut_count_sum": 16,
		"ut_asset_sum": 34754037,
		"ut_weight_total": 0.0818668492777105,
		"cl_count_sum": 6,
		"cl_asset_sum": 11174243,
		"cl_weight_total": 0.026322123886600907,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 2839472,
		"fossil_bank_weight_total": 0.006688679828829071,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 3460030,
		"fossil_insure_weight_total": 0.008150470534008946,
		"name": "Dean Fund",
		"fund_family_name": "Dean Fund",
		"label": "Dean Fund"
	},
	{
		"fund_family_label": "Aegis",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 423794347,
		"long_asset_sum": 423794347,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 423794347,
		"equity_fund_long_assets": 423794347,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 17,
		"ff_all_asset_sum": 152943165,
		"ff_all_weight_total": 0.36089005453392703,
		"grade_fossil_fam": 5,
		"c2_count_sum": 7,
		"c2_asset_sum": 77822352,
		"c2_weight_total": 0.1836323503390195,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 26567016,
		"co_weight_total": 0.0626884624301041,
		"og_count_sum": 15,
		"og_asset_sum": 126376149,
		"og_weight_total": 0.29820159210382297,
		"ut_count_sum": 1,
		"ut_asset_sum": 23529499,
		"ut_weight_total": 0.0555210308173365,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Aegis",
		"fund_family_name": "Aegis",
		"label": "Aegis"
	},
	{
		"fund_family_label": "Bushido",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 421162579,
		"long_asset_sum": 421162579,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 421162579,
		"equity_fund_long_assets": 421162579,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 68988816,
		"ff_all_weight_total": 0.16380566422545342,
		"grade_fossil_fam": 5,
		"c2_count_sum": 6,
		"c2_asset_sum": 42592100,
		"c2_weight_total": 0.10112982996051033,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 13196000,
		"mc50_weight_total": 0.03133231834445577,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 9,
		"og_asset_sum": 68988816,
		"og_weight_total": 0.16380566422545342,
		"ut_count_sum": 1,
		"ut_asset_sum": 13196000,
		"ut_weight_total": 0.03133231834445577,
		"cl_count_sum": 4,
		"cl_asset_sum": 32369308,
		"cl_weight_total": 0.07685703719655491,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 8512430,
		"fossil_bank_weight_total": 0.020211743455963594,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 8178755,
		"fossil_insure_weight_total": 0.019419472212890976,
		"name": "Bushido",
		"fund_family_name": "Bushido",
		"label": "Bushido"
	},
	{
		"fund_family_label": "Polaris Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 419330828,
		"long_asset_sum": 419330828,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 419330828,
		"equity_fund_long_assets": 419330828,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 44374234,
		"ff_all_weight_total": 0.10582154002757937,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 14125237,
		"c2_weight_total": 0.03368518615092139,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 4500728,
		"co_weight_total": 0.010733119769577255,
		"og_count_sum": 9,
		"og_asset_sum": 44374234,
		"og_weight_total": 0.10582154002757937,
		"ut_count_sum": 3,
		"ut_asset_sum": 15971479,
		"ut_weight_total": 0.03808801531758595,
		"cl_count_sum": 6,
		"cl_asset_sum": 34166554,
		"cl_weight_total": 0.08147875548038648,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 17763782,
		"fossil_insure_weight_total": 0.04236221335007594,
		"name": "Polaris Funds",
		"fund_family_name": "Polaris Funds",
		"label": "Polaris Funds"
	},
	{
		"fund_family_label": "OneAscent Investment ETF",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 604470954,
		"long_asset_sum": 604471448,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 418831569,
		"equity_fund_long_assets": 418832063,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 185639385,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 43,
		"ff_all_asset_sum": 31569875,
		"ff_all_weight_total": 0.07537597473763608,
		"grade_fossil_fam": 4,
		"c2_count_sum": 11,
		"c2_asset_sum": 3748944,
		"c2_weight_total": 0.008950947960256805,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 3298040,
		"mc50_weight_total": 0.007874373266403915,
		"co_count_sum": 8,
		"co_asset_sum": 1205525,
		"co_weight_total": 0.00287830160700949,
		"og_count_sum": 30,
		"og_asset_sum": 26481910,
		"og_weight_total": 0.06322799121518068,
		"ut_count_sum": 15,
		"ut_asset_sum": 10930657,
		"ut_weight_total": 0.026097947042798393,
		"cl_count_sum": 24,
		"cl_asset_sum": 50753293,
		"cl_weight_total": 0.12117814628723876,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 2806817,
		"fossil_bank_weight_total": 0.0067015332586894145,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 3199738,
		"fossil_insure_weight_total": 0.007639668217091584,
		"name": "OneAscent Investment ETF",
		"fund_family_name": "OneAscent Investment ETF",
		"label": "OneAscent Investment ETF"
	},
	{
		"fund_family_label": "Vert Asset Management",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 412521409,
		"long_asset_sum": 412521409,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 412521409,
		"equity_fund_long_assets": 412521409,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 412521409,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 412521409,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 20737059,
		"cl_weight_total": 0.05026904918769925,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Vert Asset Management",
		"fund_family_name": "Vert Asset Management",
		"label": "Vert Asset Management"
	},
	{
		"fund_family_label": "Tema Global Limited",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 402260759,
		"long_asset_sum": 402449043,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 402260759,
		"equity_fund_long_assets": 402449043,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 7,
		"num_five_badgers": 5,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 5,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 12,
		"ff_all_asset_sum": 29748180,
		"ff_all_weight_total": 0.07391787983454094,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 4993379,
		"mc50_weight_total": 0.012407481361559605,
		"co_count_sum": 4,
		"co_asset_sum": 8549667,
		"co_weight_total": 0.021244098224877626,
		"og_count_sum": 9,
		"og_asset_sum": 22312466,
		"og_weight_total": 0.055441717126905925,
		"ut_count_sum": 11,
		"ut_asset_sum": 25584064,
		"ut_weight_total": 0.06357094008545076,
		"cl_count_sum": 28,
		"cl_asset_sum": 51717242,
		"cl_weight_total": 0.1285063112946699,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Tema Global Limited",
		"fund_family_name": "Tema Global Limited",
		"label": "Tema Global Limited"
	},
	{
		"fund_family_label": "Keeley",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 397897755,
		"long_asset_sum": 397897755,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 397897755,
		"equity_fund_long_assets": 397897755,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 35,
		"ff_all_asset_sum": 62367528,
		"ff_all_weight_total": 0.1567425983592192,
		"grade_fossil_fam": 5,
		"c2_count_sum": 8,
		"c2_asset_sum": 14534902,
		"c2_weight_total": 0.036529238522594834,
		"mc50_count_sum": 4,
		"mc50_asset_sum": 5217088,
		"mc50_weight_total": 0.013111629644655823,
		"co_count_sum": 3,
		"co_asset_sum": 7814921,
		"co_weight_total": 0.01964052549127853,
		"og_count_sum": 21,
		"og_asset_sum": 35250218,
		"og_weight_total": 0.08859114573290316,
		"ut_count_sum": 17,
		"ut_asset_sum": 32784259,
		"ut_weight_total": 0.08239367673738195,
		"cl_count_sum": 1,
		"cl_asset_sum": 1017963,
		"cl_weight_total": 0.002558353213126322,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Keeley",
		"fund_family_name": "Keeley",
		"label": "Keeley"
	},
	{
		"fund_family_label": "The Burney Company",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 387013911,
		"long_asset_sum": 387013911,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 387013911,
		"equity_fund_long_assets": 387013911,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 10253188,
		"ff_all_weight_total": 0.026493073526754958,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 2220692,
		"c2_weight_total": 0.0057380159650126895,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 4240890,
		"og_weight_total": 0.010957978200427012,
		"ut_count_sum": 3,
		"ut_asset_sum": 6012298,
		"ut_weight_total": 0.015535095326327946,
		"cl_count_sum": 7,
		"cl_asset_sum": 46510666,
		"cl_weight_total": 0.12017827958644102,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 1921090,
		"fossil_bank_weight_total": 0.004963878417279941,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 4091331,
		"fossil_insure_weight_total": 0.010571534727081167,
		"name": "The Burney Company",
		"fund_family_name": "The Burney Company",
		"label": "The Burney Company"
	},
	{
		"fund_family_label": "EntrepreneurShares",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 384078267,
		"long_asset_sum": 384078267,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 384078267,
		"equity_fund_long_assets": 384078267,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 8254698,
		"ff_all_weight_total": 0.021492228822205136,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 7207178,
		"c2_weight_total": 0.01876486804706396,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 620670,
		"co_weight_total": 0.0016159987516294434,
		"og_count_sum": 2,
		"og_asset_sum": 7634028,
		"og_weight_total": 0.019876230070575693,
		"ut_count_sum": 1,
		"ut_asset_sum": 620670,
		"ut_weight_total": 0.0016159987516294434,
		"cl_count_sum": 5,
		"cl_asset_sum": 28662221,
		"cl_weight_total": 0.0746259902281844,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "EntrepreneurShares",
		"fund_family_name": "EntrepreneurShares",
		"label": "EntrepreneurShares"
	},
	{
		"fund_family_label": "USCF Investments",
		"as_of": "202506",
		"fund_id": 16,
		"net_asset_sum": 3809258400,
		"long_asset_sum": 4248077546,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 373573592,
		"equity_fund_long_assets": 373573592,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 6960733,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 3352994,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 20,
		"ff_all_asset_sum": 369597364,
		"ff_all_weight_total": 0.9893562390780556,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 20,
		"og_asset_sum": 369597364,
		"og_weight_total": 0.9893562390780556,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 5,
		"cl_asset_sum": 486626,
		"cl_weight_total": 0.0013026241961985364,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 312135,
		"fossil_bank_weight_total": 0.0008355381822599495,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "USCF Investments",
		"fund_family_name": "USCF Investments",
		"label": "USCF Investments"
	},
	{
		"fund_family_label": "City National Rochdale",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 2839274443,
		"long_asset_sum": 2890927033,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 371341587,
		"equity_fund_long_assets": 371341587,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 27114555,
		"ff_all_weight_total": 0.07301782496017609,
		"grade_fossil_fam": 4,
		"c2_count_sum": 3,
		"c2_asset_sum": 9769151,
		"c2_weight_total": 0.02630772135952551,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 7556631,
		"mc50_weight_total": 0.02034954140485213,
		"co_count_sum": 2,
		"co_asset_sum": 4310279,
		"co_weight_total": 0.011607315611542319,
		"og_count_sum": 5,
		"og_asset_sum": 16160248,
		"og_weight_total": 0.04351855155937598,
		"ut_count_sum": 2,
		"ut_asset_sum": 12938543,
		"ut_weight_total": 0.034842698617539976,
		"cl_count_sum": 9,
		"cl_asset_sum": 113402465,
		"cl_weight_total": 0.3053858468052489,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 3705820,
		"fossil_bank_weight_total": 0.009979544790387294,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 7556631,
		"fossil_insure_weight_total": 0.02034954140485213,
		"name": "City National Rochdale",
		"fund_family_name": "City National Rochdale",
		"label": "City National Rochdale"
	},
	{
		"fund_family_label": "AAMA",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 499006861,
		"long_asset_sum": 499006861,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 367527837,
		"equity_fund_long_assets": 367527837,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 28791850,
		"ff_all_weight_total": 0.07833923611070581,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 16044750,
		"c2_weight_total": 0.04365587687443659,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 4810200,
		"mc50_weight_total": 0.013087988216794582,
		"co_count_sum": 1,
		"co_asset_sum": 2491820,
		"co_weight_total": 0.006779949024650342,
		"og_count_sum": 5,
		"og_asset_sum": 23152200,
		"og_weight_total": 0.06299441203959742,
		"ut_count_sum": 6,
		"ut_asset_sum": 12747100,
		"ut_weight_total": 0.03468335923626922,
		"cl_count_sum": 8,
		"cl_asset_sum": 73148766,
		"cl_weight_total": 0.19902918537297082,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "AAMA",
		"fund_family_name": "AAMA",
		"label": "AAMA"
	},
	{
		"fund_family_label": "Bruce",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 355575677,
		"long_asset_sum": 355575677,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 355575677,
		"equity_fund_long_assets": 355575677,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 79253500,
		"ff_all_weight_total": 0.2228878551780132,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 20734900,
		"mc50_weight_total": 0.05831360619191059,
		"co_count_sum": 1,
		"co_asset_sum": 8374000,
		"co_weight_total": 0.023550542238017027,
		"og_count_sum": 4,
		"og_asset_sum": 54355300,
		"og_weight_total": 0.15286563034512624,
		"ut_count_sum": 5,
		"ut_asset_sum": 78223500,
		"ut_weight_total": 0.2199911441074188,
		"cl_count_sum": 6,
		"cl_asset_sum": 70527500,
		"cl_weight_total": 0.19834736896247265,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Bruce",
		"fund_family_name": "Bruce",
		"label": "Bruce"
	},
	{
		"fund_family_label": "EMQQ",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 349659178,
		"long_asset_sum": 351544313,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 349659178,
		"equity_fund_long_assets": 351544313,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 27920739,
		"ff_all_weight_total": 0.07942309964206419,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 27920739,
		"og_weight_total": 0.07942309964206419,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "EMQQ",
		"fund_family_name": "EMQQ",
		"label": "EMQQ"
	},
	{
		"fund_family_label": "AdvisorShares",
		"as_of": "202506",
		"fund_id": 18,
		"net_asset_sum": 1024394995,
		"long_asset_sum": 1475365364,
		"num_equity_funds": 10,
		"equity_fund_net_assets": 346096025,
		"equity_fund_long_assets": 346096029,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 8,
		"num_five_badgers": 6,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 6,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 18,
		"ff_all_asset_sum": 11605489,
		"ff_all_weight_total": 0.03353256907781511,
		"grade_fossil_fam": 3,
		"c2_count_sum": 4,
		"c2_asset_sum": 3055186,
		"c2_weight_total": 0.008827567333920493,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 39351,
		"co_weight_total": 0.0001136996576172794,
		"og_count_sum": 17,
		"og_asset_sum": 10432173,
		"og_weight_total": 0.030142423275246535,
		"ut_count_sum": 3,
		"ut_asset_sum": 2802803,
		"ut_weight_total": 0.008098339088426814,
		"cl_count_sum": 17,
		"cl_asset_sum": 13195538,
		"cl_weight_total": 0.038126811330736185,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 5739503,
		"fossil_bank_weight_total": 0.01658355635163904,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 909729,
		"fossil_insure_weight_total": 0.002628545038868389,
		"name": "AdvisorShares",
		"fund_family_name": "AdvisorShares",
		"label": "AdvisorShares"
	},
	{
		"fund_family_label": "Teton Westwood Funds",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 351119828,
		"long_asset_sum": 351830017,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 338816748,
		"equity_fund_long_assets": 339526937,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 29,
		"ff_all_asset_sum": 19230106,
		"ff_all_weight_total": 0.056637939157092566,
		"grade_fossil_fam": 4,
		"c2_count_sum": 6,
		"c2_asset_sum": 3169528,
		"c2_weight_total": 0.009335129719030217,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 1862965,
		"mc50_weight_total": 0.005486943146428468,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 25,
		"og_asset_sum": 15179863,
		"og_weight_total": 0.04470886208359957,
		"ut_count_sum": 10,
		"ut_asset_sum": 7970663,
		"ut_weight_total": 0.02347578978689399,
		"cl_count_sum": 9,
		"cl_asset_sum": 6873419,
		"cl_weight_total": 0.02024410510910361,
		"fossil_bank_count_sum": 6,
		"fossil_bank_asset_sum": 3592884,
		"fossil_bank_weight_total": 0.010582029313332509,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 1862965,
		"fossil_insure_weight_total": 0.005486943146428468,
		"name": "Teton Westwood Funds",
		"fund_family_name": "Teton Westwood Funds",
		"label": "Teton Westwood Funds"
	},
	{
		"fund_family_label": "Advisors Capital",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 651788012,
		"long_asset_sum": 651788012,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 338070121,
		"equity_fund_long_assets": 338070121,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 31301516,
		"ff_all_weight_total": 0.09258882715636381,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 5905337,
		"c2_weight_total": 0.017467787400235822,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 5645348,
		"mc50_weight_total": 0.016698748719056425,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 7,
		"og_asset_sum": 25656168,
		"og_weight_total": 0.07589007843730738,
		"ut_count_sum": 3,
		"ut_asset_sum": 14174894,
		"ut_weight_total": 0.04192885771174081,
		"cl_count_sum": 10,
		"cl_asset_sum": 52771010,
		"cl_weight_total": 0.15609486530162778,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 8909894,
		"fossil_bank_weight_total": 0.026355165530881092,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 5645348,
		"fossil_insure_weight_total": 0.016698748719056425,
		"name": "Advisors Capital",
		"fund_family_name": "Advisors Capital",
		"label": "Advisors Capital"
	},
	{
		"fund_family_label": "Torray Investment Partners LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 335379237,
		"long_asset_sum": 336991463,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 335379237,
		"equity_fund_long_assets": 336991463,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 56385751,
		"ff_all_weight_total": 0.16732100717934212,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 14354544,
		"c2_weight_total": 0.042596165114129315,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 20491016,
		"mc50_weight_total": 0.0608057421324053,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 35894735,
		"og_weight_total": 0.10651526504693681,
		"ut_count_sum": 1,
		"ut_asset_sum": 20491016,
		"ut_weight_total": 0.0608057421324053,
		"cl_count_sum": 4,
		"cl_asset_sum": 42647157,
		"cl_weight_total": 0.126552633174568,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 34693606,
		"fossil_insure_weight_total": 0.10295099374668729,
		"name": "Torray Investment Partners LLC",
		"fund_family_name": "Torray Investment Partners LLC",
		"label": "Torray Investment Partners LLC"
	},
	{
		"fund_family_label": "ICON Funds",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 708929120,
		"long_asset_sum": 709984032,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 333548696,
		"equity_fund_long_assets": 334603608,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 32,
		"ff_all_asset_sum": 58049440,
		"ff_all_weight_total": 0.17348719084941847,
		"grade_fossil_fam": 5,
		"c2_count_sum": 5,
		"c2_asset_sum": 8509209,
		"c2_weight_total": 0.02543071502086134,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 4702225,
		"mc50_weight_total": 0.014053121029107373,
		"co_count_sum": 8,
		"co_asset_sum": 12148868,
		"co_weight_total": 0.036308239688796186,
		"og_count_sum": 14,
		"og_asset_sum": 32420742,
		"og_weight_total": 0.09689298389155446,
		"ut_count_sum": 24,
		"ut_asset_sum": 33431481,
		"ut_weight_total": 0.09991368951407123,
		"cl_count_sum": 12,
		"cl_asset_sum": 28199325,
		"cl_weight_total": 0.0842768109063546,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 5227295,
		"fossil_bank_weight_total": 0.01562235096998715,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 3080471,
		"fossil_insure_weight_total": 0.009206329299354119,
		"name": "ICON Funds",
		"fund_family_name": "ICON Funds",
		"label": "ICON Funds"
	},
	{
		"fund_family_label": "CastleArk Management LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 328777031,
		"long_asset_sum": 328777031,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 328777031,
		"equity_fund_long_assets": 328777031,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 6028289,
		"ff_all_weight_total": 0.018335493150675723,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 6028289,
		"og_weight_total": 0.018335493150675723,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 4,
		"cl_asset_sum": 74423779,
		"cl_weight_total": 0.22636550605020822,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "CastleArk Management LLC",
		"fund_family_name": "CastleArk Management LLC",
		"label": "CastleArk Management LLC"
	},
	{
		"fund_family_label": "Poplar Forest Capital",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 327807739,
		"long_asset_sum": 328164359,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 327807739,
		"equity_fund_long_assets": 328164359,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 10,
		"ff_all_asset_sum": 58436882,
		"ff_all_weight_total": 0.17807199471043106,
		"grade_fossil_fam": 5,
		"c2_count_sum": 6,
		"c2_asset_sum": 36440360,
		"c2_weight_total": 0.11104301549090527,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 16986255,
		"co_weight_total": 0.05176142543864735,
		"og_count_sum": 10,
		"og_asset_sum": 58436882,
		"og_weight_total": 0.17807199471043106,
		"ut_count_sum": 2,
		"ut_asset_sum": 13961430,
		"ut_weight_total": 0.04254401679251219,
		"cl_count_sum": 6,
		"cl_asset_sum": 31959658,
		"cl_weight_total": 0.09738918052340961,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 12707210,
		"fossil_bank_weight_total": 0.03872209047540108,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Poplar Forest Capital",
		"fund_family_name": "Poplar Forest Capital",
		"label": "Poplar Forest Capital"
	},
	{
		"fund_family_label": "Equity Investment Corp",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 315371346,
		"long_asset_sum": 317435393,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 315371346,
		"equity_fund_long_assets": 317435393,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 38925713,
		"ff_all_weight_total": 0.12262562353908658,
		"grade_fossil_fam": 5,
		"c2_count_sum": 4,
		"c2_asset_sum": 28678065,
		"c2_weight_total": 0.0903429977639576,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 8307596,
		"co_weight_total": 0.026170982137458124,
		"og_count_sum": 6,
		"og_asset_sum": 38925713,
		"og_weight_total": 0.12262562353908658,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 3,
		"cl_asset_sum": 29923857,
		"cl_weight_total": 0.09426755068865304,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 32447691,
		"fossil_bank_weight_total": 0.10221825201451308,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 11257912,
		"fossil_insure_weight_total": 0.03546520724612457,
		"name": "Equity Investment Corp",
		"fund_family_name": "Equity Investment Corp",
		"label": "Equity Investment Corp"
	},
	{
		"fund_family_label": "DoubleLine",
		"as_of": "202506",
		"fund_id": 24,
		"net_asset_sum": 50911154553,
		"long_asset_sum": 77735413008,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 311946844,
		"equity_fund_long_assets": 311946844,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 56,
		"ff_all_asset_sum": 2101141,
		"ff_all_weight_total": 0.006735573833854847,
		"grade_fossil_fam": 3,
		"c2_count_sum": 12,
		"c2_asset_sum": 422189,
		"c2_weight_total": 0.0013534004530592397,
		"mc50_count_sum": 5,
		"mc50_asset_sum": 204251,
		"mc50_weight_total": 0.0006547621940358531,
		"co_count_sum": 8,
		"co_asset_sum": 303039,
		"co_weight_total": 0.000971444352871863,
		"og_count_sum": 42,
		"og_asset_sum": 1550892,
		"og_weight_total": 0.00497165472204617,
		"ut_count_sum": 27,
		"ut_asset_sum": 1051142,
		"ut_weight_total": 0.0033696189598250914,
		"cl_count_sum": 39,
		"cl_asset_sum": 41175700,
		"cl_weight_total": 0.1319958858118789,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 285090,
		"fossil_bank_weight_total": 0.0009139057037550923,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 155066,
		"fossil_insure_weight_total": 0.0004970911005594274,
		"name": "DoubleLine",
		"fund_family_name": "DoubleLine",
		"label": "DoubleLine"
	},
	{
		"fund_family_label": "Haverford",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 311552294,
		"long_asset_sum": 311552294,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 311552294,
		"equity_fund_long_assets": 311552294,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 10562017,
		"ff_all_weight_total": 0.033901265384359516,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 3661272,
		"c2_weight_total": 0.011751709329413572,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 10562017,
		"og_weight_total": 0.033901265384359516,
		"ut_count_sum": 1,
		"ut_asset_sum": 6900745,
		"ut_weight_total": 0.022149556054945948,
		"cl_count_sum": 3,
		"cl_asset_sum": 53644877,
		"cl_weight_total": 0.1721857872116968,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Haverford",
		"fund_family_name": "Haverford",
		"label": "Haverford"
	},
	{
		"fund_family_label": "Cromwell",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 387941377,
		"long_asset_sum": 399922970,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 309799471,
		"equity_fund_long_assets": 309861317,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 11319267,
		"ff_all_weight_total": 0.036530106789677136,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 3092203,
		"c2_weight_total": 0.009979312777528794,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 6346515,
		"og_weight_total": 0.020481791859162594,
		"ut_count_sum": 5,
		"ut_asset_sum": 7906579,
		"ut_weight_total": 0.025516508728967935,
		"cl_count_sum": 17,
		"cl_asset_sum": 39946204,
		"cl_weight_total": 0.12891639520140555,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 1198037,
		"fossil_insure_weight_total": 0.0038663651584492555,
		"name": "Cromwell",
		"fund_family_name": "Cromwell",
		"label": "Cromwell"
	},
	{
		"fund_family_label": "Jackson Square",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 306560764,
		"long_asset_sum": 306824236,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 306560764,
		"equity_fund_long_assets": 306824236,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 3514488,
		"ff_all_weight_total": 0.011454401535607506,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 3514488,
		"og_weight_total": 0.011454401535607506,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 5,
		"cl_asset_sum": 45905255,
		"cl_weight_total": 0.14961417519833733,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Jackson Square",
		"fund_family_name": "Jackson Square",
		"label": "Jackson Square"
	},
	{
		"fund_family_label": "Ashmore",
		"as_of": "202506",
		"fund_id": 11,
		"net_asset_sum": 466558707,
		"long_asset_sum": 553895979,
		"num_equity_funds": 6,
		"equity_fund_net_assets": 305264315,
		"equity_fund_long_assets": 305264315,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 12318470,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 12318470,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 1,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 15,
		"ff_all_asset_sum": 7522010,
		"ff_all_weight_total": 0.024640973839343126,
		"grade_fossil_fam": 3,
		"c2_count_sum": 4,
		"c2_asset_sum": 2605581,
		"c2_weight_total": 0.008535491611589124,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 337828,
		"co_weight_total": 0.0011066737361686053,
		"og_count_sum": 15,
		"og_asset_sum": 7522010,
		"og_weight_total": 0.024640973839343126,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 9,
		"cl_asset_sum": 24205128,
		"cl_weight_total": 0.07929236013059698,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 300457,
		"fossil_bank_weight_total": 0.0009842519588311525,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Ashmore",
		"fund_family_name": "Ashmore",
		"label": "Ashmore"
	},
	{
		"fund_family_label": "North Star",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 336197653,
		"long_asset_sum": 336276803,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 302688283,
		"equity_fund_long_assets": 302767433,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 17,
		"ff_all_asset_sum": 32489194,
		"ff_all_weight_total": 0.10730742629112293,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 2397801,
		"c2_weight_total": 0.007919613335691888,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 3,
		"co_asset_sum": 5041168,
		"co_weight_total": 0.016650298052366813,
		"og_count_sum": 11,
		"og_asset_sum": 21526816,
		"og_weight_total": 0.07110017014280397,
		"ut_count_sum": 6,
		"ut_asset_sum": 10962378,
		"ut_weight_total": 0.03620725614831896,
		"cl_count_sum": 5,
		"cl_asset_sum": 17947625,
		"cl_weight_total": 0.059278584959301085,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 4307040,
		"fossil_bank_weight_total": 0.01422557227282764,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "North Star",
		"fund_family_name": "North Star",
		"label": "North Star"
	},
	{
		"fund_family_label": "Running Oak Capital LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 302444157,
		"long_asset_sum": 303269142,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 302444157,
		"equity_fund_long_assets": 303269142,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 10591512,
		"cl_weight_total": 0.03492446323470655,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Running Oak Capital LLC",
		"fund_family_name": "Running Oak Capital LLC",
		"label": "Running Oak Capital LLC"
	},
	{
		"fund_family_label": "GoodHaven",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 300598722,
		"long_asset_sum": 300859609,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 300598722,
		"equity_fund_long_assets": 300859609,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 101466213,
		"ff_all_weight_total": 0.3372543537407841,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 11922211,
		"c2_weight_total": 0.03962715713028797,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 44086614,
		"mc50_weight_total": 0.1465355025439789,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 7,
		"og_asset_sum": 57379599,
		"og_weight_total": 0.1907188511968052,
		"ut_count_sum": 1,
		"ut_asset_sum": 44086614,
		"ut_weight_total": 0.1465355025439789,
		"cl_count_sum": 1,
		"cl_asset_sum": 18289764,
		"cl_weight_total": 0.06079168972130121,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 16572950,
		"fossil_bank_weight_total": 0.05508532718993197,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 55077594,
		"fossil_insure_weight_total": 0.1830674253119833,
		"name": "GoodHaven",
		"fund_family_name": "GoodHaven",
		"label": "GoodHaven"
	},
	{
		"fund_family_label": "Prospector Funds",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 295159847,
		"long_asset_sum": 295360495,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 295159847,
		"equity_fund_long_assets": 295360495,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 14953819,
		"ff_all_weight_total": 0.05062904231657656,
		"grade_fossil_fam": 3,
		"c2_count_sum": 8,
		"c2_asset_sum": 13176440,
		"c2_weight_total": 0.04461138243961841,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 9,
		"og_asset_sum": 14953819,
		"og_weight_total": 0.05062904231657656,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 8,
		"cl_asset_sum": 10961877,
		"cl_weight_total": 0.03711355169553057,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 5221622,
		"fossil_bank_weight_total": 0.017678809754161605,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 7007232,
		"fossil_insure_weight_total": 0.023724337271306375,
		"name": "Prospector Funds",
		"fund_family_name": "Prospector Funds",
		"label": "Prospector Funds"
	},
	{
		"fund_family_label": "Brookstone Asset Management",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 559589806,
		"long_asset_sum": 559589806,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 294097375,
		"equity_fund_long_assets": 294097375,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 13,
		"ff_all_asset_sum": 40497444,
		"ff_all_weight_total": 0.13770080062768325,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 5855152,
		"c2_weight_total": 0.019908889020175714,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 9637195,
		"mc50_weight_total": 0.032768721584135185,
		"co_count_sum": 2,
		"co_asset_sum": 6524280,
		"co_weight_total": 0.02218408103778553,
		"og_count_sum": 9,
		"og_asset_sum": 27632749,
		"og_weight_total": 0.09395782264292567,
		"ut_count_sum": 7,
		"ut_asset_sum": 22175651,
		"ut_weight_total": 0.07540241051114448,
		"cl_count_sum": 12,
		"cl_asset_sum": 38925083,
		"cl_weight_total": 0.13235440472734583,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 5726016,
		"fossil_bank_weight_total": 0.019469796355713817,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 3310009,
		"fossil_insure_weight_total": 0.011254806337526815,
		"name": "Brookstone Asset Management",
		"fund_family_name": "Brookstone Asset Management",
		"label": "Brookstone Asset Management"
	},
	{
		"fund_family_label": "Auxier Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 290306097,
		"long_asset_sum": 290306097,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 290306097,
		"equity_fund_long_assets": 290306097,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 19968352,
		"ff_all_weight_total": 0.06878378444804072,
		"grade_fossil_fam": 4,
		"c2_count_sum": 5,
		"c2_asset_sum": 7296130,
		"c2_weight_total": 0.025132541394747215,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 8811536,
		"mc50_weight_total": 0.030352569550063567,
		"co_count_sum": 1,
		"co_asset_sum": 133272,
		"co_weight_total": 0.0004590740648481799,
		"og_count_sum": 8,
		"og_asset_sum": 11156816,
		"og_weight_total": 0.03843121489797715,
		"ut_count_sum": 1,
		"ut_asset_sum": 8811536,
		"ut_weight_total": 0.030352569550063567,
		"cl_count_sum": 7,
		"cl_asset_sum": 28609708,
		"cl_weight_total": 0.0985501451593695,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 10786871,
		"fossil_bank_weight_total": 0.03715688754549306,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 16185125,
		"fossil_insure_weight_total": 0.05575192931617967,
		"name": "Auxier Funds",
		"fund_family_name": "Auxier Funds",
		"label": "Auxier Funds"
	},
	{
		"fund_family_label": "Redwheel",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 285364835,
		"long_asset_sum": 285409221,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 285364835,
		"equity_fund_long_assets": 285409221,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 285409221,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 285409221,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 14,
		"ff_all_asset_sum": 151665826,
		"ff_all_weight_total": 0.531397778490135,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 12245659,
		"co_weight_total": 0.04290561796530043,
		"og_count_sum": 6,
		"og_asset_sum": 75223786,
		"og_weight_total": 0.2635646659783287,
		"ut_count_sum": 13,
		"ut_asset_sum": 140317289,
		"ut_weight_total": 0.49163544369156875,
		"cl_count_sum": 4,
		"cl_asset_sum": 24214041,
		"cl_weight_total": 0.08483972912704177,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Redwheel",
		"fund_family_name": "Redwheel",
		"label": "Redwheel"
	},
	{
		"fund_family_label": "Easterly Funds",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 1226014979,
		"long_asset_sum": 1343795058,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 281051304,
		"equity_fund_long_assets": 281207068,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 1867129,
		"ff_all_weight_total": 0.006639694419060619,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 781581,
		"c2_weight_total": 0.002779378930831141,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 1867129,
		"og_weight_total": 0.006639694419060619,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 20813609,
		"cl_weight_total": 0.07401524132387739,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Easterly Funds",
		"fund_family_name": "Easterly Funds",
		"label": "Easterly Funds"
	},
	{
		"fund_family_label": "Paradigm Funds",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 279146775,
		"long_asset_sum": 279146775,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 279146775,
		"equity_fund_long_assets": 279146775,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 2836200,
		"cl_weight_total": 0.010160246343523045,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Paradigm Funds",
		"fund_family_name": "Paradigm Funds",
		"label": "Paradigm Funds"
	},
	{
		"fund_family_label": "SouthernSun Asset Management",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 278541174,
		"long_asset_sum": 278541174,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 278541174,
		"equity_fund_long_assets": 278541174,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 17719172,
		"cl_weight_total": 0.06361419299539536,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "SouthernSun Asset Management",
		"fund_family_name": "SouthernSun Asset Management",
		"label": "SouthernSun Asset Management"
	},
	{
		"fund_family_label": "Payson Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 274665011,
		"long_asset_sum": 274665011,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 274665011,
		"equity_fund_long_assets": 274665011,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 13535013,
		"ff_all_weight_total": 0.04927825699648362,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 10522144,
		"c2_weight_total": 0.03830900762237968,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 13535013,
		"og_weight_total": 0.04927825699648362,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 6,
		"cl_asset_sum": 78680902,
		"cl_weight_total": 0.2864613214240091,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Payson Funds",
		"fund_family_name": "Payson Funds",
		"label": "Payson Funds"
	},
	{
		"fund_family_label": "VELA Funds",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 305155699,
		"long_asset_sum": 311560304,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 273904627,
		"equity_fund_long_assets": 280309232,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 21,
		"ff_all_asset_sum": 22554405,
		"ff_all_weight_total": 0.08046258355129737,
		"grade_fossil_fam": 4,
		"c2_count_sum": 7,
		"c2_asset_sum": 10077384,
		"c2_weight_total": 0.035950952910462824,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 2109537,
		"mc50_weight_total": 0.007525749276784434,
		"co_count_sum": 4,
		"co_asset_sum": 3953993,
		"co_weight_total": 0.01410582509819013,
		"og_count_sum": 17,
		"og_asset_sum": 17925970,
		"og_weight_total": 0.06395069428180661,
		"ut_count_sum": 2,
		"ut_asset_sum": 3066171,
		"ut_weight_total": 0.010938530201531143,
		"cl_count_sum": 9,
		"cl_asset_sum": 10759386,
		"cl_weight_total": 0.038383987295859026,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 4312453,
		"fossil_bank_weight_total": 0.015384627075001225,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 6442670,
		"fossil_insure_weight_total": 0.022984152016798362,
		"name": "VELA Funds",
		"fund_family_name": "VELA Funds",
		"label": "VELA Funds"
	},
	{
		"fund_family_label": "Matthew 25",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 273490039,
		"long_asset_sum": 273490039,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 273490039,
		"equity_fund_long_assets": 273490039,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 25134507,
		"ff_all_weight_total": 0.09190282429262442,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 13573507,
		"mc50_weight_total": 0.04963071799481516,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 11561000,
		"og_weight_total": 0.04227210629780926,
		"ut_count_sum": 1,
		"ut_asset_sum": 13573507,
		"ut_weight_total": 0.04963071799481516,
		"cl_count_sum": 3,
		"cl_asset_sum": 29938995,
		"cl_weight_total": 0.10947014783233111,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 13110960,
		"fossil_bank_weight_total": 0.047939442503790786,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 13573507,
		"fossil_insure_weight_total": 0.04963071799481516,
		"name": "Matthew 25",
		"fund_family_name": "Matthew 25",
		"label": "Matthew 25"
	},
	{
		"fund_family_label": "Subversive Capital",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 270516822,
		"long_asset_sum": 270516822,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 270516822,
		"equity_fund_long_assets": 270516822,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 23,
		"ff_all_asset_sum": 10487325,
		"ff_all_weight_total": 0.03876773696535589,
		"grade_fossil_fam": 3,
		"c2_count_sum": 8,
		"c2_asset_sum": 4144536,
		"c2_weight_total": 0.015320806925641023,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 4,
		"co_asset_sum": 2918245,
		"co_weight_total": 0.010787665544880606,
		"og_count_sum": 20,
		"og_asset_sum": 8552655,
		"og_weight_total": 0.031615982092233805,
		"ut_count_sum": 5,
		"ut_asset_sum": 2628506,
		"ut_weight_total": 0.009716608307634192,
		"cl_count_sum": 33,
		"cl_asset_sum": 44213963,
		"cl_weight_total": 0.1634425640265728,
		"fossil_bank_count_sum": 7,
		"fossil_bank_asset_sum": 3515879,
		"fossil_bank_weight_total": 0.012996895993403323,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 185156,
		"fossil_insure_weight_total": 0.0006844528138068988,
		"name": "Subversive Capital",
		"fund_family_name": "Subversive Capital",
		"label": "Subversive Capital"
	},
	{
		"fund_family_label": "Adasina",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 263094193,
		"long_asset_sum": 263316287,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 263094193,
		"equity_fund_long_assets": 263316287,
		"num_e_sri": 1,
		"num_e_usf": 1,
		"sri_long_assets": 263316287,
		"usf_long_assets": 263316287,
		"equity_fund_sri_long_assets": 263316287,
		"equity_fund_usf_long_assets": 263316287,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 1749956,
		"ff_all_weight_total": 0.006645832735747182,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 1749956,
		"og_weight_total": 0.006645832735747182,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 23,
		"cl_asset_sum": 25656357,
		"cl_weight_total": 0.09743551108177369,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Adasina",
		"fund_family_name": "Adasina",
		"label": "Adasina"
	},
	{
		"fund_family_label": "Polar Capital LLP",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 261667312,
		"long_asset_sum": 261667312,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 261667312,
		"equity_fund_long_assets": 261667312,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 5377692,
		"ff_all_weight_total": 0.020551638486659734,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 5377692,
		"og_weight_total": 0.020551638486659734,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 14955302,
		"cl_weight_total": 0.05715387942686551,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 2503629,
		"fossil_insure_weight_total": 0.009567985320229835,
		"name": "Polar Capital LLP",
		"fund_family_name": "Polar Capital LLP",
		"label": "Polar Capital LLP"
	},
	{
		"fund_family_label": "Ancora",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 292345459,
		"long_asset_sum": 292345459,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 250555374,
		"equity_fund_long_assets": 250555374,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 15,
		"ff_all_asset_sum": 24634397,
		"ff_all_weight_total": 0.09831917235189695,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 2669753,
		"c2_weight_total": 0.01065534120214081,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 4372657,
		"co_weight_total": 0.017451858765559745,
		"og_count_sum": 11,
		"og_asset_sum": 10406997,
		"og_weight_total": 0.04153571657177866,
		"ut_count_sum": 4,
		"ut_asset_sum": 14227400,
		"ut_weight_total": 0.05678345578011829,
		"cl_count_sum": 4,
		"cl_asset_sum": 8980383,
		"cl_weight_total": 0.035841909341764906,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 1420906,
		"fossil_bank_weight_total": 0.0056710258387832465,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Ancora",
		"fund_family_name": "Ancora",
		"label": "Ancora"
	},
	{
		"fund_family_label": "Innovator ETFs",
		"as_of": "202506",
		"fund_id": 156,
		"net_asset_sum": 25491755785,
		"long_asset_sum": 26223021243,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 248954561,
		"equity_fund_long_assets": 248954561,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 25,
		"ff_all_asset_sum": 18199904,
		"ff_all_weight_total": 0.07310532462990305,
		"grade_fossil_fam": 4,
		"c2_count_sum": 3,
		"c2_asset_sum": 1044083,
		"c2_weight_total": 0.004193869739948247,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 4185242,
		"mc50_weight_total": 0.016811268623433656,
		"co_count_sum": 6,
		"co_asset_sum": 4532345,
		"co_weight_total": 0.018205511004877713,
		"og_count_sum": 14,
		"og_asset_sum": 9627088,
		"og_weight_total": 0.03867006075859763,
		"ut_count_sum": 21,
		"ut_asset_sum": 15708317,
		"ut_weight_total": 0.06309712478013206,
		"cl_count_sum": 14,
		"cl_asset_sum": 6096943,
		"cl_weight_total": 0.024490183973773432,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 366488,
		"fossil_bank_weight_total": 0.0014721079964467893,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 1485450,
		"fossil_insure_weight_total": 0.005966751498880954,
		"name": "Innovator ETFs",
		"fund_family_name": "Innovator ETFs",
		"label": "Innovator ETFs"
	},
	{
		"fund_family_label": "New Alternatives",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 246088843,
		"long_asset_sum": 246105648,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 246088843,
		"equity_fund_long_assets": 246105648,
		"num_e_sri": 1,
		"num_e_usf": 1,
		"sri_long_assets": 246105648,
		"usf_long_assets": 246105648,
		"equity_fund_sri_long_assets": 246105648,
		"equity_fund_usf_long_assets": 246105648,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 56656787,
		"ff_all_weight_total": 0.23021327409763467,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 46048946,
		"og_weight_total": 0.1871104802925937,
		"ut_count_sum": 2,
		"ut_asset_sum": 21956950,
		"ut_weight_total": 0.08921757862298227,
		"cl_count_sum": 16,
		"cl_asset_sum": 72113626,
		"cl_weight_total": 0.2930189802064193,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "New Alternatives",
		"fund_family_name": "New Alternatives",
		"label": "New Alternatives"
	},
	{
		"fund_family_label": "AXS",
		"as_of": "202506",
		"fund_id": 20,
		"net_asset_sum": 1174269498,
		"long_asset_sum": 2283137170,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 245564430,
		"equity_fund_long_assets": 254205880,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 42786473,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 42786473,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 3,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 38,
		"ff_all_asset_sum": 21133491,
		"ff_all_weight_total": 0.0831353350284423,
		"grade_fossil_fam": 4,
		"c2_count_sum": 14,
		"c2_asset_sum": 6425613,
		"c2_weight_total": 0.025277200511648275,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 5002197,
		"mc50_weight_total": 0.019677739161659047,
		"co_count_sum": 3,
		"co_asset_sum": 2499719,
		"co_weight_total": 0.009833442877088445,
		"og_count_sum": 32,
		"og_asset_sum": 13420795,
		"og_weight_total": 0.05279498255508488,
		"ut_count_sum": 12,
		"ut_asset_sum": 10561679,
		"ut_weight_total": 0.04154773681867626,
		"cl_count_sum": 34,
		"cl_asset_sum": 30792024,
		"cl_weight_total": 0.12113025867064917,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 912265,
		"fossil_bank_weight_total": 0.003588685674776681,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 3267911,
		"fossil_insure_weight_total": 0.012855371402109189,
		"name": "AXS",
		"fund_family_name": "AXS",
		"label": "AXS"
	},
	{
		"fund_family_label": "STFM",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 244407635,
		"long_asset_sum": 244407635,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 244407635,
		"equity_fund_long_assets": 244407635,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 14,
		"ff_all_asset_sum": 5778428,
		"ff_all_weight_total": 0.023642583833356923,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 610050,
		"c2_weight_total": 0.002496034954063526,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 856587,
		"mc50_weight_total": 0.003504747304641281,
		"co_count_sum": 4,
		"co_asset_sum": 1815186,
		"co_weight_total": 0.007426879278955422,
		"og_count_sum": 8,
		"og_asset_sum": 2643135,
		"og_weight_total": 0.010814453484646665,
		"ut_count_sum": 8,
		"ut_asset_sum": 3649250,
		"ut_weight_total": 0.014930998370816035,
		"cl_count_sum": 30,
		"cl_asset_sum": 88121414,
		"cl_weight_total": 0.36055098687894915,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "STFM",
		"fund_family_name": "STFM",
		"label": "STFM"
	},
	{
		"fund_family_label": "Simplify Asset Management",
		"as_of": "202506",
		"fund_id": 39,
		"net_asset_sum": 18823614722,
		"long_asset_sum": 19821435026,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 241769480,
		"equity_fund_long_assets": 260021859,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 53,
		"ff_all_asset_sum": 24068214,
		"ff_all_weight_total": 0.09256227185115233,
		"grade_fossil_fam": 5,
		"c2_count_sum": 9,
		"c2_asset_sum": 67312,
		"c2_weight_total": 0.0002588705436491784,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 55304,
		"mc50_weight_total": 0.0002126898108208664,
		"co_count_sum": 1,
		"co_asset_sum": 3241,
		"co_weight_total": 0.00001246433670024642,
		"og_count_sum": 41,
		"og_asset_sum": 23963761,
		"og_weight_total": 0.09216056331633257,
		"ut_count_sum": 20,
		"ut_asset_sum": 141194,
		"ut_weight_total": 0.0005430081937842003,
		"cl_count_sum": 21,
		"cl_asset_sum": 40344008,
		"cl_weight_total": 0.15515621707788804,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 21403,
		"fossil_bank_weight_total": 0.0000823123105200167,
		"fossil_insure_count_sum": 8,
		"fossil_insure_asset_sum": 83366,
		"fossil_insure_weight_total": 0.00032061150674259276,
		"name": "Simplify Asset Management",
		"fund_family_name": "Simplify Asset Management",
		"label": "Simplify Asset Management"
	},
	{
		"fund_family_label": "Guinness Atkinson",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 241338408,
		"long_asset_sum": 243311025,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 241338408,
		"equity_fund_long_assets": 243311025,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 14357857,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 14357857,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 29,
		"ff_all_asset_sum": 9580627,
		"ff_all_weight_total": 0.0393760496467433,
		"grade_fossil_fam": 3,
		"c2_count_sum": 18,
		"c2_asset_sum": 5932585,
		"c2_weight_total": 0.0243827216625305,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 28,
		"og_asset_sum": 9199037,
		"og_weight_total": 0.03780772778381086,
		"ut_count_sum": 2,
		"ut_asset_sum": 1055874,
		"ut_weight_total": 0.004339606065939676,
		"cl_count_sum": 18,
		"cl_asset_sum": 41200430,
		"cl_weight_total": 0.16933235968242705,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 1695660,
		"fossil_bank_weight_total": 0.006969104667575174,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 1099560,
		"fossil_insure_weight_total": 0.004519154033402309,
		"name": "Guinness Atkinson",
		"fund_family_name": "Guinness Atkinson",
		"label": "Guinness Atkinson"
	},
	{
		"fund_family_label": "Oaktree Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 235555081,
		"long_asset_sum": 235555081,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 235555081,
		"equity_fund_long_assets": 235555081,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 22581780,
		"ff_all_weight_total": 0.09586624030410959,
		"grade_fossil_fam": 5,
		"c2_count_sum": 4,
		"c2_asset_sum": 10221807,
		"c2_weight_total": 0.04339455110289045,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 4295271,
		"mc50_weight_total": 0.018234677773730553,
		"co_count_sum": 2,
		"co_asset_sum": 6647208,
		"co_weight_total": 0.028219336096596447,
		"og_count_sum": 7,
		"og_asset_sum": 18286509,
		"og_weight_total": 0.07763156253037905,
		"ut_count_sum": 2,
		"ut_asset_sum": 6049770,
		"ut_weight_total": 0.025683037590685638,
		"cl_count_sum": 1,
		"cl_asset_sum": 12379859,
		"cl_weight_total": 0.052556111069410556,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 8005816,
		"fossil_bank_weight_total": 0.033987023188007566,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 7820900,
		"fossil_insure_weight_total": 0.03320200085176681,
		"name": "Oaktree Funds",
		"fund_family_name": "Oaktree Funds",
		"label": "Oaktree Funds"
	},
	{
		"fund_family_label": "Muhlenkamp",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 234897091,
		"long_asset_sum": 235147347,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 234897091,
		"equity_fund_long_assets": 235147347,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 44456288,
		"ff_all_weight_total": 0.18905715317298477,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 15384901,
		"c2_weight_total": 0.06542664076920247,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 13420483,
		"mc50_weight_total": 0.05707265325855452,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 31035805,
		"og_weight_total": 0.13198449991443026,
		"ut_count_sum": 1,
		"ut_asset_sum": 13420483,
		"ut_weight_total": 0.05707265325855452,
		"cl_count_sum": 3,
		"cl_asset_sum": 25221986,
		"cl_weight_total": 0.10726034684967124,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 13420483,
		"fossil_insure_weight_total": 0.05707265325855452,
		"name": "Muhlenkamp",
		"fund_family_name": "Muhlenkamp",
		"label": "Muhlenkamp"
	},
	{
		"fund_family_label": "Monarch Funds",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 784067491,
		"long_asset_sum": 784067491,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 234522127,
		"equity_fund_long_assets": 234522127,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 14056219,
		"ff_all_weight_total": 0.05993557699568365,
		"grade_fossil_fam": 4,
		"c2_count_sum": 4,
		"c2_asset_sum": 7332583,
		"c2_weight_total": 0.03126606045151552,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 2000749,
		"co_weight_total": 0.008531173691768538,
		"og_count_sum": 6,
		"og_asset_sum": 10575239,
		"og_weight_total": 0.04509271314940786,
		"ut_count_sum": 2,
		"ut_asset_sum": 3480980,
		"ut_weight_total": 0.014842863846275794,
		"cl_count_sum": 4,
		"cl_asset_sum": 15616920,
		"cl_weight_total": 0.06659039042401317,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 1484840,
		"fossil_insure_weight_total": 0.006331342884332616,
		"name": "Monarch Funds",
		"fund_family_name": "Monarch Funds",
		"label": "Monarch Funds"
	},
	{
		"fund_family_label": "Astoria Capital Partners L P",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 233532426,
		"long_asset_sum": 233827179,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 233532426,
		"equity_fund_long_assets": 233827179,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 16,
		"ff_all_asset_sum": 15194198,
		"ff_all_weight_total": 0.06498046148861078,
		"grade_fossil_fam": 4,
		"c2_count_sum": 5,
		"c2_asset_sum": 4993194,
		"c2_weight_total": 0.02135420707444792,
		"mc50_count_sum": 4,
		"mc50_asset_sum": 5418472,
		"mc50_weight_total": 0.023172977680237933,
		"co_count_sum": 4,
		"co_asset_sum": 3765636,
		"co_weight_total": 0.016104355430811575,
		"og_count_sum": 11,
		"og_asset_sum": 9837850,
		"og_weight_total": 0.04207316720867594,
		"ut_count_sum": 10,
		"ut_asset_sum": 9908558,
		"ut_weight_total": 0.04237556148252552,
		"cl_count_sum": 26,
		"cl_asset_sum": 38864143,
		"cl_weight_total": 0.16620883494471786,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 6101215,
		"fossil_insure_weight_total": 0.026092839275968,
		"name": "Astoria Capital Partners L P",
		"fund_family_name": "Astoria Capital Partners L P",
		"label": "Astoria Capital Partners L P"
	},
	{
		"fund_family_label": "Frost Funds",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 4697948778,
		"long_asset_sum": 4709130633,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 227257566,
		"equity_fund_long_assets": 227257566,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 982508,
		"ff_all_weight_total": 0.0043233236071885065,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 982508,
		"c2_weight_total": 0.0043233236071885065,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 982508,
		"og_weight_total": 0.0043233236071885065,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 10,
		"cl_asset_sum": 72976616,
		"cl_weight_total": 0.32111853208882823,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Frost Funds",
		"fund_family_name": "Frost Funds",
		"label": "Frost Funds"
	},
	{
		"fund_family_label": "Miller Value Funds",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 232683056,
		"long_asset_sum": 232687841,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 226029910,
		"equity_fund_long_assets": 226029910,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 27302035,
		"ff_all_weight_total": 0.12078947870217707,
		"grade_fossil_fam": 5,
		"c2_count_sum": 5,
		"c2_asset_sum": 11325371,
		"c2_weight_total": 0.05010562982571643,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 4829339,
		"co_weight_total": 0.021365928960463684,
		"og_count_sum": 6,
		"og_asset_sum": 12816256,
		"og_weight_total": 0.056701593165258524,
		"ut_count_sum": 1,
		"ut_asset_sum": 9656440,
		"ut_weight_total": 0.04272195657645486,
		"cl_count_sum": 2,
		"cl_asset_sum": 5617518,
		"cl_weight_total": 0.0248529851646625,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Miller Value Funds",
		"fund_family_name": "Miller Value Funds",
		"label": "Miller Value Funds"
	},
	{
		"fund_family_label": "Strategas Asset Management, LLC",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 223225114,
		"long_asset_sum": 223240767,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 223225114,
		"equity_fund_long_assets": 223240767,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 12,
		"ff_all_asset_sum": 35209873,
		"ff_all_weight_total": 0.1577215195645695,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 4970199,
		"c2_weight_total": 0.02226385022230281,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 6152344,
		"mc50_weight_total": 0.027559231598590594,
		"co_count_sum": 1,
		"co_asset_sum": 90422,
		"co_weight_total": 0.0004050425073122957,
		"og_count_sum": 8,
		"og_asset_sum": 21839508,
		"og_weight_total": 0.09782938973686647,
		"ut_count_sum": 5,
		"ut_asset_sum": 19211208,
		"ut_weight_total": 0.08605600248632007,
		"cl_count_sum": 8,
		"cl_asset_sum": 13942823,
		"cl_weight_total": 0.06245643744809388,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 1592827,
		"fossil_bank_weight_total": 0.007135018488804959,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 6776874,
		"fossil_insure_weight_total": 0.03035679410651729,
		"name": "Strategas Asset Management, LLC",
		"fund_family_name": "Strategas Asset Management, LLC",
		"label": "Strategas Asset Management, LLC"
	},
	{
		"fund_family_label": "Bahl & Gaynor Investment Counsel",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 216656217,
		"long_asset_sum": 216835497,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 216656217,
		"equity_fund_long_assets": 216835497,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 10,
		"ff_all_asset_sum": 38644783,
		"ff_all_weight_total": 0.1782216635867512,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 8598706,
		"c2_weight_total": 0.0396554351984168,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 3581404,
		"mc50_weight_total": 0.016516686841177117,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 10,
		"og_asset_sum": 38644783,
		"og_weight_total": 0.1782216635867512,
		"ut_count_sum": 4,
		"ut_asset_sum": 15659793,
		"ut_weight_total": 0.07221969288543195,
		"cl_count_sum": 6,
		"cl_asset_sum": 38496923,
		"cl_weight_total": 0.17753976416508963,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 4153016,
		"fossil_bank_weight_total": 0.019152841935285162,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 10723970,
		"fossil_insure_weight_total": 0.04945670864950678,
		"name": "Bahl & Gaynor Investment Counsel",
		"fund_family_name": "Bahl & Gaynor Investment Counsel",
		"label": "Bahl & Gaynor Investment Counsel"
	},
	{
		"fund_family_label": "Thompson IM",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 1919763490,
		"long_asset_sum": 1919763490,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 216429562,
		"equity_fund_long_assets": 216429562,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 10,
		"ff_all_asset_sum": 12836569,
		"ff_all_weight_total": 0.05931060840940019,
		"grade_fossil_fam": 4,
		"c2_count_sum": 3,
		"c2_asset_sum": 5096122,
		"c2_weight_total": 0.023546330514682648,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 1621620,
		"co_weight_total": 0.007492599370505587,
		"og_count_sum": 8,
		"og_asset_sum": 11214949,
		"og_weight_total": 0.0518180090388946,
		"ut_count_sum": 5,
		"ut_asset_sum": 5354713,
		"ut_weight_total": 0.0247411349471751,
		"cl_count_sum": 10,
		"cl_asset_sum": 31432583,
		"cl_weight_total": 0.1452323920518769,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 8996454,
		"fossil_bank_weight_total": 0.041567584006846535,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Thompson IM",
		"fund_family_name": "Thompson IM",
		"label": "Thompson IM"
	},
	{
		"fund_family_label": "Bridges",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 253034342,
		"long_asset_sum": 253718911,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 215362067,
		"equity_fund_long_assets": 216034536,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 9108525,
		"ff_all_weight_total": 0.04216235592997964,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 2051840,
		"c2_weight_total": 0.00949774067605561,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 7056685,
		"mc50_weight_total": 0.03266461525392403,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 2051840,
		"og_weight_total": 0.00949774067605561,
		"ut_count_sum": 1,
		"ut_asset_sum": 7056685,
		"ut_weight_total": 0.03266461525392403,
		"cl_count_sum": 4,
		"cl_asset_sum": 48892167,
		"cl_weight_total": 0.22631643951594851,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 7056685,
		"fossil_insure_weight_total": 0.03266461525392403,
		"name": "Bridges",
		"fund_family_name": "Bridges",
		"label": "Bridges"
	},
	{
		"fund_family_label": "O'Shaughnessy Mutual Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 214391955,
		"long_asset_sum": 214391955,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 214391955,
		"equity_fund_long_assets": 214391955,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 20448557,
		"ff_all_weight_total": 0.09537931122462127,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 11307241,
		"c2_weight_total": 0.05274097621806751,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 20448557,
		"og_weight_total": 0.09537931122462127,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 5971135,
		"cl_weight_total": 0.02785148817734322,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 12142379,
		"fossil_bank_weight_total": 0.05663635559459309,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 6428000,
		"fossil_insure_weight_total": 0.0299824683253623,
		"name": "O'Shaughnessy Mutual Funds",
		"fund_family_name": "O'Shaughnessy Mutual Funds",
		"label": "O'Shaughnessy Mutual Funds"
	},
	{
		"fund_family_label": "Berkshire",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 208626562,
		"long_asset_sum": 212061261,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 208626562,
		"equity_fund_long_assets": 212061261,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 3190,
		"ff_all_weight_total": 0.000015042822932190336,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 1174,
		"co_weight_total": 0.000005536136088523967,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 2,
		"ut_asset_sum": 3190,
		"ut_weight_total": 0.000015042822932190336,
		"cl_count_sum": 8,
		"cl_asset_sum": 25044123,
		"cl_weight_total": 0.11809852908495154,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Berkshire",
		"fund_family_name": "Berkshire",
		"label": "Berkshire"
	},
	{
		"fund_family_label": "Paralel Advisors LLC",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 208463733,
		"long_asset_sum": 208867418,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 208463733,
		"equity_fund_long_assets": 208867418,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 3652968,
		"ff_all_weight_total": 0.01748941043547539,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 3652968,
		"co_weight_total": 0.01748941043547539,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 3652968,
		"ut_weight_total": 0.01748941043547539,
		"cl_count_sum": 4,
		"cl_asset_sum": 11153613,
		"cl_weight_total": 0.05340044467825997,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Paralel Advisors LLC",
		"fund_family_name": "Paralel Advisors LLC",
		"label": "Paralel Advisors LLC"
	},
	{
		"fund_family_label": "Eagle MLP",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 207095660,
		"long_asset_sum": 207466926,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 207095660,
		"equity_fund_long_assets": 207466926,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 18,
		"ff_all_asset_sum": 198392497,
		"ff_all_weight_total": 0.95626084034233,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 17,
		"og_asset_sum": 194544557,
		"og_weight_total": 0.9377135948888548,
		"ut_count_sum": 2,
		"ut_asset_sum": 6438412,
		"ut_weight_total": 0.031033438071955622,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Eagle MLP",
		"fund_family_name": "Eagle MLP",
		"label": "Eagle MLP"
	},
	{
		"fund_family_label": "Riverbridge",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 201479358,
		"long_asset_sum": 201531558,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 201479358,
		"equity_fund_long_assets": 201531558,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 5,
		"cl_asset_sum": 30597948,
		"cl_weight_total": 0.15182708010424847,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Riverbridge",
		"fund_family_name": "Riverbridge",
		"label": "Riverbridge"
	},
	{
		"fund_family_label": "Coho",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 200109597,
		"long_asset_sum": 200357081,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 200109597,
		"equity_fund_long_assets": 200357081,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 34820927,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 34820927,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 4497327,
		"ff_all_weight_total": 0.02244655880168268,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 4497327,
		"c2_weight_total": 0.02244655880168268,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 4497327,
		"og_weight_total": 0.02244655880168268,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 6772617,
		"cl_weight_total": 0.03380273343071913,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 6171011,
		"fossil_bank_weight_total": 0.030800064411000277,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Coho",
		"fund_family_name": "Coho",
		"label": "Coho"
	},
	{
		"fund_family_label": "Yoke ETF",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 196876722,
		"long_asset_sum": 196876722,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 196876722,
		"equity_fund_long_assets": 196876722,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 25,
		"ff_all_asset_sum": 20090444,
		"ff_all_weight_total": 0.10204580712188005,
		"grade_fossil_fam": 5,
		"c2_count_sum": 6,
		"c2_asset_sum": 4805909,
		"c2_weight_total": 0.024410752836488206,
		"mc50_count_sum": 4,
		"mc50_asset_sum": 8314716,
		"mc50_weight_total": 0.04223310869631403,
		"co_count_sum": 2,
		"co_asset_sum": 285089,
		"co_weight_total": 0.001448058445426575,
		"og_count_sum": 20,
		"og_asset_sum": 16252978,
		"og_weight_total": 0.08255408681580954,
		"ut_count_sum": 13,
		"ut_asset_sum": 10381858,
		"ut_weight_total": 0.052732785748027644,
		"cl_count_sum": 19,
		"cl_asset_sum": 22902676,
		"cl_weight_total": 0.1163300351983715,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 4285090,
		"fossil_insure_weight_total": 0.021765346133708993,
		"name": "Yoke ETF",
		"fund_family_name": "Yoke ETF",
		"label": "Yoke ETF"
	},
	{
		"fund_family_label": "Investment House Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 195350639,
		"long_asset_sum": 195350639,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 195350639,
		"equity_fund_long_assets": 195350639,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 6,
		"cl_asset_sum": 34558033,
		"cl_weight_total": 0.1769025848950512,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Investment House Funds",
		"fund_family_name": "Investment House Funds",
		"label": "Investment House Funds"
	},
	{
		"fund_family_label": "Provident",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 193802942,
		"long_asset_sum": 193802942,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 193802942,
		"equity_fund_long_assets": 193802942,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 33157209,
		"cl_weight_total": 0.1710872325147675,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 10858192,
		"fossil_bank_weight_total": 0.05602697197445021,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Provident",
		"fund_family_name": "Provident",
		"label": "Provident"
	},
	{
		"fund_family_label": "SABA ETF",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 193269001,
		"long_asset_sum": 295731969,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 193269001,
		"equity_fund_long_assets": 295731969,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "SABA ETF",
		"fund_family_name": "SABA ETF",
		"label": "SABA ETF"
	},
	{
		"fund_family_label": "Cutler",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 192704033,
		"long_asset_sum": 192704033,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 192704033,
		"equity_fund_long_assets": 192704033,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 17073436,
		"ff_all_weight_total": 0.08859926662769949,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 12053857,
		"c2_weight_total": 0.06255114027634284,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 17073436,
		"og_weight_total": 0.08859926662769949,
		"ut_count_sum": 1,
		"ut_asset_sum": 5019579,
		"ut_weight_total": 0.026048126351356643,
		"cl_count_sum": 4,
		"cl_asset_sum": 27757399,
		"cl_weight_total": 0.1440416091343558,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 4030055,
		"fossil_bank_weight_total": 0.020913184520637406,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Cutler",
		"fund_family_name": "Cutler",
		"label": "Cutler"
	},
	{
		"fund_family_label": "Rayliant",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 192145406,
		"long_asset_sum": 192302897,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 192145406,
		"equity_fund_long_assets": 192302897,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 22,
		"ff_all_asset_sum": 8422181,
		"ff_all_weight_total": 0.043796433290341955,
		"grade_fossil_fam": 3,
		"c2_count_sum": 4,
		"c2_asset_sum": 897652,
		"c2_weight_total": 0.004667906797056729,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 354920,
		"mc50_weight_total": 0.001845630021891974,
		"co_count_sum": 8,
		"co_asset_sum": 2467474,
		"co_weight_total": 0.012831184753290535,
		"og_count_sum": 16,
		"og_asset_sum": 6373275,
		"og_weight_total": 0.03314185641207475,
		"ut_count_sum": 10,
		"ut_asset_sum": 3258924,
		"ut_weight_total": 0.0169468273793088,
		"cl_count_sum": 16,
		"cl_asset_sum": 27444418,
		"cl_weight_total": 0.14271453227249092,
		"fossil_bank_count_sum": 13,
		"fossil_bank_asset_sum": 7534345,
		"fossil_bank_weight_total": 0.03917957096610978,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 1146653,
		"fossil_insure_weight_total": 0.0059627442846063835,
		"name": "Rayliant",
		"fund_family_name": "Rayliant",
		"label": "Rayliant"
	},
	{
		"fund_family_label": "CornerCap",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 190500989,
		"long_asset_sum": 191410774,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 190500989,
		"equity_fund_long_assets": 191410774,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 18,
		"ff_all_asset_sum": 22202449,
		"ff_all_weight_total": 0.11599372666451889,
		"grade_fossil_fam": 5,
		"c2_count_sum": 6,
		"c2_asset_sum": 8845303,
		"c2_weight_total": 0.04621110303853638,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 3574316,
		"mc50_weight_total": 0.018673536109310128,
		"co_count_sum": 3,
		"co_asset_sum": 4212469,
		"co_weight_total": 0.022007481146280723,
		"og_count_sum": 14,
		"og_asset_sum": 17553537,
		"og_weight_total": 0.09170610741065181,
		"ut_count_sum": 9,
		"ut_asset_sum": 10213363,
		"ut_weight_total": 0.05335834961933752,
		"cl_count_sum": 10,
		"cl_asset_sum": 16014781,
		"cl_weight_total": 0.08366708239735764,
		"fossil_bank_count_sum": 6,
		"fossil_bank_asset_sum": 10841496,
		"fossil_bank_weight_total": 0.05663994650583253,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 4309894,
		"fossil_insure_weight_total": 0.022516465034512635,
		"name": "CornerCap",
		"fund_family_name": "CornerCap",
		"label": "CornerCap"
	},
	{
		"fund_family_label": "Redwheel Asset Management LLP",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 188965852,
		"long_asset_sum": 195672969,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 188965852,
		"equity_fund_long_assets": 195672969,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 10176146,
		"ff_all_weight_total": 0.05200588539135419,
		"grade_fossil_fam": 3,
		"c2_count_sum": 3,
		"c2_asset_sum": 5159147,
		"c2_weight_total": 0.02636617120068332,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 8651063,
		"og_weight_total": 0.04421184512205158,
		"ut_count_sum": 1,
		"ut_asset_sum": 1525083,
		"ut_weight_total": 0.007794040269302604,
		"cl_count_sum": 5,
		"cl_asset_sum": 21409209,
		"cl_weight_total": 0.10941321690682784,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 2019522,
		"fossil_bank_weight_total": 0.010320904365691922,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Redwheel Asset Management LLP",
		"fund_family_name": "Redwheel Asset Management LLP",
		"label": "Redwheel Asset Management LLP"
	},
	{
		"fund_family_label": "Allied Asset",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 187398452,
		"long_asset_sum": 187398452,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 187398452,
		"equity_fund_long_assets": 187398452,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 15811454,
		"ff_all_weight_total": 0.08437345042743469,
		"grade_fossil_fam": 4,
		"c2_count_sum": 4,
		"c2_asset_sum": 11480665,
		"c2_weight_total": 0.06126339293346991,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 1315434,
		"co_weight_total": 0.007019449659061218,
		"og_count_sum": 6,
		"og_asset_sum": 14496020,
		"og_weight_total": 0.07735400076837348,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 14,
		"cl_asset_sum": 56202249,
		"cl_weight_total": 0.29990775484100585,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Allied Asset",
		"fund_family_name": "Allied Asset",
		"label": "Allied Asset"
	},
	{
		"fund_family_label": "Port Street Investments",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 185344116,
		"long_asset_sum": 185344116,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 185344116,
		"equity_fund_long_assets": 185344116,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 10509934,
		"ff_all_weight_total": 0.05670497789096256,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 10509934,
		"mc50_weight_total": 0.05670497789096256,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 10509934,
		"ut_weight_total": 0.05670497789096256,
		"cl_count_sum": 4,
		"cl_asset_sum": 25023864,
		"cl_weight_total": 0.13501299388430546,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 10509934,
		"fossil_insure_weight_total": 0.05670497789096256,
		"name": "Port Street Investments",
		"fund_family_name": "Port Street Investments",
		"label": "Port Street Investments"
	},
	{
		"fund_family_label": "Tremblant Advisors LP",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 184562795,
		"long_asset_sum": 184562795,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 184562795,
		"equity_fund_long_assets": 184562795,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 6338735,
		"cl_weight_total": 0.034344597999829814,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Tremblant Advisors LP",
		"fund_family_name": "Tremblant Advisors LP",
		"label": "Tremblant Advisors LP"
	},
	{
		"fund_family_label": "Blueprint Fund Management",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 184155941,
		"long_asset_sum": 184155987,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 184155941,
		"equity_fund_long_assets": 184155987,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 14,
		"ff_all_asset_sum": 10878291,
		"ff_all_weight_total": 0.05907106891941558,
		"grade_fossil_fam": 4,
		"c2_count_sum": 4,
		"c2_asset_sum": 2364879,
		"c2_weight_total": 0.012841716625808098,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 3990064,
		"mc50_weight_total": 0.021666762319272302,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 13,
		"og_asset_sum": 7202865,
		"og_weight_total": 0.0391128473059092,
		"ut_count_sum": 3,
		"ut_asset_sum": 4324442,
		"ut_weight_total": 0.02348249476135685,
		"cl_count_sum": 27,
		"cl_asset_sum": 39782730,
		"cl_weight_total": 0.21602735076975804,
		"fossil_bank_count_sum": 13,
		"fossil_bank_asset_sum": 9563980,
		"fossil_bank_weight_total": 0.051934124737416223,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 4837367,
		"fossil_insure_weight_total": 0.026267769399210463,
		"name": "Blueprint Fund Management",
		"fund_family_name": "Blueprint Fund Management",
		"label": "Blueprint Fund Management"
	},
	{
		"fund_family_label": "Faith Investor",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 181360586,
		"long_asset_sum": 181360587,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 181360586,
		"equity_fund_long_assets": 181360587,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 21,
		"ff_all_asset_sum": 11668381,
		"ff_all_weight_total": 0.06433801959408082,
		"grade_fossil_fam": 4,
		"c2_count_sum": 7,
		"c2_asset_sum": 3750829,
		"c2_weight_total": 0.02068161038759761,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 1923490,
		"mc50_weight_total": 0.010605887595632892,
		"co_count_sum": 2,
		"co_asset_sum": 1261026,
		"co_weight_total": 0.006953142470805964,
		"og_count_sum": 19,
		"og_asset_sum": 10647124,
		"og_weight_total": 0.058706933938188016,
		"ut_count_sum": 8,
		"ut_asset_sum": 4559911,
		"ut_weight_total": 0.025142789155176256,
		"cl_count_sum": 26,
		"cl_asset_sum": 29049227,
		"cl_weight_total": 0.16017386952987753,
		"fossil_bank_count_sum": 7,
		"fossil_bank_asset_sum": 3096484,
		"fossil_bank_weight_total": 0.017073632431505087,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 4290074,
		"fossil_insure_weight_total": 0.02365494108154822,
		"name": "Faith Investor",
		"fund_family_name": "Faith Investor",
		"label": "Faith Investor"
	},
	{
		"fund_family_label": "Copeland Funds",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 181189940,
		"long_asset_sum": 181270830,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 181189940,
		"equity_fund_long_assets": 181270830,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 17,
		"ff_all_asset_sum": 13856936,
		"ff_all_weight_total": 0.07644327551211631,
		"grade_fossil_fam": 4,
		"c2_count_sum": 5,
		"c2_asset_sum": 3933342,
		"c2_weight_total": 0.021698703536581147,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 13,
		"og_asset_sum": 8676021,
		"og_weight_total": 0.04786220154671328,
		"ut_count_sum": 5,
		"ut_asset_sum": 5556379,
		"ut_weight_total": 0.030652361441716795,
		"cl_count_sum": 8,
		"cl_asset_sum": 5851667,
		"cl_weight_total": 0.03228134940409331,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 487072,
		"fossil_bank_weight_total": 0.002686984993669417,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Copeland Funds",
		"fund_family_name": "Copeland Funds",
		"label": "Copeland Funds"
	},
	{
		"fund_family_label": "ACR Alpine Capital Research",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 174417450,
		"long_asset_sum": 175089969,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 174417450,
		"equity_fund_long_assets": 175089969,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 11164491,
		"ff_all_weight_total": 0.06376430965042892,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1,
		"c2_asset_sum": 1268960,
		"c2_weight_total": 0.007247474011489488,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 10160924,
		"og_weight_total": 0.058032587806329444,
		"ut_count_sum": 1,
		"ut_asset_sum": 1003567,
		"ut_weight_total": 0.005731721844099476,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 13490158,
		"fossil_bank_weight_total": 0.07704700661635276,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "ACR Alpine Capital Research",
		"fund_family_name": "ACR Alpine Capital Research",
		"label": "ACR Alpine Capital Research"
	},
	{
		"fund_family_label": "Vericimetry Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 173628755,
		"long_asset_sum": 173628755,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 173628755,
		"equity_fund_long_assets": 173628755,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 83,
		"ff_all_asset_sum": 18576425,
		"ff_all_weight_total": 0.10698933480229124,
		"grade_fossil_fam": 5,
		"c2_count_sum": 27,
		"c2_asset_sum": 8855507,
		"c2_weight_total": 0.05100253699336841,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 351136,
		"mc50_weight_total": 0.0020223378322329157,
		"co_count_sum": 10,
		"co_asset_sum": 1920353,
		"co_weight_total": 0.01106010925436861,
		"og_count_sum": 69,
		"og_asset_sum": 15963299,
		"og_weight_total": 0.0919392585634793,
		"ut_count_sum": 10,
		"ut_asset_sum": 1853912,
		"ut_weight_total": 0.010677447983774346,
		"cl_count_sum": 2,
		"cl_asset_sum": 1423853,
		"cl_weight_total": 0.008200559866941395,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 799796,
		"fossil_insure_weight_total": 0.004606356821483861,
		"name": "Vericimetry Funds",
		"fund_family_name": "Vericimetry Funds",
		"label": "Vericimetry Funds"
	},
	{
		"fund_family_label": "Zevenbergen Capital Investments",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 172103563,
		"long_asset_sum": 172138627,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 172103563,
		"equity_fund_long_assets": 172138627,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 813686,
		"ff_all_weight_total": 0.004726922795776686,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 813686,
		"og_weight_total": 0.004726922795776686,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 5,
		"cl_asset_sum": 18352185,
		"cl_weight_total": 0.10661282316374,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Zevenbergen Capital Investments",
		"fund_family_name": "Zevenbergen Capital Investments",
		"label": "Zevenbergen Capital Investments"
	},
	{
		"fund_family_label": "abrdn Funds",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 171305506,
		"long_asset_sum": 171305506,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 171305506,
		"equity_fund_long_assets": 171305506,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 10579968,
		"ff_all_weight_total": 0.06176081695821266,
		"grade_fossil_fam": 4,
		"c2_count_sum": 3,
		"c2_asset_sum": 3039825,
		"c2_weight_total": 0.017745051347036096,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 2293246,
		"co_weight_total": 0.01338687852800248,
		"og_count_sum": 5,
		"og_asset_sum": 4367346,
		"og_weight_total": 0.025494487024836202,
		"ut_count_sum": 1,
		"ut_asset_sum": 3919376,
		"ut_weight_total": 0.022879451405373976,
		"cl_count_sum": 3,
		"cl_asset_sum": 8061543,
		"cl_weight_total": 0.047059450616841234,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 404781,
		"fossil_bank_weight_total": 0.0023629187960835306,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 571951,
		"fossil_insure_weight_total": 0.003338777680619326,
		"name": "abrdn Funds",
		"fund_family_name": "abrdn Funds",
		"label": "abrdn Funds"
	},
	{
		"fund_family_label": "Capital Research and Management Company",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 168929276,
		"long_asset_sum": 168929276,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 168929276,
		"equity_fund_long_assets": 168929276,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 4912296,
		"ff_all_weight_total": 0.02907900937194569,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 2610132,
		"c2_weight_total": 0.015451034076532715,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 1230099,
		"co_weight_total": 0.007281739608000214,
		"og_count_sum": 3,
		"og_asset_sum": 3682197,
		"og_weight_total": 0.021797269763945474,
		"ut_count_sum": 1,
		"ut_asset_sum": 1230099,
		"ut_weight_total": 0.007281739608000214,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Capital Research and Management Company",
		"fund_family_name": "Capital Research and Management Company",
		"label": "Capital Research and Management Company"
	},
	{
		"fund_family_label": "Clark Fork Trust",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 166416363,
		"long_asset_sum": 166416363,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 166416363,
		"equity_fund_long_assets": 166416363,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 13548979,
		"ff_all_weight_total": 0.08141614656005912,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 5613593,
		"mc50_weight_total": 0.033732217786780976,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 7935386,
		"og_weight_total": 0.04768392877327814,
		"ut_count_sum": 1,
		"ut_asset_sum": 5613593,
		"ut_weight_total": 0.033732217786780976,
		"cl_count_sum": 1,
		"cl_asset_sum": 1299374,
		"cl_weight_total": 0.007807970181393761,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 5613593,
		"fossil_insure_weight_total": 0.033732217786780976,
		"name": "Clark Fork Trust",
		"fund_family_name": "Clark Fork Trust",
		"label": "Clark Fork Trust"
	},
	{
		"fund_family_label": "Leavell",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 166289465,
		"long_asset_sum": 166289465,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 166289465,
		"equity_fund_long_assets": 166289465,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 23,
		"ff_all_asset_sum": 13740137,
		"ff_all_weight_total": 0.08262782612235839,
		"grade_fossil_fam": 4,
		"c2_count_sum": 4,
		"c2_asset_sum": 1076863,
		"c2_weight_total": 0.006475834172657901,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 928496,
		"mc50_weight_total": 0.00558361288852544,
		"co_count_sum": 2,
		"co_asset_sum": 33361,
		"co_weight_total": 0.0002006200452927069,
		"og_count_sum": 18,
		"og_asset_sum": 12310247,
		"og_weight_total": 0.07402902523019123,
		"ut_count_sum": 6,
		"ut_asset_sum": 2742567,
		"ut_weight_total": 0.016492728508086786,
		"cl_count_sum": 12,
		"cl_asset_sum": 17506191,
		"cl_weight_total": 0.10527540635241084,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 1443723,
		"fossil_bank_weight_total": 0.008681987160160748,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 852128,
		"fossil_insure_weight_total": 0.005124365515277832,
		"name": "Leavell",
		"fund_family_name": "Leavell",
		"label": "Leavell"
	},
	{
		"fund_family_label": "Moerus Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 166148269,
		"long_asset_sum": 166148269,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 166148269,
		"equity_fund_long_assets": 166148269,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 17803212,
		"ff_all_weight_total": 0.10715255781569412,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 10382907,
		"c2_weight_total": 0.0624918156685701,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 3032007,
		"co_weight_total": 0.01824880282081061,
		"og_count_sum": 4,
		"og_asset_sum": 14771205,
		"og_weight_total": 0.08890375499488351,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 7953059,
		"fossil_bank_weight_total": 0.04786723959188525,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Moerus Funds",
		"fund_family_name": "Moerus Funds",
		"label": "Moerus Funds"
	},
	{
		"fund_family_label": "BeeHive",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 164419683,
		"long_asset_sum": 164422169,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 164419683,
		"equity_fund_long_assets": 164422169,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 2518288,
		"ff_all_weight_total": 0.01531598819864735,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 2518288,
		"mc50_weight_total": 0.01531598819864735,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 2518288,
		"ut_weight_total": 0.01531598819864735,
		"cl_count_sum": 6,
		"cl_asset_sum": 45231952,
		"cl_weight_total": 0.27509643179564186,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 7933272,
		"fossil_insure_weight_total": 0.048249406076135634,
		"name": "BeeHive",
		"fund_family_name": "BeeHive",
		"label": "BeeHive"
	},
	{
		"fund_family_label": "Sextant Mutual Funds",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 198835517,
		"long_asset_sum": 198835517,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 162590622,
		"equity_fund_long_assets": 162590622,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 1175018,
		"ff_all_weight_total": 0.00722684977489046,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 202058,
		"c2_weight_total": 0.0012427408021109605,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 130762,
		"co_weight_total": 0.0008042407267499106,
		"og_count_sum": 4,
		"og_asset_sum": 1044256,
		"og_weight_total": 0.00642260904814055,
		"ut_count_sum": 2,
		"ut_asset_sum": 858494,
		"ut_weight_total": 0.0052800954288741205,
		"cl_count_sum": 33,
		"cl_asset_sum": 56515525,
		"cl_weight_total": 0.3475940020698119,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 231725,
		"fossil_insure_weight_total": 0.001425205200334371,
		"name": "Sextant Mutual Funds",
		"fund_family_name": "Sextant Mutual Funds",
		"label": "Sextant Mutual Funds"
	},
	{
		"fund_family_label": "Graniteshares",
		"as_of": "202506",
		"fund_id": 40,
		"net_asset_sum": 7852334883,
		"long_asset_sum": 16926321686,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 156907462,
		"equity_fund_long_assets": 157437444,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 23715118,
		"ff_all_weight_total": 0.15063200594135662,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 2754781,
		"c2_weight_total": 0.017497622738336632,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 2754781,
		"co_weight_total": 0.017497622738336632,
		"og_count_sum": 8,
		"og_asset_sum": 20960337,
		"og_weight_total": 0.13313438320301998,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 5,
		"cl_asset_sum": 14405168,
		"cl_weight_total": 0.09149772528065178,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Graniteshares",
		"fund_family_name": "Graniteshares",
		"label": "Graniteshares"
	},
	{
		"fund_family_label": "Meehan Focus",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 154425974,
		"long_asset_sum": 154425974,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 154425974,
		"equity_fund_long_assets": 154425974,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 18300089,
		"ff_all_weight_total": 0.11850395711281057,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 3565261,
		"c2_weight_total": 0.023087184802214684,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 12768676,
		"mc50_weight_total": 0.08268476907906697,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 5531413,
		"og_weight_total": 0.0358191880337436,
		"ut_count_sum": 1,
		"ut_asset_sum": 12768676,
		"ut_weight_total": 0.08268476907906697,
		"cl_count_sum": 6,
		"cl_asset_sum": 50931833,
		"cl_weight_total": 0.32981390164325597,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 12768676,
		"fossil_insure_weight_total": 0.08268476907906697,
		"name": "Meehan Focus",
		"fund_family_name": "Meehan Focus",
		"label": "Meehan Focus"
	},
	{
		"fund_family_label": "JLens",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 153798591,
		"long_asset_sum": 158780142,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 153798591,
		"equity_fund_long_assets": 158780142,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 58,
		"ff_all_asset_sum": 12114785,
		"ff_all_weight_total": 0.07629911931934158,
		"grade_fossil_fam": 4,
		"c2_count_sum": 11,
		"c2_asset_sum": 3045758,
		"c2_weight_total": 0.01918223501777697,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 3385075,
		"mc50_weight_total": 0.021319259180408088,
		"co_count_sum": 8,
		"co_asset_sum": 852315,
		"co_weight_total": 0.005367894179109627,
		"og_count_sum": 42,
		"og_asset_sum": 7786926,
		"og_weight_total": 0.049042190678983015,
		"ut_count_sum": 29,
		"ut_asset_sum": 6232582,
		"ut_weight_total": 0.03925290607184367,
		"cl_count_sum": 34,
		"cl_asset_sum": 38926168,
		"cl_weight_total": 0.24515765957685062,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 3725900,
		"fossil_bank_weight_total": 0.023465780752356297,
		"fossil_insure_count_sum": 6,
		"fossil_insure_asset_sum": 3599814,
		"fossil_insure_weight_total": 0.02267168900755864,
		"name": "JLens",
		"fund_family_name": "JLens",
		"label": "JLens"
	},
	{
		"fund_family_label": "Vontobel Asset Management Inc",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 153512736,
		"long_asset_sum": 153639231,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 153512736,
		"equity_fund_long_assets": 153639231,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 11724435,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 11724435,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 1250269,
		"ff_all_weight_total": 0.008137693685800862,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 1250269,
		"og_weight_total": 0.008137693685800862,
		"ut_count_sum": 2,
		"ut_asset_sum": 523183,
		"ut_weight_total": 0.003405269582480532,
		"cl_count_sum": 32,
		"cl_asset_sum": 18266423,
		"cl_weight_total": 0.11889165860248285,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Vontobel Asset Management Inc",
		"fund_family_name": "Vontobel Asset Management Inc",
		"label": "Vontobel Asset Management Inc"
	},
	{
		"fund_family_label": "Main Management ETFs",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 2962928741,
		"long_asset_sum": 3060826933,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 152647934,
		"equity_fund_long_assets": 152647934,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 890418,
		"ff_all_weight_total": 0.005833148059507965,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 890418,
		"ut_weight_total": 0.005833148059507965,
		"cl_count_sum": 6,
		"cl_asset_sum": 13082044,
		"cl_weight_total": 0.08570076028673929,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Main Management ETFs",
		"fund_family_name": "Main Management ETFs",
		"label": "Main Management ETFs"
	},
	{
		"fund_family_label": "Dana Investment",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 152084097,
		"long_asset_sum": 152084097,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 152084097,
		"equity_fund_long_assets": 152084097,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 15,
		"ff_all_asset_sum": 8568530,
		"ff_all_weight_total": 0.056340736270407026,
		"grade_fossil_fam": 4,
		"c2_count_sum": 6,
		"c2_asset_sum": 2997661,
		"c2_weight_total": 0.019710548697277664,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 1693600,
		"mc50_weight_total": 0.011135944082305988,
		"co_count_sum": 1,
		"co_asset_sum": 826014,
		"co_weight_total": 0.005431297658952468,
		"og_count_sum": 13,
		"og_asset_sum": 7416128,
		"og_weight_total": 0.048763336511114634,
		"ut_count_sum": 5,
		"ut_asset_sum": 3672016,
		"ut_weight_total": 0.024144641500550842,
		"cl_count_sum": 18,
		"cl_asset_sum": 32607593,
		"cl_weight_total": 0.21440501435202655,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 2622725,
		"fossil_bank_weight_total": 0.01724522847382261,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 607779,
		"fossil_insure_weight_total": 0.003996335001417012,
		"name": "Dana Investment",
		"fund_family_name": "Dana Investment",
		"label": "Dana Investment"
	},
	{
		"fund_family_label": "Abs-Invest",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 151496316,
		"long_asset_sum": 151496316,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 151496316,
		"equity_fund_long_assets": 151496316,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 19,
		"ff_all_asset_sum": 13713615,
		"ff_all_weight_total": 0.09052111207773528,
		"grade_fossil_fam": 5,
		"c2_count_sum": 4,
		"c2_asset_sum": 3462104,
		"c2_weight_total": 0.022852727323085534,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 3575739,
		"mc50_weight_total": 0.023602811569358558,
		"co_count_sum": 4,
		"co_asset_sum": 4182842,
		"co_weight_total": 0.027610189544147068,
		"og_count_sum": 16,
		"og_asset_sum": 11272579,
		"og_weight_total": 0.07440827141961656,
		"ut_count_sum": 7,
		"ut_asset_sum": 5522405,
		"ut_weight_total": 0.036452404558801284,
		"cl_count_sum": 5,
		"cl_asset_sum": 16789481,
		"cl_weight_total": 0.11082435166278234,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 5142469,
		"fossil_bank_weight_total": 0.033944515192039386,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Abs-Invest",
		"fund_family_name": "Abs-Invest",
		"label": "Abs-Invest"
	},
	{
		"fund_family_label": "Humankind",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 150440472,
		"long_asset_sum": 150440472,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 150440472,
		"equity_fund_long_assets": 150440472,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 150440472,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 150440472,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 44307,
		"ff_all_weight_total": 0.0002945151621167474,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 44307,
		"og_weight_total": 0.0002945151621167474,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 32,
		"cl_asset_sum": 28785021,
		"cl_weight_total": 0.19133827897056851,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 3203170,
		"fossil_bank_weight_total": 0.02129194330100214,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 567888,
		"fossil_insure_weight_total": 0.003774835271721296,
		"name": "Humankind",
		"fund_family_name": "Humankind",
		"label": "Humankind"
	},
	{
		"fund_family_label": "Advisors Preferred",
		"as_of": "202506",
		"fund_id": 21,
		"net_asset_sum": 1622206010,
		"long_asset_sum": 2108161314,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 149791631,
		"equity_fund_long_assets": 149791631,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 149791631,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 149791631,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 10,
		"ff_all_asset_sum": 33539226,
		"ff_all_weight_total": 0.22390587361986866,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 1669255,
		"c2_weight_total": 0.011143846881539063,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 5273179,
		"mc50_weight_total": 0.03520342868821556,
		"co_count_sum": 1,
		"co_asset_sum": 2944903,
		"co_weight_total": 0.019659996892616785,
		"og_count_sum": 7,
		"og_asset_sum": 21754916,
		"og_weight_total": 0.1452345224814329,
		"ut_count_sum": 5,
		"ut_asset_sum": 23143257,
		"ut_weight_total": 0.15450300424327446,
		"cl_count_sum": 1,
		"cl_asset_sum": 1174111,
		"cl_weight_total": 0.00783829505134369,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Advisors Preferred",
		"fund_family_name": "Advisors Preferred",
		"label": "Advisors Preferred"
	},
	{
		"fund_family_label": "Ballast Asset Management",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 149276057,
		"long_asset_sum": 149276057,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 149276057,
		"equity_fund_long_assets": 149276057,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 22980239,
		"ff_all_weight_total": 0.15394457397812966,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 3912319,
		"c2_weight_total": 0.026208616965277962,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 10638310,
		"co_weight_total": 0.0712660168937876,
		"og_count_sum": 5,
		"og_asset_sum": 12341929,
		"og_weight_total": 0.08267855708434206,
		"ut_count_sum": 1,
		"ut_asset_sum": 2642686,
		"ut_weight_total": 0.017703348099554907,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Ballast Asset Management",
		"fund_family_name": "Ballast Asset Management",
		"label": "Ballast Asset Management"
	},
	{
		"fund_family_label": "WBI Investments",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 148092487,
		"long_asset_sum": 148198903,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 148092487,
		"equity_fund_long_assets": 148198903,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 35,
		"ff_all_asset_sum": 17968758,
		"ff_all_weight_total": 0.12124757765582111,
		"grade_fossil_fam": 5,
		"c2_count_sum": 12,
		"c2_asset_sum": 7903455,
		"c2_weight_total": 0.053330050627972594,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 7,
		"co_asset_sum": 3981631,
		"co_weight_total": 0.02686680481028932,
		"og_count_sum": 30,
		"og_asset_sum": 16154085,
		"og_weight_total": 0.1090027299324881,
		"ut_count_sum": 10,
		"ut_asset_sum": 5778119,
		"ut_weight_total": 0.038988945822358755,
		"cl_count_sum": 24,
		"cl_asset_sum": 11025373,
		"cl_weight_total": 0.07439578010911457,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 858967,
		"fossil_bank_weight_total": 0.005796041553694902,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 1080658,
		"fossil_insure_weight_total": 0.007291943314857061,
		"name": "WBI Investments",
		"fund_family_name": "WBI Investments",
		"label": "WBI Investments"
	},
	{
		"fund_family_label": "Intech",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 146019593,
		"long_asset_sum": 146019593,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 146019593,
		"equity_fund_long_assets": 146019593,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 76,
		"ff_all_asset_sum": 9037046,
		"ff_all_weight_total": 0.06188926988722671,
		"grade_fossil_fam": 4,
		"c2_count_sum": 21,
		"c2_asset_sum": 2897108,
		"c2_weight_total": 0.019840542905772925,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 140316,
		"mc50_weight_total": 0.000960939536381258,
		"co_count_sum": 13,
		"co_asset_sum": 834435,
		"co_weight_total": 0.005714541335558989,
		"og_count_sum": 51,
		"og_asset_sum": 5967036,
		"og_weight_total": 0.04086462561226287,
		"ut_count_sum": 26,
		"ut_asset_sum": 3178167,
		"ut_weight_total": 0.021765346243637317,
		"cl_count_sum": 25,
		"cl_asset_sum": 17006040,
		"cl_weight_total": 0.11646409670515928,
		"fossil_bank_count_sum": 6,
		"fossil_bank_asset_sum": 2402004,
		"fossil_bank_weight_total": 0.016449874641138056,
		"fossil_insure_count_sum": 5,
		"fossil_insure_asset_sum": 782900,
		"fossil_insure_weight_total": 0.005361609246507077,
		"name": "Intech",
		"fund_family_name": "Intech",
		"label": "Intech"
	},
	{
		"fund_family_label": "Frontier Funds",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 143840668,
		"long_asset_sum": 144048217,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 143840668,
		"equity_fund_long_assets": 144048217,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 28681860,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 28681860,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 55,
		"ff_all_asset_sum": 64736061,
		"ff_all_weight_total": 0.4494055001041769,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 1579987,
		"c2_weight_total": 0.010968459262498195,
		"mc50_count_sum": 4,
		"mc50_asset_sum": 6088820,
		"mc50_weight_total": 0.042269318751789894,
		"co_count_sum": 14,
		"co_asset_sum": 12756529,
		"co_weight_total": 0.08855735437530615,
		"og_count_sum": 27,
		"og_asset_sum": 44730829,
		"og_weight_total": 0.310526780071148,
		"ut_count_sum": 51,
		"ut_asset_sum": 56686995,
		"ut_weight_total": 0.39352791850245533,
		"cl_count_sum": 7,
		"cl_asset_sum": 13284449,
		"cl_weight_total": 0.09222223833565396,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 848538,
		"fossil_bank_weight_total": 0.005890652572256413,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Frontier Funds",
		"fund_family_name": "Frontier Funds",
		"label": "Frontier Funds"
	},
	{
		"fund_family_label": "Euclidean Technologies Management, LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 143796133,
		"long_asset_sum": 143832350,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 143796133,
		"equity_fund_long_assets": 143832350,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 18373181,
		"ff_all_weight_total": 0.12774025453939952,
		"grade_fossil_fam": 5,
		"c2_count_sum": 4,
		"c2_asset_sum": 7398221,
		"c2_weight_total": 0.051436418858483504,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 1319607,
		"co_weight_total": 0.009174618922655439,
		"og_count_sum": 8,
		"og_asset_sum": 17053574,
		"og_weight_total": 0.11856563561674408,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 4260639,
		"cl_weight_total": 0.02962225813594786,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Euclidean Technologies Management, LLC",
		"fund_family_name": "Euclidean Technologies Management, LLC",
		"label": "Euclidean Technologies Management, LLC"
	},
	{
		"fund_family_label": "Renaissance Capital",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 142853559,
		"long_asset_sum": 142853559,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 142853559,
		"equity_fund_long_assets": 142853559,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 1751718,
		"ff_all_weight_total": 0.012262333625163654,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 1751718,
		"og_weight_total": 0.012262333625163654,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 286248,
		"cl_weight_total": 0.0020037862689861303,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Renaissance Capital",
		"fund_family_name": "Renaissance Capital",
		"label": "Renaissance Capital"
	},
	{
		"fund_family_label": "Guardian Capital LP",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 138465060,
		"long_asset_sum": 138465060,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 138465060,
		"equity_fund_long_assets": 138465060,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 4351619,
		"ff_all_weight_total": 0.03142756013683163,
		"grade_fossil_fam": 3,
		"c2_count_sum": 3,
		"c2_asset_sum": 2106409,
		"c2_weight_total": 0.015212566982601965,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 4351619,
		"og_weight_total": 0.03142756013683163,
		"ut_count_sum": 1,
		"ut_asset_sum": 460641,
		"ut_weight_total": 0.003326767055891212,
		"cl_count_sum": 14,
		"cl_asset_sum": 20946738,
		"cl_weight_total": 0.15127814915907306,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 1273169,
		"fossil_bank_weight_total": 0.009194875588108654,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 4669501,
		"fossil_insure_weight_total": 0.03372331619254706,
		"name": "Guardian Capital LP",
		"fund_family_name": "Guardian Capital LP",
		"label": "Guardian Capital LP"
	},
	{
		"fund_family_label": "TBG ETF",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 137971948,
		"long_asset_sum": 137971948,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 137971948,
		"equity_fund_long_assets": 137971948,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 28954455,
		"ff_all_weight_total": 0.20985755017389476,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 7857526,
		"c2_weight_total": 0.056950170769495836,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 3862868,
		"mc50_weight_total": 0.027997488301027683,
		"co_count_sum": 1,
		"co_asset_sum": 3862868,
		"co_weight_total": 0.027997488301027683,
		"og_count_sum": 6,
		"og_asset_sum": 26243514,
		"og_weight_total": 0.19020905611914676,
		"ut_count_sum": 2,
		"ut_asset_sum": 6573809,
		"ut_weight_total": 0.04764598235577568,
		"cl_count_sum": 4,
		"cl_asset_sum": 15921189,
		"cl_weight_total": 0.11539439161937469,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 7722178,
		"fossil_bank_weight_total": 0.05596918875132502,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "TBG ETF",
		"fund_family_name": "TBG ETF",
		"label": "TBG ETF"
	},
	{
		"fund_family_label": "Villere",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 136464879,
		"long_asset_sum": 136481066,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 136464879,
		"equity_fund_long_assets": 136481066,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 6852170,
		"ff_all_weight_total": 0.05020601172619798,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 1791230,
		"c2_weight_total": 0.013124384594123847,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 6,
		"og_asset_sum": 6852170,
		"og_weight_total": 0.05020601172619798,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 3,
		"cl_asset_sum": 2851446,
		"cl_weight_total": 0.02089261231297827,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 2176349,
		"fossil_bank_weight_total": 0.015946160619818135,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Villere",
		"fund_family_name": "Villere",
		"label": "Villere"
	},
	{
		"fund_family_label": "Davidson Mutual Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 135846634,
		"long_asset_sum": 135897776,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 135846634,
		"equity_fund_long_assets": 135897776,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 8894485,
		"ff_all_weight_total": 0.06544982016482742,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 5170777,
		"c2_weight_total": 0.03804901855053169,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 6872356,
		"og_weight_total": 0.050570040233771006,
		"ut_count_sum": 2,
		"ut_asset_sum": 3723708,
		"ut_weight_total": 0.027400801614295735,
		"cl_count_sum": 7,
		"cl_asset_sum": 26145976,
		"cl_weight_total": 0.19239443624154673,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 6938609,
		"fossil_bank_weight_total": 0.05105756108915278,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Davidson Mutual Funds",
		"fund_family_name": "Davidson Mutual Funds",
		"label": "Davidson Mutual Funds"
	},
	{
		"fund_family_label": "13D Activist Fund",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 135153569,
		"long_asset_sum": 135298519,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 135153569,
		"equity_fund_long_assets": 135298519,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 9101013,
		"ff_all_weight_total": 0.06726616867107023,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 9101013,
		"ut_weight_total": 0.06726616867107023,
		"cl_count_sum": 1,
		"cl_asset_sum": 5381045,
		"cl_weight_total": 0.039771647463487755,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "13D Activist Fund",
		"fund_family_name": "13D Activist Fund",
		"label": "13D Activist Fund"
	},
	{
		"fund_family_label": "Aspiration Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 134223433,
		"long_asset_sum": 134223433,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 134223433,
		"equity_fund_long_assets": 134223433,
		"num_e_sri": 1,
		"num_e_usf": 1,
		"sri_long_assets": 134223433,
		"usf_long_assets": 134223433,
		"equity_fund_sri_long_assets": 134223433,
		"equity_fund_usf_long_assets": 134223433,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 3936512,
		"ff_all_weight_total": 0.029328053321360063,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 934096,
		"og_weight_total": 0.006959261725931269,
		"ut_count_sum": 1,
		"ut_asset_sum": 3002416,
		"ut_weight_total": 0.022368791595428796,
		"cl_count_sum": 7,
		"cl_asset_sum": 21909741,
		"cl_weight_total": 0.16323335285277646,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Aspiration Funds",
		"fund_family_name": "Aspiration Funds",
		"label": "Aspiration Funds"
	},
	{
		"fund_family_label": "Redwood Investment Management, LLC",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 1053004796,
		"long_asset_sum": 1124459431,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 133669556,
		"equity_fund_long_assets": 133669556,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 4235211,
		"ff_all_weight_total": 0.03168418544010126,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 2151452,
		"c2_weight_total": 0.016095302957391436,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 2083759,
		"mc50_weight_total": 0.015588882482709825,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 4235211,
		"og_weight_total": 0.03168418544010126,
		"ut_count_sum": 1,
		"ut_asset_sum": 2083759,
		"ut_weight_total": 0.015588882482709825,
		"cl_count_sum": 6,
		"cl_asset_sum": 7527031,
		"cl_weight_total": 0.0563107354078441,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 1409256,
		"fossil_bank_weight_total": 0.010542834450650827,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 2582458,
		"fossil_insure_weight_total": 0.019319717049108773,
		"name": "Redwood Investment Management, LLC",
		"fund_family_name": "Redwood Investment Management, LLC",
		"label": "Redwood Investment Management, LLC"
	},
	{
		"fund_family_label": "Capital Advisors",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 133071472,
		"long_asset_sum": 133071472,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 133071472,
		"equity_fund_long_assets": 133071472,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 16236425,
		"ff_all_weight_total": 0.12201281578969833,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 3207136,
		"c2_weight_total": 0.024100853111476816,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 3914463,
		"mc50_weight_total": 0.029416244828192776,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 10023380,
		"og_weight_total": 0.07532328191274536,
		"ut_count_sum": 2,
		"ut_asset_sum": 6213045,
		"ut_weight_total": 0.04668953387695298,
		"cl_count_sum": 5,
		"cl_asset_sum": 24680730,
		"cl_weight_total": 0.18546973013118845,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 3914463,
		"fossil_insure_weight_total": 0.029416244828192776,
		"name": "Capital Advisors",
		"fund_family_name": "Capital Advisors",
		"label": "Capital Advisors"
	},
	{
		"fund_family_label": "Argent",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 132298559,
		"long_asset_sum": 132308662,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 132298559,
		"equity_fund_long_assets": 132308662,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 3839886,
		"ff_all_weight_total": 0.02902218148045364,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 464749,
		"c2_weight_total": 0.0035126120465189194,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 3618966,
		"og_weight_total": 0.02735244953198907,
		"ut_count_sum": 2,
		"ut_asset_sum": 518738,
		"ut_weight_total": 0.003920665451215885,
		"cl_count_sum": 5,
		"cl_asset_sum": 5781879,
		"cl_weight_total": 0.04369992797599299,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Argent",
		"fund_family_name": "Argent",
		"label": "Argent"
	},
	{
		"fund_family_label": "AAM",
		"as_of": "202506",
		"fund_id": 9,
		"net_asset_sum": 1241821507,
		"long_asset_sum": 1250294982,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 132042124,
		"equity_fund_long_assets": 132042264,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 23,
		"ff_all_asset_sum": 15929668,
		"ff_all_weight_total": 0.12064067607928929,
		"grade_fossil_fam": 5,
		"c2_count_sum": 5,
		"c2_asset_sum": 3512092,
		"c2_weight_total": 0.026598241302496904,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1846791,
		"mc50_weight_total": 0.013986362730042255,
		"co_count_sum": 4,
		"co_asset_sum": 2038967,
		"co_weight_total": 0.015441775521207362,
		"og_count_sum": 19,
		"og_asset_sum": 13893776,
		"og_weight_total": 0.10522218855623379,
		"ut_count_sum": 12,
		"ut_asset_sum": 8554867,
		"ut_weight_total": 0.06478885427168986,
		"cl_count_sum": 39,
		"cl_asset_sum": 12544898,
		"cl_weight_total": 0.09500668664693601,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 93590,
		"fossil_bank_weight_total": 0.0007087882104172343,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "AAM",
		"fund_family_name": "AAM",
		"label": "AAM"
	},
	{
		"fund_family_label": "First Sentier",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 130386999,
		"long_asset_sum": 132518365,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 130386999,
		"equity_fund_long_assets": 132518365,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 22,
		"ff_all_asset_sum": 74264073,
		"ff_all_weight_total": 0.5604058954394736,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 2210331,
		"c2_weight_total": 0.016679431564070382,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 15067332,
		"mc50_weight_total": 0.1136999539648712,
		"co_count_sum": 4,
		"co_asset_sum": 13788471,
		"co_weight_total": 0.10404951042068773,
		"og_count_sum": 13,
		"og_asset_sum": 47810546,
		"og_weight_total": 0.3607843033680653,
		"ut_count_sum": 17,
		"ut_asset_sum": 57002009,
		"ut_weight_total": 0.4301442218970933,
		"cl_count_sum": 5,
		"cl_asset_sum": 11500205,
		"cl_weight_total": 0.08678197169124445,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "First Sentier",
		"fund_family_name": "First Sentier",
		"label": "First Sentier"
	},
	{
		"fund_family_label": "Azzad Fund",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 445562790,
		"long_asset_sum": 445562790,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 129442225,
		"equity_fund_long_assets": 129442225,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 3737209,
		"cl_weight_total": 0.02887163752013688,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Azzad Fund",
		"fund_family_name": "Azzad Fund",
		"label": "Azzad Fund"
	},
	{
		"fund_family_label": "Stance Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 125287051,
		"long_asset_sum": 125287051,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 125287051,
		"equity_fund_long_assets": 125287051,
		"num_e_sri": 1,
		"num_e_usf": 1,
		"sri_long_assets": 125287051,
		"usf_long_assets": 125287051,
		"equity_fund_sri_long_assets": 125287051,
		"equity_fund_usf_long_assets": 125287051,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 13,
		"cl_asset_sum": 16079719,
		"cl_weight_total": 0.12834302405282091,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Stance Funds",
		"fund_family_name": "Stance Funds",
		"label": "Stance Funds"
	},
	{
		"fund_family_label": "North Country Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 124535632,
		"long_asset_sum": 124535632,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 124535632,
		"equity_fund_long_assets": 124535632,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 7789236,
		"ff_all_weight_total": 0.06254624379310172,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 1959798,
		"c2_weight_total": 0.015736845499768292,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 2620533,
		"mc50_weight_total": 0.021042435469392405,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 5168703,
		"og_weight_total": 0.04150380832370931,
		"ut_count_sum": 3,
		"ut_asset_sum": 3828046,
		"ut_weight_total": 0.030738560029148928,
		"cl_count_sum": 6,
		"cl_asset_sum": 25616411,
		"cl_weight_total": 0.20569543502216298,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 5680647,
		"fossil_bank_weight_total": 0.045614631802727755,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 2620533,
		"fossil_insure_weight_total": 0.021042435469392405,
		"name": "North Country Funds",
		"fund_family_name": "North Country Funds",
		"label": "North Country Funds"
	},
	{
		"fund_family_label": "Archer",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 149558302,
		"long_asset_sum": 149558302,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 123358541,
		"equity_fund_long_assets": 123358541,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 28,
		"ff_all_asset_sum": 13419694,
		"ff_all_weight_total": 0.1087860953219283,
		"grade_fossil_fam": 5,
		"c2_count_sum": 9,
		"c2_asset_sum": 3671582,
		"c2_weight_total": 0.029763500526485638,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 2950454,
		"mc50_weight_total": 0.023917711542972935,
		"co_count_sum": 3,
		"co_asset_sum": 1261995,
		"co_weight_total": 0.010230300956623669,
		"og_count_sum": 22,
		"og_asset_sum": 10526190,
		"og_weight_total": 0.0853300461781564,
		"ut_count_sum": 16,
		"ut_asset_sum": 8272931,
		"ut_weight_total": 0.06706411192071411,
		"cl_count_sum": 25,
		"cl_asset_sum": 17243536,
		"cl_weight_total": 0.13978388411711193,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 1790879,
		"fossil_bank_weight_total": 0.014517673324297828,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 1091375,
		"fossil_insure_weight_total": 0.008847178242810118,
		"name": "Archer",
		"fund_family_name": "Archer",
		"label": "Archer"
	},
	{
		"fund_family_label": "Donoghue Forlines LLC",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 330045325,
		"long_asset_sum": 330045325,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 123032682,
		"equity_fund_long_assets": 123032682,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 11,
		"ff_all_asset_sum": 14163440,
		"ff_all_weight_total": 0.11511933065069653,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 4000256,
		"c2_weight_total": 0.03251376735817236,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 2445780,
		"mc50_weight_total": 0.019879108219391657,
		"co_count_sum": 1,
		"co_asset_sum": 1245216,
		"co_weight_total": 0.010121018088510823,
		"og_count_sum": 10,
		"og_asset_sum": 12918224,
		"og_weight_total": 0.10499831256218571,
		"ut_count_sum": 4,
		"ut_asset_sum": 4947663,
		"ut_weight_total": 0.04021421722725674,
		"cl_count_sum": 11,
		"cl_asset_sum": 12962026,
		"cl_weight_total": 0.10535433178641103,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 6436257,
		"fossil_bank_weight_total": 0.05231339263172366,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Donoghue Forlines LLC",
		"fund_family_name": "Donoghue Forlines LLC",
		"label": "Donoghue Forlines LLC"
	},
	{
		"fund_family_label": "PineBridge",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 122624900,
		"long_asset_sum": 145415981,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 122624900,
		"equity_fund_long_assets": 145415981,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 35,
		"ff_all_asset_sum": 3781138,
		"ff_all_weight_total": 0.026002217734239264,
		"grade_fossil_fam": 3,
		"c2_count_sum": 9,
		"c2_asset_sum": 916743,
		"c2_weight_total": 0.006304279582585906,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 641742,
		"mc50_weight_total": 0.00441314631023945,
		"co_count_sum": 6,
		"co_asset_sum": 435950,
		"co_weight_total": 0.0029979510986485043,
		"og_count_sum": 23,
		"og_asset_sum": 2631612,
		"og_weight_total": 0.018097130603547625,
		"ut_count_sum": 16,
		"ut_asset_sum": 1678922,
		"ut_weight_total": 0.011545649855362184,
		"cl_count_sum": 44,
		"cl_asset_sum": 12099030,
		"cl_weight_total": 0.083202890884462,
		"fossil_bank_count_sum": 14,
		"fossil_bank_asset_sum": 3314378,
		"fossil_bank_weight_total": 0.0227923917110596,
		"fossil_insure_count_sum": 6,
		"fossil_insure_asset_sum": 705876,
		"fossil_insure_weight_total": 0.0048541844929684864,
		"name": "PineBridge",
		"fund_family_name": "PineBridge",
		"label": "PineBridge"
	},
	{
		"fund_family_label": "ACV ETFs",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 122473761,
		"long_asset_sum": 122473761,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 122473761,
		"equity_fund_long_assets": 122473761,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 38,
		"ff_all_asset_sum": 9967391,
		"ff_all_weight_total": 0.08138388923975316,
		"grade_fossil_fam": 4,
		"c2_count_sum": 7,
		"c2_asset_sum": 2828475,
		"c2_weight_total": 0.023094538592637815,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 2670879,
		"mc50_weight_total": 0.021807765011805265,
		"co_count_sum": 7,
		"co_asset_sum": 458685,
		"co_weight_total": 0.00374516954696933,
		"og_count_sum": 28,
		"og_asset_sum": 6786319,
		"og_weight_total": 0.05541039112859447,
		"ut_count_sum": 20,
		"ut_asset_sum": 5027799,
		"ut_weight_total": 0.04105205032447726,
		"cl_count_sum": 30,
		"cl_asset_sum": 23732576,
		"cl_weight_total": 0.19377682048973738,
		"fossil_bank_count_sum": 6,
		"fossil_bank_asset_sum": 2719407,
		"fossil_bank_weight_total": 0.022203996821817205,
		"fossil_insure_count_sum": 5,
		"fossil_insure_asset_sum": 3173483,
		"fossil_insure_weight_total": 0.025911533818251894,
		"name": "ACV ETFs",
		"fund_family_name": "ACV ETFs",
		"label": "ACV ETFs"
	},
	{
		"fund_family_label": "Hillman Capital Management",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 121874555,
		"long_asset_sum": 121900435,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 121874555,
		"equity_fund_long_assets": 121900435,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 7,
		"cl_asset_sum": 21272907,
		"cl_weight_total": 0.17451050933493387,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 3073908,
		"fossil_bank_weight_total": 0.025216546602151172,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Hillman Capital Management",
		"fund_family_name": "Hillman Capital Management",
		"label": "Hillman Capital Management"
	},
	{
		"fund_family_label": "Freedom Day Solutions, LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 121520734,
		"long_asset_sum": 121520734,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 121520734,
		"equity_fund_long_assets": 121520734,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 17227616,
		"ff_all_weight_total": 0.14176688564109563,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 7122066,
		"c2_weight_total": 0.05860782572297498,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 6,
		"og_asset_sum": 15172016,
		"og_weight_total": 0.12485125377863501,
		"ut_count_sum": 1,
		"ut_asset_sum": 2055600,
		"ut_weight_total": 0.016915631862460607,
		"cl_count_sum": 5,
		"cl_asset_sum": 13435214,
		"cl_weight_total": 0.1105590260835653,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 2889125,
		"fossil_bank_weight_total": 0.023774749418481952,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 2793944,
		"fossil_insure_weight_total": 0.022991500364044872,
		"name": "Freedom Day Solutions, LLC",
		"fund_family_name": "Freedom Day Solutions, LLC",
		"label": "Freedom Day Solutions, LLC"
	},
	{
		"fund_family_label": "Saratoga",
		"as_of": "202506",
		"fund_id": 16,
		"net_asset_sum": 140103985,
		"long_asset_sum": 140367133,
		"num_equity_funds": 9,
		"equity_fund_net_assets": 120942750,
		"equity_fund_long_assets": 121195382,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 5,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 49,
		"ff_all_asset_sum": 4107903,
		"ff_all_weight_total": 0.033894880582166075,
		"grade_fossil_fam": 3,
		"c2_count_sum": 26,
		"c2_asset_sum": 1155037,
		"c2_weight_total": 0.00953037137999202,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 383926,
		"mc50_weight_total": 0.003167826972153114,
		"co_count_sum": 8,
		"co_asset_sum": 657191,
		"co_weight_total": 0.005422574599418317,
		"og_count_sum": 39,
		"og_asset_sum": 2773268,
		"og_weight_total": 0.022882621055643853,
		"ut_count_sum": 8,
		"ut_asset_sum": 1505867,
		"ut_weight_total": 0.01242511864024654,
		"cl_count_sum": 24,
		"cl_asset_sum": 23062036,
		"cl_weight_total": 0.19028807549779414,
		"fossil_bank_count_sum": 15,
		"fossil_bank_asset_sum": 872091,
		"fossil_bank_weight_total": 0.0071957444715179,
		"fossil_insure_count_sum": 6,
		"fossil_insure_asset_sum": 427904,
		"fossil_insure_weight_total": 0.0035306955837640743,
		"name": "Saratoga",
		"fund_family_name": "Saratoga",
		"label": "Saratoga"
	},
	{
		"fund_family_label": "ONEFUND Trust",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 127894155,
		"long_asset_sum": 129318508,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 120909832,
		"equity_fund_long_assets": 120909832,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 57,
		"ff_all_asset_sum": 10128552,
		"ff_all_weight_total": 0.08376946549723102,
		"grade_fossil_fam": 4,
		"c2_count_sum": 13,
		"c2_asset_sum": 2777947,
		"c2_weight_total": 0.022975360680345665,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 3094191,
		"mc50_weight_total": 0.025590896528580074,
		"co_count_sum": 9,
		"co_asset_sum": 613410,
		"co_weight_total": 0.005073284693671562,
		"og_count_sum": 41,
		"og_asset_sum": 6412952,
		"og_weight_total": 0.05303912753761828,
		"ut_count_sum": 30,
		"ut_asset_sum": 5394262,
		"ut_weight_total": 0.04461392353931978,
		"cl_count_sum": 36,
		"cl_asset_sum": 30675155,
		"cl_weight_total": 0.2537027344476006,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 2920306,
		"fossil_bank_weight_total": 0.02415275872685027,
		"fossil_insure_count_sum": 6,
		"fossil_insure_asset_sum": 3246233,
		"fossil_insure_weight_total": 0.026848379046627076,
		"name": "ONEFUND Trust",
		"fund_family_name": "ONEFUND Trust",
		"label": "ONEFUND Trust"
	},
	{
		"fund_family_label": "Hoya Capital Real Estate",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 120810905,
		"long_asset_sum": 120810905,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 120810905,
		"equity_fund_long_assets": 120810905,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 688063,
		"fossil_bank_weight_total": 0.005695371622288567,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 274046,
		"fossil_insure_weight_total": 0.002268387940641617,
		"name": "Hoya Capital Real Estate",
		"fund_family_name": "Hoya Capital Real Estate",
		"label": "Hoya Capital Real Estate"
	},
	{
		"fund_family_label": "Clifford Capital",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 117561225,
		"long_asset_sum": 117561225,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 117561225,
		"equity_fund_long_assets": 117561225,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 9034211,
		"ff_all_weight_total": 0.07684686000847643,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 9034211,
		"og_weight_total": 0.07684686000847643,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 6172350,
		"cl_weight_total": 0.05250328073733495,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Clifford Capital",
		"fund_family_name": "Clifford Capital",
		"label": "Clifford Capital"
	},
	{
		"fund_family_label": "Syntax",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 140540069,
		"long_asset_sum": 140544269,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 115886559,
		"equity_fund_long_assets": 115886559,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 59,
		"ff_all_asset_sum": 14766460,
		"ff_all_weight_total": 0.12742167967900403,
		"grade_fossil_fam": 5,
		"c2_count_sum": 13,
		"c2_asset_sum": 2901282,
		"c2_weight_total": 0.025035534966570197,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 1696108,
		"mc50_weight_total": 0.01463593374965944,
		"co_count_sum": 10,
		"co_asset_sum": 2082958,
		"co_weight_total": 0.017974112079727902,
		"og_count_sum": 42,
		"og_asset_sum": 10389125,
		"og_weight_total": 0.0896490938176877,
		"ut_count_sum": 31,
		"ut_asset_sum": 7626627,
		"ut_weight_total": 0.06581114381004272,
		"cl_count_sum": 36,
		"cl_asset_sum": 10244988,
		"cl_weight_total": 0.08840531713431926,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 1315764,
		"fossil_bank_weight_total": 0.011353896529104813,
		"fossil_insure_count_sum": 6,
		"fossil_insure_asset_sum": 1498628,
		"fossil_insure_weight_total": 0.012931853468873815,
		"name": "Syntax",
		"fund_family_name": "Syntax",
		"label": "Syntax"
	},
	{
		"fund_family_label": "Centerstone Investors",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 115708216,
		"long_asset_sum": 150090364,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 115708216,
		"equity_fund_long_assets": 150090364,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 5131280,
		"ff_all_weight_total": 0.03418793760803991,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 2780928,
		"c2_weight_total": 0.018528358023037376,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 5131280,
		"og_weight_total": 0.03418793760803991,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 4,
		"cl_asset_sum": 9683489,
		"cl_weight_total": 0.06451772613463713,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 7065502,
		"fossil_bank_weight_total": 0.04707498743890048,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Centerstone Investors",
		"fund_family_name": "Centerstone Investors",
		"label": "Centerstone Investors"
	},
	{
		"fund_family_label": "Perpetual Funds",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 474068054,
		"long_asset_sum": 476728894,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 115242039,
		"equity_fund_long_assets": 115269712,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 5496328,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 5496328,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 31,
		"ff_all_asset_sum": 19235543,
		"ff_all_weight_total": 0.16687421757417073,
		"grade_fossil_fam": 5,
		"c2_count_sum": 7,
		"c2_asset_sum": 4651251,
		"c2_weight_total": 0.040351024734060235,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 47576,
		"mc50_weight_total": 0.00041273634829589926,
		"co_count_sum": 4,
		"co_asset_sum": 3529130,
		"co_weight_total": 0.030616281924951805,
		"og_count_sum": 23,
		"og_asset_sum": 15117670,
		"og_weight_total": 0.1311504100921151,
		"ut_count_sum": 14,
		"ut_asset_sum": 9970287,
		"ut_weight_total": 0.08649528854552876,
		"cl_count_sum": 14,
		"cl_asset_sum": 7399709,
		"cl_weight_total": 0.06419473833681479,
		"fossil_bank_count_sum": 7,
		"fossil_bank_asset_sum": 5209473,
		"fossil_bank_weight_total": 0.045193771283127696,
		"fossil_insure_count_sum": 5,
		"fossil_insure_asset_sum": 3150691,
		"fossil_insure_weight_total": 0.027333207876844526,
		"name": "Perpetual Funds",
		"fund_family_name": "Perpetual Funds",
		"label": "Perpetual Funds"
	},
	{
		"fund_family_label": "Impact Shares",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 114801516,
		"long_asset_sum": 115796078,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 114801516,
		"equity_fund_long_assets": 115796078,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 115796078,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 115796078,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 57,
		"ff_all_asset_sum": 7644037,
		"ff_all_weight_total": 0.06601291798501155,
		"grade_fossil_fam": 4,
		"c2_count_sum": 10,
		"c2_asset_sum": 3651708,
		"c2_weight_total": 0.03153567947266746,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 562651,
		"mc50_weight_total": 0.004858981493311026,
		"co_count_sum": 10,
		"co_asset_sum": 806868,
		"co_weight_total": 0.006968008018371745,
		"og_count_sum": 39,
		"og_asset_sum": 6428550,
		"og_weight_total": 0.05551612896595686,
		"ut_count_sum": 34,
		"ut_asset_sum": 2692364,
		"ut_weight_total": 0.023250908377052286,
		"cl_count_sum": 37,
		"cl_asset_sum": 21995947,
		"cl_weight_total": 0.18995416235081813,
		"fossil_bank_count_sum": 10,
		"fossil_bank_asset_sum": 4213203,
		"fossil_bank_weight_total": 0.036384677899021764,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 351874,
		"fossil_insure_weight_total": 0.003038738496825428,
		"name": "Impact Shares",
		"fund_family_name": "Impact Shares",
		"label": "Impact Shares"
	},
	{
		"fund_family_label": "Beyond Advisors IC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 114067177,
		"long_asset_sum": 114067177,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 114067177,
		"equity_fund_long_assets": 114067177,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 114067177,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 114067177,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 18,
		"cl_asset_sum": 31436379,
		"cl_weight_total": 0.2755953099461732,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 257738,
		"fossil_bank_weight_total": 0.0022595281725960484,
		"fossil_insure_count_sum": 5,
		"fossil_insure_asset_sum": 1391749,
		"fossil_insure_weight_total": 0.012201134775168496,
		"name": "Beyond Advisors IC",
		"fund_family_name": "Beyond Advisors IC",
		"label": "Beyond Advisors IC"
	},
	{
		"fund_family_label": "Conductor",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 111637889,
		"long_asset_sum": 111716507,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 111637889,
		"equity_fund_long_assets": 111716507,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 6655148,
		"ff_all_weight_total": 0.05957175155861255,
		"grade_fossil_fam": 4,
		"c2_count_sum": 3,
		"c2_asset_sum": 1996510,
		"c2_weight_total": 0.017871217545317633,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 7682,
		"co_weight_total": 0.00006876333861745248,
		"og_count_sum": 4,
		"og_asset_sum": 4201241,
		"og_weight_total": 0.03760626887484049,
		"ut_count_sum": 2,
		"ut_asset_sum": 2446225,
		"ut_weight_total": 0.021896719345154605,
		"cl_count_sum": 3,
		"cl_asset_sum": 3718927,
		"cl_weight_total": 0.033288965971698344,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Conductor",
		"fund_family_name": "Conductor",
		"label": "Conductor"
	},
	{
		"fund_family_label": "Altegris",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 149598977,
		"long_asset_sum": 161641519,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 111231430,
		"equity_fund_long_assets": 123273972,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 19101257,
		"ff_all_weight_total": 0.15494963527256184,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 19101257,
		"og_weight_total": 0.15494963527256184,
		"ut_count_sum": 1,
		"ut_asset_sum": 12275187,
		"ut_weight_total": 0.09957647020573004,
		"cl_count_sum": 1,
		"cl_asset_sum": 8258774,
		"cl_weight_total": 0.0669952778028439,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Altegris",
		"fund_family_name": "Altegris",
		"label": "Altegris"
	},
	{
		"fund_family_label": "Sovereign's Capital, LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 111019082,
		"long_asset_sum": 111019082,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 111019082,
		"equity_fund_long_assets": 111019082,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 7231282,
		"ff_all_weight_total": 0.06513548724893978,
		"grade_fossil_fam": 4,
		"c2_count_sum": 3,
		"c2_asset_sum": 3283987,
		"c2_weight_total": 0.029580383307438986,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 2835987,
		"co_weight_total": 0.02554504098673776,
		"og_count_sum": 4,
		"og_asset_sum": 4395295,
		"og_weight_total": 0.039590446262202025,
		"ut_count_sum": 2,
		"ut_asset_sum": 3947295,
		"ut_weight_total": 0.0355551039415008,
		"cl_count_sum": 3,
		"cl_asset_sum": 3188710,
		"cl_weight_total": 0.028722179489828605,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Sovereign's Capital, LLC",
		"fund_family_name": "Sovereign's Capital, LLC",
		"label": "Sovereign's Capital, LLC"
	},
	{
		"fund_family_label": "Bretton Fund",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 108043008,
		"long_asset_sum": 108043008,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 108043008,
		"equity_fund_long_assets": 108043008,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 3994350,
		"ff_all_weight_total": 0.0369699999466879,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 3994350,
		"mc50_weight_total": 0.0369699999466879,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 3994350,
		"ut_weight_total": 0.0369699999466879,
		"cl_count_sum": 2,
		"cl_asset_sum": 13710102,
		"cl_weight_total": 0.1268948565371301,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 5257980,
		"fossil_bank_weight_total": 0.048665620268550834,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 3994350,
		"fossil_insure_weight_total": 0.0369699999466879,
		"name": "Bretton Fund",
		"fund_family_name": "Bretton Fund",
		"label": "Bretton Fund"
	},
	{
		"fund_family_label": "Cavanal Hill funds",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 314193130,
		"long_asset_sum": 314353387,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 106948806,
		"equity_fund_long_assets": 106948806,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 63,
		"ff_all_asset_sum": 80427054,
		"ff_all_weight_total": 0.7520145105687295,
		"grade_fossil_fam": 5,
		"c2_count_sum": 20,
		"c2_asset_sum": 39886997,
		"c2_weight_total": 0.3729541122693787,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 12319,
		"mc50_weight_total": 0.00011518595167860032,
		"co_count_sum": 7,
		"co_asset_sum": 332671,
		"co_weight_total": 0.0031105630108670874,
		"og_count_sum": 51,
		"og_asset_sum": 79954388,
		"og_weight_total": 0.7475949567870819,
		"ut_count_sum": 20,
		"ut_asset_sum": 783751,
		"ut_weight_total": 0.007328281907139758,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Cavanal Hill funds",
		"fund_family_name": "Cavanal Hill funds",
		"label": "Cavanal Hill funds"
	},
	{
		"fund_family_label": "Yorktown Funds",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 644179936,
		"long_asset_sum": 644179936,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 106520780,
		"equity_fund_long_assets": 106520780,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 12,
		"ff_all_asset_sum": 4798777,
		"ff_all_weight_total": 0.04505014890052439,
		"grade_fossil_fam": 3,
		"c2_count_sum": 4,
		"c2_asset_sum": 974098,
		"c2_weight_total": 0.009144675808795242,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 445002,
		"co_weight_total": 0.004177607411436529,
		"og_count_sum": 11,
		"og_asset_sum": 4661578,
		"og_weight_total": 0.04376214669100245,
		"ut_count_sum": 4,
		"ut_asset_sum": 1691685,
		"ut_weight_total": 0.01588126748602479,
		"cl_count_sum": 4,
		"cl_asset_sum": 1963654,
		"cl_weight_total": 0.018434468842605172,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Yorktown Funds",
		"fund_family_name": "Yorktown Funds",
		"label": "Yorktown Funds"
	},
	{
		"fund_family_label": "Hilton Capital Management, LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 104392085,
		"long_asset_sum": 105581350,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 104392085,
		"equity_fund_long_assets": 105581350,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 8827103,
		"ff_all_weight_total": 0.0836047559535846,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 4041903,
		"c2_weight_total": 0.038282357632290175,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 2339271,
		"co_weight_total": 0.02215610048554977,
		"og_count_sum": 5,
		"og_asset_sum": 7617672,
		"og_weight_total": 0.07214978781764014,
		"ut_count_sum": 2,
		"ut_asset_sum": 3548702,
		"ut_weight_total": 0.03361106862149423,
		"cl_count_sum": 2,
		"cl_asset_sum": 3948111,
		"cl_weight_total": 0.03739401892474381,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Hilton Capital Management, LLC",
		"fund_family_name": "Hilton Capital Management, LLC",
		"label": "Hilton Capital Management, LLC"
	},
	{
		"fund_family_label": "MarketDesk",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 101873412,
		"long_asset_sum": 107094936,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 101873412,
		"equity_fund_long_assets": 107094936,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 5410936,
		"ff_all_weight_total": 0.05052466719808302,
		"grade_fossil_fam": 3,
		"c2_count_sum": 6,
		"c2_asset_sum": 4766569,
		"c2_weight_total": 0.04450788410761084,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 644367,
		"mc50_weight_total": 0.006016783090472177,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 6,
		"og_asset_sum": 4766569,
		"og_weight_total": 0.04450788410761084,
		"ut_count_sum": 1,
		"ut_asset_sum": 644367,
		"ut_weight_total": 0.006016783090472177,
		"cl_count_sum": 5,
		"cl_asset_sum": 6384758,
		"cl_weight_total": 0.05961773953532219,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 1378420,
		"fossil_insure_weight_total": 0.012871010072782527,
		"name": "MarketDesk",
		"fund_family_name": "MarketDesk",
		"label": "MarketDesk"
	},
	{
		"fund_family_label": "Absolute Investment Advisers",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 1306886153,
		"long_asset_sum": 1670636693,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 101486915,
		"equity_fund_long_assets": 101486915,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 21830726,
		"ff_all_weight_total": 0.21510877535296052,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 2803603,
		"c2_weight_total": 0.027625265779337167,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 11890936,
		"mc50_weight_total": 0.11716718357238468,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 8565543,
		"og_weight_total": 0.08440046679909424,
		"ut_count_sum": 2,
		"ut_asset_sum": 13265183,
		"ut_weight_total": 0.13070830855386628,
		"cl_count_sum": 1,
		"cl_asset_sum": 2023584,
		"cl_weight_total": 0.019939358684811732,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 15912020,
		"fossil_insure_weight_total": 0.1567888825864891,
		"name": "Absolute Investment Advisers",
		"fund_family_name": "Absolute Investment Advisers",
		"label": "Absolute Investment Advisers"
	},
	{
		"fund_family_label": "ProFunds",
		"as_of": "202506",
		"fund_id": 64,
		"net_asset_sum": 2957677360,
		"long_asset_sum": 5037088761,
		"num_equity_funds": 7,
		"equity_fund_net_assets": 100976283,
		"equity_fund_long_assets": 101001129,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 161,
		"ff_all_asset_sum": 5420020,
		"ff_all_weight_total": 0.0536629645001295,
		"grade_fossil_fam": 3,
		"c2_count_sum": 46,
		"c2_asset_sum": 1641919,
		"c2_weight_total": 0.01625644204432606,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 345616,
		"mc50_weight_total": 0.0034219023432896477,
		"co_count_sum": 27,
		"co_asset_sum": 835227,
		"co_weight_total": 0.008269481819356692,
		"og_count_sum": 117,
		"og_asset_sum": 3842286,
		"og_weight_total": 0.03804201040168571,
		"ut_count_sum": 57,
		"ut_asset_sum": 1678524,
		"ut_weight_total": 0.01661886373567171,
		"cl_count_sum": 66,
		"cl_asset_sum": 10607894,
		"cl_weight_total": 0.10502747944530402,
		"fossil_bank_count_sum": 11,
		"fossil_bank_asset_sum": 592210,
		"fossil_bank_weight_total": 0.005863399804174466,
		"fossil_insure_count_sum": 6,
		"fossil_insure_asset_sum": 372487,
		"fossil_insure_weight_total": 0.003687948874314068,
		"name": "ProFunds",
		"fund_family_name": "ProFunds",
		"label": "ProFunds"
	},
	{
		"fund_family_label": "Nicholas Investment Partners",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 100744006,
		"long_asset_sum": 100744006,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 100744006,
		"equity_fund_long_assets": 100744006,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 1543725,
		"ff_all_weight_total": 0.015323244144172707,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 603636,
		"c2_weight_total": 0.005991780791405099,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 1543725,
		"og_weight_total": 0.015323244144172707,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 1083392,
		"cl_weight_total": 0.01075391026241303,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Nicholas Investment Partners",
		"fund_family_name": "Nicholas Investment Partners",
		"label": "Nicholas Investment Partners"
	},
	{
		"fund_family_label": "Bancreek Capital Advisors, LLC",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 99696095,
		"long_asset_sum": 99698426,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 99696095,
		"equity_fund_long_assets": 99698426,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 435598,
		"ff_all_weight_total": 0.004369156239236917,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 435598,
		"og_weight_total": 0.004369156239236917,
		"ut_count_sum": 1,
		"ut_asset_sum": 435598,
		"ut_weight_total": 0.004369156239236917,
		"cl_count_sum": 12,
		"cl_asset_sum": 21383475,
		"cl_weight_total": 0.2144815706518777,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Bancreek Capital Advisors, LLC",
		"fund_family_name": "Bancreek Capital Advisors, LLC",
		"label": "Bancreek Capital Advisors, LLC"
	},
	{
		"fund_family_label": "Pinnacle",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 143051661,
		"long_asset_sum": 143311972,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 99460532,
		"equity_fund_long_assets": 99460532,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 5843405,
		"ff_all_weight_total": 0.05875099280586997,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 1283025,
		"c2_weight_total": 0.012899840511611178,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 643729,
		"co_weight_total": 0.0064722054774450635,
		"og_count_sum": 8,
		"og_asset_sum": 5208979,
		"og_weight_total": 0.05237232191760245,
		"ut_count_sum": 3,
		"ut_asset_sum": 3093073,
		"ut_weight_total": 0.031098496436757446,
		"cl_count_sum": 5,
		"cl_asset_sum": 6772104,
		"cl_weight_total": 0.06808835488633823,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Pinnacle",
		"fund_family_name": "Pinnacle",
		"label": "Pinnacle"
	},
	{
		"fund_family_label": "James Advantage",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 497707709,
		"long_asset_sum": 497707709,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 99001603,
		"equity_fund_long_assets": 99001603,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 23,
		"ff_all_asset_sum": 7466693,
		"ff_all_weight_total": 0.07541992022088774,
		"grade_fossil_fam": 4,
		"c2_count_sum": 10,
		"c2_asset_sum": 3267001,
		"c2_weight_total": 0.03299947577616496,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 5,
		"co_asset_sum": 2586278,
		"co_weight_total": 0.026123597210845163,
		"og_count_sum": 17,
		"og_asset_sum": 4704066,
		"og_weight_total": 0.04751504882198725,
		"ut_count_sum": 7,
		"ut_asset_sum": 2858919,
		"ut_weight_total": 0.02887750211478899,
		"cl_count_sum": 12,
		"cl_asset_sum": 4605710,
		"cl_weight_total": 0.04652156995882178,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 521707,
		"fossil_bank_weight_total": 0.0052696823504968906,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "James Advantage",
		"fund_family_name": "James Advantage",
		"label": "James Advantage"
	},
	{
		"fund_family_label": "Becker",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 98985721,
		"long_asset_sum": 99056835,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 98985721,
		"equity_fund_long_assets": 99056835,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 15229727,
		"ff_all_weight_total": 0.1537473613002071,
		"grade_fossil_fam": 5,
		"c2_count_sum": 4,
		"c2_asset_sum": 6699392,
		"c2_weight_total": 0.06763179946139002,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 3524398,
		"mc50_weight_total": 0.03557955389953656,
		"co_count_sum": 1,
		"co_asset_sum": 2661665,
		"co_weight_total": 0.026870079182319928,
		"og_count_sum": 5,
		"og_asset_sum": 9043664,
		"og_weight_total": 0.09129772821835061,
		"ut_count_sum": 3,
		"ut_asset_sum": 8756612,
		"ut_weight_total": 0.08839987669704973,
		"cl_count_sum": 9,
		"cl_asset_sum": 14826469,
		"cl_weight_total": 0.14967638527921875,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 3200247,
		"fossil_bank_weight_total": 0.03230718001438265,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 6055601,
		"fossil_insure_weight_total": 0.06113259120382758,
		"name": "Becker",
		"fund_family_name": "Becker",
		"label": "Becker"
	},
	{
		"fund_family_label": "OCM",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 98011103,
		"long_asset_sum": 98419892,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 98011103,
		"equity_fund_long_assets": 98419892,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 3808000,
		"ff_all_weight_total": 0.03869136535935236,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 3808000,
		"og_weight_total": 0.03869136535935236,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 3424200,
		"cl_weight_total": 0.03479174718053948,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "OCM",
		"fund_family_name": "OCM",
		"label": "OCM"
	},
	{
		"fund_family_label": "First Manhattan Co.",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 97590807,
		"long_asset_sum": 97590807,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 97590807,
		"equity_fund_long_assets": 97590807,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 13419415,
		"ff_all_weight_total": 0.1375069580068131,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 5722399,
		"mc50_weight_total": 0.05863666031576109,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 7697016,
		"og_weight_total": 0.07887029769105199,
		"ut_count_sum": 1,
		"ut_asset_sum": 5722399,
		"ut_weight_total": 0.05863666031576109,
		"cl_count_sum": 7,
		"cl_asset_sum": 21911851,
		"cl_weight_total": 0.22452781848601785,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 8593185,
		"fossil_insure_weight_total": 0.0880532220621969,
		"name": "First Manhattan Co.",
		"fund_family_name": "First Manhattan Co.",
		"label": "First Manhattan Co."
	},
	{
		"fund_family_label": "Copley",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 96672014,
		"long_asset_sum": 103108667,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 96672014,
		"equity_fund_long_assets": 103108667,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 11084095,
		"ff_all_weight_total": 0.10749915911530503,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 1023630,
		"c2_weight_total": 0.009927681443112828,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 4172232,
		"mc50_weight_total": 0.04046441605146539,
		"co_count_sum": 1,
		"co_asset_sum": 1716475,
		"co_weight_total": 0.016647242660987945,
		"og_count_sum": 3,
		"og_asset_sum": 5195388,
		"og_weight_total": 0.050387500402851684,
		"ut_count_sum": 1,
		"ut_asset_sum": 4172232,
		"ut_weight_total": 0.04046441605146539,
		"cl_count_sum": 4,
		"cl_asset_sum": 19146022,
		"cl_weight_total": 0.1856878044985297,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 18219239,
		"fossil_bank_weight_total": 0.17669939424199907,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 9093645,
		"fossil_insure_weight_total": 0.08819476834086121,
		"name": "Copley",
		"fund_family_name": "Copley",
		"label": "Copley"
	},
	{
		"fund_family_label": "Exponential ETFs",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 95834956,
		"long_asset_sum": 95834956,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 95834956,
		"equity_fund_long_assets": 95834956,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 3628662,
		"ff_all_weight_total": 0.037863658016392264,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 1180967,
		"co_weight_total": 0.012322925259129874,
		"og_count_sum": 2,
		"og_asset_sum": 2411429,
		"og_weight_total": 0.025162311338672708,
		"ut_count_sum": 3,
		"ut_asset_sum": 3628662,
		"ut_weight_total": 0.037863658016392264,
		"cl_count_sum": 6,
		"cl_asset_sum": 22638230,
		"cl_weight_total": 0.23622100896044654,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Exponential ETFs",
		"fund_family_name": "Exponential ETFs",
		"label": "Exponential ETFs"
	},
	{
		"fund_family_label": "World Funds Trust",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 95622433,
		"long_asset_sum": 95622433,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 95622433,
		"equity_fund_long_assets": 95622433,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "World Funds Trust",
		"fund_family_name": "World Funds Trust",
		"label": "World Funds Trust"
	},
	{
		"fund_family_label": "Edgar Lomax",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 95511364,
		"long_asset_sum": 95511364,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 95511364,
		"equity_fund_long_assets": 95511364,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 12684956,
		"ff_all_weight_total": 0.132810960588941,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 6828249,
		"c2_weight_total": 0.07149148241668918,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 2610158,
		"mc50_weight_total": 0.02732824546406855,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 7,
		"og_asset_sum": 12684956,
		"og_weight_total": 0.132810960588941,
		"ut_count_sum": 3,
		"ut_asset_sum": 5603537,
		"ut_weight_total": 0.058668798824818374,
		"cl_count_sum": 6,
		"cl_asset_sum": 13723365,
		"cl_weight_total": 0.14368305953624533,
		"fossil_bank_count_sum": 6,
		"fossil_bank_asset_sum": 8106089,
		"fossil_bank_weight_total": 0.08487041395409242,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Edgar Lomax",
		"fund_family_name": "Edgar Lomax",
		"label": "Edgar Lomax"
	},
	{
		"fund_family_label": "First Foundation Advisors",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 172477691,
		"long_asset_sum": 172746866,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 94501623,
		"equity_fund_long_assets": 94770798,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 11186277,
		"ff_all_weight_total": 0.1180350618130281,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 4173846,
		"c2_weight_total": 0.04404147784004098,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 2291330,
		"mc50_weight_total": 0.024177595296812845,
		"co_count_sum": 1,
		"co_asset_sum": 803640,
		"co_weight_total": 0.008479827298700176,
		"og_count_sum": 3,
		"og_asset_sum": 8091307,
		"og_weight_total": 0.08537763921751508,
		"ut_count_sum": 1,
		"ut_asset_sum": 2291330,
		"ut_weight_total": 0.024177595296812845,
		"cl_count_sum": 2,
		"cl_asset_sum": 3015390,
		"cl_weight_total": 0.03181771245610911,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 2291330,
		"fossil_insure_weight_total": 0.024177595296812845,
		"name": "First Foundation Advisors",
		"fund_family_name": "First Foundation Advisors",
		"label": "First Foundation Advisors"
	},
	{
		"fund_family_label": "MP 63",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 93745004,
		"long_asset_sum": 93745004,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 93745004,
		"equity_fund_long_assets": 93745004,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 8464854,
		"ff_all_weight_total": 0.0902965879653704,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 3462356,
		"c2_weight_total": 0.036933765558322444,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1827087,
		"mc50_weight_total": 0.0194899666333152,
		"co_count_sum": 1,
		"co_asset_sum": 1497382,
		"co_weight_total": 0.015972925874535138,
		"og_count_sum": 5,
		"og_asset_sum": 8464854,
		"og_weight_total": 0.0902965879653704,
		"ut_count_sum": 2,
		"ut_asset_sum": 3840966,
		"ut_weight_total": 0.04097248745117126,
		"cl_count_sum": 11,
		"cl_asset_sum": 13646634,
		"cl_weight_total": 0.14557185362112737,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 4456326,
		"fossil_bank_weight_total": 0.04753667726122237,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 2895346,
		"fossil_insure_weight_total": 0.030885336566842538,
		"name": "MP 63",
		"fund_family_name": "MP 63",
		"label": "MP 63"
	},
	{
		"fund_family_label": "Kempner",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 92650116,
		"long_asset_sum": 92650116,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 92650116,
		"equity_fund_long_assets": 92650116,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 11423484,
		"ff_all_weight_total": 0.12329702857576562,
		"grade_fossil_fam": 5,
		"c2_count_sum": 5,
		"c2_asset_sum": 7589602,
		"c2_weight_total": 0.08191681055207745,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 334926,
		"co_weight_total": 0.0036149549990849446,
		"og_count_sum": 5,
		"og_asset_sum": 9392955,
		"og_weight_total": 0.10138093081286591,
		"ut_count_sum": 1,
		"ut_asset_sum": 1695603,
		"ut_weight_total": 0.01830114276381478,
		"cl_count_sum": 7,
		"cl_asset_sum": 14731460,
		"cl_weight_total": 0.15900098819088365,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 7574794,
		"fossil_bank_weight_total": 0.08175698344511517,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 2787268,
		"fossil_insure_weight_total": 0.030083804752063126,
		"name": "Kempner",
		"fund_family_name": "Kempner",
		"label": "Kempner"
	},
	{
		"fund_family_label": "Sarofim",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 90835357,
		"long_asset_sum": 90835357,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 90835357,
		"equity_fund_long_assets": 90835357,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 4009775,
		"ff_all_weight_total": 0.04414332846184554,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 2389006,
		"c2_weight_total": 0.026300397542335856,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 904853,
		"mc50_weight_total": 0.009961462473252568,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 3104922,
		"og_weight_total": 0.03418186598859296,
		"ut_count_sum": 1,
		"ut_asset_sum": 904853,
		"ut_weight_total": 0.009961462473252568,
		"cl_count_sum": 5,
		"cl_asset_sum": 18249552,
		"cl_weight_total": 0.20090802307299788,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 904853,
		"fossil_insure_weight_total": 0.009961462473252568,
		"name": "Sarofim",
		"fund_family_name": "Sarofim",
		"label": "Sarofim"
	},
	{
		"fund_family_label": "Themes ETF Trust",
		"as_of": "202506",
		"fund_id": 33,
		"net_asset_sum": 164002092,
		"long_asset_sum": 296107489,
		"num_equity_funds": 18,
		"equity_fund_net_assets": 90418079,
		"equity_fund_long_assets": 90431682,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 14,
		"num_five_badgers": 11,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 10,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 53,
		"ff_all_asset_sum": 3351341,
		"ff_all_weight_total": 0.03705936819797292,
		"grade_fossil_fam": 3,
		"c2_count_sum": 23,
		"c2_asset_sum": 873867,
		"c2_weight_total": 0.009663283715103298,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 744874,
		"mc50_weight_total": 0.008236869905836762,
		"co_count_sum": 11,
		"co_asset_sum": 758579,
		"co_weight_total": 0.008388420774922665,
		"og_count_sum": 42,
		"og_asset_sum": 2142695,
		"og_weight_total": 0.02369407438424069,
		"ut_count_sum": 12,
		"ut_asset_sum": 2070817,
		"ut_weight_total": 0.022899242325272684,
		"cl_count_sum": 51,
		"cl_asset_sum": 8790974,
		"cl_weight_total": 0.09721121851963342,
		"fossil_bank_count_sum": 28,
		"fossil_bank_asset_sum": 5612366,
		"fossil_bank_weight_total": 0.06206194417571488,
		"fossil_insure_count_sum": 6,
		"fossil_insure_asset_sum": 244015,
		"fossil_insure_weight_total": 0.0026983353024441145,
		"name": "Themes ETF Trust",
		"fund_family_name": "Themes ETF Trust",
		"label": "Themes ETF Trust"
	},
	{
		"fund_family_label": "Nia Impact Capital",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 90118020,
		"long_asset_sum": 90118020,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 90118020,
		"equity_fund_long_assets": 90118020,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 90118020,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 90118020,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 12,
		"cl_asset_sum": 22202033,
		"cl_weight_total": 0.2463661873618617,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Nia Impact Capital",
		"fund_family_name": "Nia Impact Capital",
		"label": "Nia Impact Capital"
	},
	{
		"fund_family_label": "Curran Investment Partners",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 88421638,
		"long_asset_sum": 88421638,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 88421638,
		"equity_fund_long_assets": 88421638,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 6341991,
		"ff_all_weight_total": 0.07172442338152568,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 2185509,
		"c2_weight_total": 0.024716902439649444,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 2292072,
		"co_weight_total": 0.02592207124685928,
		"og_count_sum": 6,
		"og_asset_sum": 5049518,
		"og_weight_total": 0.05710726598392127,
		"ut_count_sum": 3,
		"ut_asset_sum": 2394864,
		"ut_weight_total": 0.02708459212212287,
		"cl_count_sum": 6,
		"cl_asset_sum": 20090693,
		"cl_weight_total": 0.2272146666181416,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Curran Investment Partners",
		"fund_family_name": "Curran Investment Partners",
		"label": "Curran Investment Partners"
	},
	{
		"fund_family_label": "KKM Financial LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 88327532,
		"long_asset_sum": 88327532,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 88327532,
		"equity_fund_long_assets": 88327532,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 11038812,
		"ff_all_weight_total": 0.12497589086945167,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 1978380,
		"c2_weight_total": 0.022398225731021217,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 4753598,
		"mc50_weight_total": 0.053817851493914715,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 8620308,
		"og_weight_total": 0.09759480203748928,
		"ut_count_sum": 2,
		"ut_asset_sum": 4753598,
		"ut_weight_total": 0.053817851493914715,
		"cl_count_sum": 4,
		"cl_asset_sum": 8159586,
		"cl_weight_total": 0.09237873871535321,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 4830579,
		"fossil_insure_weight_total": 0.05468939175160017,
		"name": "KKM Financial LLC",
		"fund_family_name": "KKM Financial LLC",
		"label": "KKM Financial LLC"
	},
	{
		"fund_family_label": "Keating Investment Counselors Inc",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 87709539,
		"long_asset_sum": 87709539,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 87709539,
		"equity_fund_long_assets": 87709539,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 16314974,
		"ff_all_weight_total": 0.1860113983725305,
		"grade_fossil_fam": 5,
		"c2_count_sum": 4,
		"c2_asset_sum": 7956419,
		"c2_weight_total": 0.09071326894102134,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 7,
		"og_asset_sum": 16314974,
		"og_weight_total": 0.1860113983725305,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 3184338,
		"cl_weight_total": 0.03630549238207716,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Keating Investment Counselors Inc",
		"fund_family_name": "Keating Investment Counselors Inc",
		"label": "Keating Investment Counselors Inc"
	},
	{
		"fund_family_label": "Schwartz",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 87116956,
		"long_asset_sum": 87116956,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 87116956,
		"equity_fund_long_assets": 87116956,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 33345071,
		"ff_all_weight_total": 0.3827621226802277,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 5075640,
		"c2_weight_total": 0.05826236628378062,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 1925040,
		"co_weight_total": 0.022097190815528495,
		"og_count_sum": 6,
		"og_asset_sum": 33345071,
		"og_weight_total": 0.3827621226802277,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Schwartz",
		"fund_family_name": "Schwartz",
		"label": "Schwartz"
	},
	{
		"fund_family_label": "Kirr Marbach Partners",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 85658713,
		"long_asset_sum": 85658713,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 85658713,
		"equity_fund_long_assets": 85658713,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 10117283,
		"ff_all_weight_total": 0.11811154575717242,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 1811304,
		"c2_weight_total": 0.02114558970784443,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 4300535,
		"co_weight_total": 0.05020545895897362,
		"og_count_sum": 4,
		"og_asset_sum": 5816748,
		"og_weight_total": 0.0679060867981988,
		"ut_count_sum": 1,
		"ut_asset_sum": 4300535,
		"ut_weight_total": 0.05020545895897362,
		"cl_count_sum": 5,
		"cl_asset_sum": 18831510,
		"cl_weight_total": 0.21984348515719587,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Kirr Marbach Partners",
		"fund_family_name": "Kirr Marbach Partners",
		"label": "Kirr Marbach Partners"
	},
	{
		"fund_family_label": "Kennedy Capital Management",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 85360475,
		"long_asset_sum": 85876389,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 85360475,
		"equity_fund_long_assets": 85876389,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 61020427,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 61020427,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 15,
		"ff_all_asset_sum": 3226464,
		"ff_all_weight_total": 0.03757102548874057,
		"grade_fossil_fam": 3,
		"c2_count_sum": 5,
		"c2_asset_sum": 991752,
		"c2_weight_total": 0.011548599231390597,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 3,
		"co_asset_sum": 583437,
		"co_weight_total": 0.006793916311502106,
		"og_count_sum": 13,
		"og_asset_sum": 2801511,
		"og_weight_total": 0.032622598977700375,
		"ut_count_sum": 4,
		"ut_asset_sum": 764958,
		"ut_weight_total": 0.008907663781717697,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Kennedy Capital Management",
		"fund_family_name": "Kennedy Capital Management",
		"label": "Kennedy Capital Management"
	},
	{
		"fund_family_label": "Modern Capital",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 84760335,
		"long_asset_sum": 85966933,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 84760335,
		"equity_fund_long_assets": 85966933,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 2502833,
		"ff_all_weight_total": 0.029113903598259112,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 793962,
		"c2_weight_total": 0.009235667393182446,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 481786,
		"mc50_weight_total": 0.00560431765083442,
		"co_count_sum": 1,
		"co_asset_sum": 481786,
		"co_weight_total": 0.00560431765083442,
		"og_count_sum": 4,
		"og_asset_sum": 1626666,
		"og_weight_total": 0.018921996437862916,
		"ut_count_sum": 2,
		"ut_asset_sum": 1357953,
		"ut_weight_total": 0.015796224811230615,
		"cl_count_sum": 1,
		"cl_asset_sum": 1281480,
		"cl_weight_total": 0.014906661844037172,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 433200,
		"fossil_bank_weight_total": 0.005039146854291057,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Modern Capital",
		"fund_family_name": "Modern Capital",
		"label": "Modern Capital"
	},
	{
		"fund_family_label": "RiverPark Funds",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 910237571,
		"long_asset_sum": 919576957,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 84657572,
		"equity_fund_long_assets": 84657572,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 2064818,
		"ff_all_weight_total": 0.02439023410687942,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 2064818,
		"og_weight_total": 0.02439023410687942,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 17,
		"cl_asset_sum": 18609863,
		"cl_weight_total": 0.21982514452457957,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 75562,
		"fossil_bank_weight_total": 0.0008925604433824301,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "RiverPark Funds",
		"fund_family_name": "RiverPark Funds",
		"label": "RiverPark Funds"
	},
	{
		"fund_family_label": "Intrepid Funds",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 1036502643,
		"long_asset_sum": 1084708836,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 84407237,
		"equity_fund_long_assets": 84502541,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 4807774,
		"ff_all_weight_total": 0.05689502283724226,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1,
		"c2_asset_sum": 1336950,
		"c2_weight_total": 0.015821417725178227,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 3470824,
		"mc50_weight_total": 0.041073605112064024,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 1336950,
		"og_weight_total": 0.015821417725178227,
		"ut_count_sum": 1,
		"ut_asset_sum": 3470824,
		"ut_weight_total": 0.041073605112064024,
		"cl_count_sum": 1,
		"cl_asset_sum": 2706664,
		"cl_weight_total": 0.032030563435956325,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 3470824,
		"fossil_insure_weight_total": 0.041073605112064024,
		"name": "Intrepid Funds",
		"fund_family_name": "Intrepid Funds",
		"label": "Intrepid Funds"
	},
	{
		"fund_family_label": "Plumb Funds",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 83837575,
		"long_asset_sum": 83873547,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 83837575,
		"equity_fund_long_assets": 83873547,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 3520623,
		"ff_all_weight_total": 0.04197536799057753,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 1427160,
		"c2_weight_total": 0.017015615185560235,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 3520623,
		"og_weight_total": 0.04197536799057753,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 11,
		"cl_asset_sum": 13396006,
		"cl_weight_total": 0.15971669828152135,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Plumb Funds",
		"fund_family_name": "Plumb Funds",
		"label": "Plumb Funds"
	},
	{
		"fund_family_label": "ReyndersMcVeigh Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 82962597,
		"long_asset_sum": 82962597,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 82962597,
		"equity_fund_long_assets": 82962597,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 82962597,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 82962597,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 9,
		"cl_asset_sum": 19447126,
		"cl_weight_total": 0.23440835633436113,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "ReyndersMcVeigh Funds",
		"fund_family_name": "ReyndersMcVeigh Funds",
		"label": "ReyndersMcVeigh Funds"
	},
	{
		"fund_family_label": "River1 Asset Management LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 81539851,
		"long_asset_sum": 82089031,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 81539851,
		"equity_fund_long_assets": 82089031,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 16244949,
		"cl_weight_total": 0.1978942716475725,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "River1 Asset Management LLC",
		"fund_family_name": "River1 Asset Management LLC",
		"label": "River1 Asset Management LLC"
	},
	{
		"fund_family_label": "Waycross",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 180873747,
		"long_asset_sum": 224091336,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 81343413,
		"equity_fund_long_assets": 81343413,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 3868520,
		"ff_all_weight_total": 0.04755787662855995,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 1707387,
		"c2_weight_total": 0.02098986183429505,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 2161133,
		"co_weight_total": 0.0265680147942649,
		"og_count_sum": 1,
		"og_asset_sum": 1707387,
		"og_weight_total": 0.02098986183429505,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 6,
		"cl_asset_sum": 21265169,
		"cl_weight_total": 0.26142459746556246,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 8988125,
		"fossil_bank_weight_total": 0.11049603979611723,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Waycross",
		"fund_family_name": "Waycross",
		"label": "Waycross"
	},
	{
		"fund_family_label": "SWP Investment Management, LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 80316512,
		"long_asset_sum": 80316512,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 80316512,
		"equity_fund_long_assets": 80316512,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 7524464,
		"ff_all_weight_total": 0.09368514409589898,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1680948,
		"mc50_weight_total": 0.020929046321135063,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 7524464,
		"og_weight_total": 0.09368514409589898,
		"ut_count_sum": 2,
		"ut_asset_sum": 3209022,
		"ut_weight_total": 0.03995469823191525,
		"cl_count_sum": 7,
		"cl_asset_sum": 15597432,
		"cl_weight_total": 0.19419956882589723,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 4579319,
		"fossil_bank_weight_total": 0.05701590975464672,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "SWP Investment Management, LLC",
		"fund_family_name": "SWP Investment Management, LLC",
		"label": "SWP Investment Management, LLC"
	},
	{
		"fund_family_label": "Rockefeller",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 80089804,
		"long_asset_sum": 80089804,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 80089804,
		"equity_fund_long_assets": 80089804,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 80089804,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 80089804,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 6746503,
		"ff_all_weight_total": 0.08423672756147586,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 4745948,
		"og_weight_total": 0.05925783012279565,
		"ut_count_sum": 3,
		"ut_asset_sum": 5674665,
		"ut_weight_total": 0.07085377559420672,
		"cl_count_sum": 7,
		"cl_asset_sum": 12373867,
		"cl_weight_total": 0.1544999036331766,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 3144622,
		"fossil_insure_weight_total": 0.03926369953408801,
		"name": "Rockefeller",
		"fund_family_name": "Rockefeller",
		"label": "Rockefeller"
	},
	{
		"fund_family_label": "Counterpoint Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 79752148,
		"long_asset_sum": 79752148,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 79752148,
		"equity_fund_long_assets": 79752148,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 13402705,
		"ff_all_weight_total": 0.16805447045764837,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 4914183,
		"c2_weight_total": 0.06161818989502327,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 9,
		"og_asset_sum": 13402705,
		"og_weight_total": 0.16805447045764837,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 3,
		"cl_asset_sum": 4332890,
		"cl_weight_total": 0.05432944577241982,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Counterpoint Funds",
		"fund_family_name": "Counterpoint Funds",
		"label": "Counterpoint Funds"
	},
	{
		"fund_family_label": "Acuitas Investments",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 79166630,
		"long_asset_sum": 79194648,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 79166630,
		"equity_fund_long_assets": 79194648,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 10,
		"ff_all_asset_sum": 4267016,
		"ff_all_weight_total": 0.05388010563542122,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 455838,
		"c2_weight_total": 0.005755919263635088,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 10,
		"og_asset_sum": 4267016,
		"og_weight_total": 0.05388010563542122,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Acuitas Investments",
		"fund_family_name": "Acuitas Investments",
		"label": "Acuitas Investments"
	},
	{
		"fund_family_label": "Monetta",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 116527166,
		"long_asset_sum": 116534808,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 78712916,
		"equity_fund_long_assets": 78712916,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 2823800,
		"ff_all_weight_total": 0.035874671445280976,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 822080,
		"co_weight_total": 0.010444029287391665,
		"og_count_sum": 1,
		"og_asset_sum": 1195200,
		"og_weight_total": 0.015184293261349891,
		"ut_count_sum": 2,
		"ut_asset_sum": 1628600,
		"ut_weight_total": 0.020690378183931084,
		"cl_count_sum": 7,
		"cl_asset_sum": 15323345,
		"cl_weight_total": 0.19467383218276402,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 1365725,
		"fossil_bank_weight_total": 0.01735071026970974,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 1130220,
		"fossil_insure_weight_total": 0.01435876165482168,
		"name": "Monetta",
		"fund_family_name": "Monetta",
		"label": "Monetta"
	},
	{
		"fund_family_label": "EIP Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 78499047,
		"long_asset_sum": 83051326,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 78499047,
		"equity_fund_long_assets": 83051326,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 69,
		"ff_all_asset_sum": 69014024,
		"ff_all_weight_total": 0.8309803987958001,
		"grade_fossil_fam": 5,
		"c2_count_sum": 11,
		"c2_asset_sum": 12117848,
		"c2_weight_total": 0.14590794131330306,
		"mc50_count_sum": 4,
		"mc50_asset_sum": 4381032,
		"mc50_weight_total": 0.05275089767982753,
		"co_count_sum": 12,
		"co_asset_sum": 10130782,
		"co_weight_total": 0.12198218243980836,
		"og_count_sum": 53,
		"og_asset_sum": 58032530,
		"og_weight_total": 0.6987550084389983,
		"ut_count_sum": 35,
		"ut_asset_sum": 25987319,
		"ut_weight_total": 0.3129067319165982,
		"cl_count_sum": 3,
		"cl_asset_sum": 1082073,
		"cl_weight_total": 0.013028967171457323,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "EIP Funds",
		"fund_family_name": "EIP Funds",
		"label": "EIP Funds"
	},
	{
		"fund_family_label": "Blue Current Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 78161319,
		"long_asset_sum": 78161319,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 78161319,
		"equity_fund_long_assets": 78161319,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 5765869,
		"ff_all_weight_total": 0.07376882931056984,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1,
		"c2_asset_sum": 2446086,
		"c2_weight_total": 0.031295352116562924,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 5765869,
		"og_weight_total": 0.07376882931056984,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 4,
		"cl_asset_sum": 7659258,
		"cl_weight_total": 0.09799294712516303,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 11629878,
		"fossil_bank_weight_total": 0.14879326690994046,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 2602861,
		"fossil_insure_weight_total": 0.033301139659631385,
		"name": "Blue Current Funds",
		"fund_family_name": "Blue Current Funds",
		"label": "Blue Current Funds"
	},
	{
		"fund_family_label": "Chase",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 77756900,
		"long_asset_sum": 77791944,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 77756900,
		"equity_fund_long_assets": 77791944,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 8685776,
		"ff_all_weight_total": 0.11165392652997591,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 2359149,
		"c2_weight_total": 0.030326392151866007,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 3066596,
		"mc50_weight_total": 0.03942048292301321,
		"co_count_sum": 1,
		"co_asset_sum": 2359149,
		"co_weight_total": 0.030326392151866007,
		"og_count_sum": 3,
		"og_asset_sum": 5619180,
		"og_weight_total": 0.0722334436069627,
		"ut_count_sum": 1,
		"ut_asset_sum": 3066596,
		"ut_weight_total": 0.03942048292301321,
		"cl_count_sum": 5,
		"cl_asset_sum": 7668851,
		"cl_weight_total": 0.0985815574939225,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 2393296,
		"fossil_bank_weight_total": 0.03076534505938044,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 3066596,
		"fossil_insure_weight_total": 0.03942048292301321,
		"name": "Chase",
		"fund_family_name": "Chase",
		"label": "Chase"
	},
	{
		"fund_family_label": "Logan Capital",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 76192922,
		"long_asset_sum": 76262125,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 76192922,
		"equity_fund_long_assets": 76262125,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 381384,
		"ff_all_weight_total": 0.005000962142085603,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 381384,
		"og_weight_total": 0.005000962142085603,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 4,
		"cl_asset_sum": 10557014,
		"cl_weight_total": 0.13843062988344476,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Logan Capital",
		"fund_family_name": "Logan Capital",
		"label": "Logan Capital"
	},
	{
		"fund_family_label": "The Rock Creek Group, LP",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 75633145,
		"long_asset_sum": 75633145,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 75633145,
		"equity_fund_long_assets": 75633145,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 12,
		"ff_all_asset_sum": 4786353,
		"ff_all_weight_total": 0.06328380235940209,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 7,
		"og_asset_sum": 2774848,
		"og_weight_total": 0.03668825354280851,
		"ut_count_sum": 10,
		"ut_asset_sum": 4081713,
		"ut_weight_total": 0.05396725205596039,
		"cl_count_sum": 22,
		"cl_asset_sum": 7991256,
		"cl_weight_total": 0.1056581211848324,
		"fossil_bank_count_sum": 21,
		"fossil_bank_asset_sum": 8056343,
		"fossil_bank_weight_total": 0.1065186830456409,
		"fossil_insure_count_sum": 6,
		"fossil_insure_asset_sum": 2292107,
		"fossil_insure_weight_total": 0.030305588905499038,
		"name": "The Rock Creek Group, LP",
		"fund_family_name": "The Rock Creek Group, LP",
		"label": "The Rock Creek Group, LP"
	},
	{
		"fund_family_label": "Towle",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 74125185,
		"long_asset_sum": 74125185,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 74125185,
		"equity_fund_long_assets": 74125185,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 12579623,
		"ff_all_weight_total": 0.16970781253362133,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 843183,
		"c2_weight_total": 0.011375121694468622,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 843183,
		"co_weight_total": 0.011375121694468622,
		"og_count_sum": 7,
		"og_asset_sum": 11736440,
		"og_weight_total": 0.15833269083915272,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Towle",
		"fund_family_name": "Towle",
		"label": "Towle"
	},
	{
		"fund_family_label": "LoCorr Funds",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 2713618020,
		"long_asset_sum": 7773280983,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 73912762,
		"equity_fund_long_assets": 73935735,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 27,
		"ff_all_asset_sum": 28363696,
		"ff_all_weight_total": 0.3836263479358121,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 1533543,
		"c2_weight_total": 0.020741566983813714,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 903923,
		"co_weight_total": 0.012225793116143364,
		"og_count_sum": 26,
		"og_asset_sum": 27459773,
		"og_weight_total": 0.3714005548196687,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 2991905,
		"cl_weight_total": 0.04046629143539318,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "LoCorr Funds",
		"fund_family_name": "LoCorr Funds",
		"label": "LoCorr Funds"
	},
	{
		"fund_family_label": "Union Street Partners",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 73861107,
		"long_asset_sum": 73861107,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 73861107,
		"equity_fund_long_assets": 73861107,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 9999519,
		"ff_all_weight_total": 0.1353827393894868,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 5279631,
		"c2_weight_total": 0.07148052898800988,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 7348731,
		"og_weight_total": 0.09949391903915006,
		"ut_count_sum": 1,
		"ut_asset_sum": 2650788,
		"ut_weight_total": 0.03588882035033675,
		"cl_count_sum": 5,
		"cl_asset_sum": 18839656,
		"cl_weight_total": 0.2550686926476745,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 5079903,
		"fossil_bank_weight_total": 0.06877642654340396,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Union Street Partners",
		"fund_family_name": "Union Street Partners",
		"label": "Union Street Partners"
	},
	{
		"fund_family_label": "Golub",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 73533585,
		"long_asset_sum": 73533585,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 73533585,
		"equity_fund_long_assets": 73533585,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 3,
		"cl_asset_sum": 10039407,
		"cl_weight_total": 0.13652818640625233,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 2566443,
		"fossil_bank_weight_total": 0.03490164392229755,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Golub",
		"fund_family_name": "Golub",
		"label": "Golub"
	},
	{
		"fund_family_label": "InfraCap",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 88643066,
		"long_asset_sum": 103009195,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 72879066,
		"equity_fund_long_assets": 87193372,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 20,
		"ff_all_asset_sum": 14123947,
		"ff_all_weight_total": 0.16198418154994626,
		"grade_fossil_fam": 5,
		"c2_count_sum": 4,
		"c2_asset_sum": 4189747,
		"c2_weight_total": 0.048051209672221415,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 417968,
		"mc50_weight_total": 0.004793575364879799,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 16,
		"og_asset_sum": 12665664,
		"og_weight_total": 0.14525948142021622,
		"ut_count_sum": 9,
		"ut_asset_sum": 3412659,
		"ut_weight_total": 0.03913897262741484,
		"cl_count_sum": 5,
		"cl_asset_sum": 6519302,
		"cl_weight_total": 0.07476832069299946,
		"fossil_bank_count_sum": 7,
		"fossil_bank_asset_sum": 10935035,
		"fossil_bank_weight_total": 0.12541130993305316,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "InfraCap",
		"fund_family_name": "InfraCap",
		"label": "InfraCap"
	},
	{
		"fund_family_label": "Cook & Bynum",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 72637956,
		"long_asset_sum": 72637956,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 72637956,
		"equity_fund_long_assets": 72637956,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 17049484,
		"ff_all_weight_total": 0.23471866416505444,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 17049484,
		"mc50_weight_total": 0.23471866416505444,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 17049484,
		"ut_weight_total": 0.23471866416505444,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 17049484,
		"fossil_insure_weight_total": 0.23471866416505444,
		"name": "Cook & Bynum",
		"fund_family_name": "Cook & Bynum",
		"label": "Cook & Bynum"
	},
	{
		"fund_family_label": "The Future Fund",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 109998290,
		"long_asset_sum": 128068764,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 71455401,
		"equity_fund_long_assets": 72066605,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 4175974,
		"ff_all_weight_total": 0.05794603478268471,
		"grade_fossil_fam": 4,
		"c2_count_sum": 3,
		"c2_asset_sum": 2217963,
		"c2_weight_total": 0.030776571201043813,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 6,
		"og_asset_sum": 4175974,
		"og_weight_total": 0.05794603478268471,
		"ut_count_sum": 2,
		"ut_asset_sum": 1343756,
		"ut_weight_total": 0.018646028906176445,
		"cl_count_sum": 10,
		"cl_asset_sum": 10635658,
		"cl_weight_total": 0.14758094959516962,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 3070820,
		"fossil_bank_weight_total": 0.0426108597733999,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "The Future Fund",
		"fund_family_name": "The Future Fund",
		"label": "The Future Fund"
	},
	{
		"fund_family_label": "Beck, Mack & Oliver",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 71317776,
		"long_asset_sum": 71317776,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 71317776,
		"equity_fund_long_assets": 71317776,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 5854660,
		"ff_all_weight_total": 0.08209257675113145,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 5854660,
		"og_weight_total": 0.08209257675113145,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 8003575,
		"cl_weight_total": 0.11222412488017013,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Beck, Mack & Oliver",
		"fund_family_name": "Beck, Mack & Oliver",
		"label": "Beck, Mack & Oliver"
	},
	{
		"fund_family_label": "Jacob",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 70709858,
		"long_asset_sum": 70924902,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 70709858,
		"equity_fund_long_assets": 70924902,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 3,
		"num_five_badgers": 3,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 3,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Jacob",
		"fund_family_name": "Jacob",
		"label": "Jacob"
	},
	{
		"fund_family_label": "Rational Funds",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 1562535543,
		"long_asset_sum": 1564624201,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 70431489,
		"equity_fund_long_assets": 70467432,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 5385101,
		"ff_all_weight_total": 0.07641971400348462,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 5385101,
		"og_weight_total": 0.07641971400348462,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 3,
		"cl_asset_sum": 6959057,
		"cl_weight_total": 0.09875564927639197,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Rational Funds",
		"fund_family_name": "Rational Funds",
		"label": "Rational Funds"
	},
	{
		"fund_family_label": "Marmont Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 69879616,
		"long_asset_sum": 69879616,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 69879616,
		"equity_fund_long_assets": 69879616,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 3903833,
		"ff_all_weight_total": 0.05586511809108968,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 3903833,
		"og_weight_total": 0.05586511809108968,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 4,
		"cl_asset_sum": 12844797,
		"cl_weight_total": 0.18381321671830594,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 3421827,
		"fossil_bank_weight_total": 0.048967455688365545,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Marmont Funds",
		"fund_family_name": "Marmont Funds",
		"label": "Marmont Funds"
	},
	{
		"fund_family_label": "Sound ETF",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 69705348,
		"long_asset_sum": 70013845,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 69705348,
		"equity_fund_long_assets": 70013845,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 7016976,
		"ff_all_weight_total": 0.10022269166905488,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 779212,
		"c2_weight_total": 0.011129398763915908,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 826207,
		"mc50_weight_total": 0.011800623148178764,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 6,
		"og_asset_sum": 4997098,
		"og_weight_total": 0.07137299772637826,
		"ut_count_sum": 2,
		"ut_asset_sum": 2019878,
		"ut_weight_total": 0.028849693942676623,
		"cl_count_sum": 8,
		"cl_asset_sum": 7260890,
		"cl_weight_total": 0.10370648833812798,
		"fossil_bank_count_sum": 6,
		"fossil_bank_asset_sum": 5254801,
		"fossil_bank_weight_total": 0.07505374115648127,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Sound ETF",
		"fund_family_name": "Sound ETF",
		"label": "Sound ETF"
	},
	{
		"fund_family_label": "Matrix Asset Advisors Inc",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 69653097,
		"long_asset_sum": 69653097,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 69653097,
		"equity_fund_long_assets": 69653097,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 5,
		"cl_asset_sum": 16245773,
		"cl_weight_total": 0.23323834401792645,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 13587149,
		"fossil_bank_weight_total": 0.19506884238040414,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Matrix Asset Advisors Inc",
		"fund_family_name": "Matrix Asset Advisors Inc",
		"label": "Matrix Asset Advisors Inc"
	},
	{
		"fund_family_label": "Vaughan Nelson",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 68873239,
		"long_asset_sum": 68952662,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 68873239,
		"equity_fund_long_assets": 68952662,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 10919102,
		"ff_all_weight_total": 0.15835649680936176,
		"grade_fossil_fam": 5,
		"c2_count_sum": 4,
		"c2_asset_sum": 4232939,
		"c2_weight_total": 0.06138905848189008,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 3066648,
		"co_weight_total": 0.04447468612596857,
		"og_count_sum": 7,
		"og_asset_sum": 7852454,
		"og_weight_total": 0.11388181068339319,
		"ut_count_sum": 1,
		"ut_asset_sum": 1103729,
		"ut_weight_total": 0.016007054230915696,
		"cl_count_sum": 4,
		"cl_asset_sum": 9403981,
		"cl_weight_total": 0.13638314645488234,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 1434454,
		"fossil_bank_weight_total": 0.02080346078589395,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Vaughan Nelson",
		"fund_family_name": "Vaughan Nelson",
		"label": "Vaughan Nelson"
	},
	{
		"fund_family_label": "Reynolds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 68473257,
		"long_asset_sum": 68473257,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 68473257,
		"equity_fund_long_assets": 68473257,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 10,
		"ff_all_asset_sum": 700169,
		"ff_all_weight_total": 0.010225437355784026,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 90656,
		"mc50_weight_total": 0.0013239621418913957,
		"co_count_sum": 1,
		"co_asset_sum": 34468,
		"co_weight_total": 0.0005033790053246628,
		"og_count_sum": 7,
		"og_asset_sum": 513525,
		"og_weight_total": 0.007499643254884166,
		"ut_count_sum": 3,
		"ut_asset_sum": 186644,
		"ut_weight_total": 0.0027257941008998593,
		"cl_count_sum": 18,
		"cl_asset_sum": 14940305,
		"cl_weight_total": 0.21819182633593726,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 521900,
		"fossil_bank_weight_total": 0.007621953779707018,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 90656,
		"fossil_insure_weight_total": 0.0013239621418913957,
		"name": "Reynolds",
		"fund_family_name": "Reynolds",
		"label": "Reynolds"
	},
	{
		"fund_family_label": "AlphaCentric Funds",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 494995696,
		"long_asset_sum": 504826417,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 67771160,
		"equity_fund_long_assets": 67771160,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 3,
		"cl_asset_sum": 6637250,
		"cl_weight_total": 0.09793620177078273,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "AlphaCentric Funds",
		"fund_family_name": "AlphaCentric Funds",
		"label": "AlphaCentric Funds"
	},
	{
		"fund_family_label": "Al Frank",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 67310412,
		"long_asset_sum": 67310412,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 67310412,
		"equity_fund_long_assets": 67310412,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 4312640,
		"ff_all_weight_total": 0.06407091966693058,
		"grade_fossil_fam": 4,
		"c2_count_sum": 3,
		"c2_asset_sum": 3464940,
		"c2_weight_total": 0.05147702854648995,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 847700,
		"co_weight_total": 0.012593891120440624,
		"og_count_sum": 3,
		"og_asset_sum": 3464940,
		"og_weight_total": 0.05147702854648995,
		"ut_count_sum": 1,
		"ut_asset_sum": 847700,
		"ut_weight_total": 0.012593891120440624,
		"cl_count_sum": 9,
		"cl_asset_sum": 9159050,
		"cl_weight_total": 0.13607181605128194,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 4861510,
		"fossil_bank_weight_total": 0.0722252301768707,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Al Frank",
		"fund_family_name": "Al Frank",
		"label": "Al Frank"
	},
	{
		"fund_family_label": "Sparrow",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 65208204,
		"long_asset_sum": 65208204,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 65208204,
		"equity_fund_long_assets": 65208204,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 2818358,
		"ff_all_weight_total": 0.04322091128288091,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 2818358,
		"mc50_weight_total": 0.04322091128288091,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 2818358,
		"ut_weight_total": 0.04322091128288091,
		"cl_count_sum": 7,
		"cl_asset_sum": 11368217,
		"cl_weight_total": 0.17433721989950834,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 3162408,
		"fossil_insure_weight_total": 0.04849708788176408,
		"name": "Sparrow",
		"fund_family_name": "Sparrow",
		"label": "Sparrow"
	},
	{
		"fund_family_label": "Xsquare Capital",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 69195954,
		"long_asset_sum": 69365504,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 64794360,
		"equity_fund_long_assets": 64923183,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 5609299,
		"ff_all_weight_total": 0.08639901404710856,
		"grade_fossil_fam": 4,
		"c2_count_sum": 5,
		"c2_asset_sum": 4003584,
		"c2_weight_total": 0.06166647744304219,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1099245,
		"mc50_weight_total": 0.01693147115106787,
		"co_count_sum": 3,
		"co_asset_sum": 1657719,
		"co_weight_total": 0.025533544773983122,
		"og_count_sum": 6,
		"og_asset_sum": 4011731,
		"og_weight_total": 0.061791964204835736,
		"ut_count_sum": 2,
		"ut_asset_sum": 1275567,
		"ut_weight_total": 0.019647326903241943,
		"cl_count_sum": 6,
		"cl_asset_sum": 4020745,
		"cl_weight_total": 0.06193080521021281,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 362120,
		"fossil_bank_weight_total": 0.005577668611842399,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 2023032,
		"fossil_insure_weight_total": 0.03116039458508989,
		"name": "Xsquare Capital",
		"fund_family_name": "Xsquare Capital",
		"label": "Xsquare Capital"
	},
	{
		"fund_family_label": "F/m investments, LLC",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 531851672,
		"long_asset_sum": 531929411,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 64724699,
		"equity_fund_long_assets": 64799699,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 4614432,
		"ff_all_weight_total": 0.07121070114847293,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1,
		"c2_asset_sum": 1726890,
		"c2_weight_total": 0.026649660826356617,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 1416250,
		"co_weight_total": 0.021855811398136277,
		"og_count_sum": 2,
		"og_asset_sum": 3198182,
		"og_weight_total": 0.049354889750336646,
		"ut_count_sum": 2,
		"ut_asset_sum": 2887542,
		"ut_weight_total": 0.04456104032211631,
		"cl_count_sum": 6,
		"cl_asset_sum": 14345455,
		"cl_weight_total": 0.221381506725826,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "F/m investments, LLC",
		"fund_family_name": "F/m investments, LLC",
		"label": "F/m investments, LLC"
	},
	{
		"fund_family_label": "Private Capital Management",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 64387482,
		"long_asset_sum": 64418356,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 64387482,
		"equity_fund_long_assets": 64418356,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 4414127,
		"ff_all_weight_total": 0.06852281359058589,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 4414127,
		"og_weight_total": 0.06852281359058589,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Private Capital Management",
		"fund_family_name": "Private Capital Management",
		"label": "Private Capital Management"
	},
	{
		"fund_family_label": "Slow Capital Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 63727584,
		"long_asset_sum": 63727584,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 63727584,
		"equity_fund_long_assets": 63727584,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 7,
		"cl_asset_sum": 14917881,
		"cl_weight_total": 0.23408828742040497,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 1237296,
		"fossil_insure_weight_total": 0.01941539161440672,
		"name": "Slow Capital Funds",
		"fund_family_name": "Slow Capital Funds",
		"label": "Slow Capital Funds"
	},
	{
		"fund_family_label": "SmartETFs",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 62357835,
		"long_asset_sum": 62357835,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 62357835,
		"equity_fund_long_assets": 62357835,
		"num_e_sri": 2,
		"num_e_usf": 0,
		"sri_long_assets": 11336498,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 11336498,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 4,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 950267,
		"ff_all_weight_total": 0.015238935091316111,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 862266,
		"og_weight_total": 0.013827709060136549,
		"ut_count_sum": 3,
		"ut_asset_sum": 497167,
		"ut_weight_total": 0.007972807266320263,
		"cl_count_sum": 29,
		"cl_asset_sum": 12025946,
		"cl_weight_total": 0.19285380898807664,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 1324446,
		"fossil_bank_weight_total": 0.02123944809822214,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 297227,
		"fossil_insure_weight_total": 0.004766474012447674,
		"name": "SmartETFs",
		"fund_family_name": "SmartETFs",
		"label": "SmartETFs"
	},
	{
		"fund_family_label": "HVIA Equity Fund",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 61035079,
		"long_asset_sum": 61035079,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 61035079,
		"equity_fund_long_assets": 61035079,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 3169005,
		"ff_all_weight_total": 0.05192104363459577,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 891975,
		"c2_weight_total": 0.01461413689658696,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 588600,
		"co_weight_total": 0.009643634605601149,
		"og_count_sum": 3,
		"og_asset_sum": 2580405,
		"og_weight_total": 0.04227740902899462,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 6,
		"cl_asset_sum": 7862883,
		"cl_weight_total": 0.12882563812197245,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 2318988,
		"fossil_bank_weight_total": 0.03799434748007781,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "HVIA Equity Fund",
		"fund_family_name": "HVIA Equity Fund",
		"label": "HVIA Equity Fund"
	},
	{
		"fund_family_label": "Fort Pitt Capital Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 60495784,
		"long_asset_sum": 60495784,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 60495784,
		"equity_fund_long_assets": 60495784,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 1720752,
		"ff_all_weight_total": 0.02844416397678225,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 1720752,
		"og_weight_total": 0.02844416397678225,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 6,
		"cl_asset_sum": 17343193,
		"cl_weight_total": 0.2866843249770926,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 2222982,
		"fossil_bank_weight_total": 0.0367460648166821,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Fort Pitt Capital Funds",
		"fund_family_name": "Fort Pitt Capital Funds",
		"label": "Fort Pitt Capital Funds"
	},
	{
		"fund_family_label": "Permanent Portfolio Family of Funds",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 4790537969,
		"long_asset_sum": 4790570803,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 60337297,
		"equity_fund_long_assets": 60337297,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 2615200,
		"ff_all_weight_total": 0.043343008885532275,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 1412400,
		"c2_weight_total": 0.023408406909577007,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 2615200,
		"og_weight_total": 0.043343008885532275,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 5,
		"cl_asset_sum": 7788370,
		"cl_weight_total": 0.12908052543354734,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 1154200,
		"fossil_bank_weight_total": 0.019129130030468552,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Permanent Portfolio Family of Funds",
		"fund_family_name": "Permanent Portfolio Family of Funds",
		"label": "Permanent Portfolio Family of Funds"
	},
	{
		"fund_family_label": "Madison Asset Management, LLC",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 235606262,
		"long_asset_sum": 237261547,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 60320765,
		"equity_fund_long_assets": 60402627,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 7877001,
		"ff_all_weight_total": 0.13040825194573077,
		"grade_fossil_fam": 5,
		"c2_count_sum": 4,
		"c2_asset_sum": 5710119,
		"c2_weight_total": 0.09453428242450448,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 7877001,
		"og_weight_total": 0.13040825194573077,
		"ut_count_sum": 1,
		"ut_asset_sum": 2166882,
		"ut_weight_total": 0.03587396952122629,
		"cl_count_sum": 2,
		"cl_asset_sum": 2557854,
		"cl_weight_total": 0.04234673435643784,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 4253196,
		"fossil_bank_weight_total": 0.07041408977129422,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Madison Asset Management, LLC",
		"fund_family_name": "Madison Asset Management, LLC",
		"label": "Madison Asset Management, LLC"
	},
	{
		"fund_family_label": "Wellington Shields",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 59712710,
		"long_asset_sum": 59712710,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 59712710,
		"equity_fund_long_assets": 59712710,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 8144279,
		"ff_all_weight_total": 0.13639104639531516,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 1074677,
		"c2_weight_total": 0.017997458162592184,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1541490,
		"mc50_weight_total": 0.025815107035001426,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 6,
		"og_asset_sum": 5224791,
		"og_weight_total": 0.0874988088800525,
		"ut_count_sum": 3,
		"ut_asset_sum": 3691358,
		"ut_weight_total": 0.06181863124282921,
		"cl_count_sum": 5,
		"cl_asset_sum": 8763189,
		"cl_weight_total": 0.14675584142806447,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 1541490,
		"fossil_insure_weight_total": 0.025815107035001426,
		"name": "Wellington Shields",
		"fund_family_name": "Wellington Shields",
		"label": "Wellington Shields"
	},
	{
		"fund_family_label": "Monteagle Funds",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 59636327,
		"long_asset_sum": 59638211,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 59636327,
		"equity_fund_long_assets": 59638211,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 51,
		"ff_all_asset_sum": 6695596,
		"ff_all_weight_total": 0.11227023560448518,
		"grade_fossil_fam": 5,
		"c2_count_sum": 18,
		"c2_asset_sum": 2041482,
		"c2_weight_total": 0.034231107301323976,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 6,
		"co_asset_sum": 1231278,
		"co_weight_total": 0.02064579033063215,
		"og_count_sum": 46,
		"og_asset_sum": 5722113,
		"og_weight_total": 0.09594709338279782,
		"ut_count_sum": 8,
		"ut_asset_sum": 2859547,
		"ut_weight_total": 0.04794823573765484,
		"cl_count_sum": 17,
		"cl_asset_sum": 3793848,
		"cl_weight_total": 0.06361438306725867,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 639101,
		"fossil_bank_weight_total": 0.01071630066166807,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 379636,
		"fossil_insure_weight_total": 0.006365650371370127,
		"name": "Monteagle Funds",
		"fund_family_name": "Monteagle Funds",
		"label": "Monteagle Funds"
	},
	{
		"fund_family_label": "Dhandho Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 59403036,
		"long_asset_sum": 59403036,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 59403036,
		"equity_fund_long_assets": 59403036,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 19124650,
		"ff_all_weight_total": 0.321947349627046,
		"grade_fossil_fam": 5,
		"c2_count_sum": 4,
		"c2_asset_sum": 11775358,
		"c2_weight_total": 0.19822821850384886,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 4,
		"co_asset_sum": 11775358,
		"co_weight_total": 0.19822821850384886,
		"og_count_sum": 4,
		"og_asset_sum": 9669212,
		"og_weight_total": 0.16277302729106305,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Dhandho Funds",
		"fund_family_name": "Dhandho Funds",
		"label": "Dhandho Funds"
	},
	{
		"fund_family_label": "Chevy Chase Trust Company",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 59385376,
		"long_asset_sum": 68544555,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 59385376,
		"equity_fund_long_assets": 68544555,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 9930942,
		"ff_all_weight_total": 0.1448830180602967,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 3504964,
		"c2_weight_total": 0.051134098105969174,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 3915066,
		"mc50_weight_total": 0.0571170970473147,
		"co_count_sum": 1,
		"co_asset_sum": 2039852,
		"co_weight_total": 0.029759504602517296,
		"og_count_sum": 4,
		"og_asset_sum": 7035655,
		"og_weight_total": 0.10264352872376223,
		"ut_count_sum": 3,
		"ut_asset_sum": 4935139,
		"ut_weight_total": 0.07199899393905176,
		"cl_count_sum": 5,
		"cl_asset_sum": 7282452,
		"cl_weight_total": 0.1062440627122023,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 7627082,
		"fossil_bank_weight_total": 0.11127188731475461,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 1875214,
		"fossil_insure_weight_total": 0.027357592444797404,
		"name": "Chevy Chase Trust Company",
		"fund_family_name": "Chevy Chase Trust Company",
		"label": "Chevy Chase Trust Company"
	},
	{
		"fund_family_label": "Acquirers Funds",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 58714111,
		"long_asset_sum": 58714111,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 58714111,
		"equity_fund_long_assets": 58714111,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 23,
		"ff_all_asset_sum": 11476521,
		"ff_all_weight_total": 0.1954644429513716,
		"grade_fossil_fam": 5,
		"c2_count_sum": 9,
		"c2_asset_sum": 6673287,
		"c2_weight_total": 0.1136572944108785,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 5,
		"co_asset_sum": 2051856,
		"co_weight_total": 0.03494655654413298,
		"og_count_sum": 18,
		"og_asset_sum": 9424665,
		"og_weight_total": 0.16051788640723863,
		"ut_count_sum": 1,
		"ut_asset_sum": 1095009,
		"ut_weight_total": 0.018649843816931844,
		"cl_count_sum": 1,
		"cl_asset_sum": 1169042,
		"cl_weight_total": 0.01991075024537117,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Acquirers Funds",
		"fund_family_name": "Acquirers Funds",
		"label": "Acquirers Funds"
	},
	{
		"fund_family_label": "Indexperts",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 77891271,
		"long_asset_sum": 77891271,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 57976396,
		"equity_fund_long_assets": 57976396,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 2369117,
		"ff_all_weight_total": 0.040863474852765945,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 569548,
		"c2_weight_total": 0.009823791047653255,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 1035629,
		"mc50_weight_total": 0.017862942015229786,
		"co_count_sum": 2,
		"co_asset_sum": 220579,
		"co_weight_total": 0.0038046345619689777,
		"og_count_sum": 6,
		"og_asset_sum": 1762845,
		"og_weight_total": 0.0304062536070714,
		"ut_count_sum": 4,
		"ut_asset_sum": 1197912,
		"ut_weight_total": 0.020662063919944247,
		"cl_count_sum": 14,
		"cl_asset_sum": 6246647,
		"cl_weight_total": 0.1077446587055877,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 971128,
		"fossil_insure_weight_total": 0.016750403043335083,
		"name": "Indexperts",
		"fund_family_name": "Indexperts",
		"label": "Indexperts"
	},
	{
		"fund_family_label": "Procure ETF Trust II",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 57117897,
		"long_asset_sum": 57117897,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 57117897,
		"equity_fund_long_assets": 57117897,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Procure ETF Trust II",
		"fund_family_name": "Procure ETF Trust II",
		"label": "Procure ETF Trust II"
	},
	{
		"fund_family_label": "SRN Advisors",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 111069646,
		"long_asset_sum": 115517177,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 55764536,
		"equity_fund_long_assets": 57494434,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 674947,
		"ff_all_weight_total": 0.011739345064254393,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 674947,
		"og_weight_total": 0.011739345064254393,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 8,
		"cl_asset_sum": 9025007,
		"cl_weight_total": 0.15697183835221337,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 1542154,
		"fossil_insure_weight_total": 0.02682266599928612,
		"name": "SRN Advisors",
		"fund_family_name": "SRN Advisors",
		"label": "SRN Advisors"
	},
	{
		"fund_family_label": "BFS",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 55552221,
		"long_asset_sum": 55552221,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 55552221,
		"equity_fund_long_assets": 55552221,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 1336800,
		"ff_all_weight_total": 0.02406384436006618,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 1336800,
		"c2_weight_total": 0.02406384436006618,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 1336800,
		"og_weight_total": 0.02406384436006618,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 5,
		"cl_asset_sum": 10819595,
		"cl_weight_total": 0.19476440014882573,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 797600,
		"fossil_bank_weight_total": 0.014357661775575093,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "BFS",
		"fund_family_name": "BFS",
		"label": "BFS"
	},
	{
		"fund_family_label": "Williamsburg Investment Trust",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 55374508,
		"long_asset_sum": 55374508,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 55374508,
		"equity_fund_long_assets": 55374508,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 4493068,
		"ff_all_weight_total": 0.08113964642358538,
		"grade_fossil_fam": 4,
		"c2_count_sum": 3,
		"c2_asset_sum": 2755416,
		"c2_weight_total": 0.049759647525897656,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1255071,
		"mc50_weight_total": 0.02266514042887749,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 4493068,
		"og_weight_total": 0.08113964642358538,
		"ut_count_sum": 1,
		"ut_asset_sum": 1255071,
		"ut_weight_total": 0.02266514042887749,
		"cl_count_sum": 8,
		"cl_asset_sum": 10969482,
		"cl_weight_total": 0.1980962431305033,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 2596765,
		"fossil_bank_weight_total": 0.046894592724869,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 543582,
		"fossil_insure_weight_total": 0.009816466450591308,
		"name": "Williamsburg Investment Trust",
		"fund_family_name": "Williamsburg Investment Trust",
		"label": "Williamsburg Investment Trust"
	},
	{
		"fund_family_label": "Hunter Perkins Capital Management, LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 55273044,
		"long_asset_sum": 55317837,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 55273044,
		"equity_fund_long_assets": 55317837,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 4451261,
		"ff_all_weight_total": 0.08046701102937195,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 3366986,
		"c2_weight_total": 0.06086619041160268,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 1780106,
		"co_weight_total": 0.03217960239479356,
		"og_count_sum": 2,
		"og_asset_sum": 2671155,
		"og_weight_total": 0.048287408634578394,
		"ut_count_sum": 1,
		"ut_asset_sum": 1780106,
		"ut_weight_total": 0.03217960239479356,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 1558262,
		"fossil_insure_weight_total": 0.028169250363133322,
		"name": "Hunter Perkins Capital Management, LLC",
		"fund_family_name": "Hunter Perkins Capital Management, LLC",
		"label": "Hunter Perkins Capital Management, LLC"
	},
	{
		"fund_family_label": "Spear",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 55027271,
		"long_asset_sum": 55053618,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 55027271,
		"equity_fund_long_assets": 55053618,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 8641298,
		"ff_all_weight_total": 0.15696149161350303,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 2660163,
		"co_weight_total": 0.04831949464247745,
		"og_count_sum": 1,
		"og_asset_sum": 3127817,
		"og_weight_total": 0.056814013567645996,
		"ut_count_sum": 2,
		"ut_asset_sum": 5513481,
		"ut_weight_total": 0.10014747804585704,
		"cl_count_sum": 3,
		"cl_asset_sum": 5773649,
		"cl_weight_total": 0.10487319834275015,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Spear",
		"fund_family_name": "Spear",
		"label": "Spear"
	},
	{
		"fund_family_label": "AOT Invest LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 54440736,
		"long_asset_sum": 54440736,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 54440736,
		"equity_fund_long_assets": 54440736,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 7,
		"cl_asset_sum": 13397154,
		"cl_weight_total": 0.24608693754617866,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "AOT Invest LLC",
		"fund_family_name": "AOT Invest LLC",
		"label": "AOT Invest LLC"
	},
	{
		"fund_family_label": "Penn Capital Management",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 71093557,
		"long_asset_sum": 71128525,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 53862353,
		"equity_fund_long_assets": 53890178,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 4760819,
		"ff_all_weight_total": 0.08834298153552211,
		"grade_fossil_fam": 4,
		"c2_count_sum": 5,
		"c2_asset_sum": 3078420,
		"c2_weight_total": 0.057123953088445915,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 9,
		"og_asset_sum": 4760819,
		"og_weight_total": 0.08834298153552211,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 436492,
		"cl_weight_total": 0.008099657789217174,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Penn Capital Management",
		"fund_family_name": "Penn Capital Management",
		"label": "Penn Capital Management"
	},
	{
		"fund_family_label": "Teucrium",
		"as_of": "202506",
		"fund_id": 12,
		"net_asset_sum": 532520599,
		"long_asset_sum": 965330032,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 53530972,
		"equity_fund_long_assets": 53543429,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 3801538,
		"ff_all_weight_total": 0.07099915098825665,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1,
		"c2_asset_sum": 1850709,
		"c2_weight_total": 0.034564633505261684,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1950829,
		"mc50_weight_total": 0.03643451748299497,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 1850709,
		"og_weight_total": 0.034564633505261684,
		"ut_count_sum": 1,
		"ut_asset_sum": 1950829,
		"ut_weight_total": 0.03643451748299497,
		"cl_count_sum": 5,
		"cl_asset_sum": 10004976,
		"cl_weight_total": 0.1868572145426099,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 1946574,
		"fossil_bank_weight_total": 0.03635504928158411,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 1950829,
		"fossil_insure_weight_total": 0.03643451748299497,
		"name": "Teucrium",
		"fund_family_name": "Teucrium",
		"label": "Teucrium"
	},
	{
		"fund_family_label": "KBI",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 53069461,
		"long_asset_sum": 54590015,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 53069461,
		"equity_fund_long_assets": 54590015,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 54590015,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 54590015,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 3744587,
		"ff_all_weight_total": 0.06859472377869835,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 3416698,
		"og_weight_total": 0.06258833231681654,
		"ut_count_sum": 1,
		"ut_asset_sum": 327889,
		"ut_weight_total": 0.006006391461881811,
		"cl_count_sum": 8,
		"cl_asset_sum": 10777999,
		"cl_weight_total": 0.19743535516522573,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "KBI",
		"fund_family_name": "KBI",
		"label": "KBI"
	},
	{
		"fund_family_label": "Perritt",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 53019807,
		"long_asset_sum": 53024534,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 53019807,
		"equity_fund_long_assets": 53024534,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 3356587,
		"ff_all_weight_total": 0.06330252709057282,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 8,
		"og_asset_sum": 3356587,
		"og_weight_total": 0.06330252709057282,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Perritt",
		"fund_family_name": "Perritt",
		"label": "Perritt"
	},
	{
		"fund_family_label": "Commonwealth Intl Series Tr",
		"as_of": "202506",
		"fund_id": 5,
		"net_asset_sum": 52913364,
		"long_asset_sum": 52913364,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 52913364,
		"equity_fund_long_assets": 52913364,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 17,
		"ff_all_asset_sum": 3882646,
		"ff_all_weight_total": 0.07337741747056566,
		"grade_fossil_fam": 4,
		"c2_count_sum": 7,
		"c2_asset_sum": 1001771,
		"c2_weight_total": 0.01893228712504463,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 54170,
		"mc50_weight_total": 0.0010237489342011972,
		"co_count_sum": 6,
		"co_asset_sum": 451260,
		"co_weight_total": 0.00852828030362991,
		"og_count_sum": 13,
		"og_asset_sum": 2606805,
		"og_weight_total": 0.049265531482746025,
		"ut_count_sum": 6,
		"ut_asset_sum": 1544963,
		"ut_weight_total": 0.029197973502497403,
		"cl_count_sum": 10,
		"cl_asset_sum": 3705021,
		"cl_weight_total": 0.07002051504417674,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 661802,
		"fossil_insure_weight_total": 0.01250727509972717,
		"name": "Commonwealth Intl Series Tr",
		"fund_family_name": "Commonwealth Intl Series Tr",
		"label": "Commonwealth Intl Series Tr"
	},
	{
		"fund_family_label": "Texas Capital Funds Trust",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 52589835,
		"long_asset_sum": 52589835,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 52589835,
		"equity_fund_long_assets": 52589835,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 142,
		"ff_all_asset_sum": 19127328,
		"ff_all_weight_total": 0.36370770130767666,
		"grade_fossil_fam": 5,
		"c2_count_sum": 41,
		"c2_asset_sum": 12591055,
		"c2_weight_total": 0.23941993733199582,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 129241,
		"mc50_weight_total": 0.002457528151590512,
		"co_count_sum": 4,
		"co_asset_sum": 1403120,
		"co_weight_total": 0.026680441191724597,
		"og_count_sum": 139,
		"og_asset_sum": 18722614,
		"og_weight_total": 0.3560120316026852,
		"ut_count_sum": 9,
		"ut_asset_sum": 1321937,
		"ut_weight_total": 0.025136739828143594,
		"cl_count_sum": 9,
		"cl_asset_sum": 3185208,
		"cl_weight_total": 0.06056698979945459,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Texas Capital Funds Trust",
		"fund_family_name": "Texas Capital Funds Trust",
		"label": "Texas Capital Funds Trust"
	},
	{
		"fund_family_label": "IMS",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 64926609,
		"long_asset_sum": 65095044,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 52551804,
		"equity_fund_long_assets": 52551804,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 2400362,
		"ff_all_weight_total": 0.04567611037672465,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 1053940,
		"c2_weight_total": 0.020055258236234857,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 1907051,
		"og_weight_total": 0.03628897306741363,
		"ut_count_sum": 2,
		"ut_asset_sum": 1346422,
		"ut_weight_total": 0.025620852140489793,
		"cl_count_sum": 9,
		"cl_asset_sum": 13752551,
		"cl_weight_total": 0.2616951265840465,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 5968405,
		"fossil_bank_weight_total": 0.11357183856143169,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "IMS",
		"fund_family_name": "IMS",
		"label": "IMS"
	},
	{
		"fund_family_label": "Matisse Funds",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 104640726,
		"long_asset_sum": 104640726,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 51814184,
		"equity_fund_long_assets": 51814184,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Matisse Funds",
		"fund_family_name": "Matisse Funds",
		"label": "Matisse Funds"
	},
	{
		"fund_family_label": "Appleseed Fund",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 51469660,
		"long_asset_sum": 51469660,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 51469660,
		"equity_fund_long_assets": 51469660,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Appleseed Fund",
		"fund_family_name": "Appleseed Fund",
		"label": "Appleseed Fund"
	},
	{
		"fund_family_label": "Oelschlager Investments",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 51402547,
		"long_asset_sum": 51402547,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 51402547,
		"equity_fund_long_assets": 51402547,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 3688689,
		"ff_all_weight_total": 0.07176082150170496,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 2442832,
		"c2_weight_total": 0.04752355948431894,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 446016,
		"co_weight_total": 0.008676924122067336,
		"og_count_sum": 2,
		"og_asset_sum": 3242673,
		"og_weight_total": 0.06308389737963763,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 10,
		"cl_asset_sum": 7619840,
		"cl_weight_total": 0.14823856880088063,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 1533747,
		"fossil_bank_weight_total": 0.029837957251417913,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Oelschlager Investments",
		"fund_family_name": "Oelschlager Investments",
		"label": "Oelschlager Investments"
	},
	{
		"fund_family_label": "JAG Capital Management",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 51225029,
		"long_asset_sum": 51229614,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 51225029,
		"equity_fund_long_assets": 51229614,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 1070561,
		"ff_all_weight_total": 0.02089730756120864,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 1070561,
		"co_weight_total": 0.02089730756120864,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 1070561,
		"ut_weight_total": 0.02089730756120864,
		"cl_count_sum": 6,
		"cl_asset_sum": 11637124,
		"cl_weight_total": 0.22715619133886114,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "JAG Capital Management",
		"fund_family_name": "JAG Capital Management",
		"label": "JAG Capital Management"
	},
	{
		"fund_family_label": "Emerald Mutual Fund Advisers Trust",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 51211584,
		"long_asset_sum": 51234952,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 51211584,
		"equity_fund_long_assets": 51234952,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Emerald Mutual Fund Advisers Trust",
		"fund_family_name": "Emerald Mutual Fund Advisers Trust",
		"label": "Emerald Mutual Fund Advisers Trust"
	},
	{
		"fund_family_label": "USA Mutuals",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 76980571,
		"long_asset_sum": 77006561,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 51123734,
		"equity_fund_long_assets": 51127675,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "USA Mutuals",
		"fund_family_name": "USA Mutuals",
		"label": "USA Mutuals"
	},
	{
		"fund_family_label": "Matrix Advisors Funds Trust",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 48550791,
		"long_asset_sum": 48550791,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 48550791,
		"equity_fund_long_assets": 48550791,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 4858767,
		"ff_all_weight_total": 0.10007595962751667,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 2551407,
		"mc50_weight_total": 0.05255129622913868,
		"co_count_sum": 1,
		"co_asset_sum": 2551407,
		"co_weight_total": 0.05255129622913868,
		"og_count_sum": 2,
		"og_asset_sum": 4858767,
		"og_weight_total": 0.10007595962751667,
		"ut_count_sum": 2,
		"ut_asset_sum": 4858767,
		"ut_weight_total": 0.10007595962751667,
		"cl_count_sum": 3,
		"cl_asset_sum": 7092830,
		"cl_weight_total": 0.14609092568646306,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 6364196,
		"fossil_bank_weight_total": 0.13108326082679064,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Matrix Advisors Funds Trust",
		"fund_family_name": "Matrix Advisors Funds Trust",
		"label": "Matrix Advisors Funds Trust"
	},
	{
		"fund_family_label": "Alta Capital",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 47585631,
		"long_asset_sum": 47585631,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 47585631,
		"equity_fund_long_assets": 47585631,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 845201,
		"ff_all_weight_total": 0.017761685244858893,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 845201,
		"mc50_weight_total": 0.017761685244858893,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 845201,
		"ut_weight_total": 0.017761685244858893,
		"cl_count_sum": 5,
		"cl_asset_sum": 11538251,
		"cl_weight_total": 0.2424734264845621,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 845201,
		"fossil_insure_weight_total": 0.017761685244858893,
		"name": "Alta Capital",
		"fund_family_name": "Alta Capital",
		"label": "Alta Capital"
	},
	{
		"fund_family_label": "Mohrfunds",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 102774805,
		"long_asset_sum": 102774805,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 47204259,
		"equity_fund_long_assets": 47204259,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 3327978,
		"ff_all_weight_total": 0.07050164689588709,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 1027648,
		"co_weight_total": 0.021770238994748333,
		"og_count_sum": 2,
		"og_asset_sum": 1877843,
		"og_weight_total": 0.03978121974121022,
		"ut_count_sum": 2,
		"ut_asset_sum": 1450135,
		"ut_weight_total": 0.03072042715467687,
		"cl_count_sum": 6,
		"cl_asset_sum": 3394011,
		"cl_weight_total": 0.07190052490814441,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 781201,
		"fossil_bank_weight_total": 0.016549375343440937,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Mohrfunds",
		"fund_family_name": "Mohrfunds",
		"label": "Mohrfunds"
	},
	{
		"fund_family_label": "Split Rock Private Trading & Wealth Management, LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 47071560,
		"long_asset_sum": 47142477,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 47071560,
		"equity_fund_long_assets": 47142477,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 5289926,
		"ff_all_weight_total": 0.11221145634753134,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 989273,
		"mc50_weight_total": 0.020984748001255854,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 4300653,
		"og_weight_total": 0.09122670834627548,
		"ut_count_sum": 2,
		"ut_asset_sum": 1873121,
		"ut_weight_total": 0.03973319009096616,
		"cl_count_sum": 5,
		"cl_asset_sum": 7036346,
		"cl_weight_total": 0.14925702779682112,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 941337,
		"fossil_bank_weight_total": 0.019967915559464557,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 989273,
		"fossil_insure_weight_total": 0.020984748001255854,
		"name": "Split Rock Private Trading & Wealth Management, LLC",
		"fund_family_name": "Split Rock Private Trading & Wealth Management, LLC",
		"label": "Split Rock Private Trading & Wealth Management, LLC"
	},
	{
		"fund_family_label": "AMF",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 46309390,
		"long_asset_sum": 46309390,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 46309390,
		"equity_fund_long_assets": 46309390,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 3945260,
		"ff_all_weight_total": 0.08519352122755233,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 1815404,
		"c2_weight_total": 0.03920163923558483,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 1347360,
		"co_weight_total": 0.029094747307187592,
		"og_count_sum": 3,
		"og_asset_sum": 2597900,
		"og_weight_total": 0.05609877392036475,
		"ut_count_sum": 1,
		"ut_asset_sum": 782496,
		"ut_weight_total": 0.01689713468477991,
		"cl_count_sum": 7,
		"cl_asset_sum": 8712433,
		"cl_weight_total": 0.18813534360957895,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 1140059,
		"fossil_bank_weight_total": 0.02461831175059745,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "AMF",
		"fund_family_name": "AMF",
		"label": "AMF"
	},
	{
		"fund_family_label": "Biondo Investment Advisor",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 45955959,
		"long_asset_sum": 45955959,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 45955959,
		"equity_fund_long_assets": 45955959,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 5342270,
		"cl_weight_total": 0.11624760131760062,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Biondo Investment Advisor",
		"fund_family_name": "Biondo Investment Advisor",
		"label": "Biondo Investment Advisor"
	},
	{
		"fund_family_label": "WealthTrust Asset Management",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 45603001,
		"long_asset_sum": 45603001,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 45603001,
		"equity_fund_long_assets": 45603001,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 720819,
		"ff_all_weight_total": 0.015806393969554768,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 720819,
		"c2_weight_total": 0.015806393969554768,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 720819,
		"og_weight_total": 0.015806393969554768,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 4,
		"cl_asset_sum": 3527687,
		"cl_weight_total": 0.07735646607994066,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 924700,
		"fossil_bank_weight_total": 0.020277174302629777,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "WealthTrust Asset Management",
		"fund_family_name": "WealthTrust Asset Management",
		"label": "WealthTrust Asset Management"
	},
	{
		"fund_family_label": "Firsthand Funds",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 45541363,
		"long_asset_sum": 45544534,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 45541363,
		"equity_fund_long_assets": 45544534,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 7231340,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 7231340,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 2,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 8,
		"cl_asset_sum": 2092048,
		"cl_weight_total": 0.045934118021714744,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Firsthand Funds",
		"fund_family_name": "Firsthand Funds",
		"label": "Firsthand Funds"
	},
	{
		"fund_family_label": "Midas",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 45244047,
		"long_asset_sum": 45244047,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 45244047,
		"equity_fund_long_assets": 45244047,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 2719575,
		"ff_all_weight_total": 0.06010901279454511,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 2719575,
		"mc50_weight_total": 0.06010901279454511,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 2719575,
		"ut_weight_total": 0.06010901279454511,
		"cl_count_sum": 1,
		"cl_asset_sum": 5145120,
		"cl_weight_total": 0.11371927007325405,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 2719575,
		"fossil_insure_weight_total": 0.06010901279454511,
		"name": "Midas",
		"fund_family_name": "Midas",
		"label": "Midas"
	},
	{
		"fund_family_label": "RiverNorth Funds",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 1324577417,
		"long_asset_sum": 1333668382,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 43793178,
		"equity_fund_long_assets": 43962596,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "RiverNorth Funds",
		"fund_family_name": "RiverNorth Funds",
		"label": "RiverNorth Funds"
	},
	{
		"fund_family_label": "Pacific Capital Partners Limited",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 43030628,
		"long_asset_sum": 43030628,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 43030628,
		"equity_fund_long_assets": 43030628,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 3546974,
		"ff_all_weight_total": 0.08242905495127796,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 1525463,
		"c2_weight_total": 0.03545063297705067,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 564918,
		"co_weight_total": 0.01312827691011156,
		"og_count_sum": 4,
		"og_asset_sum": 2982056,
		"og_weight_total": 0.0693007780411664,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 4,
		"cl_asset_sum": 3926594,
		"cl_weight_total": 0.09125114325545051,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 711043,
		"fossil_bank_weight_total": 0.016524113940424016,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 1515468,
		"fossil_insure_weight_total": 0.03521835656221425,
		"name": "Pacific Capital Partners Limited",
		"fund_family_name": "Pacific Capital Partners Limited",
		"label": "Pacific Capital Partners Limited"
	},
	{
		"fund_family_label": "Innealta Capital",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 221788447,
		"long_asset_sum": 222414266,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 42804924,
		"equity_fund_long_assets": 42928477,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 54,
		"ff_all_asset_sum": 3545778,
		"ff_all_weight_total": 0.08259733975654436,
		"grade_fossil_fam": 4,
		"c2_count_sum": 23,
		"c2_asset_sum": 1827216,
		"c2_weight_total": 0.042564193460671806,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 33449,
		"mc50_weight_total": 0.000779179750541814,
		"co_count_sum": 8,
		"co_asset_sum": 393677,
		"co_weight_total": 0.009170532651321407,
		"og_count_sum": 44,
		"og_asset_sum": 2995318,
		"og_weight_total": 0.0697746160433318,
		"ut_count_sum": 9,
		"ut_asset_sum": 259808,
		"ut_weight_total": 0.006052113146245556,
		"cl_count_sum": 12,
		"cl_asset_sum": 664322,
		"cl_weight_total": 0.015475088948531763,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Innealta Capital",
		"fund_family_name": "Innealta Capital",
		"label": "Innealta Capital"
	},
	{
		"fund_family_label": "DEMZ",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 42568138,
		"long_asset_sum": 42568138,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 42568138,
		"equity_fund_long_assets": 42568138,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 9,
		"cl_asset_sum": 9215563,
		"cl_weight_total": 0.21648969001181118,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 859990,
		"fossil_insure_weight_total": 0.020202668953948608,
		"name": "DEMZ",
		"fund_family_name": "DEMZ",
		"label": "DEMZ"
	},
	{
		"fund_family_label": "Geneva",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 42560079,
		"long_asset_sum": 42560079,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 42560079,
		"equity_fund_long_assets": 42560079,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Geneva",
		"fund_family_name": "Geneva",
		"label": "Geneva"
	},
	{
		"fund_family_label": "Auer",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 41939965,
		"long_asset_sum": 41939965,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 41939965,
		"equity_fund_long_assets": 41939965,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 11,
		"ff_all_asset_sum": 4396725,
		"ff_all_weight_total": 0.10483377847358719,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 1281000,
		"c2_weight_total": 0.030543659251980777,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 423360,
		"co_weight_total": 0.010094429024916926,
		"og_count_sum": 10,
		"og_asset_sum": 3973365,
		"og_weight_total": 0.09473934944867025,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 737520,
		"cl_weight_total": 0.01758513627753385,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 526526,
		"fossil_bank_weight_total": 0.01255427847877317,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Auer",
		"fund_family_name": "Auer",
		"label": "Auer"
	},
	{
		"fund_family_label": "Papp",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 41465647,
		"long_asset_sum": 41465647,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 41465647,
		"equity_fund_long_assets": 41465647,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 554000,
		"ff_all_weight_total": 0.013360457151434295,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 554000,
		"c2_weight_total": 0.013360457151434295,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 554000,
		"og_weight_total": 0.013360457151434295,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 2535200,
		"cl_weight_total": 0.06113976709443362,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Papp",
		"fund_family_name": "Papp",
		"label": "Papp"
	},
	{
		"fund_family_label": "Blue Chip Investor Fund",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 41421228,
		"long_asset_sum": 41421228,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 41421228,
		"equity_fund_long_assets": 41421228,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 17522405,
		"ff_all_weight_total": 0.4230295876307675,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 2710400,
		"c2_weight_total": 0.06543504697639578,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 11976624,
		"mc50_weight_total": 0.28914217608420495,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 5545781,
		"og_weight_total": 0.13388741154656256,
		"ut_count_sum": 1,
		"ut_asset_sum": 11976624,
		"ut_weight_total": 0.28914217608420495,
		"cl_count_sum": 1,
		"cl_asset_sum": 3437060,
		"cl_weight_total": 0.08297822556105773,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 11976624,
		"fossil_insure_weight_total": 0.28914217608420495,
		"name": "Blue Chip Investor Fund",
		"fund_family_name": "Blue Chip Investor Fund",
		"label": "Blue Chip Investor Fund"
	},
	{
		"fund_family_label": "Aztlan ETFs",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 40992445,
		"long_asset_sum": 40992445,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 40992445,
		"equity_fund_long_assets": 40992445,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 1818538,
		"ff_all_weight_total": 0.04436276001590049,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 641000,
		"c2_weight_total": 0.01563702774986952,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 619019,
		"co_weight_total": 0.015100806990166115,
		"og_count_sum": 1,
		"og_asset_sum": 641000,
		"og_weight_total": 0.01563702774986952,
		"ut_count_sum": 1,
		"ut_asset_sum": 558519,
		"ut_weight_total": 0.013624925275864858,
		"cl_count_sum": 5,
		"cl_asset_sum": 2678177,
		"cl_weight_total": 0.06533342912334211,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Aztlan ETFs",
		"fund_family_name": "Aztlan ETFs",
		"label": "Aztlan ETFs"
	},
	{
		"fund_family_label": "Concorde",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 40736646,
		"long_asset_sum": 40841004,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 40736646,
		"equity_fund_long_assets": 40841004,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 9899722,
		"ff_all_weight_total": 0.24239663647837845,
		"grade_fossil_fam": 5,
		"c2_count_sum": 4,
		"c2_asset_sum": 4575611,
		"c2_weight_total": 0.11203473352418075,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 987200,
		"co_weight_total": 0.02417178578665696,
		"og_count_sum": 7,
		"og_asset_sum": 9899722,
		"og_weight_total": 0.24239663647837845,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 3,
		"cl_asset_sum": 2417123,
		"cl_weight_total": 0.05918373113452353,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 905970,
		"fossil_insure_weight_total": 0.02218285329126581,
		"name": "Concorde",
		"fund_family_name": "Concorde",
		"label": "Concorde"
	},
	{
		"fund_family_label": "Chesapeake",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 39976818,
		"long_asset_sum": 39976818,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 39976818,
		"equity_fund_long_assets": 39976818,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 1494511,
		"ff_all_weight_total": 0.037384441152870145,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 1164444,
		"c2_weight_total": 0.02912798112145894,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 1494511,
		"og_weight_total": 0.037384441152870145,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 4,
		"cl_asset_sum": 7791381,
		"cl_weight_total": 0.19489747783327827,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 3334875,
		"fossil_bank_weight_total": 0.0834202211891902,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Chesapeake",
		"fund_family_name": "Chesapeake",
		"label": "Chesapeake"
	},
	{
		"fund_family_label": "Formidable Funds",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 39675926,
		"long_asset_sum": 39774712,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 39675926,
		"equity_fund_long_assets": 39774712,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 4010850,
		"ff_all_weight_total": 0.1008391965226549,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 1530347,
		"c2_weight_total": 0.03847537601277917,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 676494,
		"co_weight_total": 0.017008143264494284,
		"og_count_sum": 6,
		"og_asset_sum": 2538514,
		"og_weight_total": 0.06382231001446347,
		"ut_count_sum": 2,
		"ut_asset_sum": 795842,
		"ut_weight_total": 0.02000874324369715,
		"cl_count_sum": 2,
		"cl_asset_sum": 1593333,
		"cl_weight_total": 0.04005894498997253,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Formidable Funds",
		"fund_family_name": "Formidable Funds",
		"label": "Formidable Funds"
	},
	{
		"fund_family_label": "Sparkline Capital",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 39438987,
		"long_asset_sum": 39438987,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 39438987,
		"equity_fund_long_assets": 39438987,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 374271,
		"ff_all_weight_total": 0.009489873560900537,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 374271,
		"og_weight_total": 0.009489873560900537,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 12,
		"cl_asset_sum": 5648685,
		"cl_weight_total": 0.14322591500638696,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 582985,
		"fossil_bank_weight_total": 0.01478194660527158,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Sparkline Capital",
		"fund_family_name": "Sparkline Capital",
		"label": "Sparkline Capital"
	},
	{
		"fund_family_label": "Ranger Funds",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 194408298,
		"long_asset_sum": 257790251,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 38715199,
		"equity_fund_long_assets": 38715199,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 2717399,
		"ff_all_weight_total": 0.07018946228327536,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1,
		"c2_asset_sum": 584159,
		"c2_weight_total": 0.015088621913063135,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 7,
		"og_asset_sum": 2717399,
		"og_weight_total": 0.07018946228327536,
		"ut_count_sum": 2,
		"ut_asset_sum": 1169747,
		"ut_weight_total": 0.030214154394505373,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Ranger Funds",
		"fund_family_name": "Ranger Funds",
		"label": "Ranger Funds"
	},
	{
		"fund_family_label": "Adirondack Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 38698478,
		"long_asset_sum": 38698478,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 38698478,
		"equity_fund_long_assets": 38698478,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 3071281,
		"ff_all_weight_total": 0.07936438740562354,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 1603089,
		"c2_weight_total": 0.04142511754596653,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 1388814,
		"co_weight_total": 0.035888078078936334,
		"og_count_sum": 4,
		"og_asset_sum": 2870213,
		"og_weight_total": 0.07416862751036359,
		"ut_count_sum": 3,
		"ut_asset_sum": 1589882,
		"ut_weight_total": 0.0410838379741963,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Adirondack Funds",
		"fund_family_name": "Adirondack Funds",
		"label": "Adirondack Funds"
	},
	{
		"fund_family_label": "SonicShares",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 38114979,
		"long_asset_sum": 38119545,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 38114979,
		"equity_fund_long_assets": 38119545,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 15,
		"ff_all_asset_sum": 10152667,
		"ff_all_weight_total": 0.26633757039859735,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 15,
		"og_asset_sum": 10152667,
		"og_weight_total": 0.26633757039859735,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "SonicShares",
		"fund_family_name": "SonicShares",
		"label": "SonicShares"
	},
	{
		"fund_family_label": "Volumetric",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 38079371,
		"long_asset_sum": 38079371,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 38079371,
		"equity_fund_long_assets": 38079371,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 2133972,
		"ff_all_weight_total": 0.05604010633473962,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1,
		"c2_asset_sum": 618915,
		"c2_weight_total": 0.01625328842747954,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 2133972,
		"og_weight_total": 0.05604010633473962,
		"ut_count_sum": 1,
		"ut_asset_sum": 504630,
		"ut_weight_total": 0.013252057130880655,
		"cl_count_sum": 5,
		"cl_asset_sum": 3798944,
		"cl_weight_total": 0.09976383275868711,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 1182723,
		"fossil_bank_weight_total": 0.031059415345909995,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Volumetric",
		"fund_family_name": "Volumetric",
		"label": "Volumetric"
	},
	{
		"fund_family_label": "Affinity Investment Advisors, LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 37936159,
		"long_asset_sum": 37940598,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 37936159,
		"equity_fund_long_assets": 37940598,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 13,
		"ff_all_asset_sum": 2661234,
		"ff_all_weight_total": 0.0701421205854478,
		"grade_fossil_fam": 4,
		"c2_count_sum": 5,
		"c2_asset_sum": 1150724,
		"c2_weight_total": 0.030329622110858663,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 332067,
		"mc50_weight_total": 0.008752286930216546,
		"co_count_sum": 2,
		"co_asset_sum": 223387,
		"co_weight_total": 0.005887809148395605,
		"og_count_sum": 12,
		"og_asset_sum": 2457611,
		"og_weight_total": 0.06477523100716547,
		"ut_count_sum": 6,
		"ut_asset_sum": 1092576,
		"ut_weight_total": 0.028797015798222265,
		"cl_count_sum": 9,
		"cl_asset_sum": 3720611,
		"cl_weight_total": 0.09806411063947912,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 887638,
		"fossil_bank_weight_total": 0.023395466776775634,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 189044,
		"fossil_insure_weight_total": 0.004982631006501268,
		"name": "Affinity Investment Advisors, LLC",
		"fund_family_name": "Affinity Investment Advisors, LLC",
		"label": "Affinity Investment Advisors, LLC"
	},
	{
		"fund_family_label": "Knowledge Leaders Capital",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 37211563,
		"long_asset_sum": 37211563,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 37211563,
		"equity_fund_long_assets": 37211563,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 2112601,
		"ff_all_weight_total": 0.05677270261396975,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1,
		"c2_asset_sum": 876492,
		"c2_weight_total": 0.023554291444301868,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 327511,
		"mc50_weight_total": 0.008801323395096304,
		"co_count_sum": 1,
		"co_asset_sum": 327511,
		"co_weight_total": 0.008801323395096304,
		"og_count_sum": 2,
		"og_asset_sum": 1474523,
		"og_weight_total": 0.03962539815916897,
		"ut_count_sum": 2,
		"ut_asset_sum": 638078,
		"ut_weight_total": 0.017147304454800782,
		"cl_count_sum": 6,
		"cl_asset_sum": 3649123,
		"cl_weight_total": 0.09806422267186143,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Knowledge Leaders Capital",
		"fund_family_name": "Knowledge Leaders Capital",
		"label": "Knowledge Leaders Capital"
	},
	{
		"fund_family_label": "Moncapfund",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 36109481,
		"long_asset_sum": 36109481,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 36109481,
		"equity_fund_long_assets": 36109481,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 1730610,
		"ff_all_weight_total": 0.04792674810252742,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 1730610,
		"og_weight_total": 0.04792674810252742,
		"ut_count_sum": 1,
		"ut_asset_sum": 297780,
		"ut_weight_total": 0.008246587648268886,
		"cl_count_sum": 3,
		"cl_asset_sum": 1836075,
		"cl_weight_total": 0.050847449178236595,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Moncapfund",
		"fund_family_name": "Moncapfund",
		"label": "Moncapfund"
	},
	{
		"fund_family_label": "Neiman Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 35392755,
		"long_asset_sum": 35392755,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 35392755,
		"equity_fund_long_assets": 35392755,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 5438379,
		"ff_all_weight_total": 0.15365797322079053,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 2126518,
		"c2_weight_total": 0.06008342667870868,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 692354,
		"mc50_weight_total": 0.019562026183042265,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 4746025,
		"og_weight_total": 0.13409594703774827,
		"ut_count_sum": 2,
		"ut_asset_sum": 1812706,
		"ut_weight_total": 0.051216866276728105,
		"cl_count_sum": 7,
		"cl_asset_sum": 5860022,
		"cl_weight_total": 0.16557123060920237,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 878850,
		"fossil_bank_weight_total": 0.024831353196438085,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 692354,
		"fossil_insure_weight_total": 0.019562026183042265,
		"name": "Neiman Funds",
		"fund_family_name": "Neiman Funds",
		"label": "Neiman Funds"
	},
	{
		"fund_family_label": "Genter Capital Management",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 34274870,
		"long_asset_sum": 34274870,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 34274870,
		"equity_fund_long_assets": 34274870,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 6272238,
		"ff_all_weight_total": 0.1829981557916923,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 1313618,
		"c2_weight_total": 0.03832598052158914,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1007469,
		"mc50_weight_total": 0.029393809517001816,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 5264769,
		"og_weight_total": 0.15360434627469047,
		"ut_count_sum": 2,
		"ut_asset_sum": 1914723,
		"ut_weight_total": 0.05586375674072579,
		"cl_count_sum": 4,
		"cl_asset_sum": 4650246,
		"cl_weight_total": 0.13567508789967694,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Genter Capital Management",
		"fund_family_name": "Genter Capital Management",
		"label": "Genter Capital Management"
	},
	{
		"fund_family_label": "GuruFocusETF",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 33829528,
		"long_asset_sum": 33829528,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 33829528,
		"equity_fund_long_assets": 33829528,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 1948911,
		"ff_all_weight_total": 0.05760976032535837,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1454933,
		"mc50_weight_total": 0.04300778302316249,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 493978,
		"og_weight_total": 0.01460197730219588,
		"ut_count_sum": 1,
		"ut_asset_sum": 1454933,
		"ut_weight_total": 0.04300778302316249,
		"cl_count_sum": 4,
		"cl_asset_sum": 7425526,
		"cl_weight_total": 0.21949836249562807,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 493570,
		"fossil_bank_weight_total": 0.0145899168324193,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 1454933,
		"fossil_insure_weight_total": 0.04300778302316249,
		"name": "GuruFocusETF",
		"fund_family_name": "GuruFocusETF",
		"label": "GuruFocusETF"
	},
	{
		"fund_family_label": "CrossingBridge",
		"as_of": "202506",
		"fund_id": 6,
		"net_asset_sum": 2416729813,
		"long_asset_sum": 2723537961,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 31913791,
		"equity_fund_long_assets": 32415269,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 52766016,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "CrossingBridge",
		"fund_family_name": "CrossingBridge",
		"label": "CrossingBridge"
	},
	{
		"fund_family_label": "Evolutionary Tree",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 31797403,
		"long_asset_sum": 31797403,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 31797403,
		"equity_fund_long_assets": 31797403,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 2552646,
		"cl_weight_total": 0.08027844286528683,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Evolutionary Tree",
		"fund_family_name": "Evolutionary Tree",
		"label": "Evolutionary Tree"
	},
	{
		"fund_family_label": "Castle Investment Management",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 31687497,
		"long_asset_sum": 31687497,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 31687497,
		"equity_fund_long_assets": 31687497,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 871947,
		"ff_all_weight_total": 0.027517067693923567,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 871947,
		"og_weight_total": 0.027517067693923567,
		"ut_count_sum": 1,
		"ut_asset_sum": 871947,
		"ut_weight_total": 0.027517067693923567,
		"cl_count_sum": 3,
		"cl_asset_sum": 2085510,
		"cl_weight_total": 0.06581491747360166,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Castle Investment Management",
		"fund_family_name": "Castle Investment Management",
		"label": "Castle Investment Management"
	},
	{
		"fund_family_label": "Carbon Collective Funds",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 50095711,
		"long_asset_sum": 50170810,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 31239895,
		"equity_fund_long_assets": 31240811,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 50170810,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 31240811,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 2142507,
		"ff_all_weight_total": 0.0685803899264971,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 2123752,
		"og_weight_total": 0.06798005339874179,
		"ut_count_sum": 1,
		"ut_asset_sum": 18755,
		"ut_weight_total": 0.0006003365277553134,
		"cl_count_sum": 14,
		"cl_asset_sum": 11464876,
		"cl_weight_total": 0.36698394289444025,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Carbon Collective Funds",
		"fund_family_name": "Carbon Collective Funds",
		"label": "Carbon Collective Funds"
	},
	{
		"fund_family_label": "Reaves Select Research",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 31066969,
		"long_asset_sum": 31066969,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 31066969,
		"equity_fund_long_assets": 31066969,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 16,
		"ff_all_asset_sum": 18132094,
		"ff_all_weight_total": 0.583645414523702,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 608112,
		"c2_weight_total": 0.01957423010915548,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1225232,
		"mc50_weight_total": 0.039438414478090864,
		"co_count_sum": 4,
		"co_asset_sum": 4589470,
		"co_weight_total": 0.14772828337389463,
		"og_count_sum": 10,
		"og_asset_sum": 10942799,
		"og_weight_total": 0.3522325914703813,
		"ut_count_sum": 14,
		"ut_asset_sum": 16044501,
		"ut_weight_total": 0.5164488688935184,
		"cl_count_sum": 5,
		"cl_asset_sum": 5401460,
		"cl_weight_total": 0.17386504618458273,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Reaves Select Research",
		"fund_family_name": "Reaves Select Research",
		"label": "Reaves Select Research"
	},
	{
		"fund_family_label": "CULTIVAR ETF",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 30964779,
		"long_asset_sum": 30964779,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 30964779,
		"equity_fund_long_assets": 30964779,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 3228265,
		"ff_all_weight_total": 0.10425603231335835,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 452417,
		"c2_weight_total": 0.014610696882415987,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 6,
		"og_asset_sum": 1759493,
		"og_weight_total": 0.05682239811884335,
		"ut_count_sum": 3,
		"ut_asset_sum": 1468772,
		"ut_weight_total": 0.047433634194515004,
		"cl_count_sum": 7,
		"cl_asset_sum": 3330355,
		"cl_weight_total": 0.1075530040114286,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "CULTIVAR ETF",
		"fund_family_name": "CULTIVAR ETF",
		"label": "CULTIVAR ETF"
	},
	{
		"fund_family_label": "Research Affiliates LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 30943326,
		"long_asset_sum": 32326329,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 30943326,
		"equity_fund_long_assets": 32326329,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 2245857,
		"ff_all_weight_total": 0.06947454503726667,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1,
		"c2_asset_sum": 243705,
		"c2_weight_total": 0.007538901184851518,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 475807,
		"mc50_weight_total": 0.014718868944259028,
		"co_count_sum": 3,
		"co_asset_sum": 867168,
		"co_weight_total": 0.026825440030632617,
		"og_count_sum": 5,
		"og_asset_sum": 1119281,
		"og_weight_total": 0.03462443879724172,
		"ut_count_sum": 6,
		"ut_asset_sum": 1846088,
		"ut_weight_total": 0.05710787636913551,
		"cl_count_sum": 2,
		"cl_asset_sum": 458215,
		"cl_weight_total": 0.014174668580524562,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Research Affiliates LLC",
		"fund_family_name": "Research Affiliates LLC",
		"label": "Research Affiliates LLC"
	},
	{
		"fund_family_label": "Point Bridge Capital",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 30447786,
		"long_asset_sum": 30447786,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 30447786,
		"equity_fund_long_assets": 30447786,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 36,
		"ff_all_asset_sum": 7709715,
		"ff_all_weight_total": 0.25321102164866766,
		"grade_fossil_fam": 5,
		"c2_count_sum": 9,
		"c2_asset_sum": 1888461,
		"c2_weight_total": 0.06202293329308082,
		"mc50_count_sum": 5,
		"mc50_asset_sum": 1017238,
		"mc50_weight_total": 0.03340926003618128,
		"co_count_sum": 7,
		"co_asset_sum": 1514446,
		"co_weight_total": 0.049739117320385794,
		"og_count_sum": 28,
		"og_asset_sum": 5953431,
		"og_weight_total": 0.1955291921718052,
		"ut_count_sum": 16,
		"ut_asset_sum": 3400233,
		"ut_weight_total": 0.11167422813599649,
		"cl_count_sum": 7,
		"cl_asset_sum": 1537434,
		"cl_weight_total": 0.050494114744500634,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 664419,
		"fossil_bank_weight_total": 0.021821586633589712,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 638242,
		"fossil_insure_weight_total": 0.020961852530098576,
		"name": "Point Bridge Capital",
		"fund_family_name": "Point Bridge Capital",
		"label": "Point Bridge Capital"
	},
	{
		"fund_family_label": "FMQQ",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 30129875,
		"long_asset_sum": 30405811,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 30129875,
		"equity_fund_long_assets": 30405811,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 2516724,
		"ff_all_weight_total": 0.08277115186962124,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 2516724,
		"og_weight_total": 0.08277115186962124,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "FMQQ",
		"fund_family_name": "FMQQ",
		"label": "FMQQ"
	},
	{
		"fund_family_label": "Taylor Frigon Capital Management",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 29285093,
		"long_asset_sum": 29285093,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 29285093,
		"equity_fund_long_assets": 29285093,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Taylor Frigon Capital Management",
		"fund_family_name": "Taylor Frigon Capital Management",
		"label": "Taylor Frigon Capital Management"
	},
	{
		"fund_family_label": "PLUS ETF",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 28821072,
		"long_asset_sum": 28821072,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 28821072,
		"equity_fund_long_assets": 28821072,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 419433,
		"ff_all_weight_total": 0.01455299788987724,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 419433,
		"og_weight_total": 0.01455299788987724,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 519313,
		"cl_weight_total": 0.01801851784000262,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "PLUS ETF",
		"fund_family_name": "PLUS ETF",
		"label": "PLUS ETF"
	},
	{
		"fund_family_label": "Lawson Kroeker",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 27938313,
		"long_asset_sum": 27946610,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 27938313,
		"equity_fund_long_assets": 27946610,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 5607710,
		"ff_all_weight_total": 0.20065796889139684,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 1018060,
		"c2_weight_total": 0.0364287475296646,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1864030,
		"mc50_weight_total": 0.0666996820007865,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 6,
		"og_asset_sum": 3743680,
		"og_weight_total": 0.13395828689061035,
		"ut_count_sum": 1,
		"ut_asset_sum": 1864030,
		"ut_weight_total": 0.0666996820007865,
		"cl_count_sum": 3,
		"cl_asset_sum": 2256462,
		"cl_weight_total": 0.08074188604628611,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 1864030,
		"fossil_insure_weight_total": 0.0666996820007865,
		"name": "Lawson Kroeker",
		"fund_family_name": "Lawson Kroeker",
		"label": "Lawson Kroeker"
	},
	{
		"fund_family_label": "Walthausen Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 27799993,
		"long_asset_sum": 27806095,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 27799993,
		"equity_fund_long_assets": 27806095,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 1739100,
		"ff_all_weight_total": 0.06254384155703992,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1,
		"c2_asset_sum": 845250,
		"c2_weight_total": 0.03039801165895463,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 1739100,
		"og_weight_total": 0.06254384155703992,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 347412,
		"cl_weight_total": 0.012494095269400467,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Walthausen Funds",
		"fund_family_name": "Walthausen Funds",
		"label": "Walthausen Funds"
	},
	{
		"fund_family_label": "Reflection Asset Management",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 27663864,
		"long_asset_sum": 27663864,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 27663864,
		"equity_fund_long_assets": 27663864,
		"num_e_sri": 1,
		"num_e_usf": 1,
		"sri_long_assets": 27663864,
		"usf_long_assets": 27663864,
		"equity_fund_sri_long_assets": 27663864,
		"equity_fund_usf_long_assets": 27663864,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 88521,
		"ff_all_weight_total": 0.003199878368401464,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 88521,
		"og_weight_total": 0.003199878368401464,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 33,
		"cl_asset_sum": 7108514,
		"cl_weight_total": 0.25696027134893373,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 850704,
		"fossil_bank_weight_total": 0.030751452508586654,
		"fossil_insure_count_sum": 4,
		"fossil_insure_asset_sum": 173437,
		"fossil_insure_weight_total": 0.006269442330977336,
		"name": "Reflection Asset Management",
		"fund_family_name": "Reflection Asset Management",
		"label": "Reflection Asset Management"
	},
	{
		"fund_family_label": "Boyar Value Fund",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 27228592,
		"long_asset_sum": 27322729,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 27228592,
		"equity_fund_long_assets": 27322729,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 4,
		"cl_asset_sum": 3638294,
		"cl_weight_total": 0.13315997827303414,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 1380953,
		"fossil_bank_weight_total": 0.05054227928696288,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Boyar Value Fund",
		"fund_family_name": "Boyar Value Fund",
		"label": "Boyar Value Fund"
	},
	{
		"fund_family_label": "ArrowShares",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 81064937,
		"long_asset_sum": 81231604,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 26299455,
		"equity_fund_long_assets": 26303257,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 36,
		"ff_all_asset_sum": 5972747,
		"ff_all_weight_total": 0.22707252565718383,
		"grade_fossil_fam": 5,
		"c2_count_sum": 7,
		"c2_asset_sum": 1304788,
		"c2_weight_total": 0.04960556785800329,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 9,
		"co_asset_sum": 1579085,
		"co_weight_total": 0.060033820146303554,
		"og_count_sum": 25,
		"og_asset_sum": 4050524,
		"og_weight_total": 0.15399324882085896,
		"ut_count_sum": 10,
		"ut_asset_sum": 1861617,
		"ut_weight_total": 0.0707751515335154,
		"cl_count_sum": 1,
		"cl_asset_sum": 200887,
		"cl_weight_total": 0.007637343162483642,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "ArrowShares",
		"fund_family_name": "ArrowShares",
		"label": "ArrowShares"
	},
	{
		"fund_family_label": "Morgan Dempsey",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 25982884,
		"long_asset_sum": 25982884,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 25982884,
		"equity_fund_long_assets": 25982884,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 6171095,
		"ff_all_weight_total": 0.2375061598242905,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 1624748,
		"c2_weight_total": 0.0625314726417591,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 665589,
		"mc50_weight_total": 0.02561644042285683,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 7,
		"og_asset_sum": 5516773,
		"og_weight_total": 0.21232335101830882,
		"ut_count_sum": 5,
		"ut_asset_sum": 3776770,
		"ut_weight_total": 0.14535607363678335,
		"cl_count_sum": 4,
		"cl_asset_sum": 2826572,
		"cl_weight_total": 0.10878592230177374,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 1595538,
		"fossil_bank_weight_total": 0.06140727103273062,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Morgan Dempsey",
		"fund_family_name": "Morgan Dempsey",
		"label": "Morgan Dempsey"
	},
	{
		"fund_family_label": "Upright Investments Trust",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 28294506,
		"long_asset_sum": 28294506,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 25716588,
		"equity_fund_long_assets": 25716588,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 43790,
		"ff_all_weight_total": 0.0017027919878018032,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 33399,
		"c2_weight_total": 0.0012987337200409323,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 43790,
		"og_weight_total": 0.0017027919878018032,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 7,
		"cl_asset_sum": 5817214,
		"cl_weight_total": 0.2262047360248568,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 401058,
		"fossil_bank_weight_total": 0.015595303700475351,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Upright Investments Trust",
		"fund_family_name": "Upright Investments Trust",
		"label": "Upright Investments Trust"
	},
	{
		"fund_family_label": "Clough Capital Partners L.P.",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 67774340,
		"long_asset_sum": 82332603,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 25176687,
		"equity_fund_long_assets": 25176687,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 4194115,
		"ff_all_weight_total": 0.1665872479568102,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 625825,
		"c2_weight_total": 0.024857321378305257,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 7,
		"og_asset_sum": 4194115,
		"og_weight_total": 0.1665872479568102,
		"ut_count_sum": 1,
		"ut_asset_sum": 578204,
		"ut_weight_total": 0.022965849319253166,
		"cl_count_sum": 3,
		"cl_asset_sum": 1946770,
		"cl_weight_total": 0.07732431197162677,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Clough Capital Partners L.P.",
		"fund_family_name": "Clough Capital Partners L.P.",
		"label": "Clough Capital Partners L.P."
	},
	{
		"fund_family_label": "Empiric Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 24933253,
		"long_asset_sum": 24968564,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 24933253,
		"equity_fund_long_assets": 24968564,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 334328,
		"ff_all_weight_total": 0.013389957067615102,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 334328,
		"c2_weight_total": 0.013389957067615102,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 334328,
		"og_weight_total": 0.013389957067615102,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 1243081,
		"cl_weight_total": 0.049785842710057336,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Empiric Funds",
		"fund_family_name": "Empiric Funds",
		"label": "Empiric Funds"
	},
	{
		"fund_family_label": "Manor Investment Funds",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 27370844,
		"long_asset_sum": 27370844,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 24823960,
		"equity_fund_long_assets": 24823960,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 977265,
		"ff_all_weight_total": 0.03936781238770929,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 644581,
		"c2_weight_total": 0.025966082768422123,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 977265,
		"og_weight_total": 0.03936781238770929,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 9,
		"cl_asset_sum": 5764050,
		"cl_weight_total": 0.23219703866748093,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 250296,
		"fossil_bank_weight_total": 0.010082839321365326,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Manor Investment Funds",
		"fund_family_name": "Manor Investment Funds",
		"label": "Manor Investment Funds"
	},
	{
		"fund_family_label": "StockSnips",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 24724646,
		"long_asset_sum": 24724646,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 24724646,
		"equity_fund_long_assets": 24724646,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 2655121,
		"ff_all_weight_total": 0.10738762447802083,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1099874,
		"mc50_weight_total": 0.04448492407130925,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 1835084,
		"og_weight_total": 0.07422084020940077,
		"ut_count_sum": 3,
		"ut_asset_sum": 2655121,
		"ut_weight_total": 0.10738762447802083,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "StockSnips",
		"fund_family_name": "StockSnips",
		"label": "StockSnips"
	},
	{
		"fund_family_label": "Nightview",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 24434040,
		"long_asset_sum": 24434040,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 24434040,
		"equity_fund_long_assets": 24434040,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 3,
		"cl_asset_sum": 6986839,
		"cl_weight_total": 0.2859469412344418,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 2060232,
		"fossil_bank_weight_total": 0.08431810703428495,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Nightview",
		"fund_family_name": "Nightview",
		"label": "Nightview"
	},
	{
		"fund_family_label": "Mundoval Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 24345487,
		"long_asset_sum": 24345487,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 24345487,
		"equity_fund_long_assets": 24345487,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 1206078,
		"ff_all_weight_total": 0.0495401057288359,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 852128,
		"mc50_weight_total": 0.035001476865096186,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 353950,
		"og_weight_total": 0.014538628863739715,
		"ut_count_sum": 1,
		"ut_asset_sum": 852128,
		"ut_weight_total": 0.035001476865096186,
		"cl_count_sum": 8,
		"cl_asset_sum": 7609573,
		"cl_weight_total": 0.3125660620385207,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 1043250,
		"fossil_bank_weight_total": 0.04285188462239429,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 852128,
		"fossil_insure_weight_total": 0.035001476865096186,
		"name": "Mundoval Funds",
		"fund_family_name": "Mundoval Funds",
		"label": "Mundoval Funds"
	},
	{
		"fund_family_label": "WP Trust",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 79584760,
		"long_asset_sum": 93564862,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 24308563,
		"equity_fund_long_assets": 24470263,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 2849750,
		"ff_all_weight_total": 0.11645767763100871,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 1616558,
		"c2_weight_total": 0.06606214244611919,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1233192,
		"mc50_weight_total": 0.05039553518488951,
		"co_count_sum": 1,
		"co_asset_sum": 341880,
		"co_weight_total": 0.01397124338222274,
		"og_count_sum": 3,
		"og_asset_sum": 1616558,
		"og_weight_total": 0.06606214244611919,
		"ut_count_sum": 1,
		"ut_asset_sum": 1233192,
		"ut_weight_total": 0.05039553518488951,
		"cl_count_sum": 2,
		"cl_asset_sum": 8391684,
		"cl_weight_total": 0.3429339521197627,
		"fossil_bank_count_sum": 4,
		"fossil_bank_asset_sum": 7994888,
		"fossil_bank_weight_total": 0.32671851544873054,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 1233192,
		"fossil_insure_weight_total": 0.05039553518488951,
		"name": "WP Trust",
		"fund_family_name": "WP Trust",
		"label": "WP Trust"
	},
	{
		"fund_family_label": "Baywood",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 24260832,
		"long_asset_sum": 24260832,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 24260832,
		"equity_fund_long_assets": 24260832,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 18891187,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 18891187,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 14,
		"ff_all_asset_sum": 3094560,
		"ff_all_weight_total": 0.12755374588967106,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 369328,
		"c2_weight_total": 0.015223220704054997,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 726512,
		"mc50_weight_total": 0.029945881493264534,
		"co_count_sum": 2,
		"co_asset_sum": 201716,
		"co_weight_total": 0.008314471655382636,
		"og_count_sum": 12,
		"og_asset_sum": 2341164,
		"og_weight_total": 0.09649974081680299,
		"ut_count_sum": 4,
		"ut_asset_sum": 1047874,
		"ut_weight_total": 0.043192005946045046,
		"cl_count_sum": 10,
		"cl_asset_sum": 2057130,
		"cl_weight_total": 0.08479222806538539,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 536112,
		"fossil_bank_weight_total": 0.02209784066762426,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 1265064,
		"fossil_insure_weight_total": 0.05214429579331822,
		"name": "Baywood",
		"fund_family_name": "Baywood",
		"label": "Baywood"
	},
	{
		"fund_family_label": "Wrona Investment Management",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 22995524,
		"long_asset_sum": 22995524,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 22995524,
		"equity_fund_long_assets": 22995524,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 433711,
		"ff_all_weight_total": 0.018860670450475493,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 80196,
		"co_weight_total": 0.003487461298990186,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 2,
		"ut_asset_sum": 433711,
		"ut_weight_total": 0.018860670450475493,
		"cl_count_sum": 3,
		"cl_asset_sum": 1275393,
		"cl_weight_total": 0.055462663081737126,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 553216,
		"fossil_bank_weight_total": 0.024057551373910854,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Wrona Investment Management",
		"fund_family_name": "Wrona Investment Management",
		"label": "Wrona Investment Management"
	},
	{
		"fund_family_label": "Frank Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 22913563,
		"long_asset_sum": 22913563,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 22913563,
		"equity_fund_long_assets": 22913563,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 1965521,
		"ff_all_weight_total": 0.08577980648404615,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 1965521,
		"mc50_weight_total": 0.08577980648404615,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 1965521,
		"og_weight_total": 0.08577980648404615,
		"ut_count_sum": 1,
		"ut_asset_sum": 1965521,
		"ut_weight_total": 0.08577980648404615,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Frank Funds",
		"fund_family_name": "Frank Funds",
		"label": "Frank Funds"
	},
	{
		"fund_family_label": "Saturna Capital",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 64342972,
		"long_asset_sum": 64342972,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 22023473,
		"equity_fund_long_assets": 22023473,
		"num_e_sri": 1,
		"num_e_usf": 1,
		"sri_long_assets": 64342972,
		"usf_long_assets": 64342972,
		"equity_fund_sri_long_assets": 22023473,
		"equity_fund_usf_long_assets": 22023473,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 1018793,
		"ff_all_weight_total": 0.04625941603306617,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 1018793,
		"og_weight_total": 0.04625941603306617,
		"ut_count_sum": 1,
		"ut_asset_sum": 407968,
		"ut_weight_total": 0.01852423548275061,
		"cl_count_sum": 11,
		"cl_asset_sum": 5194913,
		"cl_weight_total": 0.23588073506844265,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 1257072,
		"fossil_insure_weight_total": 0.057078735946869054,
		"name": "Saturna Capital",
		"fund_family_name": "Saturna Capital",
		"label": "Saturna Capital"
	},
	{
		"fund_family_label": "Clockwise Capital Innovation ETF",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 21502265,
		"long_asset_sum": 21502265,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 21502265,
		"equity_fund_long_assets": 21502265,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 1145618,
		"ff_all_weight_total": 0.05327894526460352,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 213109,
		"c2_weight_total": 0.009911002399049589,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 463699,
		"mc50_weight_total": 0.021565123488153457,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 1145618,
		"og_weight_total": 0.05327894526460352,
		"ut_count_sum": 2,
		"ut_asset_sum": 932509,
		"ut_weight_total": 0.043367942865553934,
		"cl_count_sum": 8,
		"cl_asset_sum": 4928828,
		"cl_weight_total": 0.22922366550686638,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Clockwise Capital Innovation ETF",
		"fund_family_name": "Clockwise Capital Innovation ETF",
		"label": "Clockwise Capital Innovation ETF"
	},
	{
		"fund_family_label": "Tanaka",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 21299632,
		"long_asset_sum": 21299632,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 21299632,
		"equity_fund_long_assets": 21299632,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 1027950,
		"ff_all_weight_total": 0.0482613971922144,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 1027950,
		"og_weight_total": 0.0482613971922144,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 2838718,
		"cl_weight_total": 0.1332754481391979,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Tanaka",
		"fund_family_name": "Tanaka",
		"label": "Tanaka"
	},
	{
		"fund_family_label": "Kurv Investment Management Inc.",
		"as_of": "202506",
		"fund_id": 7,
		"net_asset_sum": 84965294,
		"long_asset_sum": 93198909,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 20764791,
		"equity_fund_long_assets": 21473292,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 6,
		"cl_asset_sum": 5095617,
		"cl_weight_total": 0.23730022392467814,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Kurv Investment Management Inc.",
		"fund_family_name": "Kurv Investment Management Inc.",
		"label": "Kurv Investment Management Inc."
	},
	{
		"fund_family_label": "Russell Investment Management Limited",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 19427997,
		"long_asset_sum": 19428118,
		"num_equity_funds": 4,
		"equity_fund_net_assets": 19427997,
		"equity_fund_long_assets": 19428118,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 127,
		"ff_all_asset_sum": 3516522,
		"ff_all_weight_total": 0.18100168014215273,
		"grade_fossil_fam": 5,
		"c2_count_sum": 35,
		"c2_asset_sum": 481900,
		"c2_weight_total": 0.02480425535813608,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 457431,
		"mc50_weight_total": 0.02354479214095776,
		"co_count_sum": 21,
		"co_asset_sum": 543755,
		"co_weight_total": 0.027988042897412916,
		"og_count_sum": 100,
		"og_asset_sum": 2649260,
		"og_weight_total": 0.13636215304024815,
		"ut_count_sum": 50,
		"ut_asset_sum": 2073202,
		"ut_weight_total": 0.10671141692674505,
		"cl_count_sum": 78,
		"cl_asset_sum": 2165809,
		"cl_weight_total": 0.11147806493660374,
		"fossil_bank_count_sum": 41,
		"fossil_bank_asset_sum": 803969,
		"fossil_bank_weight_total": 0.04138172312933244,
		"fossil_insure_count_sum": 7,
		"fossil_insure_asset_sum": 137038,
		"fossil_insure_weight_total": 0.0070535910889567375,
		"name": "Russell Investment Management Limited",
		"fund_family_name": "Russell Investment Management Limited",
		"label": "Russell Investment Management Limited"
	},
	{
		"fund_family_label": "Vontobel",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 19241450,
		"long_asset_sum": 19241450,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 19241450,
		"equity_fund_long_assets": 19241450,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 284756,
		"ff_all_weight_total": 0.014799092583978858,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 284756,
		"mc50_weight_total": 0.014799092583978858,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 284756,
		"ut_weight_total": 0.014799092583978858,
		"cl_count_sum": 3,
		"cl_asset_sum": 2244274,
		"cl_weight_total": 0.11663746755052244,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 284756,
		"fossil_insure_weight_total": 0.014799092583978858,
		"name": "Vontobel",
		"fund_family_name": "Vontobel",
		"label": "Vontobel"
	},
	{
		"fund_family_label": "Lisanti SmallCap",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 18759556,
		"long_asset_sum": 18759556,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 18759556,
		"equity_fund_long_assets": 18759556,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 112450,
		"ff_all_weight_total": 0.005994278329401826,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 112450,
		"og_weight_total": 0.005994278329401826,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Lisanti SmallCap",
		"fund_family_name": "Lisanti SmallCap",
		"label": "Lisanti SmallCap"
	},
	{
		"fund_family_label": "AmericaFirst Funds",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 17325412,
		"long_asset_sum": 17325412,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 17325412,
		"equity_fund_long_assets": 17325412,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 10,
		"ff_all_asset_sum": 2061476,
		"ff_all_weight_total": 0.11898568414996423,
		"grade_fossil_fam": 5,
		"c2_count_sum": 3,
		"c2_asset_sum": 536757,
		"c2_weight_total": 0.030980908275081712,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 373373,
		"mc50_weight_total": 0.021550598623570973,
		"co_count_sum": 3,
		"co_asset_sum": 536757,
		"co_weight_total": 0.030980908275081712,
		"og_count_sum": 6,
		"og_asset_sum": 1158301,
		"og_weight_total": 0.06685561070640052,
		"ut_count_sum": 4,
		"ut_asset_sum": 988572,
		"ut_weight_total": 0.05705907599773096,
		"cl_count_sum": 10,
		"cl_asset_sum": 1875604,
		"cl_weight_total": 0.10825739670721828,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 525077,
		"fossil_bank_weight_total": 0.03030675403274681,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "AmericaFirst Funds",
		"fund_family_name": "AmericaFirst Funds",
		"label": "AmericaFirst Funds"
	},
	{
		"fund_family_label": "Intelligent Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 17302199,
		"long_asset_sum": 17302199,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 17302199,
		"equity_fund_long_assets": 17302199,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 1282207,
		"ff_all_weight_total": 0.07410659188465003,
		"grade_fossil_fam": 4,
		"c2_count_sum": 4,
		"c2_asset_sum": 613436,
		"c2_weight_total": 0.03545422174372171,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 167495,
		"mc50_weight_total": 0.00968056141303195,
		"co_count_sum": 3,
		"co_asset_sum": 370017,
		"co_weight_total": 0.021385547582708997,
		"og_count_sum": 6,
		"og_asset_sum": 1064004,
		"og_weight_total": 0.061495304729762966,
		"ut_count_sum": 1,
		"ut_asset_sum": 167495,
		"ut_weight_total": 0.00968056141303195,
		"cl_count_sum": 4,
		"cl_asset_sum": 1502930,
		"cl_weight_total": 0.08686352526635487,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Intelligent Funds",
		"fund_family_name": "Intelligent Funds",
		"label": "Intelligent Funds"
	},
	{
		"fund_family_label": "Strategic Asset Management",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 16440719,
		"long_asset_sum": 16440719,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 16440719,
		"equity_fund_long_assets": 16440719,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 1151559,
		"ff_all_weight_total": 0.07004310456251944,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1,
		"c2_asset_sum": 519825,
		"c2_weight_total": 0.031618142734511794,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 631734,
		"co_weight_total": 0.03842496182800764,
		"og_count_sum": 2,
		"og_asset_sum": 1151559,
		"og_weight_total": 0.07004310456251944,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Strategic Asset Management",
		"fund_family_name": "Strategic Asset Management",
		"label": "Strategic Asset Management"
	},
	{
		"fund_family_label": "Long Pond Capital, LP",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 15847556,
		"long_asset_sum": 15847556,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 15847556,
		"equity_fund_long_assets": 15847556,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 491517,
		"cl_weight_total": 0.03101531870277032,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Long Pond Capital, LP",
		"fund_family_name": "Long Pond Capital, LP",
		"label": "Long Pond Capital, LP"
	},
	{
		"fund_family_label": "Rice Hall James",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 15532441,
		"long_asset_sum": 15532441,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 15532441,
		"equity_fund_long_assets": 15532441,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 397400,
		"ff_all_weight_total": 0.025585160761273776,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 397400,
		"og_weight_total": 0.025585160761273776,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Rice Hall James",
		"fund_family_name": "Rice Hall James",
		"label": "Rice Hall James"
	},
	{
		"fund_family_label": "Brendan Wood TopGun Partnerships Inc.",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 14737303,
		"long_asset_sum": 14737303,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 14737303,
		"equity_fund_long_assets": 14737303,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 1120682,
		"ff_all_weight_total": 0.07604390029844674,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 1120682,
		"og_weight_total": 0.07604390029844674,
		"ut_count_sum": 1,
		"ut_asset_sum": 555372,
		"ut_weight_total": 0.03768477855140795,
		"cl_count_sum": 5,
		"cl_asset_sum": 3021848,
		"cl_weight_total": 0.20504755856617726,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 595809,
		"fossil_bank_weight_total": 0.040428632023104906,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Brendan Wood TopGun Partnerships Inc.",
		"fund_family_name": "Brendan Wood TopGun Partnerships Inc.",
		"label": "Brendan Wood TopGun Partnerships Inc."
	},
	{
		"fund_family_label": "Laffer Tengler Investments, Inc.",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 14658523,
		"long_asset_sum": 14658523,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 14658523,
		"equity_fund_long_assets": 14658523,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 1854102,
		"ff_all_weight_total": 0.1264862769598274,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 772425,
		"c2_weight_total": 0.05269459958551077,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 1854102,
		"og_weight_total": 0.1264862769598274,
		"ut_count_sum": 1,
		"ut_asset_sum": 284891,
		"ut_weight_total": 0.019435177746079873,
		"cl_count_sum": 7,
		"cl_asset_sum": 3484606,
		"cl_weight_total": 0.23771876607213427,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 593845,
		"fossil_bank_weight_total": 0.04051192606512948,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Laffer Tengler Investments, Inc.",
		"fund_family_name": "Laffer Tengler Investments, Inc.",
		"label": "Laffer Tengler Investments, Inc."
	},
	{
		"fund_family_label": "VistaShares Advisors LLC",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 243254359,
		"long_asset_sum": 250140956,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 13944007,
		"equity_fund_long_assets": 14010802,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 543927,
		"ff_all_weight_total": 0.03882197464499177,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 543927,
		"og_weight_total": 0.03882197464499177,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 7,
		"cl_asset_sum": 2199873,
		"cl_weight_total": 0.15701263924791742,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "VistaShares Advisors LLC",
		"fund_family_name": "VistaShares Advisors LLC",
		"label": "VistaShares Advisors LLC"
	},
	{
		"fund_family_label": "REMSGroup",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 13749176,
		"long_asset_sum": 13749176,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 13749176,
		"equity_fund_long_assets": 13749176,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 712616,
		"cl_weight_total": 0.051829724195835446,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "REMSGroup",
		"fund_family_name": "REMSGroup",
		"label": "REMSGroup"
	},
	{
		"fund_family_label": "Grandeur peak global",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 12351663,
		"long_asset_sum": 12396653,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 12351663,
		"equity_fund_long_assets": 12396653,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 200363,
		"ff_all_weight_total": 0.01616266906882043,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 5,
		"og_asset_sum": 200363,
		"og_weight_total": 0.01616266906882043,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 30938,
		"cl_weight_total": 0.002495673630616264,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Grandeur peak global",
		"fund_family_name": "Grandeur peak global",
		"label": "Grandeur peak global"
	},
	{
		"fund_family_label": "Liberty Street",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 555407194,
		"long_asset_sum": 555908910,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 11746904,
		"equity_fund_long_assets": 11784416,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Liberty Street",
		"fund_family_name": "Liberty Street",
		"label": "Liberty Street"
	},
	{
		"fund_family_label": "Mesirow",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 163807753,
		"long_asset_sum": 163864972,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 10226430,
		"equity_fund_long_assets": 10226430,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 5,
		"ff_all_asset_sum": 629874,
		"ff_all_weight_total": 0.061592755243032024,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 257445,
		"c2_weight_total": 0.02517447437668864,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 471895,
		"og_weight_total": 0.046144646763337745,
		"ut_count_sum": 1,
		"ut_asset_sum": 157979,
		"ut_weight_total": 0.015448108479694283,
		"cl_count_sum": 1,
		"cl_asset_sum": 89877,
		"cl_weight_total": 0.008788697522009148,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Mesirow",
		"fund_family_name": "Mesirow",
		"label": "Mesirow"
	},
	{
		"fund_family_label": "Armada ETF",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 10176116,
		"long_asset_sum": 10176116,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 10176116,
		"equity_fund_long_assets": 10176116,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 2,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 2,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 31109,
		"cl_weight_total": 0.0030570602772216826,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Armada ETF",
		"fund_family_name": "Armada ETF",
		"label": "Armada ETF"
	},
	{
		"fund_family_label": "ALPHA BLUE CAPITAL",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 10061555,
		"long_asset_sum": 10061555,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 10061555,
		"equity_fund_long_assets": 10061555,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 10,
		"ff_all_asset_sum": 694852,
		"ff_all_weight_total": 0.06906010055105796,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 182050,
		"c2_weight_total": 0.018093624693201003,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 74364,
		"mc50_weight_total": 0.007390905282533366,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 9,
		"og_asset_sum": 631745,
		"og_weight_total": 0.06278800841420636,
		"ut_count_sum": 2,
		"ut_asset_sum": 137471,
		"ut_weight_total": 0.013662997419384976,
		"cl_count_sum": 1,
		"cl_asset_sum": 44262,
		"cl_weight_total": 0.004399121209395566,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 52526,
		"fossil_bank_weight_total": 0.0052204654250759455,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 213036,
		"fossil_insure_weight_total": 0.021173267949139075,
		"name": "ALPHA BLUE CAPITAL",
		"fund_family_name": "ALPHA BLUE CAPITAL",
		"label": "ALPHA BLUE CAPITAL"
	},
	{
		"fund_family_label": "National security index",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 9928817,
		"long_asset_sum": 9928817,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 9928817,
		"equity_fund_long_assets": 9928817,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 12,
		"ff_all_asset_sum": 846846,
		"ff_all_weight_total": 0.08529173213686989,
		"grade_fossil_fam": 4,
		"c2_count_sum": 4,
		"c2_asset_sum": 184899,
		"c2_weight_total": 0.01862246025886065,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 82311,
		"mc50_weight_total": 0.0082901115006954,
		"co_count_sum": 4,
		"co_asset_sum": 390472,
		"co_weight_total": 0.03932714239772976,
		"og_count_sum": 10,
		"og_asset_sum": 782397,
		"og_weight_total": 0.07880062649961218,
		"ut_count_sum": 5,
		"ut_asset_sum": 359878,
		"ut_weight_total": 0.03624580853892261,
		"cl_count_sum": 11,
		"cl_asset_sum": 1435705,
		"cl_weight_total": 0.1445998047904398,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 217057,
		"fossil_bank_weight_total": 0.021861315401421944,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 204750,
		"fossil_insure_weight_total": 0.020621792102724825,
		"name": "National security index",
		"fund_family_name": "National security index",
		"label": "National security index"
	},
	{
		"fund_family_label": "Altrius Capital Management,Inc.",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 9723690,
		"long_asset_sum": 10104453,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 9723690,
		"equity_fund_long_assets": 10104453,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 948521,
		"ff_all_weight_total": 0.09387158315249722,
		"grade_fossil_fam": 5,
		"c2_count_sum": 5,
		"c2_asset_sum": 578747,
		"c2_weight_total": 0.0572764305004932,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 8,
		"og_asset_sum": 948521,
		"og_weight_total": 0.09387158315249722,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 8,
		"cl_asset_sum": 1323679,
		"cl_weight_total": 0.13099957018949962,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 1024158,
		"fossil_bank_weight_total": 0.10135709473832973,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 259473,
		"fossil_insure_weight_total": 0.025679074364540068,
		"name": "Altrius Capital Management,Inc.",
		"fund_family_name": "Altrius Capital Management,Inc.",
		"label": "Altrius Capital Management,Inc."
	},
	{
		"fund_family_label": "Issachar Fund",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 9709708,
		"long_asset_sum": 9748816,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 9709708,
		"equity_fund_long_assets": 9748816,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 296037,
		"ff_all_weight_total": 0.030366456808703743,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 296037,
		"og_weight_total": 0.030366456808703743,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 197490,
		"cl_weight_total": 0.02025784464492919,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Issachar Fund",
		"fund_family_name": "Issachar Fund",
		"label": "Issachar Fund"
	},
	{
		"fund_family_label": "Empowered Funds, LLC",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 114072670,
		"long_asset_sum": 119082102,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 9620508,
		"equity_fund_long_assets": 9620508,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 791459,
		"ff_all_weight_total": 0.0822679010297585,
		"grade_fossil_fam": 4,
		"c2_count_sum": 1,
		"c2_asset_sum": 225544,
		"c2_weight_total": 0.023444084241705323,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 7,
		"og_asset_sum": 791459,
		"og_weight_total": 0.0822679010297585,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 26,
		"cl_asset_sum": 2715322,
		"cl_weight_total": 0.2822430998446236,
		"fossil_bank_count_sum": 2,
		"fossil_bank_asset_sum": 232850,
		"fossil_bank_weight_total": 0.02420350359877046,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Empowered Funds, LLC",
		"fund_family_name": "Empowered Funds, LLC",
		"label": "Empowered Funds, LLC"
	},
	{
		"fund_family_label": "MSA Power Funds LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 9505699,
		"long_asset_sum": 9507921,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 9505699,
		"equity_fund_long_assets": 9507921,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 164270,
		"cl_weight_total": 0.017277173422034112,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "MSA Power Funds LLC",
		"fund_family_name": "MSA Power Funds LLC",
		"label": "MSA Power Funds LLC"
	},
	{
		"fund_family_label": "Otter Creek",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 168559374,
		"long_asset_sum": 221457738,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 9287888,
		"equity_fund_long_assets": 9287888,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 294196,
		"ff_all_weight_total": 0.031675231225871806,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 294196,
		"co_weight_total": 0.031675231225871806,
		"og_count_sum": 1,
		"og_asset_sum": 294196,
		"og_weight_total": 0.031675231225871806,
		"ut_count_sum": 1,
		"ut_asset_sum": 294196,
		"ut_weight_total": 0.031675231225871806,
		"cl_count_sum": 3,
		"cl_asset_sum": 948316,
		"cl_weight_total": 0.10210243706642458,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Otter Creek",
		"fund_family_name": "Otter Creek",
		"label": "Otter Creek"
	},
	{
		"fund_family_label": "Wireless",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 8379194,
		"long_asset_sum": 8379194,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 8379194,
		"equity_fund_long_assets": 8379194,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 8,
		"cl_asset_sum": 3640447,
		"cl_weight_total": 0.4344626702759239,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Wireless",
		"fund_family_name": "Wireless",
		"label": "Wireless"
	},
	{
		"fund_family_label": "NorthQuest Fund",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 8361455,
		"long_asset_sum": 8361455,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 8361455,
		"equity_fund_long_assets": 8361455,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 282128,
		"ff_all_weight_total": 0.03374149594777464,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 282128,
		"c2_weight_total": 0.03374149594777464,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 282128,
		"og_weight_total": 0.03374149594777464,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 908502,
		"cl_weight_total": 0.1086535776369065,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "NorthQuest Fund",
		"fund_family_name": "NorthQuest Fund",
		"label": "NorthQuest Fund"
	},
	{
		"fund_family_label": "BTS",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 73059296,
		"long_asset_sum": 73123762,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 8169067,
		"equity_fund_long_assets": 8169067,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 788896,
		"ff_all_weight_total": 0.09657112617634303,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 173162,
		"c2_weight_total": 0.021197279934171184,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 160009,
		"mc50_weight_total": 0.019587181743031364,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 6,
		"og_asset_sum": 580109,
		"og_weight_total": 0.07101288311137612,
		"ut_count_sum": 4,
		"ut_asset_sum": 442253,
		"ut_weight_total": 0.054137516560948756,
		"cl_count_sum": 3,
		"cl_asset_sum": 672467,
		"cl_weight_total": 0.08231870298040156,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 301663,
		"fossil_insure_weight_total": 0.03692747286807661,
		"name": "BTS",
		"fund_family_name": "BTS",
		"label": "BTS"
	},
	{
		"fund_family_label": "Honeytree",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 8074142,
		"long_asset_sum": 8074142,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 8074142,
		"equity_fund_long_assets": 8074142,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 311087,
		"cl_weight_total": 0.03852879971642807,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Honeytree",
		"fund_family_name": "Honeytree",
		"label": "Honeytree"
	},
	{
		"fund_family_label": "Range Cancer",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 7834574,
		"long_asset_sum": 7837575,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 7834574,
		"equity_fund_long_assets": 7837575,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 114509,
		"cl_weight_total": 0.014610258912992858,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Range Cancer",
		"fund_family_name": "Range Cancer",
		"label": "Range Cancer"
	},
	{
		"fund_family_label": "M3Sixty",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 26726633,
		"long_asset_sum": 26726633,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 7642951,
		"equity_fund_long_assets": 7642951,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 308031,
		"ff_all_weight_total": 0.040302626564006495,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 308031,
		"og_weight_total": 0.040302626564006495,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "M3Sixty",
		"fund_family_name": "M3Sixty",
		"label": "M3Sixty"
	},
	{
		"fund_family_label": "Channing Capital",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 7573531,
		"long_asset_sum": 7573531,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 7573531,
		"equity_fund_long_assets": 7573531,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 503488,
		"ff_all_weight_total": 0.06647995499061138,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 159051,
		"c2_weight_total": 0.021000904333790937,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 159051,
		"og_weight_total": 0.021000904333790937,
		"ut_count_sum": 2,
		"ut_asset_sum": 344437,
		"ut_weight_total": 0.045479050656820445,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Channing Capital",
		"fund_family_name": "Channing Capital",
		"label": "Channing Capital"
	},
	{
		"fund_family_label": "WHITEWOLF",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 7271801,
		"long_asset_sum": 7271801,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 7271801,
		"equity_fund_long_assets": 7271801,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 4,
		"ff_all_asset_sum": 1414760,
		"ff_all_weight_total": 0.19455427891934887,
		"grade_fossil_fam": 5,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 4,
		"og_asset_sum": 1414760,
		"og_weight_total": 0.19455427891934887,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "WHITEWOLF",
		"fund_family_name": "WHITEWOLF",
		"label": "WHITEWOLF"
	},
	{
		"fund_family_label": "Rita ETF",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 7248601,
		"long_asset_sum": 7248601,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 7248601,
		"equity_fund_long_assets": 7248601,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 7248601,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 7248601,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 1,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 1,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Rita ETF",
		"fund_family_name": "Rita ETF",
		"label": "Rita ETF"
	},
	{
		"fund_family_label": "QRAFT Technologies, Inc",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 6399508,
		"long_asset_sum": 6399508,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 6399508,
		"equity_fund_long_assets": 6399508,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 17,
		"ff_all_asset_sum": 1048020,
		"ff_all_weight_total": 0.16376571448930136,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 28897,
		"c2_weight_total": 0.004515503379322285,
		"mc50_count_sum": 2,
		"mc50_asset_sum": 141274,
		"mc50_weight_total": 0.022075759574017254,
		"co_count_sum": 4,
		"co_asset_sum": 234884,
		"co_weight_total": 0.03670344657745564,
		"og_count_sum": 10,
		"og_asset_sum": 612520,
		"og_weight_total": 0.09571360798361374,
		"ut_count_sum": 13,
		"ut_asset_sum": 686317,
		"ut_weight_total": 0.10724527573057178,
		"cl_count_sum": 11,
		"cl_asset_sum": 1356632,
		"cl_weight_total": 0.21199004673484273,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "QRAFT Technologies, Inc",
		"fund_family_name": "QRAFT Technologies, Inc",
		"label": "QRAFT Technologies, Inc"
	},
	{
		"fund_family_label": "Perkins",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 6121679,
		"long_asset_sum": 6121679,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 6121679,
		"equity_fund_long_assets": 6121679,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Perkins",
		"fund_family_name": "Perkins",
		"label": "Perkins"
	},
	{
		"fund_family_label": "Suncoast Equity Management, LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 5374545,
		"long_asset_sum": 5374545,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 5374545,
		"equity_fund_long_assets": 5374545,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 148164,
		"ff_all_weight_total": 0.02756772898915164,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 148164,
		"mc50_weight_total": 0.02756772898915164,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 1,
		"ut_asset_sum": 148164,
		"ut_weight_total": 0.02756772898915164,
		"cl_count_sum": 3,
		"cl_asset_sum": 1120322,
		"cl_weight_total": 0.2084496455048753,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 148164,
		"fossil_insure_weight_total": 0.02756772898915164,
		"name": "Suncoast Equity Management, LLC",
		"fund_family_name": "Suncoast Equity Management, LLC",
		"label": "Suncoast Equity Management, LLC"
	},
	{
		"fund_family_label": "NEXPOINT FUNDS I",
		"as_of": "202506",
		"fund_id": 3,
		"net_asset_sum": 633612760,
		"long_asset_sum": 744492268,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 4905718,
		"equity_fund_long_assets": 5692912,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 5692912,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 5692912,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 7,
		"ff_all_asset_sum": 1093297,
		"ff_all_weight_total": 0.19204530124477595,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 308982,
		"c2_weight_total": 0.0542748596851664,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 399072,
		"co_weight_total": 0.07009980129677044,
		"og_count_sum": 7,
		"og_asset_sum": 1093297,
		"og_weight_total": 0.19204530124477595,
		"ut_count_sum": 4,
		"ut_asset_sum": 788952,
		"ut_weight_total": 0.1385849631963396,
		"cl_count_sum": 3,
		"cl_asset_sum": 459132,
		"cl_weight_total": 0.08064976237117313,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "NEXPOINT FUNDS I",
		"fund_family_name": "NEXPOINT FUNDS I",
		"label": "NEXPOINT FUNDS I"
	},
	{
		"fund_family_label": "Hypatia Capital Group",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 4800319,
		"long_asset_sum": 4800319,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 4800319,
		"equity_fund_long_assets": 4800319,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 4800319,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 4800319,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 14,
		"ff_all_asset_sum": 366121,
		"ff_all_weight_total": 0.07627013954697594,
		"grade_fossil_fam": 4,
		"c2_count_sum": 2,
		"c2_asset_sum": 52670,
		"c2_weight_total": 0.010972187473374166,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 7,
		"co_asset_sum": 180730,
		"co_weight_total": 0.03764958120491576,
		"og_count_sum": 6,
		"og_asset_sum": 163115,
		"og_weight_total": 0.03398003341027961,
		"ut_count_sum": 9,
		"ut_asset_sum": 232100,
		"ut_weight_total": 0.04835095334289242,
		"cl_count_sum": 3,
		"cl_asset_sum": 132101,
		"cl_weight_total": 0.027519212785650286,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 38263,
		"fossil_bank_weight_total": 0.007970928598703544,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Hypatia Capital Group",
		"fund_family_name": "Hypatia Capital Group",
		"label": "Hypatia Capital Group"
	},
	{
		"fund_family_label": "Reverb ETF",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 4621525,
		"long_asset_sum": 4621525,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 4621525,
		"equity_fund_long_assets": 4621525,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 64,
		"ff_all_asset_sum": 364356,
		"ff_all_weight_total": 0.07883891139829385,
		"grade_fossil_fam": 4,
		"c2_count_sum": 15,
		"c2_asset_sum": 99570,
		"c2_weight_total": 0.02154483639058536,
		"mc50_count_sum": 4,
		"mc50_asset_sum": 68690,
		"mc50_weight_total": 0.014863059271560794,
		"co_count_sum": 9,
		"co_asset_sum": 28138,
		"co_weight_total": 0.006088466469401334,
		"og_count_sum": 50,
		"og_asset_sum": 266196,
		"og_weight_total": 0.05759916910543598,
		"ut_count_sum": 25,
		"ut_asset_sum": 148876,
		"ut_weight_total": 0.03221360914416778,
		"cl_count_sum": 38,
		"cl_asset_sum": 1189632,
		"cl_weight_total": 0.25741113593456705,
		"fossil_bank_count_sum": 15,
		"fossil_bank_asset_sum": 163351,
		"fossil_bank_weight_total": 0.035345692168710544,
		"fossil_insure_count_sum": 5,
		"fossil_insure_asset_sum": 76886,
		"fossil_insure_weight_total": 0.01663649985664905,
		"name": "Reverb ETF",
		"fund_family_name": "Reverb ETF",
		"label": "Reverb ETF"
	},
	{
		"fund_family_label": "Sarmaya Partners, LLC",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 4541621,
		"long_asset_sum": 4541621,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 4541621,
		"equity_fund_long_assets": 4541621,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 14,
		"ff_all_asset_sum": 1116414,
		"ff_all_weight_total": 0.2458183983207758,
		"grade_fossil_fam": 5,
		"c2_count_sum": 7,
		"c2_asset_sum": 688501,
		"c2_weight_total": 0.1515980747843116,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 168028,
		"co_weight_total": 0.03699736283586851,
		"og_count_sum": 13,
		"og_asset_sum": 1033131,
		"og_weight_total": 0.22748067264969932,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 163303,
		"cl_weight_total": 0.03595698540234863,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Sarmaya Partners, LLC",
		"fund_family_name": "Sarmaya Partners, LLC",
		"label": "Sarmaya Partners, LLC"
	},
	{
		"fund_family_label": "Acruence",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 4365679,
		"long_asset_sum": 4398123,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 4365679,
		"equity_fund_long_assets": 4398123,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 9,
		"ff_all_asset_sum": 666621,
		"ff_all_weight_total": 0.15156943086857735,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 47162,
		"c2_weight_total": 0.010723210787874736,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 65138,
		"co_weight_total": 0.014810408894885387,
		"og_count_sum": 4,
		"og_asset_sum": 316908,
		"og_weight_total": 0.07205528358347413,
		"ut_count_sum": 6,
		"ut_asset_sum": 408737,
		"ut_weight_total": 0.09293441770500734,
		"cl_count_sum": 1,
		"cl_asset_sum": 238439,
		"cl_weight_total": 0.0542138089362212,
		"fossil_bank_count_sum": 3,
		"fossil_bank_asset_sum": 265482,
		"fossil_bank_weight_total": 0.06036256830470635,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Acruence",
		"fund_family_name": "Acruence",
		"label": "Acruence"
	},
	{
		"fund_family_label": "IRET ETF",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 4292241,
		"long_asset_sum": 4292241,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 4292241,
		"equity_fund_long_assets": 4292241,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "IRET ETF",
		"fund_family_name": "IRET ETF",
		"label": "IRET ETF"
	},
	{
		"fund_family_label": "Grizzle ETF",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 4173055,
		"long_asset_sum": 4174637,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 4173055,
		"equity_fund_long_assets": 4174637,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 6,
		"ff_all_asset_sum": 368700,
		"ff_all_weight_total": 0.08831905624369256,
		"grade_fossil_fam": 4,
		"c2_count_sum": 3,
		"c2_asset_sum": 142965,
		"c2_weight_total": 0.034246091336803654,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 6,
		"og_asset_sum": 368700,
		"og_weight_total": 0.08831905624369256,
		"ut_count_sum": 1,
		"ut_asset_sum": 30658,
		"ut_weight_total": 0.007343872054025296,
		"cl_count_sum": 7,
		"cl_asset_sum": 1104179,
		"cl_weight_total": 0.26449700896149775,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Grizzle ETF",
		"fund_family_name": "Grizzle ETF",
		"label": "Grizzle ETF"
	},
	{
		"fund_family_label": "Adler",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 3994418,
		"long_asset_sum": 3994418,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 3994418,
		"equity_fund_long_assets": 3994418,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 275882,
		"ff_all_weight_total": 0.06906688283499623,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 112482,
		"og_weight_total": 0.028159796996708907,
		"ut_count_sum": 1,
		"ut_asset_sum": 163400,
		"ut_weight_total": 0.04090708583828733,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 255840,
		"fossil_bank_weight_total": 0.06404938091106138,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Adler",
		"fund_family_name": "Adler",
		"label": "Adler"
	},
	{
		"fund_family_label": "iMGP",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 3841288,
		"long_asset_sum": 3849865,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 3841288,
		"equity_fund_long_assets": 3849865,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 2,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 11928,
		"ff_all_weight_total": 0.003098290459535594,
		"grade_fossil_fam": 2,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 11928,
		"og_weight_total": 0.003098290459535594,
		"ut_count_sum": 1,
		"ut_asset_sum": 11928,
		"ut_weight_total": 0.003098290459535594,
		"cl_count_sum": 1,
		"cl_asset_sum": 178149,
		"cl_weight_total": 0.04627409013043315,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 1,
		"fossil_insure_asset_sum": 47610,
		"fossil_insure_weight_total": 0.012366667402623209,
		"name": "iMGP",
		"fund_family_name": "iMGP",
		"label": "iMGP"
	},
	{
		"fund_family_label": "Bitwise Investments",
		"as_of": "202506",
		"fund_id": 10,
		"net_asset_sum": 4348951205,
		"long_asset_sum": 4352742546,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 3786937,
		"equity_fund_long_assets": 3787434,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 47672,
		"ff_all_weight_total": 0.012586886002501957,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 47672,
		"c2_weight_total": 0.012586886002501957,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 1,
		"og_asset_sum": 47672,
		"og_weight_total": 0.012586886002501957,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 4,
		"cl_asset_sum": 444801,
		"cl_weight_total": 0.11744125442185924,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Bitwise Investments",
		"fund_family_name": "Bitwise Investments",
		"label": "Bitwise Investments"
	},
	{
		"fund_family_label": "Mason Capital Partners",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 3784042,
		"long_asset_sum": 3784042,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 3784042,
		"equity_fund_long_assets": 3784042,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 20,
		"ff_all_asset_sum": 621487,
		"ff_all_weight_total": 0.16423892758061354,
		"grade_fossil_fam": 5,
		"c2_count_sum": 5,
		"c2_asset_sum": 113547,
		"c2_weight_total": 0.030006802250080733,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 17,
		"og_asset_sum": 522063,
		"og_weight_total": 0.13796437777381965,
		"ut_count_sum": 3,
		"ut_asset_sum": 99424,
		"ut_weight_total": 0.0262745498067939,
		"cl_count_sum": 3,
		"cl_asset_sum": 194337,
		"cl_weight_total": 0.05135698810954001,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 22230,
		"fossil_bank_weight_total": 0.00587467052427008,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Mason Capital Partners",
		"fund_family_name": "Mason Capital Partners",
		"label": "Mason Capital Partners"
	},
	{
		"fund_family_label": "First Sentier Investors",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 3722081,
		"long_asset_sum": 3722081,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 3722081,
		"equity_fund_long_assets": 3722081,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 22,
		"ff_all_asset_sum": 2738184,
		"ff_all_weight_total": 0.7356594335265675,
		"grade_fossil_fam": 5,
		"c2_count_sum": 1,
		"c2_asset_sum": 80543,
		"c2_weight_total": 0.021639238909631466,
		"mc50_count_sum": 3,
		"mc50_asset_sum": 577334,
		"mc50_weight_total": 0.15511054165667001,
		"co_count_sum": 4,
		"co_asset_sum": 548873,
		"co_weight_total": 0.1474640127391102,
		"og_count_sum": 13,
		"og_asset_sum": 1719520,
		"og_weight_total": 0.46197812460287674,
		"ut_count_sum": 15,
		"ut_asset_sum": 1792178,
		"ut_weight_total": 0.48149892492936075,
		"cl_count_sum": 2,
		"cl_asset_sum": 55366,
		"cl_weight_total": 0.014875012123594301,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "First Sentier Investors",
		"fund_family_name": "First Sentier Investors",
		"label": "First Sentier Investors"
	},
	{
		"fund_family_label": "Langar Funds",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 3468424,
		"long_asset_sum": 3468424,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 3468424,
		"equity_fund_long_assets": 3468424,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 330887,
		"cl_weight_total": 0.09539981271032608,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Langar Funds",
		"fund_family_name": "Langar Funds",
		"label": "Langar Funds"
	},
	{
		"fund_family_label": "Forester",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 3082695,
		"long_asset_sum": 3082695,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 3082695,
		"equity_fund_long_assets": 3082695,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 8,
		"ff_all_asset_sum": 420182,
		"ff_all_weight_total": 0.13630346174370153,
		"grade_fossil_fam": 5,
		"c2_count_sum": 5,
		"c2_asset_sum": 236383,
		"c2_weight_total": 0.0766806317199723,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 60630,
		"co_weight_total": 0.019667855561448667,
		"og_count_sum": 6,
		"og_asset_sum": 285824,
		"og_weight_total": 0.0927188709878856,
		"ut_count_sum": 3,
		"ut_asset_sum": 207249,
		"ut_weight_total": 0.06722981027964167,
		"cl_count_sum": 3,
		"cl_asset_sum": 115418,
		"cl_weight_total": 0.03744061608430286,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 63330,
		"fossil_bank_weight_total": 0.020543712563195517,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 104230,
		"fossil_insure_weight_total": 0.03381132418224962,
		"name": "Forester",
		"fund_family_name": "Forester",
		"label": "Forester"
	},
	{
		"fund_family_label": "Grayscale",
		"as_of": "202506",
		"fund_id": 20,
		"net_asset_sum": 28962825817,
		"long_asset_sum": 28965038913,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 2997653,
		"equity_fund_long_assets": 2997653,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 1,
		"ff_all_asset_sum": 111537,
		"ff_all_weight_total": 0.037208109144053696,
		"grade_fossil_fam": 3,
		"c2_count_sum": 1,
		"c2_asset_sum": 111537,
		"c2_weight_total": 0.037208109144053696,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 1,
		"co_asset_sum": 111537,
		"co_weight_total": 0.037208109144053696,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 513630,
		"cl_weight_total": 0.1713440481603441,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Grayscale",
		"fund_family_name": "Grayscale",
		"label": "Grayscale"
	},
	{
		"fund_family_label": "Bullfinch",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 2973770,
		"long_asset_sum": 3298627,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 2973770,
		"equity_fund_long_assets": 3298627,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 167138,
		"ff_all_weight_total": 0.05066896014614566,
		"grade_fossil_fam": 3,
		"c2_count_sum": 2,
		"c2_asset_sum": 167138,
		"c2_weight_total": 0.05066896014614566,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 2,
		"co_asset_sum": 167138,
		"co_weight_total": 0.05066896014614566,
		"og_count_sum": 1,
		"og_asset_sum": 87538,
		"og_weight_total": 0.026537707961524597,
		"ut_count_sum": 1,
		"ut_asset_sum": 79600,
		"ut_weight_total": 0.024131252184621057,
		"cl_count_sum": 1,
		"cl_asset_sum": 2989,
		"cl_weight_total": 0.0009061345826612102,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 130288,
		"fossil_bank_weight_total": 0.03949764553555161,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Bullfinch",
		"fund_family_name": "Bullfinch",
		"label": "Bullfinch"
	},
	{
		"fund_family_label": "Kingsbarn Capital",
		"as_of": "202506",
		"fund_id": 2,
		"net_asset_sum": 4449755,
		"long_asset_sum": 4449755,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 2780574,
		"equity_fund_long_assets": 2780574,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 0,
		"cl_asset_sum": 0,
		"cl_weight_total": 0,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Kingsbarn Capital",
		"fund_family_name": "Kingsbarn Capital",
		"label": "Kingsbarn Capital"
	},
	{
		"fund_family_label": "Tema ETFs",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 2575519,
		"long_asset_sum": 2575519,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 2575519,
		"equity_fund_long_assets": 2575519,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 59,
		"ff_all_asset_sum": 237767,
		"ff_all_weight_total": 0.09231809200398056,
		"grade_fossil_fam": 5,
		"c2_count_sum": 13,
		"c2_asset_sum": 67158,
		"c2_weight_total": 0.026075521089147468,
		"mc50_count_sum": 6,
		"mc50_asset_sum": 53473,
		"mc50_weight_total": 0.020762028934750626,
		"co_count_sum": 10,
		"co_asset_sum": 19672,
		"co_weight_total": 0.00763807217108474,
		"og_count_sum": 42,
		"og_asset_sum": 162584,
		"og_weight_total": 0.06312669407602894,
		"ut_count_sum": 31,
		"ut_asset_sum": 117673,
		"ut_weight_total": 0.045689043645183745,
		"cl_count_sum": 36,
		"cl_asset_sum": 468432,
		"cl_weight_total": 0.1818786815395266,
		"fossil_bank_count_sum": 8,
		"fossil_bank_asset_sum": 82506,
		"fossil_bank_weight_total": 0.032034708344221105,
		"fossil_insure_count_sum": 6,
		"fossil_insure_asset_sum": 56936,
		"fossil_insure_weight_total": 0.022106612298336763,
		"name": "Tema ETFs",
		"fund_family_name": "Tema ETFs",
		"label": "Tema ETFs"
	},
	{
		"fund_family_label": "Accuvest Global Advisors",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 1998687,
		"long_asset_sum": 3003886,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 1998687,
		"equity_fund_long_assets": 3003886,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 3,
		"ff_all_asset_sum": 101539,
		"ff_all_weight_total": 0.03380254776645984,
		"grade_fossil_fam": 3,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 3,
		"og_asset_sum": 101539,
		"og_weight_total": 0.03380254776645984,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 6,
		"cl_asset_sum": 240560,
		"cl_weight_total": 0.08008293257467161,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 19214,
		"fossil_bank_weight_total": 0.006396381220858581,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Accuvest Global Advisors",
		"fund_family_name": "Accuvest Global Advisors",
		"label": "Accuvest Global Advisors"
	},
	{
		"fund_family_label": "Genter funds",
		"as_of": "202506",
		"fund_id": 4,
		"net_asset_sum": 46456605,
		"long_asset_sum": 46825019,
		"num_equity_funds": 2,
		"equity_fund_net_assets": 1330498,
		"equity_fund_long_assets": 1330498,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 11,
		"ff_all_asset_sum": 213329,
		"ff_all_weight_total": 0.16033770813635195,
		"grade_fossil_fam": 5,
		"c2_count_sum": 2,
		"c2_asset_sum": 36370,
		"c2_weight_total": 0.02733562921552682,
		"mc50_count_sum": 1,
		"mc50_asset_sum": 19126,
		"mc50_weight_total": 0.014375068583342478,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 10,
		"og_asset_sum": 194203,
		"og_weight_total": 0.14596263955300948,
		"ut_count_sum": 4,
		"ut_asset_sum": 81549,
		"ut_weight_total": 0.06129208762433314,
		"cl_count_sum": 13,
		"cl_asset_sum": 245766,
		"cl_weight_total": 0.1847173013413023,
		"fossil_bank_count_sum": 5,
		"fossil_bank_asset_sum": 142612,
		"fossil_bank_weight_total": 0.10718693301305225,
		"fossil_insure_count_sum": 2,
		"fossil_insure_asset_sum": 46581,
		"fossil_insure_weight_total": 0.0350101991885745,
		"name": "Genter funds",
		"fund_family_name": "Genter funds",
		"label": "Genter funds"
	},
	{
		"fund_family_label": "Bain Capital Public Equity LP",
		"as_of": "202506",
		"fund_id": 1,
		"net_asset_sum": 1296637,
		"long_asset_sum": 1342593,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 1296637,
		"equity_fund_long_assets": 1342593,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 2,
		"ff_all_asset_sum": 93002,
		"ff_all_weight_total": 0.06927043415241999,
		"grade_fossil_fam": 4,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 2,
		"og_asset_sum": 93002,
		"og_weight_total": 0.06927043415241999,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 2,
		"cl_asset_sum": 70916,
		"cl_weight_total": 0.05282017707525661,
		"fossil_bank_count_sum": 1,
		"fossil_bank_asset_sum": 44091,
		"fossil_bank_weight_total": 0.032840183138151326,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Bain Capital Public Equity LP",
		"fund_family_name": "Bain Capital Public Equity LP",
		"label": "Bain Capital Public Equity LP"
	},
	{
		"fund_family_label": "Fisher Investments",
		"as_of": "202506",
		"fund_id": 8,
		"net_asset_sum": 7364897,
		"long_asset_sum": 7364897,
		"num_equity_funds": 5,
		"equity_fund_net_assets": 1227230,
		"equity_fund_long_assets": 1227230,
		"num_e_sri": 3,
		"num_e_usf": 0,
		"sri_long_assets": 3806928,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 768741,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 1,
		"num_c2_free": 0,
		"num_five_badgers": 0,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 0,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 37,
		"ff_all_asset_sum": 87621,
		"ff_all_weight_total": 0.07139737457526299,
		"grade_fossil_fam": 4,
		"c2_count_sum": 25,
		"c2_asset_sum": 58960,
		"c2_weight_total": 0.04804315409499442,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 4,
		"co_asset_sum": 5073,
		"co_weight_total": 0.004133699469537087,
		"og_count_sum": 34,
		"og_asset_sum": 82902,
		"og_weight_total": 0.0675521295926599,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 49,
		"cl_asset_sum": 222460,
		"cl_weight_total": 0.18127001458569297,
		"fossil_bank_count_sum": 35,
		"fossil_bank_asset_sum": 113583,
		"fossil_bank_weight_total": 0.09255233330345575,
		"fossil_insure_count_sum": 3,
		"fossil_insure_asset_sum": 5546,
		"fossil_insure_weight_total": 0.004519120295299169,
		"name": "Fisher Investments",
		"fund_family_name": "Fisher Investments",
		"label": "Fisher Investments"
	},
	{
		"fund_family_label": "Tuttle Capital Management, LLC",
		"as_of": "202506",
		"fund_id": 18,
		"net_asset_sum": 7686066214,
		"long_asset_sum": 8030010887,
		"num_equity_funds": 1,
		"equity_fund_net_assets": 565699,
		"equity_fund_long_assets": 565699,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"num_c2_free": 1,
		"num_five_badgers": 1,
		"num_sri_badgers": 0,
		"num_fossil_A_grade": 1,
		"num_sri_fossil_A_grade": 0,
		"ff_all_count_sum": 0,
		"ff_all_asset_sum": 0,
		"ff_all_weight_total": 0,
		"grade_fossil_fam": 1,
		"c2_count_sum": 0,
		"c2_asset_sum": 0,
		"c2_weight_total": 0,
		"mc50_count_sum": 0,
		"mc50_asset_sum": 0,
		"mc50_weight_total": 0,
		"co_count_sum": 0,
		"co_asset_sum": 0,
		"co_weight_total": 0,
		"og_count_sum": 0,
		"og_asset_sum": 0,
		"og_weight_total": 0,
		"ut_count_sum": 0,
		"ut_asset_sum": 0,
		"ut_weight_total": 0,
		"cl_count_sum": 1,
		"cl_asset_sum": 32218,
		"cl_weight_total": 0.056952548970388844,
		"fossil_bank_count_sum": 0,
		"fossil_bank_asset_sum": 0,
		"fossil_bank_weight_total": 0,
		"fossil_insure_count_sum": 0,
		"fossil_insure_asset_sum": 0,
		"fossil_insure_weight_total": 0,
		"name": "Tuttle Capital Management, LLC",
		"fund_family_name": "Tuttle Capital Management, LLC",
		"label": "Tuttle Capital Management, LLC"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/FamilyFunds.json
// module id = 1004
// module chunks = 0